/* eslint-disable */
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**  BigInt  */
  BigInt: { input: any; output: any; }
  /**  Country Code  */
  CountryCode: { input: any; output: any; }
  /**  Date  */
  DateTime: { input: any; output: any; }
  /**  mock  */
  DividendMock: { input: any; output: any; }
  /**  File  */
  FileScalar: { input: File; output: string; }
  /**  Rate  */
  Rate: { input: any; output: any; }
  /**  Date with no time of day  */
  TimelessDate: { input: any; output: any; }
  /**  URL  */
  URL: { input: any; output: any; }
  /**  UUID  */
  UUID: { input: string; output: string; }
  /**  mock  */
  VatMock: { input: any; output: any; }
};

/**  Result payload returned after accepting an invitation  */
export type AcceptInvitationPayload = {
  __typename?: 'AcceptInvitationPayload';
  businessId: Scalars['ID']['output'];
  roleId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/**  represents accountant approval status for a charge  */
export type AccountantApprovalStatus = {
  __typename?: 'AccountantApprovalStatus';
  approvedCount: Scalars['Int']['output'];
  pendingCount: Scalars['Int']['output'];
  totalCharges: Scalars['Int']['output'];
  unapprovedCount: Scalars['Int']['output'];
};

/**  represents accountant approval status  */
export const AccountantStatus = {
  Approved: 'APPROVED',
  Pending: 'PENDING',
  Unapproved: 'UNAPPROVED'
} as const;

export type AccountantStatus = typeof AccountantStatus[keyof typeof AccountantStatus];
/**  Accounting method enum (שיטת חשבונאות)  */
export const AccountingMethod = {
  /** Double-entry (כפולה) */
  DoubleEntry: 'DOUBLE_ENTRY',
  /** Single-entry (חד צידית) */
  SingleEntry: 'SINGLE_ENTRY'
} as const;

export type AccountingMethod = typeof AccountingMethod[keyof typeof AccountingMethod];
/**  Business accounting system enum (הנח''ש של העסק)  */
export const AccountingSystem = {
  /** Computerized (ממוחשב) */
  Computerized: 'COMPUTERIZED',
  /** Manual (ידני) */
  Manual: 'MANUAL'
} as const;

export type AccountingSystem = typeof AccountingSystem[keyof typeof AccountingSystem];
/**  the input for adding a new business trip accommodation expense  */
export type AddBusinessTripAccommodationsExpenseInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  attendeesStay?: InputMaybe<Array<BusinessTripAttendeeStayInput>>;
  businessTripId: Scalars['UUID']['input'];
  country?: InputMaybe<Scalars['CountryCode']['input']>;
  currency?: InputMaybe<Currency>;
  date?: InputMaybe<Scalars['TimelessDate']['input']>;
  employeeBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  nightsCount?: InputMaybe<Scalars['Int']['input']>;
  valueDate?: InputMaybe<Scalars['TimelessDate']['input']>;
};

/**  the input for adding a new business trip T&S expense  */
export type AddBusinessTripCarRentalExpenseInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  businessTripId: Scalars['UUID']['input'];
  currency?: InputMaybe<Currency>;
  date?: InputMaybe<Scalars['TimelessDate']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  employeeBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  isFuelExpense?: InputMaybe<Scalars['Boolean']['input']>;
  valueDate?: InputMaybe<Scalars['TimelessDate']['input']>;
};

/**  the input for adding a new business trip flights expense  */
export type AddBusinessTripFlightsExpenseInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  attendeeIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  businessTripId: Scalars['UUID']['input'];
  currency?: InputMaybe<Currency>;
  date?: InputMaybe<Scalars['TimelessDate']['input']>;
  employeeBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  flightClass?: InputMaybe<FlightClass>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  valueDate?: InputMaybe<Scalars['TimelessDate']['input']>;
};

/**  the input for adding a new business trip other expense  */
export type AddBusinessTripOtherExpenseInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  businessTripId: Scalars['UUID']['input'];
  currency?: InputMaybe<Currency>;
  date?: InputMaybe<Scalars['TimelessDate']['input']>;
  deductibleExpense?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employeeBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  valueDate?: InputMaybe<Scalars['TimelessDate']['input']>;
};

/**  the input for adding a new business trip T&S expense  */
export type AddBusinessTripTravelAndSubsistenceExpenseInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  businessTripId: Scalars['UUID']['input'];
  currency?: InputMaybe<Currency>;
  date?: InputMaybe<Scalars['TimelessDate']['input']>;
  employeeBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  expenseType?: InputMaybe<Scalars['String']['input']>;
  valueDate?: InputMaybe<Scalars['TimelessDate']['input']>;
};

/**  Represents a business entity managed by an accountant in the system. */
export type AdminBusiness = {
  __typename?: 'AdminBusiness';
  business: LtdFinancialEntity;
  governmentId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  registrationDate: Scalars['TimelessDate']['output'];
  /**  Social Security Info  */
  socialSecurityDeductionsId?: Maybe<Scalars['String']['output']>;
  socialSecurityEmployerIds: Array<AnnualId>;
  /**  Tax Advances Info  */
  taxAdvancesAnnualIds: Array<AnnualId>;
  taxAdvancesRates: Array<TaxAdvancesRate>;
  withholdingTaxAnnualIds: Array<AnnualId>;
  /**  Withholding Tax Info  */
  withholdingTaxCompanyId?: Maybe<Scalars['String']['output']>;
};

/**  defines a tag / category for charge arrangement */
export type AdminContextInfo = {
  __typename?: 'AdminContextInfo';
  accumulatedDepreciationTaxCategory?: Maybe<TaxCategory>;
  amexBusiness?: Maybe<Business>;
  balanceCancellationTaxCategory: TaxCategory;
  bankDepositBusiness?: Maybe<Business>;
  bankDepositInterestIncomeTaxCategory?: Maybe<TaxCategory>;
  batchedEmployeesBusiness?: Maybe<Business>;
  batchedFundsBusiness?: Maybe<Business>;
  businessTripTag?: Maybe<Tag>;
  businessTripTaxCategory?: Maybe<TaxCategory>;
  calBusiness?: Maybe<Business>;
  compensationFundExpensesTaxCategory?: Maybe<TaxCategory>;
  dateEstablished?: Maybe<Scalars['TimelessDate']['output']>;
  defaultForeignCurrency: Currency;
  defaultLocalCurrency: Currency;
  defaultTaxCategory: TaxCategory;
  developmentForeignTaxCategory: TaxCategory;
  developmentLocalTaxCategory: TaxCategory;
  discountBusiness?: Maybe<Business>;
  dividendTaxCategory?: Maybe<TaxCategory>;
  dividendWithholdingTaxBusiness?: Maybe<Business>;
  etanaBusiness?: Maybe<Business>;
  etherscanBusiness?: Maybe<Business>;
  exchangeRateRevaluationTaxCategory: TaxCategory;
  exchangeRateTaxCategory: TaxCategory;
  expensesInAdvanceTaxCategory: TaxCategory;
  expensesToPayTaxCategory: TaxCategory;
  feeTaxCategory: TaxCategory;
  fineTaxCategory: TaxCategory;
  foreignSecuritiesBusiness?: Maybe<Business>;
  foreignSecuritiesFeesCategory?: Maybe<TaxCategory>;
  generalFeeTaxCategory: TaxCategory;
  gnmDepreciationExpensesTaxCategory?: Maybe<TaxCategory>;
  id: Scalars['ID']['output'];
  incomeExchangeRateTaxCategory: TaxCategory;
  incomeInAdvanceTaxCategory?: Maybe<TaxCategory>;
  incomeToCollectTaxCategory: TaxCategory;
  initialAccounterYear?: Maybe<Scalars['Int']['output']>;
  inputVatTaxCategory: TaxCategory;
  isracardBusiness?: Maybe<Business>;
  krakenBusiness?: Maybe<Business>;
  ledgerLock?: Maybe<Scalars['TimelessDate']['output']>;
  locality: Scalars['String']['output'];
  marketingDepreciationExpensesTaxCategory?: Maybe<TaxCategory>;
  outputVatTaxCategory: TaxCategory;
  ownerId: Scalars['UUID']['output'];
  pensionFundExpensesTaxCategory?: Maybe<TaxCategory>;
  poalimBusiness?: Maybe<Business>;
  propertyOutputVatTaxCategory?: Maybe<TaxCategory>;
  recoveryReserveExpensesTaxCategory?: Maybe<TaxCategory>;
  recoveryReserveTaxCategory?: Maybe<TaxCategory>;
  rndDepreciationExpensesTaxCategory?: Maybe<TaxCategory>;
  salaryExcessExpensesTaxCategory: TaxCategory;
  salaryExpensesTaxCategory?: Maybe<TaxCategory>;
  socialSecurityBusiness: Business;
  socialSecurityExpensesTaxCategory?: Maybe<TaxCategory>;
  swiftBusiness?: Maybe<Business>;
  taxBusiness: Business;
  taxDeductionsBusiness?: Maybe<Business>;
  taxExpensesTaxCategory: TaxCategory;
  trainingFundExpensesTaxCategory?: Maybe<TaxCategory>;
  untaxableGiftsTaxCategory: TaxCategory;
  vacationReserveExpensesTaxCategory?: Maybe<TaxCategory>;
  vacationReserveTaxCategory?: Maybe<TaxCategory>;
  vatBusiness: Business;
  zkufotExpensesTaxCategory?: Maybe<TaxCategory>;
  zkufotIncomeTaxCategory?: Maybe<TaxCategory>;
};

/**  input variables for updateAdminContext  */
export type AdminContextInput = {
  accumulatedDepreciationTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  amexBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  balanceCancellationTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  bankDepositBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  bankDepositInterestIncomeTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  batchedEmployeesBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  batchedFundsBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  businessTripTagId?: InputMaybe<Scalars['UUID']['input']>;
  businessTripTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  calBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  compensationFundExpensesTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  dateEstablished?: InputMaybe<Scalars['TimelessDate']['input']>;
  defaultForeignCurrency?: InputMaybe<Currency>;
  defaultLocalCurrency?: InputMaybe<Currency>;
  defaultTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  developmentForeignTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  developmentLocalTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  discountBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  dividendTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  dividendWithholdingTaxBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  etanaBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  etherscanBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  exchangeRateRevaluationTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  exchangeRateTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  expensesInAdvanceTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  expensesToPayTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  feeTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  fineTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  foreignSecuritiesBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  foreignSecuritiesFeesCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  generalFeeTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  gnmDepreciationExpensesTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  incomeExchangeRateTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  incomeInAdvanceTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  incomeToCollectTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  initialAccounterYear?: InputMaybe<Scalars['Int']['input']>;
  inputVatTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  isracardBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  krakenBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  ledgerLock?: InputMaybe<Scalars['TimelessDate']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  marketingDepreciationExpensesTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  outputVatTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  ownerId: Scalars['UUID']['input'];
  pensionFundExpensesTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  poalimBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  propertyOutputVatTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  recoveryReserveExpensesTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  recoveryReserveTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  rndDepreciationExpensesTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  salaryExcessExpensesTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  salaryExpensesTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  socialSecurityBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  socialSecurityExpensesTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  swiftBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  taxBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  taxDeductionsBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  taxExpensesTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  trainingFundExpensesTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  untaxableGiftsTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  vacationReserveExpensesTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  vacationReserveTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  vatBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  zkufotExpensesTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  zkufotIncomeTaxCategoryId?: InputMaybe<Scalars['UUID']['input']>;
};

/**  Input for an American Express credit card transaction  */
export type AmexTransactionInput = {
  adendum?: InputMaybe<Scalars['String']['input']>;
  card: Scalars['String']['input'];
  cardIndex: Scalars['Int']['input'];
  chargingDate?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clientIpAddress?: InputMaybe<Scalars['String']['input']>;
  currencyId?: InputMaybe<Scalars['String']['input']>;
  currentPaymentCurrency?: InputMaybe<Scalars['String']['input']>;
  dealSum?: InputMaybe<Scalars['String']['input']>;
  dealSumOutbound?: InputMaybe<Scalars['String']['input']>;
  dealSumType?: InputMaybe<Scalars['String']['input']>;
  dealsInbound?: InputMaybe<Scalars['String']['input']>;
  displayProperties?: InputMaybe<Scalars['String']['input']>;
  esbServicesCall?: InputMaybe<Scalars['String']['input']>;
  fullPaymentDate?: InputMaybe<Scalars['String']['input']>;
  fullPurchaseDate?: InputMaybe<Scalars['String']['input']>;
  fullPurchaseDateOutbound?: InputMaybe<Scalars['String']['input']>;
  fullSupplierNameHeb?: InputMaybe<Scalars['String']['input']>;
  fullSupplierNameOutbound?: InputMaybe<Scalars['String']['input']>;
  horaatKeva?: InputMaybe<Scalars['String']['input']>;
  isButton: Scalars['String']['input'];
  isCaptcha: Scalars['String']['input'];
  isError: Scalars['String']['input'];
  isHoraatKeva: Scalars['String']['input'];
  isShowDealsOutbound?: InputMaybe<Scalars['String']['input']>;
  isShowLinkForSupplierDetails?: InputMaybe<Scalars['String']['input']>;
  kodMatbeaMekori?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  moreInfo?: InputMaybe<Scalars['String']['input']>;
  paymentDate?: InputMaybe<Scalars['String']['input']>;
  paymentSum?: InputMaybe<Scalars['String']['input']>;
  paymentSumOutbound?: InputMaybe<Scalars['String']['input']>;
  paymentSumSign?: InputMaybe<Scalars['String']['input']>;
  purchaseDate?: InputMaybe<Scalars['String']['input']>;
  purchaseDateOutbound?: InputMaybe<Scalars['String']['input']>;
  returnCode?: InputMaybe<Scalars['String']['input']>;
  returnMessage?: InputMaybe<Scalars['String']['input']>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  solek?: InputMaybe<Scalars['String']['input']>;
  specificDate?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
  supplierName?: InputMaybe<Scalars['String']['input']>;
  supplierNameOutbound?: InputMaybe<Scalars['String']['input']>;
  tablePageNum: Scalars['Boolean']['input'];
  voucherNumber?: InputMaybe<Scalars['Int']['input']>;
  voucherNumberRatz?: InputMaybe<Scalars['Int']['input']>;
  voucherNumberRatzOutbound?: InputMaybe<Scalars['Int']['input']>;
};

/**  Result type for annualAuditOpeningBalanceStatus query  */
export type AnnualAuditOpeningBalanceStatusInfo = {
  __typename?: 'AnnualAuditOpeningBalanceStatusInfo';
  /**  Only relevant for MIGRATING users  */
  balanceChargeId?: Maybe<Scalars['UUID']['output']>;
  derivedStatus: AnnualAuditStepStatus;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  userType: AnnualAuditOpeningBalanceUserType;
};

/**  User type classification for annual audit opening balance step  */
export const AnnualAuditOpeningBalanceUserType = {
  Continuing: 'CONTINUING',
  Error: 'ERROR',
  Migrating: 'MIGRATING',
  New: 'NEW'
} as const;

export type AnnualAuditOpeningBalanceUserType = typeof AnnualAuditOpeningBalanceUserType[keyof typeof AnnualAuditOpeningBalanceUserType];
/**  Status values for annual audit steps  */
export const AnnualAuditStepStatus = {
  Blocked: 'BLOCKED',
  Completed: 'COMPLETED',
  InProgress: 'IN_PROGRESS',
  Pending: 'PENDING'
} as const;

export type AnnualAuditStepStatus = typeof AnnualAuditStepStatus[keyof typeof AnnualAuditStepStatus];
/**  Persisted manual status for a single annual audit step  */
export type AnnualAuditStepStatusInfo = {
  __typename?: 'AnnualAuditStepStatusInfo';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /**  JSON-encoded evidence metadata (step-specific structure)  */
  evidence?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['UUID']['output'];
  status: AnnualAuditStepStatus;
  stepId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  year: Scalars['Int']['output'];
};

/**  Represents an annual identifier for tax purposes.  */
export type AnnualId = {
  __typename?: 'AnnualId';
  id: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

/**  Input type representing an annual identifier for tax purposes.  */
export type AnnualIdInput = {
  id: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

/**  annual revenue report  */
export type AnnualRevenueReport = {
  __typename?: 'AnnualRevenueReport';
  countries: Array<AnnualRevenueReportCountry>;
  id: Scalars['ID']['output'];
  year: Scalars['Int']['output'];
};

/**  annual revenue report country client record  */
export type AnnualRevenueReportClientRecord = {
  __typename?: 'AnnualRevenueReportClientRecord';
  chargeId: Scalars['UUID']['output'];
  date: Scalars['TimelessDate']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  revenueDefaultForeign: FinancialAmount;
  revenueLocal: FinancialAmount;
  revenueOriginal: FinancialAmount;
};

/**  annual revenue report country  */
export type AnnualRevenueReportCountry = {
  __typename?: 'AnnualRevenueReportCountry';
  clients: Array<AnnualRevenueReportCountryClient>;
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  revenueDefaultForeign: FinancialAmount;
  revenueLocal: FinancialAmount;
};

/**  annual revenue report country client  */
export type AnnualRevenueReportCountryClient = {
  __typename?: 'AnnualRevenueReportCountryClient';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  records: Array<AnnualRevenueReportClientRecord>;
  revenueDefaultForeign: FinancialAmount;
  revenueLocal: FinancialAmount;
};

/**  annual revenue report filter  */
export type AnnualRevenueReportFilter = {
  adminBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  year: Scalars['Int']['input'];
};

/**  API key metadata (plaintext key is never stored)  */
export type ApiKey = {
  __typename?: 'ApiKey';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  roleId: Scalars['String']['output'];
};

/**  Audit opinion type enum (חוות דעת)  */
export const AuditOpinionType = {
  /** Adverse opinion (שלילית) */
  Adverse: 'ADVERSE',
  /** Disclaimer of opinion (המנעות) */
  Disclaimer: 'DISCLAIMER',
  /** No audit opinion (אין חוות דעת) */
  None: 'NONE',
  /** Qualified opinion (הסתייגות) */
  Qualified: 'QUALIFIED',
  /** Unqualified opinion (נוסח אחיד (בלתי מסוייג)) */
  Unqualified: 'UNQUALIFIED',
  /** Unqualified opinion with emphasis on going concern (בנוסח אחיד עם הפניית תשומת לב להערת עסק חי) */
  UnqualifiedWithGoingConcern: 'UNQUALIFIED_WITH_GOING_CONCERN',
  /** Unqualified opinion with other emphases (בנוסח אחיד עם הפניות תשומת לב אחרת) */
  UnqualifiedWithOtherEmphases: 'UNQUALIFIED_WITH_OTHER_EMPHASES'
} as const;

export type AuditOpinionType = typeof AuditOpinionType[keyof typeof AuditOpinionType];
/**  Result of the auto-match operation  */
export type AutoMatchChargesResult = {
  __typename?: 'AutoMatchChargesResult';
  /**  Array of error messages encountered during the operation  */
  errors: Array<Scalars['String']['output']>;
  /**  Array of charges that were merged, with their confidence scores  */
  mergedCharges: Array<MergedCharge>;
  /**  Array of charge UUIDs that had multiple high-confidence matches and were skipped  */
  skippedCharges: Array<Scalars['UUID']['output']>;
  /**  Total number of charges that were successfully matched and merged  */
  totalMatches: Scalars['Int']['output'];
};

/**  transactions for balance report  */
export type BalanceTransactions = {
  __typename?: 'BalanceTransactions';
  account: FinancialAccount;
  amount: FinancialAmount;
  amountUsd: FinancialAmount;
  charge: Charge;
  chargeId: Scalars['UUID']['output'];
  counterparty?: Maybe<FinancialEntity>;
  date: Scalars['TimelessDate']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isFee: Scalars['Boolean']['output'];
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

/**  input type for creating a bank account  */
export type BankAccountInsertInput = {
  accountAgreementOpeningDate?: InputMaybe<Scalars['Int']['input']>;
  accountClosingReasonCode?: InputMaybe<Scalars['Int']['input']>;
  accountDealDate?: InputMaybe<Scalars['Int']['input']>;
  accountUpdateDate?: InputMaybe<Scalars['Int']['input']>;
  bankNumber: Scalars['Int']['input'];
  branchNumber: Scalars['Int']['input'];
  branchTypeCode?: InputMaybe<Scalars['Int']['input']>;
  extendedBankNumber?: InputMaybe<Scalars['Int']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  kodHarshaatPeilut?: InputMaybe<Scalars['Int']['input']>;
  metegDoarNet?: InputMaybe<Scalars['Int']['input']>;
  mymailEntitlementSwitch?: InputMaybe<Scalars['Int']['input']>;
  partyAccountInvolvementCode?: InputMaybe<Scalars['Int']['input']>;
  partyPreferredIndication?: InputMaybe<Scalars['Int']['input']>;
  productLabel?: InputMaybe<Scalars['String']['input']>;
  serviceAuthorizationDesc?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
};

/**  input type for updating a bank account  */
export type BankAccountUpdateInput = {
  accountAgreementOpeningDate?: InputMaybe<Scalars['Int']['input']>;
  accountClosingReasonCode?: InputMaybe<Scalars['Int']['input']>;
  accountDealDate?: InputMaybe<Scalars['Int']['input']>;
  accountUpdateDate?: InputMaybe<Scalars['Int']['input']>;
  bankNumber?: InputMaybe<Scalars['Int']['input']>;
  branchNumber?: InputMaybe<Scalars['Int']['input']>;
  branchTypeCode?: InputMaybe<Scalars['Int']['input']>;
  extendedBankNumber?: InputMaybe<Scalars['Int']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  kodHarshaatPeilut?: InputMaybe<Scalars['Int']['input']>;
  metegDoarNet?: InputMaybe<Scalars['Int']['input']>;
  mymailEntitlementSwitch?: InputMaybe<Scalars['Int']['input']>;
  partyAccountInvolvementCode?: InputMaybe<Scalars['Int']['input']>;
  partyPreferredIndication?: InputMaybe<Scalars['Int']['input']>;
  productLabel?: InputMaybe<Scalars['String']['input']>;
  serviceAuthorizationDesc?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
};

/**  Bank Deposit  */
export type BankDeposit = {
  __typename?: 'BankDeposit';
  account?: Maybe<FinancialAccount>;
  closeDate?: Maybe<Scalars['TimelessDate']['output']>;
  currency?: Maybe<Currency>;
  id: Scalars['ID']['output'];
  isOpen: Scalars['Boolean']['output'];
  metadata: BankDepositMetadata;
  name: Scalars['String']['output'];
  openDate?: Maybe<Scalars['TimelessDate']['output']>;
};

/**  charge of bank deposits  */
export type BankDepositCharge = Charge & {
  __typename?: 'BankDepositCharge';
  accountantApproval: AccountantStatus;
  additionalDocuments: Array<Document>;
  counterparty?: Maybe<FinancialEntity>;
  decreasedVAT?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  isInvoicePaymentDifferentCurrency?: Maybe<Scalars['Boolean']['output']>;
  ledger: Ledger;
  metadata?: Maybe<ChargeMetadata>;
  minDebitDate?: Maybe<Scalars['DateTime']['output']>;
  minDocumentsDate?: Maybe<Scalars['DateTime']['output']>;
  minEventDate?: Maybe<Scalars['DateTime']['output']>;
  miscExpenses: Array<MiscExpense>;
  missingInfoSuggestions?: Maybe<ChargeSuggestions>;
  optionalDocuments?: Maybe<Scalars['Boolean']['output']>;
  optionalVAT?: Maybe<Scalars['Boolean']['output']>;
  owner: Business;
  property?: Maybe<Scalars['Boolean']['output']>;
  tags: Array<Tag>;
  taxCategory?: Maybe<TaxCategory>;
  totalAmount?: Maybe<FinancialAmount>;
  transactions: Array<Transaction>;
  userDescription?: Maybe<Scalars['String']['output']>;
  validationData?: Maybe<ValidationData>;
  vat?: Maybe<FinancialAmount>;
  withholdingTax?: Maybe<FinancialAmount>;
  yearsOfRelevance?: Maybe<Array<YearOfRelevance>>;
};

/**  represent a bank deposit account  */
export type BankDepositFinancialAccount = FinancialAccount & {
  __typename?: 'BankDepositFinancialAccount';
  accountTaxCategories: Array<CurrencyTaxCategory>;
  charges: Array<Charge>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  privateOrBusiness: PrivateOrBusinessType;
  type: FinancialAccountType;
};


/**  represent a bank deposit account  */
export type BankDepositFinancialAccountChargesArgs = {
  filter?: InputMaybe<ChargeFilter>;
};

/**  Metadata for Bank Deposit, including current balance, total interest, total deposit amount, and associated transactions.  */
export type BankDepositMetadata = {
  __typename?: 'BankDepositMetadata';
  currentBalance: FinancialAmount;
  id: Scalars['ID']['output'];
  potentialCloseDate?: Maybe<Scalars['TimelessDate']['output']>;
  totalDeposit: FinancialAmount;
  totalInterest: FinancialAmount;
  transactions: Array<Transaction>;
};

/**  represent a single bank account */
export type BankFinancialAccount = FinancialAccount & {
  __typename?: 'BankFinancialAccount';
  accountAgreementOpeningDate?: Maybe<Scalars['Int']['output']>;
  accountClosingReasonCode?: Maybe<Scalars['Int']['output']>;
  accountDealDate?: Maybe<Scalars['Int']['output']>;
  /**  the external identifier of the bank account  */
  accountNumber: Scalars['String']['output'];
  accountTaxCategories: Array<CurrencyTaxCategory>;
  accountUpdateDate?: Maybe<Scalars['Int']['output']>;
  bankNumber: Scalars['Int']['output'];
  branchNumber: Scalars['Int']['output'];
  branchTypeCode?: Maybe<Scalars['Int']['output']>;
  charges: Array<Charge>;
  extendedBankNumber?: Maybe<Scalars['Int']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  kodHarshaatPeilut?: Maybe<Scalars['Int']['output']>;
  metegDoarNet?: Maybe<Scalars['Int']['output']>;
  mymailEntitlementSwitch?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  partyAccountInvolvementCode?: Maybe<Scalars['Int']['output']>;
  partyPreferredIndication?: Maybe<Scalars['Int']['output']>;
  privateOrBusiness: PrivateOrBusinessType;
  productLabel?: Maybe<Scalars['String']['output']>;
  serviceAuthorizationDesc?: Maybe<Scalars['String']['output']>;
  swiftCode?: Maybe<Scalars['String']['output']>;
  type: FinancialAccountType;
};


/**  represent a single bank account */
export type BankFinancialAccountChargesArgs = {
  filter?: InputMaybe<ChargeFilter>;
};

/**  result type for batchUpdateCharges  */
export type BatchUpdateChargesResult = BatchUpdateChargesSuccessfulResult | CommonError;

/**  successful result type for batchUpdateCharges  */
export type BatchUpdateChargesSuccessfulResult = {
  __typename?: 'BatchUpdateChargesSuccessfulResult';
  charges: Array<Charge>;
};

/**  contract billing cycle  */
export const BillingCycle = {
  Annual: 'ANNUAL',
  Monthly: 'MONTHLY'
} as const;

export type BillingCycle = typeof BillingCycle[keyof typeof BillingCycle];
/**  input required to bootstrap a new client business and its initial owner  */
export type BootstrapClientInput = {
  businessName: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  dateEstablished?: InputMaybe<Scalars['TimelessDate']['input']>;
  initialAccounterYear?: InputMaybe<Scalars['Int']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  ownerEmail: Scalars['String']['input'];
  ownerRole: Scalars['String']['input'];
};

/**  Result returned after bootstrapping, including business, invitation token, and admin context.  */
export type BootstrapClientResult = {
  __typename?: 'BootstrapClientResult';
  adminContext: AdminContextInfo;
  business: Business;
  id: Scalars['ID']['output'];
  invitationToken: Scalars['String']['output'];
};

/**  represent a financial entity of any type that may hold financial accounts (company, business, individual)  */
export type Business = {
  accounts: Array<FinancialAccount>;
  charges: PaginatedCharges;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  irsCode?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pcn874RecordType?: Maybe<Pcn874RecordType>;
  sortCode?: Maybe<SortCode>;
  updatedAt: Scalars['DateTime']['output'];
};


/**  represent a financial entity of any type that may hold financial accounts (company, business, individual)  */
export type BusinessChargesArgs = {
  filter?: InputMaybe<ChargeFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/**  configuration for business email processing  */
export type BusinessEmailConfig = {
  __typename?: 'BusinessEmailConfig';
  attachments?: Maybe<Array<EmailAttachmentType>>;
  businessId: Scalars['UUID']['output'];
  emailBody?: Maybe<Scalars['Boolean']['output']>;
  internalEmailLinks?: Maybe<Array<Scalars['String']['output']>>;
};

/**  single business transaction info  */
export type BusinessTransaction = {
  __typename?: 'BusinessTransaction';
  amount: FinancialAmount;
  business: FinancialEntity;
  chargeId: Scalars['UUID']['output'];
  counterAccount?: Maybe<FinancialEntity>;
  details?: Maybe<Scalars['String']['output']>;
  foreignAmount?: Maybe<FinancialAmount>;
  invoiceDate: Scalars['TimelessDate']['output'];
  reference?: Maybe<Scalars['String']['output']>;
};

/**  single business transaction summery  */
export type BusinessTransactionSum = {
  __typename?: 'BusinessTransactionSum';
  business: FinancialEntity;
  credit: FinancialAmount;
  debit: FinancialAmount;
  foreignCurrenciesSum: Array<ForeignCurrencySum>;
  total: FinancialAmount;
};

/**  input variables for businessTransactions  */
export type BusinessTransactionsFilter = {
  businessIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  fromDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  includeRevaluation?: InputMaybe<Scalars['Boolean']['input']>;
  ownerIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  toDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  type?: InputMaybe<FinancialEntityType>;
};

/**  result type for businessTransactionsFromLedgerRecords  */
export type BusinessTransactionsFromLedgerRecordsResult = BusinessTransactionsFromLedgerRecordsSuccessfulResult | CommonError;

/**  result type for businessTransactionsFromLedgerRecords */
export type BusinessTransactionsFromLedgerRecordsSuccessfulResult = {
  __typename?: 'BusinessTransactionsFromLedgerRecordsSuccessfulResult';
  businessTransactions: Array<BusinessTransaction>;
};

/**  result type for businessTransactionsSumFromLedgerRecords  */
export type BusinessTransactionsSumFromLedgerRecordsResult = BusinessTransactionsSumFromLedgerRecordsSuccessfulResult | CommonError;

/**  result type for businessTransactionsSumFromLedgerRecords */
export type BusinessTransactionsSumFromLedgerRecordsSuccessfulResult = {
  __typename?: 'BusinessTransactionsSumFromLedgerRecordsSuccessfulResult';
  businessTransactionsSum: Array<BusinessTransactionSum>;
};

/**  represent a business trip  */
export type BusinessTrip = {
  __typename?: 'BusinessTrip';
  accommodationExpenses: Array<BusinessTripAccommodationExpense>;
  accountantApproval: AccountantStatus;
  attendees: Array<BusinessTripAttendee>;
  carRentalExpenses: Array<BusinessTripCarRentalExpense>;
  dates?: Maybe<DateRange>;
  destination?: Maybe<Country>;
  flightExpenses: Array<BusinessTripFlightExpense>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  otherExpenses: Array<BusinessTripOtherExpense>;
  purpose?: Maybe<Scalars['String']['output']>;
  summary: BusinessTripSummary;
  travelAndSubsistenceExpenses: Array<BusinessTripTravelAndSubsistenceExpense>;
  uncategorizedTransactions: Array<Maybe<UncategorizedTransaction>>;
};

/**  represent a business trip accommodation expense  */
export type BusinessTripAccommodationExpense = BusinessTripExpense & {
  __typename?: 'BusinessTripAccommodationExpense';
  amount?: Maybe<FinancialAmount>;
  attendeesStay: Array<BusinessTripAttendeeStay>;
  businessTrip: BusinessTrip;
  charges?: Maybe<Array<Charge>>;
  country?: Maybe<Country>;
  date?: Maybe<Scalars['TimelessDate']['output']>;
  employee?: Maybe<FinancialEntity>;
  id: Scalars['UUID']['output'];
  nightsCount?: Maybe<Scalars['Int']['output']>;
  payedByEmployee?: Maybe<Scalars['Boolean']['output']>;
  transactions?: Maybe<Array<Transaction>>;
  valueDate?: Maybe<Scalars['TimelessDate']['output']>;
};

/**  represent business trip attendee  */
export type BusinessTripAttendee = {
  __typename?: 'BusinessTripAttendee';
  accommodations: Array<BusinessTripAccommodationExpense>;
  arrivalDate?: Maybe<Scalars['TimelessDate']['output']>;
  business?: Maybe<Business>;
  departureDate?: Maybe<Scalars['TimelessDate']['output']>;
  flights: Array<BusinessTripFlightExpense>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

/**  represent a business trip attendee accommodation stay info  */
export type BusinessTripAttendeeStay = {
  __typename?: 'BusinessTripAttendeeStay';
  attendee: BusinessTripAttendee;
  id: Scalars['UUID']['output'];
  nightsCount: Scalars['Int']['output'];
};

/**  the input for attendee accommodation stay info  */
export type BusinessTripAttendeeStayInput = {
  attendeeId: Scalars['UUID']['input'];
  nightsCount: Scalars['Int']['input'];
};

/**  the input for updating a business trip attendee  */
export type BusinessTripAttendeeUpdateInput = {
  arrivalDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  attendeeId: Scalars['UUID']['input'];
  businessTripId: Scalars['UUID']['input'];
  departureDate?: InputMaybe<Scalars['TimelessDate']['input']>;
};

/**  represent a business trip car rental expense  */
export type BusinessTripCarRentalExpense = BusinessTripExpense & {
  __typename?: 'BusinessTripCarRentalExpense';
  amount?: Maybe<FinancialAmount>;
  businessTrip: BusinessTrip;
  charges?: Maybe<Array<Charge>>;
  date?: Maybe<Scalars['TimelessDate']['output']>;
  /**  הוצאה מוכרת  */
  days: Scalars['Int']['output'];
  employee?: Maybe<FinancialEntity>;
  id: Scalars['UUID']['output'];
  /**  פירוט  */
  isFuelExpense: Scalars['Boolean']['output'];
  payedByEmployee?: Maybe<Scalars['Boolean']['output']>;
  transactions?: Maybe<Array<Transaction>>;
  valueDate?: Maybe<Scalars['TimelessDate']['output']>;
};

/**  charge of dividends  */
export type BusinessTripCharge = Charge & {
  __typename?: 'BusinessTripCharge';
  accountantApproval: AccountantStatus;
  additionalDocuments: Array<Document>;
  businessTrip?: Maybe<BusinessTrip>;
  counterparty?: Maybe<FinancialEntity>;
  decreasedVAT?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  isInvoicePaymentDifferentCurrency?: Maybe<Scalars['Boolean']['output']>;
  ledger: Ledger;
  metadata?: Maybe<ChargeMetadata>;
  minDebitDate?: Maybe<Scalars['DateTime']['output']>;
  minDocumentsDate?: Maybe<Scalars['DateTime']['output']>;
  minEventDate?: Maybe<Scalars['DateTime']['output']>;
  miscExpenses: Array<MiscExpense>;
  missingInfoSuggestions?: Maybe<ChargeSuggestions>;
  optionalDocuments?: Maybe<Scalars['Boolean']['output']>;
  optionalVAT?: Maybe<Scalars['Boolean']['output']>;
  owner: Business;
  property?: Maybe<Scalars['Boolean']['output']>;
  tags: Array<Tag>;
  taxCategory?: Maybe<TaxCategory>;
  totalAmount?: Maybe<FinancialAmount>;
  transactions: Array<Transaction>;
  userDescription?: Maybe<Scalars['String']['output']>;
  validationData?: Maybe<ValidationData>;
  vat?: Maybe<FinancialAmount>;
  withholdingTax?: Maybe<FinancialAmount>;
  yearsOfRelevance?: Maybe<Array<YearOfRelevance>>;
};

/**  business trip expense prototype  */
export type BusinessTripExpense = {
  amount?: Maybe<FinancialAmount>;
  businessTrip: BusinessTrip;
  charges?: Maybe<Array<Charge>>;
  date?: Maybe<Scalars['TimelessDate']['output']>;
  employee?: Maybe<FinancialEntity>;
  id: Scalars['UUID']['output'];
  /**  שולם על ידי העובד  */
  payedByEmployee?: Maybe<Scalars['Boolean']['output']>;
  transactions?: Maybe<Array<Transaction>>;
  valueDate?: Maybe<Scalars['TimelessDate']['output']>;
};

/**  represent category type of business trip summary  */
export const BusinessTripExpenseCategories = {
  Accommodation: 'ACCOMMODATION',
  CarRental: 'CAR_RENTAL',
  Flight: 'FLIGHT',
  Other: 'OTHER',
  TravelAndSubsistence: 'TRAVEL_AND_SUBSISTENCE'
} as const;

export type BusinessTripExpenseCategories = typeof BusinessTripExpenseCategories[keyof typeof BusinessTripExpenseCategories];
/**  represent a business trip flight expense  */
export type BusinessTripFlightExpense = BusinessTripExpense & {
  __typename?: 'BusinessTripFlightExpense';
  amount?: Maybe<FinancialAmount>;
  attendees: Array<BusinessTripAttendee>;
  businessTrip: BusinessTrip;
  charges?: Maybe<Array<Charge>>;
  class?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['TimelessDate']['output']>;
  employee?: Maybe<FinancialEntity>;
  id: Scalars['UUID']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  payedByEmployee?: Maybe<Scalars['Boolean']['output']>;
  transactions?: Maybe<Array<Transaction>>;
  valueDate?: Maybe<Scalars['TimelessDate']['output']>;
};

/**  represent a business trip other expense  */
export type BusinessTripOtherExpense = BusinessTripExpense & {
  __typename?: 'BusinessTripOtherExpense';
  amount?: Maybe<FinancialAmount>;
  businessTrip: BusinessTrip;
  charges?: Maybe<Array<Charge>>;
  date?: Maybe<Scalars['TimelessDate']['output']>;
  /**  הוצאה מוכרת  */
  deductibleExpense?: Maybe<Scalars['Boolean']['output']>;
  /**  פירוט  */
  description?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<FinancialEntity>;
  id: Scalars['UUID']['output'];
  payedByEmployee?: Maybe<Scalars['Boolean']['output']>;
  transactions?: Maybe<Array<Transaction>>;
  valueDate?: Maybe<Scalars['TimelessDate']['output']>;
};

/**  represent business trip summary data  */
export type BusinessTripSummary = {
  __typename?: 'BusinessTripSummary';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  excessExpenditure?: Maybe<FinancialAmount>;
  excessTax?: Maybe<Scalars['Float']['output']>;
  rows: Array<BusinessTripSummaryRow>;
};

/**  represent category type of business trip summary  */
export const BusinessTripSummaryCategories = {
  Accommodation: 'ACCOMMODATION',
  CarRental: 'CAR_RENTAL',
  Flight: 'FLIGHT',
  Other: 'OTHER',
  Total: 'TOTAL',
  TravelAndSubsistence: 'TRAVEL_AND_SUBSISTENCE'
} as const;

export type BusinessTripSummaryCategories = typeof BusinessTripSummaryCategories[keyof typeof BusinessTripSummaryCategories];
/**  represent business trip summary data row  */
export type BusinessTripSummaryRow = {
  __typename?: 'BusinessTripSummaryRow';
  excessExpenditure?: Maybe<FinancialAmount>;
  maxTaxableForeignCurrency: FinancialAmount;
  maxTaxableLocalCurrency?: Maybe<FinancialAmount>;
  taxableForeignCurrency: FinancialAmount;
  taxableLocalCurrency?: Maybe<FinancialAmount>;
  totalForeignCurrency: FinancialAmount;
  totalLocalCurrency?: Maybe<FinancialAmount>;
  type: BusinessTripSummaryCategories;
};

/**  represent a business trip travel and subsistence expense  */
export type BusinessTripTravelAndSubsistenceExpense = BusinessTripExpense & {
  __typename?: 'BusinessTripTravelAndSubsistenceExpense';
  amount?: Maybe<FinancialAmount>;
  businessTrip: BusinessTrip;
  charges?: Maybe<Array<Charge>>;
  date?: Maybe<Scalars['TimelessDate']['output']>;
  employee?: Maybe<FinancialEntity>;
  /**  סוג ההוצאה  */
  expenseType?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  payedByEmployee?: Maybe<Scalars['Boolean']['output']>;
  transactions?: Maybe<Array<Transaction>>;
  valueDate?: Maybe<Scalars['TimelessDate']['output']>;
};

/**  Business type enum (סוג עסק)  */
export const BusinessType = {
  /** Combination (שילוב) */
  Combination: 'COMBINATION',
  /** Commercial (מסחרי) */
  Commercial: 'COMMERCIAL',
  /** Industrial (תעשייתי) */
  Industrial: 'INDUSTRIAL',
  /** Report includes more than one business (הדוח כולל יותר מעסק אחד) */
  Multiple: 'MULTIPLE',
  /** Service providers (נותני שירותים) */
  Service: 'SERVICE'
} as const;

export type BusinessType = typeof BusinessType[keyof typeof BusinessType];
/**  Input for a Cal (Visa Cal) credit card transaction  */
export type CalTransactionInput = {
  amtBeforeConvAndIndex?: InputMaybe<Scalars['String']['input']>;
  branchCodeDesc?: InputMaybe<Scalars['String']['input']>;
  card: Scalars['Int']['input'];
  cashAccountTrnAmt?: InputMaybe<Scalars['String']['input']>;
  chargeExternalToCardComment?: InputMaybe<Scalars['String']['input']>;
  crdExtIdNumTypeCode?: InputMaybe<Scalars['String']['input']>;
  curPaymentNum?: InputMaybe<Scalars['Int']['input']>;
  debCrdCurrencySymbol?: InputMaybe<Scalars['String']['input']>;
  debCrdDate?: InputMaybe<Scalars['String']['input']>;
  debitSpreadInd?: InputMaybe<Scalars['Boolean']['input']>;
  earlyPaymentInd?: InputMaybe<Scalars['Boolean']['input']>;
  isAbroadTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  isImmediateCommentInd?: InputMaybe<Scalars['Boolean']['input']>;
  isImmediateHhkInd?: InputMaybe<Scalars['Boolean']['input']>;
  isMargarita?: InputMaybe<Scalars['Boolean']['input']>;
  isSpreadPaymenstAbroad?: InputMaybe<Scalars['Boolean']['input']>;
  merchantAddress?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  merchantName?: InputMaybe<Scalars['String']['input']>;
  merchantPhoneNo?: InputMaybe<Scalars['String']['input']>;
  numOfPayments?: InputMaybe<Scalars['Int']['input']>;
  onGoingTransactionsComment?: InputMaybe<Scalars['String']['input']>;
  refundInd?: InputMaybe<Scalars['Boolean']['input']>;
  tokenInd?: InputMaybe<Scalars['Int']['input']>;
  tokenNumberPart4?: InputMaybe<Scalars['String']['input']>;
  transCardPresentInd?: InputMaybe<Scalars['Boolean']['input']>;
  transSource?: InputMaybe<Scalars['String']['input']>;
  trnAmt?: InputMaybe<Scalars['String']['input']>;
  trnCurrencySymbol?: InputMaybe<Scalars['String']['input']>;
  trnExacWay?: InputMaybe<Scalars['Int']['input']>;
  trnIntId?: InputMaybe<Scalars['String']['input']>;
  trnNumaretor?: InputMaybe<Scalars['Int']['input']>;
  trnPurchaseDate?: InputMaybe<Scalars['String']['input']>;
  trnType?: InputMaybe<Scalars['String']['input']>;
  trnTypeCode?: InputMaybe<Scalars['String']['input']>;
  walletProviderCode?: InputMaybe<Scalars['Int']['input']>;
  walletProviderDesc?: InputMaybe<Scalars['String']['input']>;
};

/**  represent a single credit card  */
export type CardFinancialAccount = FinancialAccount & {
  __typename?: 'CardFinancialAccount';
  accountTaxCategories: Array<CurrencyTaxCategory>;
  charges: Array<Charge>;
  fourDigits: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  /**  the external identifier of the card  */
  number: Scalars['String']['output'];
  privateOrBusiness: PrivateOrBusinessType;
  type: FinancialAccountType;
};


/**  represent a single credit card  */
export type CardFinancialAccountChargesArgs = {
  filter?: InputMaybe<ChargeFilter>;
};

/**  the input for categorizing a business trip expense  */
export type CategorizeBusinessTripExpenseInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  businessTripId: Scalars['UUID']['input'];
  category?: InputMaybe<BusinessTripExpenseCategories>;
  transactionId: Scalars['UUID']['input'];
};

/**  the input for categorizing into an existing business trip expense  */
export type CategorizeIntoExistingBusinessTripExpenseInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  businessTripExpenseId: Scalars['UUID']['input'];
  transactionId: Scalars['UUID']['input'];
};

/**  A field that changed on an existing row (reserved for future upsert logic)  */
export type ChangedField = {
  __typename?: 'ChangedField';
  field: Scalars['String']['output'];
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
};

/**  A transaction row that was updated rather than inserted (reserved for future upsert logic)  */
export type ChangedTransaction = {
  __typename?: 'ChangedTransaction';
  changedFields: Array<ChangedField>;
  id: Scalars['ID']['output'];
};

/**  represent a complex type for grouped charge with ledger info, bank/card transactions and documents  */
export type Charge = {
  /**  calculated based on ledger record and transaction approvals  */
  accountantApproval: AccountantStatus;
  /**  additional documents attached to the charge  */
  additionalDocuments: Array<Document>;
  /**  calculated counterparty details for the charge  */
  counterparty?: Maybe<FinancialEntity>;
  /**  decreased VAT for property-related charges  */
  decreasedVAT?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  /**  is invoice currency different from the payment currency */
  isInvoicePaymentDifferentCurrency?: Maybe<Scalars['Boolean']['output']>;
  /**  ledger records linked to the charge  */
  ledger: Ledger;
  /**  metadata about the charge  */
  metadata?: Maybe<ChargeMetadata>;
  /**  minimal debit date from linked transactions  */
  minDebitDate?: Maybe<Scalars['DateTime']['output']>;
  /**  minimal date from linked documents  */
  minDocumentsDate?: Maybe<Scalars['DateTime']['output']>;
  /**  minimal event date from linked transactions  */
  minEventDate?: Maybe<Scalars['DateTime']['output']>;
  /**  list of misc expenses linked to transactions of the charge  */
  miscExpenses: Array<MiscExpense>;
  /**  missing info suggestions data  */
  missingInfoSuggestions?: Maybe<ChargeSuggestions>;
  /**  flag for optional documents  */
  optionalDocuments?: Maybe<Scalars['Boolean']['output']>;
  /**  flag for optional VAT  */
  optionalVAT?: Maybe<Scalars['Boolean']['output']>;
  /**  the financial entity that created the charge  */
  owner: Business;
  /**  פחת, ציוד   */
  property?: Maybe<Scalars['Boolean']['output']>;
  /**  user customer tags  */
  tags: Array<Tag>;
  taxCategory?: Maybe<TaxCategory>;
  /**  the total amount of the charge  */
  totalAmount?: Maybe<FinancialAmount>;
  /**  list of financial/bank transactions linked to the charge  */
  transactions: Array<Transaction>;
  /**  user custom description  */
  userDescription?: Maybe<Scalars['String']['output']>;
  /**  missing info validation data  */
  validationData?: Maybe<ValidationData>;
  /**  calculated field based on the actual ledger records, optional because not all charges has VAT  */
  vat?: Maybe<FinancialAmount>;
  /**  withholding tax  */
  withholdingTax?: Maybe<FinancialAmount>;
  /**  the tax year in which the action took place  */
  yearsOfRelevance?: Maybe<Array<YearOfRelevance>>;
};

/**  input variables for charge filtering  */
export type ChargeFilter = {
  accountantStatus?: InputMaybe<Array<AccountantStatus>>;
  /**  filter by business trip (should be later in business trip module?)  */
  businessTrip?: InputMaybe<Scalars['UUID']['input']>;
  /**  Include only charges including specific business  */
  byBusinesses?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**  Include only charges related to specific financial accounts  */
  byFinancialAccounts?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**  Include only charges related to specific owners financial entities  */
  byOwners?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**  Include only charges with those tags  */
  byTags?: InputMaybe<Array<Scalars['String']['input']>>;
  chargesType?: InputMaybe<ChargeFilterType>;
  /**  Include only charges with user description | transactions description / reference | documents description / remarks / serial that contains this text  */
  freeText?: InputMaybe<Scalars['String']['input']>;
  /**  Include only charges with any doc/transaction date occurred after this date  */
  fromAnyDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  /**  Include only charges with main date occurred after this date  */
  fromDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  sortBy?: InputMaybe<ChargeSortBy>;
  /**  Include only charges with any doc/transaction date occurred before this date  */
  toAnyDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  /**  Include only charges with main date  occurred before this date  */
  toDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  /**  Include only charges that are not balances  */
  unbalanced?: InputMaybe<Scalars['Boolean']['input']>;
  withOpenDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Include only charges that doesn't have documents linked  */
  withoutDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Include only charges that doesn't have invoice document linked  */
  withoutInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Include only charges that doesn't have ledger records linked  */
  withoutLedger?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Include only charges that doesn't have receipt document linked  */
  withoutReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Include only charges that doesn't have transactions linked  */
  withoutTransactions?: InputMaybe<Scalars['Boolean']['input']>;
};

/**  filter charges by type  */
export const ChargeFilterType = {
  All: 'ALL',
  Expense: 'EXPENSE',
  Income: 'INCOME'
} as const;

export type ChargeFilterType = typeof ChargeFilterType[keyof typeof ChargeFilterType];
/**  A single charge match with its confidence score  */
export type ChargeMatch = {
  __typename?: 'ChargeMatch';
  charge: Charge;
  /**  UUID of the matched charge  */
  chargeId: Scalars['UUID']['output'];
  /**  Confidence score between 0.00 and 1.00  */
  confidenceScore: Scalars['Float']['output'];
};

/**  Result of finding matches for a single charge  */
export type ChargeMatchesResult = {
  __typename?: 'ChargeMatchesResult';
  /**  Array of up to 5 matches, ordered by confidence score (highest first)  */
  matches: Array<ChargeMatch>;
};

/**  represent charge's metadata */
export type ChargeMetadata = {
  __typename?: 'ChargeMetadata';
  /**  when the initial charge was created from the first event we found  */
  createdAt: Scalars['DateTime']['output'];
  documentsCount: Scalars['Int']['output'];
  invalidLedger: LedgerValidationStatus;
  invoicesCount: Scalars['Int']['output'];
  isLedgerLocked: Scalars['Boolean']['output'];
  ledgerCount: Scalars['Int']['output'];
  miscExpensesCount: Scalars['Int']['output'];
  openDocuments: Scalars['Boolean']['output'];
  optionalBusinesses: Array<Scalars['String']['output']>;
  receiptsCount: Scalars['Int']['output'];
  transactionsCount: Scalars['Int']['output'];
  /**  when the charge was last updated  */
  updatedAt: Scalars['DateTime']['output'];
};

/**  input variables for sorting charges  */
export type ChargeSortBy = {
  asc?: InputMaybe<Scalars['Boolean']['input']>;
  field: ChargeSortByField;
};

/**  fields that can be used to sort charges  */
export const ChargeSortByField = {
  AbsAmount: 'ABS_AMOUNT',
  Amount: 'AMOUNT',
  Date: 'DATE'
} as const;

export type ChargeSortByField = typeof ChargeSortByField[keyof typeof ChargeSortByField];
/**  represent charge suggestions for missing info  */
export type ChargeSuggestions = {
  __typename?: 'ChargeSuggestions';
  description?: Maybe<Scalars['String']['output']>;
  tags: Array<Tag>;
};

/**  Charge type enum  */
export const ChargeType = {
  BankDeposit: 'BANK_DEPOSIT',
  BusinessTrip: 'BUSINESS_TRIP',
  Common: 'COMMON',
  Conversion: 'CONVERSION',
  CreditcardBank: 'CREDITCARD_BANK',
  Dividend: 'DIVIDEND',
  Financial: 'FINANCIAL',
  ForeignSecurities: 'FOREIGN_SECURITIES',
  Internal: 'INTERNAL',
  Payroll: 'PAYROLL',
  Vat: 'VAT'
} as const;

export type ChargeType = typeof ChargeType[keyof typeof ChargeType];
/**  result type for charges with ledger changes  */
export type ChargesWithLedgerChangesResult = {
  __typename?: 'ChargesWithLedgerChangesResult';
  charge?: Maybe<Charge>;
  progress: Scalars['Float']['output'];
};

/**  business extended with green invoice data  */
export type Client = {
  __typename?: 'Client';
  emails: Array<Scalars['String']['output']>;
  generatedDocumentType: DocumentType;
  id: Scalars['UUID']['output'];
  integrations: ClientIntegrations;
  originalBusiness: LtdFinancialEntity;
};

/**  fields for inserting a new client  */
export type ClientInsertInput = {
  businessId: Scalars['UUID']['input'];
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  generatedDocumentType: DocumentType;
  integrations?: InputMaybe<ClientIntegrationsInput>;
};

/**  integrations associated with a client  */
export type ClientIntegrations = {
  __typename?: 'ClientIntegrations';
  greenInvoiceInfo?: Maybe<GreenInvoiceClient>;
  hiveId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linearId?: Maybe<Scalars['String']['output']>;
  notionId?: Maybe<Scalars['String']['output']>;
  slackChannelKey?: Maybe<Scalars['String']['output']>;
  workflowyUrl?: Maybe<Scalars['String']['output']>;
};

/**  integrations input for client insert/update  */
export type ClientIntegrationsInput = {
  greenInvoiceId?: InputMaybe<Scalars['UUID']['input']>;
  hiveId?: InputMaybe<Scalars['String']['input']>;
  linearId?: InputMaybe<Scalars['String']['input']>;
  notionId?: InputMaybe<Scalars['String']['input']>;
  slackChannelKey?: InputMaybe<Scalars['String']['input']>;
  workflowyUrl?: InputMaybe<Scalars['String']['input']>;
};

/**  fields for updating an existing client  */
export type ClientUpdateInput = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  generatedDocumentType?: InputMaybe<DocumentType>;
  integrations?: InputMaybe<ClientIntegrationsInput>;
  newBusinessId?: InputMaybe<Scalars['UUID']['input']>;
};

/**  common charge  */
export type CommonCharge = Charge & {
  __typename?: 'CommonCharge';
  accountantApproval: AccountantStatus;
  additionalDocuments: Array<Document>;
  counterparty?: Maybe<FinancialEntity>;
  decreasedVAT?: Maybe<Scalars['Boolean']['output']>;
  /**  depreciation records  */
  depreciationRecords: Array<DepreciationRecord>;
  id: Scalars['UUID']['output'];
  isInvoicePaymentDifferentCurrency?: Maybe<Scalars['Boolean']['output']>;
  ledger: Ledger;
  metadata?: Maybe<ChargeMetadata>;
  minDebitDate?: Maybe<Scalars['DateTime']['output']>;
  minDocumentsDate?: Maybe<Scalars['DateTime']['output']>;
  minEventDate?: Maybe<Scalars['DateTime']['output']>;
  miscExpenses: Array<MiscExpense>;
  missingInfoSuggestions?: Maybe<ChargeSuggestions>;
  optionalDocuments?: Maybe<Scalars['Boolean']['output']>;
  optionalVAT?: Maybe<Scalars['Boolean']['output']>;
  owner: Business;
  property?: Maybe<Scalars['Boolean']['output']>;
  tags: Array<Tag>;
  taxCategory?: Maybe<TaxCategory>;
  totalAmount?: Maybe<FinancialAmount>;
  transactions: Array<Transaction>;
  userDescription?: Maybe<Scalars['String']['output']>;
  validationData?: Maybe<ValidationData>;
  vat?: Maybe<FinancialAmount>;
  withholdingTax?: Maybe<FinancialAmount>;
  yearsOfRelevance?: Maybe<Array<YearOfRelevance>>;
};

/**  common type of errors */
export type CommonError = Error & {
  __typename?: 'CommonError';
  message: Scalars['String']['output'];
};

/**  temp type until DB supports transactions differentiation  */
export type CommonTransaction = Transaction & {
  __typename?: 'CommonTransaction';
  account: FinancialAccount;
  amount: FinancialAmount;
  balance: FinancialAmount;
  chargeId: Scalars['UUID']['output'];
  counterparty?: Maybe<FinancialEntity>;
  createdAt: Scalars['DateTime']['output'];
  cryptoExchangeRate?: Maybe<ConversionRate>;
  debitExchangeRates?: Maybe<ExchangeRates>;
  direction: TransactionDirection;
  effectiveDate?: Maybe<Scalars['TimelessDate']['output']>;
  eventDate: Scalars['TimelessDate']['output'];
  eventExchangeRates?: Maybe<ExchangeRates>;
  exactEffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isFee?: Maybe<Scalars['Boolean']['output']>;
  missingInfoSuggestions?: Maybe<TransactionSuggestions>;
  referenceKey?: Maybe<Scalars['String']['output']>;
  sourceDescription: Scalars['String']['output'];
  sourceEffectiveDate?: Maybe<Scalars['TimelessDate']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/**  a client contract  */
export type Contract = {
  __typename?: 'Contract';
  amount: FinancialAmount;
  billingCycle: BillingCycle;
  client: Client;
  documentType: DocumentType;
  endDate: Scalars['TimelessDate']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  msCloud?: Maybe<Scalars['URL']['output']>;
  operationsLimit: Scalars['BigInt']['output'];
  plan?: Maybe<SubscriptionPlan>;
  product?: Maybe<Product>;
  purchaseOrders: Array<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['TimelessDate']['output'];
};

/**  charge with conversion transactions  */
export type ConversionCharge = Charge & {
  __typename?: 'ConversionCharge';
  accountantApproval: AccountantStatus;
  additionalDocuments: Array<Document>;
  counterparty?: Maybe<FinancialEntity>;
  decreasedVAT?: Maybe<Scalars['Boolean']['output']>;
  eventRate?: Maybe<ConversionRate>;
  id: Scalars['UUID']['output'];
  isInvoicePaymentDifferentCurrency?: Maybe<Scalars['Boolean']['output']>;
  ledger: Ledger;
  metadata?: Maybe<ChargeMetadata>;
  minDebitDate?: Maybe<Scalars['DateTime']['output']>;
  minDocumentsDate?: Maybe<Scalars['DateTime']['output']>;
  minEventDate?: Maybe<Scalars['DateTime']['output']>;
  miscExpenses: Array<MiscExpense>;
  missingInfoSuggestions?: Maybe<ChargeSuggestions>;
  officialRate?: Maybe<ConversionRate>;
  optionalDocuments?: Maybe<Scalars['Boolean']['output']>;
  optionalVAT?: Maybe<Scalars['Boolean']['output']>;
  owner: Business;
  property?: Maybe<Scalars['Boolean']['output']>;
  tags: Array<Tag>;
  taxCategory?: Maybe<TaxCategory>;
  totalAmount?: Maybe<FinancialAmount>;
  transactions: Array<Transaction>;
  userDescription?: Maybe<Scalars['String']['output']>;
  validationData?: Maybe<ValidationData>;
  vat?: Maybe<FinancialAmount>;
  withholdingTax?: Maybe<FinancialAmount>;
  yearsOfRelevance?: Maybe<Array<YearOfRelevance>>;
};

/**  represent exchange rate between two currencies  */
export type ConversionRate = {
  __typename?: 'ConversionRate';
  from: Currency;
  rate: Scalars['Float']['output'];
  to: Currency;
};

/**  המרה  */
export type ConversionTransaction = Transaction & {
  __typename?: 'ConversionTransaction';
  account: FinancialAccount;
  amount: FinancialAmount;
  balance: FinancialAmount;
  /**  המרה של הבנק  */
  bankRate: Scalars['Rate']['output'];
  chargeId: Scalars['UUID']['output'];
  counterparty?: Maybe<FinancialEntity>;
  createdAt: Scalars['DateTime']['output'];
  cryptoExchangeRate?: Maybe<ConversionRate>;
  debitExchangeRates?: Maybe<ExchangeRates>;
  direction: TransactionDirection;
  effectiveDate: Scalars['TimelessDate']['output'];
  eventDate: Scalars['TimelessDate']['output'];
  eventExchangeRates?: Maybe<ExchangeRates>;
  exactEffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isFee?: Maybe<Scalars['Boolean']['output']>;
  missingInfoSuggestions?: Maybe<TransactionSuggestions>;
  /**  בנק ישראל  */
  officialRateToLocal?: Maybe<Scalars['Rate']['output']>;
  referenceKey?: Maybe<Scalars['String']['output']>;
  sourceDescription: Scalars['String']['output'];
  sourceEffectiveDate?: Maybe<Scalars['TimelessDate']['output']>;
  type: ConversionTransactionType;
  updatedAt: Scalars['DateTime']['output'];
};

/**  Type pf conversion transaction  */
export const ConversionTransactionType = {
  /**  מכירה  */
  Base: 'BASE',
  /**  קניה  */
  Quote: 'QUOTE'
} as const;

export type ConversionTransactionType = typeof ConversionTransactionType[keyof typeof ConversionTransactionType];
/**  Corporate tax variables  */
export type CorporateTax = {
  __typename?: 'CorporateTax';
  corporateId: Scalars['UUID']['output'];
  date: Scalars['TimelessDate']['output'];
  id: Scalars['ID']['output'];
  taxRate: Scalars['Float']['output'];
};

/**  Corporate tax rule  */
export type CorporateTaxRule = {
  __typename?: 'CorporateTaxRule';
  id: Scalars['ID']['output'];
  isCompliant: Scalars['Boolean']['output'];
  percentage: CorporateTaxRulePercentage;
  rule: Scalars['String']['output'];
};

/**  Corporate tax rule percentage  */
export type CorporateTaxRulePercentage = {
  __typename?: 'CorporateTaxRulePercentage';
  formatted: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

/**  result type for corporateTaxReport  */
export type CorporateTaxRulingComplianceReport = {
  __typename?: 'CorporateTaxRulingComplianceReport';
  businessTripRndExpenses: FinancialAmount;
  differences: CorporateTaxRulingComplianceReportDifferences;
  foreignDevelopmentExpenses: FinancialAmount;
  foreignDevelopmentRelativeToRnd: CorporateTaxRule;
  id: Scalars['ID']['output'];
  localDevelopmentExpenses: FinancialAmount;
  localDevelopmentRelativeToRnd: CorporateTaxRule;
  researchAndDevelopmentExpenses: FinancialAmount;
  rndRelativeToIncome: CorporateTaxRule;
  totalIncome: FinancialAmount;
  year: Scalars['Int']['output'];
};

/**  Differences between the report info and the generated ledger suggested info  */
export type CorporateTaxRulingComplianceReportDifferences = {
  __typename?: 'CorporateTaxRulingComplianceReportDifferences';
  businessTripRndExpenses?: Maybe<FinancialAmount>;
  foreignDevelopmentExpenses?: Maybe<FinancialAmount>;
  foreignDevelopmentRelativeToRnd?: Maybe<CorporateTaxRule>;
  id: Scalars['ID']['output'];
  localDevelopmentExpenses?: Maybe<FinancialAmount>;
  localDevelopmentRelativeToRnd?: Maybe<CorporateTaxRule>;
  researchAndDevelopmentExpenses?: Maybe<FinancialAmount>;
  rndRelativeToIncome?: Maybe<CorporateTaxRule>;
  totalIncome?: Maybe<FinancialAmount>;
};

/**  a country  */
export type Country = {
  __typename?: 'Country';
  code: Scalars['CountryCode']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/**  Input type for creating a new admin business.  */
export type CreateAdminBusinessInput = {
  businessId: Scalars['UUID']['input'];
  companyTaxId: Scalars['String']['input'];
  registrationDate: Scalars['TimelessDate']['input'];
  socialSecurityEmployerId?: InputMaybe<Scalars['String']['input']>;
  taxAdvancesAnnualId?: InputMaybe<Scalars['String']['input']>;
  taxAdvancesRate?: InputMaybe<Scalars['Float']['input']>;
  withholdingTaxAnnualId?: InputMaybe<Scalars['String']['input']>;
};

/**  input for creating a new contract  */
export type CreateContractInput = {
  amount: FinancialAmountInput;
  billingCycle: BillingCycle;
  clientId: Scalars['UUID']['input'];
  deactivateContracts?: InputMaybe<Array<Scalars['UUID']['input']>>;
  documentType: DocumentType;
  endDate: Scalars['TimelessDate']['input'];
  isActive: Scalars['Boolean']['input'];
  msCloud?: InputMaybe<Scalars['URL']['input']>;
  operationsLimit?: InputMaybe<Scalars['BigInt']['input']>;
  plan?: InputMaybe<SubscriptionPlan>;
  product?: InputMaybe<Product>;
  purchaseOrders: Array<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['TimelessDate']['input'];
};

/**  input type for creating a financial account  */
export type CreateFinancialAccountInput = {
  bankAccountDetails?: InputMaybe<BankAccountInsertInput>;
  currencies?: InputMaybe<Array<FinancialAccountCurrencyInput>>;
  name: Scalars['String']['input'];
  number: Scalars['String']['input'];
  ownerId: Scalars['UUID']['input'];
  privateOrBusiness: PrivateOrBusinessType;
  type: FinancialAccountType;
};

/**  Credit invoice document - חשבונית זיכוי  */
export type CreditInvoice = Document & FinancialDocument & Linkable & {
  __typename?: 'CreditInvoice';
  allocationNumber?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<FinancialAmount>;
  charge?: Maybe<Charge>;
  creditor?: Maybe<FinancialEntity>;
  date?: Maybe<Scalars['TimelessDate']['output']>;
  debtor?: Maybe<FinancialEntity>;
  description?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<DocumentType>;
  exchangeRateOverride?: Maybe<Scalars['Float']['output']>;
  file?: Maybe<Scalars['URL']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Scalars['URL']['output']>;
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  issuedDocumentInfo?: Maybe<IssuedDocumentInfo>;
  missingInfoSuggestions?: Maybe<DocumentSuggestions>;
  noVatAmount?: Maybe<Scalars['Float']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<FinancialAmount>;
  vatReportDateOverride?: Maybe<Scalars['TimelessDate']['output']>;
};

/**  charge of creditcard over bank account  */
export type CreditcardBankCharge = Charge & {
  __typename?: 'CreditcardBankCharge';
  accountantApproval: AccountantStatus;
  additionalDocuments: Array<Document>;
  counterparty?: Maybe<FinancialEntity>;
  creditCardTransactions: Array<Transaction>;
  decreasedVAT?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  isInvoicePaymentDifferentCurrency?: Maybe<Scalars['Boolean']['output']>;
  ledger: Ledger;
  metadata?: Maybe<ChargeMetadata>;
  minDebitDate?: Maybe<Scalars['DateTime']['output']>;
  minDocumentsDate?: Maybe<Scalars['DateTime']['output']>;
  minEventDate?: Maybe<Scalars['DateTime']['output']>;
  miscExpenses: Array<MiscExpense>;
  missingInfoSuggestions?: Maybe<ChargeSuggestions>;
  optionalDocuments?: Maybe<Scalars['Boolean']['output']>;
  optionalVAT?: Maybe<Scalars['Boolean']['output']>;
  owner: Business;
  property?: Maybe<Scalars['Boolean']['output']>;
  tags: Array<Tag>;
  taxCategory?: Maybe<TaxCategory>;
  totalAmount?: Maybe<FinancialAmount>;
  transactions: Array<Transaction>;
  userDescription?: Maybe<Scalars['String']['output']>;
  validCreditCardAmount: Scalars['Boolean']['output'];
  validationData?: Maybe<ValidationData>;
  vat?: Maybe<FinancialAmount>;
  withholdingTax?: Maybe<FinancialAmount>;
  yearsOfRelevance?: Maybe<Array<YearOfRelevance>>;
};

/**  represent a single credit card  */
export type CryptoWalletFinancialAccount = FinancialAccount & {
  __typename?: 'CryptoWalletFinancialAccount';
  accountTaxCategories: Array<CurrencyTaxCategory>;
  charges: Array<Charge>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  /**  the external identifier of the wallet  */
  number: Scalars['String']['output'];
  privateOrBusiness: PrivateOrBusinessType;
  type: FinancialAccountType;
};


/**  represent a single credit card  */
export type CryptoWalletFinancialAccountChargesArgs = {
  filter?: InputMaybe<ChargeFilter>;
};

/**  All possible currencies  */
export const Currency = {
  /**  FIAT currencies  */
  Aud: 'AUD',
  Cad: 'CAD',
  /**  Crypto currencies  */
  Eth: 'ETH',
  Eur: 'EUR',
  Gbp: 'GBP',
  Grt: 'GRT',
  Ils: 'ILS',
  Jpy: 'JPY',
  Sek: 'SEK',
  Usd: 'USD',
  Usdc: 'USDC'
} as const;

export type Currency = typeof Currency[keyof typeof Currency];
/**  Input for daily currency exchange rates  */
export type CurrencyRateInput = {
  aud?: InputMaybe<Scalars['Float']['input']>;
  cad?: InputMaybe<Scalars['Float']['input']>;
  eur?: InputMaybe<Scalars['Float']['input']>;
  exchangeDate: Scalars['TimelessDate']['input'];
  gbp?: InputMaybe<Scalars['Float']['input']>;
  jpy?: InputMaybe<Scalars['Float']['input']>;
  sek?: InputMaybe<Scalars['Float']['input']>;
  usd?: InputMaybe<Scalars['Float']['input']>;
};

/**  extended type for currency tax category linked to financial account  */
export type CurrencyTaxCategory = {
  __typename?: 'CurrencyTaxCategory';
  currency: Currency;
  id: Scalars['ID']['output'];
  taxCategory: TaxCategory;
};

/**  Currency reporting type enum (דיווח מטבע)  */
export const CurrencyType = {
  /** Amounts in dollars (הסכומים בדולרים) */
  Dollars: 'DOLLARS',
  /** Amounts in shekels (הסכומים בשקלים) */
  Shekels: 'SHEKELS'
} as const;

export type CurrencyType = typeof CurrencyType[keyof typeof CurrencyType];
/**  a date range  */
export type DateRange = {
  __typename?: 'DateRange';
  end: Scalars['TimelessDate']['output'];
  start: Scalars['TimelessDate']['output'];
};

/**  the input for removing a business trip attendee  */
export type DeleteBusinessTripAttendeeInput = {
  attendeeId: Scalars['UUID']['input'];
  businessTripId: Scalars['UUID']['input'];
};

/** Result of a delete-credentials mutation — either a confirmation or an error */
export type DeleteProviderCredentialsResult = CommonError | ProviderCredentialDeleteResult;

/**  represent a category of depreciation  */
export type DepreciationCategory = {
  __typename?: 'DepreciationCategory';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

/**  Depreciation report record core fields  */
export type DepreciationCoreRecord = {
  id: Scalars['ID']['output'];
  netValue: Scalars['Int']['output'];
  originalCost?: Maybe<Scalars['Int']['output']>;
  pastYearsAccumulatedDepreciation: Scalars['Int']['output'];
  reportYearClaimedDepreciation: Scalars['Int']['output'];
  reportYearDelta?: Maybe<Scalars['Int']['output']>;
  totalDepreciableCosts: Scalars['Int']['output'];
  totalDepreciation: Scalars['Int']['output'];
};

/**  represent a depreciation record for a charge */
export type DepreciationRecord = {
  __typename?: 'DepreciationRecord';
  activationDate: Scalars['TimelessDate']['output'];
  amount: FinancialAmount;
  category: DepreciationCategory;
  charge: Charge;
  chargeId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  type?: Maybe<DepreciationType>;
};

/**  Depreciation report category group  */
export type DepreciationReportCategory = {
  __typename?: 'DepreciationReportCategory';
  category: DepreciationCategory;
  id: Scalars['ID']['output'];
  records: Array<DepreciationReportRecord>;
  summary: DepreciationReportSummaryRecord;
};

/**  input variables for depreciationReport  */
export type DepreciationReportFilter = {
  financialEntityId?: InputMaybe<Scalars['UUID']['input']>;
  year: Scalars['Int']['input'];
};

/**  Depreciation report record  */
export type DepreciationReportRecord = DepreciationCoreRecord & {
  __typename?: 'DepreciationReportRecord';
  activationDate?: Maybe<Scalars['TimelessDate']['output']>;
  chargeId: Scalars['UUID']['output'];
  claimedDepreciationRate?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  netValue: Scalars['Int']['output'];
  originalCost?: Maybe<Scalars['Int']['output']>;
  pastYearsAccumulatedDepreciation: Scalars['Int']['output'];
  purchaseDate: Scalars['TimelessDate']['output'];
  reportYearClaimedDepreciation: Scalars['Int']['output'];
  reportYearDelta?: Maybe<Scalars['Int']['output']>;
  statutoryDepreciationRate: Scalars['Float']['output'];
  totalDepreciableCosts: Scalars['Int']['output'];
  totalDepreciation: Scalars['Int']['output'];
};

/**  depreciation report result  */
export type DepreciationReportResult = {
  __typename?: 'DepreciationReportResult';
  categories: Array<DepreciationReportCategory>;
  id: Scalars['ID']['output'];
  summary: DepreciationReportSummaryRecord;
  year: Scalars['Int']['output'];
};

/**  Depreciation report summary record  */
export type DepreciationReportSummaryRecord = DepreciationCoreRecord & {
  __typename?: 'DepreciationReportSummaryRecord';
  id: Scalars['ID']['output'];
  netValue: Scalars['Int']['output'];
  originalCost?: Maybe<Scalars['Int']['output']>;
  pastYearsAccumulatedDepreciation: Scalars['Int']['output'];
  reportYearClaimedDepreciation: Scalars['Int']['output'];
  reportYearDelta?: Maybe<Scalars['Int']['output']>;
  totalDepreciableCosts: Scalars['Int']['output'];
  totalDepreciation: Scalars['Int']['output'];
};

/**  depreciation type  */
export const DepreciationType = {
  GeneralAndManagement: 'GENERAL_AND_MANAGEMENT',
  Marketing: 'MARKETING',
  ResearchAndDevelopment: 'RESEARCH_AND_DEVELOPMENT'
} as const;

export type DepreciationType = typeof DepreciationType[keyof typeof DepreciationType];
/**  Input for a Discount Bank account transaction  */
export type DiscountTransactionInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  balanceAfterOperation?: InputMaybe<Scalars['String']['input']>;
  branchTreasuryNumber?: InputMaybe<Scalars['String']['input']>;
  businessDayDate?: InputMaybe<Scalars['String']['input']>;
  categoryCode?: InputMaybe<Scalars['Int']['input']>;
  categoryDescCode?: InputMaybe<Scalars['Int']['input']>;
  categoryDescription?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  channelName?: InputMaybe<Scalars['String']['input']>;
  checkNumber?: InputMaybe<Scalars['Int']['input']>;
  commissionChannelCode?: InputMaybe<Scalars['String']['input']>;
  commissionChannelName?: InputMaybe<Scalars['String']['input']>;
  commissionTypeName?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  instituteCode?: InputMaybe<Scalars['String']['input']>;
  isLastSeen?: InputMaybe<Scalars['Boolean']['input']>;
  operationAmount?: InputMaybe<Scalars['String']['input']>;
  operationBank?: InputMaybe<Scalars['Int']['input']>;
  operationBranch?: InputMaybe<Scalars['Int']['input']>;
  operationCode?: InputMaybe<Scalars['String']['input']>;
  operationDate?: InputMaybe<Scalars['String']['input']>;
  operationDescription?: InputMaybe<Scalars['String']['input']>;
  operationDescription2?: InputMaybe<Scalars['String']['input']>;
  operationDescription3?: InputMaybe<Scalars['String']['input']>;
  operationDescriptionToDisplay?: InputMaybe<Scalars['String']['input']>;
  operationDetailsServiceName?: InputMaybe<Scalars['String']['input']>;
  operationNumber?: InputMaybe<Scalars['Int']['input']>;
  operationOrder?: InputMaybe<Scalars['Int']['input']>;
  urn?: InputMaybe<Scalars['String']['input']>;
  valueDate?: InputMaybe<Scalars['String']['input']>;
};

/**  charge of dividends  */
export type DividendCharge = Charge & {
  __typename?: 'DividendCharge';
  accountantApproval: AccountantStatus;
  additionalDocuments: Array<Document>;
  counterparty?: Maybe<FinancialEntity>;
  decreasedVAT?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  isInvoicePaymentDifferentCurrency?: Maybe<Scalars['Boolean']['output']>;
  ledger: Ledger;
  metadata?: Maybe<ChargeMetadata>;
  minDebitDate?: Maybe<Scalars['DateTime']['output']>;
  minDocumentsDate?: Maybe<Scalars['DateTime']['output']>;
  minEventDate?: Maybe<Scalars['DateTime']['output']>;
  miscExpenses: Array<MiscExpense>;
  missingInfoSuggestions?: Maybe<ChargeSuggestions>;
  optionalDocuments?: Maybe<Scalars['Boolean']['output']>;
  optionalVAT?: Maybe<Scalars['Boolean']['output']>;
  owner: Business;
  property?: Maybe<Scalars['Boolean']['output']>;
  tags: Array<Tag>;
  taxCategory?: Maybe<TaxCategory>;
  totalAmount?: Maybe<FinancialAmount>;
  transactions: Array<Transaction>;
  userDescription?: Maybe<Scalars['String']['output']>;
  validationData?: Maybe<ValidationData>;
  vat?: Maybe<FinancialAmount>;
  withholdingTax?: Maybe<FinancialAmount>;
  yearsOfRelevance?: Maybe<Array<YearOfRelevance>>;
};

/**  represent a generic document with identifier and a URL  */
export type Document = {
  charge?: Maybe<Charge>;
  description?: Maybe<Scalars['String']['output']>;
  /**  the specific type of the document */
  documentType?: Maybe<DocumentType>;
  /**  link to original file gmail, pdf  */
  file?: Maybe<Scalars['URL']['output']>;
  id: Scalars['UUID']['output'];
  /**  previewable image  */
  image?: Maybe<Scalars['URL']['output']>;
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
};

/**  client input  */
export type DocumentClientInput = {
  add?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['CountryCode']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  fax?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  self?: InputMaybe<Scalars['Boolean']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/**  document discount info  */
export type DocumentDiscount = {
  __typename?: 'DocumentDiscount';
  amount: Scalars['Float']['output'];
  type: DocumentDiscountType;
};

/**  discount input  */
export type DocumentDiscountInput = {
  amount: Scalars['Float']['input'];
  type: DocumentDiscountType;
};

/**  discount type enum  */
export const DocumentDiscountType = {
  Percentage: 'PERCENTAGE',
  Sum: 'SUM'
} as const;

export type DocumentDiscountType = typeof DocumentDiscountType[keyof typeof DocumentDiscountType];
/**  for previewing/issuing document  */
export type DocumentDraft = {
  __typename?: 'DocumentDraft';
  client?: Maybe<Client>;
  currency: Currency;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<DocumentDiscount>;
  dueDate?: Maybe<Scalars['String']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  income?: Maybe<Array<DocumentIncomeRecord>>;
  language: DocumentLanguage;
  linkType?: Maybe<DocumentLinkType>;
  linkedDocumentIds?: Maybe<Array<Scalars['String']['output']>>;
  linkedPaymentId?: Maybe<Scalars['String']['output']>;
  maxPayments?: Maybe<Scalars['Int']['output']>;
  payment?: Maybe<Array<DocumentPaymentRecord>>;
  remarks?: Maybe<Scalars['String']['output']>;
  rounding?: Maybe<Scalars['Boolean']['output']>;
  signed?: Maybe<Scalars['Boolean']['output']>;
  type: DocumentType;
  vatType: DocumentVatType;
};

/**  income info  */
export type DocumentIncomeRecord = {
  __typename?: 'DocumentIncomeRecord';
  currency: Currency;
  currencyRate?: Maybe<Scalars['Float']['output']>;
  description: Scalars['String']['output'];
  itemId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  vatRate?: Maybe<Scalars['Float']['output']>;
  vatType: DocumentVatType;
};

/**  income input  */
export type DocumentIncomeRecordInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountTotal?: InputMaybe<Scalars['Float']['input']>;
  catalogNum?: InputMaybe<Scalars['String']['input']>;
  currency: Currency;
  currencyRate?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  itemId?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
  vat?: InputMaybe<Scalars['Float']['input']>;
  vatRate?: InputMaybe<Scalars['Float']['input']>;
  vatType: DocumentVatType;
};

/**  input for issuing or previewing document  */
export type DocumentIssueInput = {
  client?: InputMaybe<DocumentClientInput>;
  currency: Currency;
  date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<DocumentDiscountInput>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  income?: InputMaybe<Array<DocumentIncomeRecordInput>>;
  language: DocumentLanguage;
  linkType?: InputMaybe<DocumentLinkType>;
  linkedDocumentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  linkedPaymentId?: InputMaybe<Scalars['String']['input']>;
  maxPayments?: InputMaybe<Scalars['Int']['input']>;
  payment?: InputMaybe<Array<DocumentPaymentRecordInput>>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  rounding?: InputMaybe<Scalars['Boolean']['input']>;
  signed?: InputMaybe<Scalars['Boolean']['input']>;
  type: DocumentType;
  vatType: DocumentVatType;
};

/**  document language enum  */
export const DocumentLanguage = {
  English: 'ENGLISH',
  Hebrew: 'HEBREW'
} as const;

export type DocumentLanguage = typeof DocumentLanguage[keyof typeof DocumentLanguage];
/**  link type enum  */
export const DocumentLinkType = {
  Cancel: 'CANCEL',
  Link: 'LINK'
} as const;

export type DocumentLinkType = typeof DocumentLinkType[keyof typeof DocumentLinkType];
/**  payment info  */
export type DocumentPaymentRecord = {
  __typename?: 'DocumentPaymentRecord';
  accountId?: Maybe<Scalars['String']['output']>;
  bankAccount?: Maybe<Scalars['String']['output']>;
  bankBranch?: Maybe<Scalars['String']['output']>;
  /**  subType: GreenInvoicePaymentSubType  */
  bankName?: Maybe<Scalars['String']['output']>;
  cardNum?: Maybe<Scalars['String']['output']>;
  /**  appType: GreenInvoicePaymentAppType  */
  cardType?: Maybe<DocumentPaymentRecordCardType>;
  chequeNum?: Maybe<Scalars['String']['output']>;
  currency: Currency;
  currencyRate?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  firstPayment?: Maybe<Scalars['Float']['output']>;
  /**  dealType: GreenInvoicePaymentDealType  */
  numPayments?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Float']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
  type: PaymentType;
};

/**  card type enum  */
export const DocumentPaymentRecordCardType = {
  AmericanExpress: 'AMERICAN_EXPRESS',
  Diners: 'DINERS',
  Isracard: 'ISRACARD',
  Mastercard: 'MASTERCARD',
  Unknown: 'UNKNOWN',
  Visa: 'VISA'
} as const;

export type DocumentPaymentRecordCardType = typeof DocumentPaymentRecordCardType[keyof typeof DocumentPaymentRecordCardType];
/**  payment input  */
export type DocumentPaymentRecordInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankBranch?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  cardNum?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<DocumentPaymentRecordCardType>;
  chequeNum?: InputMaybe<Scalars['String']['input']>;
  currency: Currency;
  currencyRate?: InputMaybe<Scalars['Float']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  firstPayment?: InputMaybe<Scalars['Float']['input']>;
  numPayments?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  transactionId?: InputMaybe<Scalars['String']['input']>;
  type: PaymentType;
};

/**  Document status  */
export const DocumentStatus = {
  Cancelled: 'CANCELLED',
  CancelledByOtherDoc: 'CANCELLED_BY_OTHER_DOC',
  Closed: 'CLOSED',
  ManuallyClosed: 'MANUALLY_CLOSED',
  Open: 'OPEN'
} as const;

export type DocumentStatus = typeof DocumentStatus[keyof typeof DocumentStatus];
/**  represent document suggestions for missing info  */
export type DocumentSuggestions = {
  __typename?: 'DocumentSuggestions';
  /**  The document amount  */
  amount?: Maybe<FinancialAmount>;
  /**  The counter-side of the document (opposite to it's owner)  */
  counterparty?: Maybe<FinancialEntity>;
  /**  The document direction (income or expense)  */
  isIncome?: Maybe<Scalars['Boolean']['output']>;
  /**  The owner of the document  */
  owner?: Maybe<FinancialEntity>;
};

/**  All possible document types  */
export const DocumentType = {
  CreditInvoice: 'CREDIT_INVOICE',
  Invoice: 'INVOICE',
  InvoiceReceipt: 'INVOICE_RECEIPT',
  Other: 'OTHER',
  Proforma: 'PROFORMA',
  Receipt: 'RECEIPT',
  Unprocessed: 'UNPROCESSED'
} as const;

export type DocumentType = typeof DocumentType[keyof typeof DocumentType];
/**  VAT type enum  */
export const DocumentVatType = {
  Default: 'DEFAULT',
  Exempt: 'EXEMPT',
  Mixed: 'MIXED'
} as const;

export type DocumentVatType = typeof DocumentVatType[keyof typeof DocumentVatType];
/**  input variables for documents filtering  */
export type DocumentsFilters = {
  businessIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  fromDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  ownerIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  toDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  /**  Include only documents without matching transactions  */
  unmatched?: InputMaybe<Scalars['Boolean']['input']>;
};

/**  dynamic report data  */
export type DynamicReportInfo = {
  __typename?: 'DynamicReportInfo';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isLocked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  template: Array<DynamicReportNode>;
  updated: Scalars['DateTime']['output'];
};

/**  a single node of dynamic report template  */
export type DynamicReportNode = {
  __typename?: 'DynamicReportNode';
  data: DynamicReportNodeData;
  droppable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  parent: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/**  data of a single node of dynamic report template  */
export type DynamicReportNodeData = {
  __typename?: 'DynamicReportNodeData';
  hebrewText?: Maybe<Scalars['String']['output']>;
  isOpen: Scalars['Boolean']['output'];
  nodeType: Scalars['String']['output'];
};

/**  types of email attachments that can be parsed  */
export const EmailAttachmentType = {
  Jpeg: 'JPEG',
  Pdf: 'PDF',
  Png: 'PNG'
} as const;

export type EmailAttachmentType = typeof EmailAttachmentType[keyof typeof EmailAttachmentType];
/**  represent employee record */
export type Employee = {
  __typename?: 'Employee';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

/**  basic structure of error  */
export type Error = {
  message: Scalars['String']['output'];
};

/**  represent a financial amount in a specific currency  */
export type ExchangeRates = {
  __typename?: 'ExchangeRates';
  /**  fiat currencies  */
  aud?: Maybe<Scalars['Float']['output']>;
  cad?: Maybe<Scalars['Float']['output']>;
  date: Scalars['TimelessDate']['output'];
  /**  crypto currencies  */
  eth?: Maybe<Scalars['Float']['output']>;
  eur?: Maybe<Scalars['Float']['output']>;
  gbp?: Maybe<Scalars['Float']['output']>;
  grt?: Maybe<Scalars['Float']['output']>;
  ils?: Maybe<Scalars['Float']['output']>;
  jpy?: Maybe<Scalars['Float']['output']>;
  sek?: Maybe<Scalars['Float']['output']>;
  usd?: Maybe<Scalars['Float']['output']>;
  usdc?: Maybe<Scalars['Float']['output']>;
};

/**  Represent something external that we scrape, like bank or card  */
export type FinancialAccount = {
  /**  account's tax categories per currency  */
  accountTaxCategories: Array<CurrencyTaxCategory>;
  charges: Array<Charge>;
  id: Scalars['UUID']['output'];
  /**  the name of the account */
  name: Scalars['String']['output'];
  /**  Account number  */
  number: Scalars['String']['output'];
  /**  indicates if the account is private or business  */
  privateOrBusiness: PrivateOrBusinessType;
  /**  the general type of the account */
  type: FinancialAccountType;
};


/**  Represent something external that we scrape, like bank or card  */
export type FinancialAccountChargesArgs = {
  filter?: InputMaybe<ChargeFilter>;
};

/**  input type for financial account currency and tax category  */
export type FinancialAccountCurrencyInput = {
  currency: Currency;
  taxCategoryId: Scalars['UUID']['input'];
};

/**  general types of financial accounts  */
export const FinancialAccountType = {
  BankAccount: 'BANK_ACCOUNT',
  BankDepositAccount: 'BANK_DEPOSIT_ACCOUNT',
  CreditCard: 'CREDIT_CARD',
  CryptoWallet: 'CRYPTO_WALLET',
  ForeignSecurities: 'FOREIGN_SECURITIES'
} as const;

export type FinancialAccountType = typeof FinancialAccountType[keyof typeof FinancialAccountType];
/**  Represent financial amount  */
export type FinancialAmount = {
  __typename?: 'FinancialAmount';
  /**  currency of the amount  */
  currency: Currency;
  /**  formatted value with the currency symbol, like: 10$  */
  formatted: Scalars['String']['output'];
  /**  the raw amount, for example: 19.99  */
  raw: Scalars['Float']['output'];
};

/**  input variables for updateCharge.FinancialAmount */
export type FinancialAmountInput = {
  currency: Currency;
  raw: Scalars['Float']['input'];
};

/**  financial charge  */
export type FinancialCharge = Charge & {
  __typename?: 'FinancialCharge';
  accountantApproval: AccountantStatus;
  additionalDocuments: Array<Document>;
  counterparty?: Maybe<FinancialEntity>;
  decreasedVAT?: Maybe<Scalars['Boolean']['output']>;
  exchangeRates?: Maybe<ExchangeRates>;
  id: Scalars['UUID']['output'];
  isInvoicePaymentDifferentCurrency?: Maybe<Scalars['Boolean']['output']>;
  ledger: Ledger;
  metadata?: Maybe<ChargeMetadata>;
  minDebitDate?: Maybe<Scalars['DateTime']['output']>;
  minDocumentsDate?: Maybe<Scalars['DateTime']['output']>;
  minEventDate?: Maybe<Scalars['DateTime']['output']>;
  miscExpenses: Array<MiscExpense>;
  missingInfoSuggestions?: Maybe<ChargeSuggestions>;
  optionalDocuments?: Maybe<Scalars['Boolean']['output']>;
  optionalVAT?: Maybe<Scalars['Boolean']['output']>;
  owner: Business;
  property?: Maybe<Scalars['Boolean']['output']>;
  tags: Array<Tag>;
  taxCategory?: Maybe<TaxCategory>;
  totalAmount?: Maybe<FinancialAmount>;
  transactions: Array<Transaction>;
  type: ChargeType;
  userDescription?: Maybe<Scalars['String']['output']>;
  validationData?: Maybe<ValidationData>;
  vat?: Maybe<FinancialAmount>;
  withholdingTax?: Maybe<FinancialAmount>;
  yearsOfRelevance?: Maybe<Array<YearOfRelevance>>;
};

/**  result type for generateFinancialCharges  */
export type FinancialChargesGenerationResult = {
  __typename?: 'FinancialChargesGenerationResult';
  bankDepositsRevaluationCharge?: Maybe<FinancialCharge>;
  depreciationCharge?: Maybe<FinancialCharge>;
  id: Scalars['ID']['output'];
  recoveryReserveCharge?: Maybe<FinancialCharge>;
  revaluationCharge?: Maybe<FinancialCharge>;
  taxExpensesCharge?: Maybe<FinancialCharge>;
  vacationReserveCharge?: Maybe<FinancialCharge>;
};

/**  represent a financial document  */
export type FinancialDocument = {
  allocationNumber?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<FinancialAmount>;
  charge?: Maybe<Charge>;
  creditor?: Maybe<FinancialEntity>;
  date?: Maybe<Scalars['TimelessDate']['output']>;
  debtor?: Maybe<FinancialEntity>;
  description?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<DocumentType>;
  exchangeRateOverride?: Maybe<Scalars['Float']['output']>;
  file?: Maybe<Scalars['URL']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Scalars['URL']['output']>;
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  issuedDocumentInfo?: Maybe<IssuedDocumentInfo>;
  /**  missing info suggestions data  */
  missingInfoSuggestions?: Maybe<DocumentSuggestions>;
  noVatAmount?: Maybe<Scalars['Float']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<FinancialAmount>;
  vatReportDateOverride?: Maybe<Scalars['TimelessDate']['output']>;
};

/**  represent a financial entity of any type, including businesses, tax categories, etc.  */
export type FinancialEntity = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  irsCode?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sortCode?: Maybe<SortCode>;
  updatedAt: Scalars['DateTime']['output'];
};

/**  represent financial entity type  */
export const FinancialEntityType = {
  Business: 'BUSINESS',
  TaxCategory: 'TAX_CATEGORY'
} as const;

export type FinancialEntityType = typeof FinancialEntityType[keyof typeof FinancialEntityType];
/**  Represent financial rounded amount with Int values  */
export type FinancialIntAmount = {
  __typename?: 'FinancialIntAmount';
  /**  currency of the amount  */
  currency: Currency;
  /**  formatted value with the currency symbol, like: 10$  */
  formatted: Scalars['String']['output'];
  /**  the raw amount, for example: 19  */
  raw: Scalars['Int']['output'];
};

/**  result type for flagForeignFeeTransactions  */
export type FlagForeignFeeTransactionsResult = {
  __typename?: 'FlagForeignFeeTransactionsResult';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  transactions?: Maybe<Array<Transaction>>;
};

/**  represent flight classes  */
export const FlightClass = {
  Business: 'BUSINESS',
  Economy: 'ECONOMY',
  FirstClass: 'FIRST_CLASS',
  PremiumEconomy: 'PREMIUM_ECONOMY'
} as const;

export type FlightClass = typeof FlightClass[keyof typeof FlightClass];
/**  summary of foreign currency business transactions  */
export type ForeignCurrencySum = {
  __typename?: 'ForeignCurrencySum';
  credit: FinancialAmount;
  currency: Currency;
  debit: FinancialAmount;
  total: FinancialAmount;
};

/**  charge of foreign securities  */
export type ForeignSecuritiesCharge = Charge & {
  __typename?: 'ForeignSecuritiesCharge';
  accountantApproval: AccountantStatus;
  additionalDocuments: Array<Document>;
  counterparty?: Maybe<FinancialEntity>;
  decreasedVAT?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  isInvoicePaymentDifferentCurrency?: Maybe<Scalars['Boolean']['output']>;
  ledger: Ledger;
  metadata?: Maybe<ChargeMetadata>;
  minDebitDate?: Maybe<Scalars['DateTime']['output']>;
  minDocumentsDate?: Maybe<Scalars['DateTime']['output']>;
  minEventDate?: Maybe<Scalars['DateTime']['output']>;
  miscExpenses: Array<MiscExpense>;
  missingInfoSuggestions?: Maybe<ChargeSuggestions>;
  optionalDocuments?: Maybe<Scalars['Boolean']['output']>;
  optionalVAT?: Maybe<Scalars['Boolean']['output']>;
  owner: Business;
  property?: Maybe<Scalars['Boolean']['output']>;
  tags: Array<Tag>;
  taxCategory?: Maybe<TaxCategory>;
  totalAmount?: Maybe<FinancialAmount>;
  transactions: Array<Transaction>;
  userDescription?: Maybe<Scalars['String']['output']>;
  validationData?: Maybe<ValidationData>;
  vat?: Maybe<FinancialAmount>;
  withholdingTax?: Maybe<FinancialAmount>;
  yearsOfRelevance?: Maybe<Array<YearOfRelevance>>;
};

/**  represent a foreign securities account  */
export type ForeignSecuritiesFinancialAccount = FinancialAccount & {
  __typename?: 'ForeignSecuritiesFinancialAccount';
  accountTaxCategories: Array<CurrencyTaxCategory>;
  charges: Array<Charge>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  privateOrBusiness: PrivateOrBusinessType;
  type: FinancialAccountType;
};


/**  represent a foreign securities account  */
export type ForeignSecuritiesFinancialAccountChargesArgs = {
  filter?: InputMaybe<ChargeFilter>;
};

/**  fund entity prototype  */
export type Fund = {
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

/**  API key payload returned after generating a new API key  */
export type GenerateApiKeyPayload = {
  __typename?: 'GenerateApiKeyPayload';
  apiKey: Scalars['String']['output'];
  record: ApiKey;
};

/**  result type for generateDocuments */
export type GenerateDocumentsResult = {
  __typename?: 'GenerateDocumentsResult';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/**  result type for ledger records  */
export type GeneratedLedgerRecords = CommonError | Ledger;

/**  client info  */
export type GreenInvoiceClient = {
  __typename?: 'GreenInvoiceClient';
  add?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  businessId: Scalars['UUID']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  emails?: Maybe<Array<Scalars['String']['output']>>;
  fax?: Maybe<Scalars['String']['output']>;
  greenInvoiceId?: Maybe<Scalars['ID']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  self?: Maybe<Scalars['Boolean']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/**  IFRS reporting option enum (דווח בחלופה - יישום תקני חשבונאות)  */
export const IfrsReportingOption = {
  /** No IFRS implementation (במידה ואין יישום תקני חשבונאות) */
  None: 'NONE',
  /** Option 1 (חלופה 1) */
  Option_1: 'OPTION_1',
  /** Accounting adjustments for those who implemented Option 2 per directive 7/2010 (התאמות חשבונאיות למי שיישם את חלופה 2 בהוראת ביצוע 7/2010) */
  Option_2Adjustments: 'OPTION_2_ADJUSTMENTS',
  /** Accounting adjustments for those who implemented Option 3 per directive 7/2010 (התאמות חשבונאיות למי שיישם את חלופה 3 בהוראת ביצוע 7/2010) */
  Option_3Adjustments: 'OPTION_3_ADJUSTMENTS'
} as const;

export type IfrsReportingOption = typeof IfrsReportingOption[keyof typeof IfrsReportingOption];
/**  income chart information  */
export type IncomeExpenseChart = {
  __typename?: 'IncomeExpenseChart';
  currency: Currency;
  fromDate: Scalars['TimelessDate']['output'];
  monthlyData: Array<IncomeExpenseChartMonthData>;
  toDate: Scalars['TimelessDate']['output'];
};

/**  input variables for incomeExpenseChart filters  */
export type IncomeExpenseChartFilters = {
  currency?: InputMaybe<Currency>;
  fromDate: Scalars['TimelessDate']['input'];
  toDate: Scalars['TimelessDate']['input'];
};

/**  income chart month information  */
export type IncomeExpenseChartMonthData = {
  __typename?: 'IncomeExpenseChartMonthData';
  balance: FinancialAmount;
  date: Scalars['TimelessDate']['output'];
  expense: FinancialAmount;
  income: FinancialAmount;
};

/**  Business type enum (סוג עסק)  */
export const IndividualOrCompany = {
  /** Company (חברה) */
  Company: 'COMPANY',
  /** Individual (יחיד) */
  Individual: 'INDIVIDUAL'
} as const;

export type IndividualOrCompany = typeof IndividualOrCompany[keyof typeof IndividualOrCompany];
/**  the input for adding an attendee to a business trip  */
export type InsertBusinessTripAttendeeInput = {
  arrivalDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  attendeeId: Scalars['UUID']['input'];
  businessTripId: Scalars['UUID']['input'];
  departureDate?: InputMaybe<Scalars['TimelessDate']['input']>;
};

/**  the input for creating a business trip  */
export type InsertBusinessTripInput = {
  destinationCode?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  name: Scalars['String']['input'];
  toDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  tripPurpose?: InputMaybe<Scalars['String']['input']>;
};

/**  input variables for insertDepreciationCategory  */
export type InsertDepreciationCategoryInput = {
  name: Scalars['String']['input'];
  percentage: Scalars['Float']['input'];
};

/**  result type for insertDepreciationCategory  */
export type InsertDepreciationCategoryResult = CommonError | DepreciationCategory;

/**  input variables for insertDepreciationRecord  */
export type InsertDepreciationRecordInput = {
  activationDate: Scalars['TimelessDate']['input'];
  amount?: InputMaybe<Scalars['Float']['input']>;
  categoryId: Scalars['UUID']['input'];
  chargeId: Scalars['UUID']['input'];
  currency?: InputMaybe<Currency>;
  type?: InputMaybe<DepreciationType>;
};

/**  result type for insertDepreciationRecord  */
export type InsertDepreciationRecordResult = CommonError | DepreciationRecord;

/**  input variables for insertDocument  */
export type InsertDocumentInput = {
  allocationNumber?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<FinancialAmountInput>;
  chargeId?: InputMaybe<Scalars['UUID']['input']>;
  creditorId?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['TimelessDate']['input']>;
  debtorId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<DocumentType>;
  exchangeRateOverride?: InputMaybe<Scalars['Float']['input']>;
  file?: InputMaybe<Scalars['URL']['input']>;
  image?: InputMaybe<Scalars['URL']['input']>;
  noVatAmount?: InputMaybe<Scalars['Float']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<FinancialAmountInput>;
  vatReportDateOverride?: InputMaybe<Scalars['TimelessDate']['input']>;
};

/**  result type for insertDocument  */
export type InsertDocumentResult = CommonError | InsertDocumentSuccessfulResult;

/**  result type for insertDocument */
export type InsertDocumentSuccessfulResult = {
  __typename?: 'InsertDocumentSuccessfulResult';
  document?: Maybe<Document>;
};

/**  input variables for insertMiscExpense  */
export type InsertMiscExpenseInput = {
  amount: Scalars['Float']['input'];
  creditorId: Scalars['UUID']['input'];
  currency: Currency;
  debtorId: Scalars['UUID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  invoiceDate: Scalars['TimelessDate']['input'];
  valueDate: Scalars['DateTime']['input'];
};

/**  input for insertNewBusiness  */
export type InsertNewBusinessInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['CountryCode']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exemptDealer?: InputMaybe<Scalars['Boolean']['input']>;
  governmentId?: InputMaybe<Scalars['String']['input']>;
  hebrewName?: InputMaybe<Scalars['String']['input']>;
  irsCode?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDocumentsOptional?: InputMaybe<Scalars['Boolean']['input']>;
  isReceiptEnough?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  optionalVAT?: InputMaybe<Scalars['Boolean']['input']>;
  pcn874RecordType?: InputMaybe<Pcn874RecordType>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['Int']['input']>;
  suggestions?: InputMaybe<SuggestionsInput>;
  taxCategory?: InputMaybe<Scalars['UUID']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/**  result type for insertSalaryRecord  */
export type InsertSalaryRecordsResult = CommonError | InsertSalaryRecordsSuccessfulResult;

/**  result type for insertSalaryRecord */
export type InsertSalaryRecordsSuccessfulResult = {
  __typename?: 'InsertSalaryRecordsSuccessfulResult';
  salaryRecords: Array<Salary>;
};

/**  input for insertTaxCategory  */
export type InsertTaxCategoryInput = {
  hashavshevetName?: InputMaybe<Scalars['String']['input']>;
  irsCode?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sortCode?: InputMaybe<Scalars['Int']['input']>;
  taxExcluded?: InputMaybe<Scalars['Boolean']['input']>;
};

/**  Summary of a single inserted transaction row  */
export type InsertedTransactionSummary = {
  __typename?: 'InsertedTransactionSummary';
  account?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/**  charge of internal transfer  */
export type InternalTransferCharge = Charge & {
  __typename?: 'InternalTransferCharge';
  accountantApproval: AccountantStatus;
  additionalDocuments: Array<Document>;
  counterparty?: Maybe<FinancialEntity>;
  decreasedVAT?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  isInvoicePaymentDifferentCurrency?: Maybe<Scalars['Boolean']['output']>;
  ledger: Ledger;
  metadata?: Maybe<ChargeMetadata>;
  minDebitDate?: Maybe<Scalars['DateTime']['output']>;
  minDocumentsDate?: Maybe<Scalars['DateTime']['output']>;
  minEventDate?: Maybe<Scalars['DateTime']['output']>;
  miscExpenses: Array<MiscExpense>;
  missingInfoSuggestions?: Maybe<ChargeSuggestions>;
  optionalDocuments?: Maybe<Scalars['Boolean']['output']>;
  optionalVAT?: Maybe<Scalars['Boolean']['output']>;
  owner: Business;
  property?: Maybe<Scalars['Boolean']['output']>;
  tags: Array<Tag>;
  taxCategory?: Maybe<TaxCategory>;
  totalAmount?: Maybe<FinancialAmount>;
  transactions: Array<Transaction>;
  userDescription?: Maybe<Scalars['String']['output']>;
  validationData?: Maybe<ValidationData>;
  vat?: Maybe<FinancialAmount>;
  withholdingTax?: Maybe<FinancialAmount>;
  yearsOfRelevance?: Maybe<Array<YearOfRelevance>>;
};

/**  Invitation payload returned after creating an invitation  */
export type InvitationPayload = {
  __typename?: 'InvitationPayload';
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  roleId: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

/**  invoice document  */
export type Invoice = Document & FinancialDocument & Linkable & {
  __typename?: 'Invoice';
  allocationNumber?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<FinancialAmount>;
  charge?: Maybe<Charge>;
  creditor?: Maybe<FinancialEntity>;
  date?: Maybe<Scalars['TimelessDate']['output']>;
  debtor?: Maybe<FinancialEntity>;
  description?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<DocumentType>;
  exchangeRateOverride?: Maybe<Scalars['Float']['output']>;
  file?: Maybe<Scalars['URL']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Scalars['URL']['output']>;
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  issuedDocumentInfo?: Maybe<IssuedDocumentInfo>;
  missingInfoSuggestions?: Maybe<DocumentSuggestions>;
  noVatAmount?: Maybe<Scalars['Float']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<FinancialAmount>;
  vatReportDateOverride?: Maybe<Scalars['TimelessDate']['output']>;
};

/**  Invoice receipt document - חשבונית מס קבלה  */
export type InvoiceReceipt = Document & FinancialDocument & Linkable & {
  __typename?: 'InvoiceReceipt';
  allocationNumber?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<FinancialAmount>;
  charge?: Maybe<Charge>;
  creditor?: Maybe<FinancialEntity>;
  date?: Maybe<Scalars['TimelessDate']['output']>;
  debtor?: Maybe<FinancialEntity>;
  description?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<DocumentType>;
  exchangeRateOverride?: Maybe<Scalars['Float']['output']>;
  file?: Maybe<Scalars['URL']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Scalars['URL']['output']>;
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  issuedDocumentInfo?: Maybe<IssuedDocumentInfo>;
  missingInfoSuggestions?: Maybe<DocumentSuggestions>;
  noVatAmount?: Maybe<Scalars['Float']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<FinancialAmount>;
  vatReportDateOverride?: Maybe<Scalars['TimelessDate']['output']>;
};

/**  Input for an Isracard credit card transaction  */
export type IsracardTransactionInput = {
  adendum?: InputMaybe<Scalars['String']['input']>;
  card: Scalars['String']['input'];
  cardIndex: Scalars['Int']['input'];
  chargingDate?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clientIpAddress?: InputMaybe<Scalars['String']['input']>;
  currencyId?: InputMaybe<Scalars['String']['input']>;
  currentPaymentCurrency?: InputMaybe<Scalars['String']['input']>;
  dealSum?: InputMaybe<Scalars['String']['input']>;
  dealSumOutbound?: InputMaybe<Scalars['String']['input']>;
  dealSumType?: InputMaybe<Scalars['String']['input']>;
  dealsInbound?: InputMaybe<Scalars['String']['input']>;
  displayProperties?: InputMaybe<Scalars['String']['input']>;
  esbServicesCall?: InputMaybe<Scalars['String']['input']>;
  fullPaymentDate?: InputMaybe<Scalars['String']['input']>;
  fullPurchaseDate?: InputMaybe<Scalars['String']['input']>;
  fullPurchaseDateOutbound?: InputMaybe<Scalars['String']['input']>;
  fullSupplierNameHeb?: InputMaybe<Scalars['String']['input']>;
  fullSupplierNameOutbound?: InputMaybe<Scalars['String']['input']>;
  horaatKeva?: InputMaybe<Scalars['String']['input']>;
  isButton: Scalars['String']['input'];
  isCaptcha: Scalars['String']['input'];
  isError: Scalars['String']['input'];
  isHoraatKeva: Scalars['String']['input'];
  isShowDealsOutbound?: InputMaybe<Scalars['String']['input']>;
  isShowLinkForSupplierDetails?: InputMaybe<Scalars['String']['input']>;
  kodMatbeaMekori?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  moreInfo?: InputMaybe<Scalars['String']['input']>;
  paymentDate?: InputMaybe<Scalars['String']['input']>;
  paymentSum?: InputMaybe<Scalars['String']['input']>;
  paymentSumOutbound?: InputMaybe<Scalars['String']['input']>;
  paymentSumSign?: InputMaybe<Scalars['String']['input']>;
  purchaseDate?: InputMaybe<Scalars['String']['input']>;
  purchaseDateOutbound?: InputMaybe<Scalars['String']['input']>;
  returnCode?: InputMaybe<Scalars['String']['input']>;
  returnMessage?: InputMaybe<Scalars['String']['input']>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  solek?: InputMaybe<Scalars['String']['input']>;
  specificDate?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['Int']['input']>;
  supplierName?: InputMaybe<Scalars['String']['input']>;
  supplierNameOutbound?: InputMaybe<Scalars['String']['input']>;
  tablePageNum: Scalars['Boolean']['input'];
  voucherNumber?: InputMaybe<Scalars['Int']['input']>;
  voucherNumberRatz?: InputMaybe<Scalars['Int']['input']>;
  voucherNumberRatzOutbound?: InputMaybe<Scalars['Int']['input']>;
};

/**  Information about an issued document in the external system  */
export type IssuedDocumentInfo = {
  __typename?: 'IssuedDocumentInfo';
  /**  ID of the issued document in the external system  */
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  linkedDocuments?: Maybe<Array<FinancialDocument>>;
  originalDocument?: Maybe<DocumentDraft>;
  /**  Status of the issued document in the external system  */
  status: DocumentStatus;
};

/**  array of ledger records linked to the charge  */
export type Ledger = {
  __typename?: 'Ledger';
  balance?: Maybe<LedgerBalanceInfo>;
  records: Array<LedgerRecord>;
  validate: LedgerValidation;
};

/**  info about ledger total balance  */
export type LedgerBalanceInfo = {
  __typename?: 'LedgerBalanceInfo';
  isBalanced: Scalars['Boolean']['output'];
  unbalancedEntities: Array<LedgerBalanceUnbalancedEntity>;
};

/**  unbalanced entity over ledger records  */
export type LedgerBalanceUnbalancedEntity = {
  __typename?: 'LedgerBalanceUnbalancedEntity';
  balance: FinancialAmount;
  entity: FinancialEntity;
};

/**  represent atomic movement of funds  */
export type LedgerRecord = {
  __typename?: 'LedgerRecord';
  creditAccount1?: Maybe<FinancialEntity>;
  creditAccount2?: Maybe<FinancialEntity>;
  creditAmount1?: Maybe<FinancialAmount>;
  creditAmount2?: Maybe<FinancialAmount>;
  debitAccount1?: Maybe<FinancialEntity>;
  debitAccount2?: Maybe<FinancialEntity>;
  debitAmount1?: Maybe<FinancialAmount>;
  debitAmount2?: Maybe<FinancialAmount>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  localCurrencyCreditAmount1: FinancialAmount;
  localCurrencyCreditAmount2?: Maybe<FinancialAmount>;
  localCurrencyDebitAmount1: FinancialAmount;
  localCurrencyDebitAmount2?: Maybe<FinancialAmount>;
  reference?: Maybe<Scalars['String']['output']>;
  valueDate: Scalars['DateTime']['output'];
};

/**  ledger validation info */
export type LedgerValidation = {
  __typename?: 'LedgerValidation';
  differences: Array<LedgerRecord>;
  errors: Array<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
  matches: Array<Scalars['UUID']['output']>;
};

/**  represent charge's metadata ledger validation status  */
export const LedgerValidationStatus = {
  Diff: 'DIFF',
  Invalid: 'INVALID',
  Valid: 'VALID'
} as const;

export type LedgerValidationStatus = typeof LedgerValidationStatus[keyof typeof LedgerValidationStatus];
/**  represent a link to an external file  */
export type Linkable = {
  description?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['URL']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
};

/**  Financial entity, identifier by ID, can be a company or individual  */
export type LtdFinancialEntity = Business & FinancialEntity & {
  __typename?: 'LtdFinancialEntity';
  accounts: Array<FinancialAccount>;
  address?: Maybe<Scalars['String']['output']>;
  adminInfo?: Maybe<AdminBusiness>;
  charges: PaginatedCharges;
  city?: Maybe<Scalars['String']['output']>;
  clientInfo?: Maybe<Client>;
  country: Country;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  exemptDealer?: Maybe<Scalars['Boolean']['output']>;
  governmentId?: Maybe<Scalars['String']['output']>;
  hebrewName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  irsCode?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  isDocumentsOptional?: Maybe<Scalars['Boolean']['output']>;
  isReceiptEnough?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  optionalVAT?: Maybe<Scalars['Boolean']['output']>;
  pcn874RecordType?: Maybe<Pcn874RecordType>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  sortCode?: Maybe<SortCode>;
  suggestions?: Maybe<Suggestions>;
  taxCategory?: Maybe<TaxCategory>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


/**  Financial entity, identifier by ID, can be a company or individual  */
export type LtdFinancialEntityChargesArgs = {
  filter?: InputMaybe<ChargeFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/**  Input for a Max (formerly Leumi Card) credit card transaction  */
export type MaxTransactionInput = {
  actualPaymentAmount: Scalars['String']['input'];
  arn: Scalars['String']['input'];
  cardIndex: Scalars['Int']['input'];
  categoryId: Scalars['Int']['input'];
  comments: Scalars['String']['input'];
  dealDataAcq: Scalars['String']['input'];
  dealDataAdjustmentAmount?: InputMaybe<Scalars['String']['input']>;
  dealDataAdjustmentType: Scalars['String']['input'];
  dealDataAmount: Scalars['String']['input'];
  dealDataAmountIls: Scalars['String']['input'];
  dealDataAmountLeft: Scalars['String']['input'];
  dealDataArn: Scalars['String']['input'];
  dealDataAuthorizationNumber: Scalars['String']['input'];
  dealDataCardName?: InputMaybe<Scalars['String']['input']>;
  dealDataCardToken?: InputMaybe<Scalars['String']['input']>;
  dealDataCommissionVat: Scalars['String']['input'];
  dealDataDirectExchange?: InputMaybe<Scalars['String']['input']>;
  dealDataExchangeCommissionAmount?: InputMaybe<Scalars['String']['input']>;
  dealDataExchangeCommissionMaam?: InputMaybe<Scalars['String']['input']>;
  dealDataExchangeCommissionType?: InputMaybe<Scalars['String']['input']>;
  dealDataExchangeDirect: Scalars['String']['input'];
  dealDataExchangeRate: Scalars['String']['input'];
  dealDataIndexRateBase?: InputMaybe<Scalars['String']['input']>;
  dealDataIndexRatePmt?: InputMaybe<Scalars['String']['input']>;
  dealDataInterestAmount: Scalars['String']['input'];
  dealDataIsAllowedSpreadWithBenefit: Scalars['Boolean']['input'];
  dealDataIssuerCurrency: Scalars['String']['input'];
  dealDataIssuerExchangeRate?: InputMaybe<Scalars['String']['input']>;
  dealDataOriginalTerm?: InputMaybe<Scalars['String']['input']>;
  dealDataPercentMaam?: InputMaybe<Scalars['String']['input']>;
  dealDataPlan: Scalars['String']['input'];
  dealDataPosEntryEmv: Scalars['String']['input'];
  dealDataProcessingDate: Scalars['String']['input'];
  dealDataPurchaseAmount?: InputMaybe<Scalars['String']['input']>;
  dealDataPurchaseTime?: InputMaybe<Scalars['String']['input']>;
  dealDataRefNbr: Scalars['String']['input'];
  dealDataShowCancelDebit: Scalars['Boolean']['input'];
  dealDataShowSpread: Scalars['Boolean']['input'];
  dealDataShowSpreadBenefitButton: Scalars['Boolean']['input'];
  dealDataShowSpreadButton: Scalars['Boolean']['input'];
  dealDataShowSpreadForLeumi: Scalars['Boolean']['input'];
  dealDataTdmCardToken: Scalars['String']['input'];
  dealDataTdmTransactionType: Scalars['Int']['input'];
  dealDataTransactionType: Scalars['Int']['input'];
  dealDataTxnCode: Scalars['Int']['input'];
  dealDataUserName: Scalars['String']['input'];
  dealDataWithdrawalCommissionAmount?: InputMaybe<Scalars['String']['input']>;
  discountKeyAmount?: InputMaybe<Scalars['String']['input']>;
  discountKeyRecType?: InputMaybe<Scalars['String']['input']>;
  ethocaInd: Scalars['Boolean']['input'];
  fundsTransferComment?: InputMaybe<Scalars['String']['input']>;
  fundsTransferReceiverOrTransfer?: InputMaybe<Scalars['String']['input']>;
  isRegisterCh: Scalars['Boolean']['input'];
  isSpreadingAutorizationAllowed: Scalars['Boolean']['input'];
  issuerId: Scalars['Int']['input'];
  merchant: Scalars['String']['input'];
  merchantAddress?: InputMaybe<Scalars['String']['input']>;
  merchantCommercialName?: InputMaybe<Scalars['String']['input']>;
  merchantCoordinates?: InputMaybe<Scalars['String']['input']>;
  merchantMaxPhone: Scalars['Boolean']['input'];
  merchantName: Scalars['String']['input'];
  merchantNumber: Scalars['String']['input'];
  merchantPhone: Scalars['String']['input'];
  merchantTaxId: Scalars['String']['input'];
  originalAmount: Scalars['String']['input'];
  originalCurrency: Scalars['String']['input'];
  paymentCurrency?: InputMaybe<Scalars['Int']['input']>;
  paymentDate: Scalars['String']['input'];
  planName: Scalars['String']['input'];
  planTypeId: Scalars['Int']['input'];
  promotionAmount?: InputMaybe<Scalars['String']['input']>;
  promotionClub: Scalars['String']['input'];
  promotionType?: InputMaybe<Scalars['String']['input']>;
  purchaseDate: Scalars['String']['input'];
  receiptPDF?: InputMaybe<Scalars['String']['input']>;
  refIndex: Scalars['Int']['input'];
  runtimeReferenceId?: InputMaybe<Scalars['String']['input']>;
  runtimeReferenceInternalId: Scalars['String']['input'];
  runtimeReferenceType: Scalars['Int']['input'];
  shortCardNumber?: InputMaybe<Scalars['String']['input']>;
  spreadTransactionByCampainInd: Scalars['Boolean']['input'];
  spreadTransactionByCampainNumber?: InputMaybe<Scalars['Int']['input']>;
  tableType: Scalars['Int']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
  upSaleForTransactionResult?: InputMaybe<Scalars['String']['input']>;
  userIndex: Scalars['Int']['input'];
};

/**  result type for mergeCharge  */
export type MergeChargeResult = CommonError | MergeChargeSuccessfulResult;

/**  successful result type for mergeCharge  */
export type MergeChargeSuccessfulResult = {
  __typename?: 'MergeChargeSuccessfulResult';
  charge: Charge;
};

/**  result type for mergeChargesByTransactionReference  */
export type MergeChargesByTransactionReferenceResult = {
  __typename?: 'MergeChargesByTransactionReferenceResult';
  charges?: Maybe<Array<Charge>>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/**  A charge that was successfully merged during auto-match  */
export type MergedCharge = {
  __typename?: 'MergedCharge';
  /**  UUID of the deleted/merged-away charge  */
  chargeId: Scalars['UUID']['output'];
  /**  Confidence score that triggered the merge  */
  confidenceScore: Scalars['Float']['output'];
};

/**  a misc expense   */
export type MiscExpense = {
  __typename?: 'MiscExpense';
  amount: FinancialAmount;
  charge: Charge;
  chargeId: Scalars['UUID']['output'];
  creditor: FinancialEntity;
  debtor: FinancialEntity;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  invoiceDate: Scalars['TimelessDate']['output'];
  valueDate: Scalars['DateTime']['output'];
};

/**  represent a missing info attributes for a charge */
export const MissingChargeInfo = {
  Counterparty: 'COUNTERPARTY',
  Description: 'DESCRIPTION',
  Documents: 'DOCUMENTS',
  Tags: 'TAGS',
  TaxCategory: 'TAX_CATEGORY',
  Transactions: 'TRANSACTIONS',
  Vat: 'VAT'
} as const;

export type MissingChargeInfo = typeof MissingChargeInfo[keyof typeof MissingChargeInfo];
/**  charge of monthly VAT payment  */
export type MonthlyVatCharge = Charge & {
  __typename?: 'MonthlyVatCharge';
  accountantApproval: AccountantStatus;
  additionalDocuments: Array<Document>;
  counterparty?: Maybe<FinancialEntity>;
  decreasedVAT?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  isInvoicePaymentDifferentCurrency?: Maybe<Scalars['Boolean']['output']>;
  ledger: Ledger;
  metadata?: Maybe<ChargeMetadata>;
  minDebitDate?: Maybe<Scalars['DateTime']['output']>;
  minDocumentsDate?: Maybe<Scalars['DateTime']['output']>;
  minEventDate?: Maybe<Scalars['DateTime']['output']>;
  miscExpenses: Array<MiscExpense>;
  missingInfoSuggestions?: Maybe<ChargeSuggestions>;
  optionalDocuments?: Maybe<Scalars['Boolean']['output']>;
  optionalVAT?: Maybe<Scalars['Boolean']['output']>;
  owner: Business;
  property?: Maybe<Scalars['Boolean']['output']>;
  tags: Array<Tag>;
  taxCategory?: Maybe<TaxCategory>;
  totalAmount?: Maybe<FinancialAmount>;
  transactions: Array<Transaction>;
  userDescription?: Maybe<Scalars['String']['output']>;
  validationData?: Maybe<ValidationData>;
  vat?: Maybe<FinancialAmount>;
  withholdingTax?: Maybe<FinancialAmount>;
  yearsOfRelevance?: Maybe<Array<YearOfRelevance>>;
};

/**  mutation root  */
export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation: AcceptInvitationPayload;
  addBusinessTripAccommodationsExpense: Scalars['UUID']['output'];
  addBusinessTripCarRentalExpense: Scalars['UUID']['output'];
  addBusinessTripFlightsExpense: Scalars['UUID']['output'];
  addBusinessTripOtherExpense: Scalars['UUID']['output'];
  addBusinessTripTravelAndSubsistenceExpense: Scalars['UUID']['output'];
  addDeelContract: Scalars['Boolean']['output'];
  addSortCode: Scalars['Boolean']['output'];
  addTag: Scalars['Boolean']['output'];
  assignChargeToDeposit: BankDeposit;
  /**  Automatically match all unmatched charges above the confidence threshold  */
  autoMatchCharges: AutoMatchChargesResult;
  batchGenerateBusinessesOutOfTransactions: Array<Business>;
  batchUpdateCharges: BatchUpdateChargesResult;
  batchUploadDocuments: Array<UploadDocumentResult>;
  batchUploadDocumentsFromGoogleDrive: Array<UploadDocumentResult>;
  bootstrapNewClient: BootstrapClientResult;
  calculateCreditcardTransactionsDebitDate: Scalars['Boolean']['output'];
  categorizeBusinessTripExpense: Scalars['UUID']['output'];
  categorizeIntoExistingBusinessTripExpense: Scalars['UUID']['output'];
  closeDocument: Scalars['Boolean']['output'];
  createAdminBusiness: AdminBusiness;
  createContract: Contract;
  createDeposit: BankDeposit;
  createDepositFromCharge: BankDeposit;
  createFinancialAccount: FinancialAccount;
  createInvitation: InvitationPayload;
  creditShareholdersBusinessTripTravelAndSubsistence: Array<Scalars['UUID']['output']>;
  deleteAdminBusiness: Scalars['Boolean']['output'];
  deleteBusinessTripAttendee: Scalars['Boolean']['output'];
  deleteBusinessTripExpense: Scalars['Boolean']['output'];
  deleteCharge: Scalars['Boolean']['output'];
  deleteContract: Scalars['Boolean']['output'];
  deleteDepreciationCategory: Scalars['Boolean']['output'];
  deleteDepreciationRecord: Scalars['Boolean']['output'];
  deleteDocument: Scalars['Boolean']['output'];
  deleteDynamicReportTemplate: Scalars['String']['output'];
  deleteFinancialAccount: Scalars['Boolean']['output'];
  deleteMiscExpense: Scalars['Boolean']['output'];
  deleteProviderCredentials: DeleteProviderCredentialsResult;
  deleteTag: Scalars['Boolean']['output'];
  fetchDeelDocuments: Array<Charge>;
  flagForeignFeeTransactions: FlagForeignFeeTransactionsResult;
  generateApiKey: GenerateApiKeyPayload;
  generateBalanceCharge: FinancialCharge;
  generateBankDepositsRevaluationCharge: FinancialCharge;
  generateDepreciationCharge: FinancialCharge;
  generateFinancialCharges: FinancialChargesGenerationResult;
  generateRecoveryReserveCharge: FinancialCharge;
  generateRevaluationCharge: FinancialCharge;
  generateTaxExpensesCharge: FinancialCharge;
  generateVacationReserveCharge: FinancialCharge;
  insertBusinessTrip: Scalars['UUID']['output'];
  insertBusinessTripAttendee: Scalars['UUID']['output'];
  insertClient: UpdateClientResponse;
  insertDepreciationCategory: InsertDepreciationCategoryResult;
  insertDepreciationRecord: InsertDepreciationRecordResult;
  insertDocument: InsertDocumentResult;
  insertDynamicReportTemplate: DynamicReportInfo;
  insertEmailDocuments: Scalars['Boolean']['output'];
  insertMiscExpense: MiscExpense;
  insertMiscExpenses: Charge;
  insertNewBusiness: UpdateBusinessResponse;
  insertOrUpdateSalaryRecords: InsertSalaryRecordsResult;
  insertSalaryRecords: InsertSalaryRecordsResult;
  insertSalaryRecordsFromFile: Scalars['Boolean']['output'];
  insertTaxCategory: TaxCategory;
  issueGreenInvoiceDocument: Charge;
  issueGreenInvoiceDocuments: GenerateDocumentsResult;
  lockDynamicReportTemplate: DynamicReportInfo;
  lockLedgerRecords: Scalars['Boolean']['output'];
  mergeBusinesses: Business;
  mergeCharges: MergeChargeResult;
  mergeChargesByTransactionReference: MergeChargesByTransactionReferenceResult;
  pong?: Maybe<Scalars['Boolean']['output']>;
  previewDocument: Scalars['FileScalar']['output'];
  regenerateLedgerRecords: GeneratedLedgerRecords;
  revokeApiKey: Scalars['Boolean']['output'];
  setAnnualAuditStep03Status: AnnualAuditStepStatusInfo;
  setAnnualAuditStep09Status: AnnualAuditStepStatusInfo;
  setAnnualAuditStepStatus: AnnualAuditStepStatusInfo;
  setDeelCredentials: SetProviderCredentialsResult;
  setGreenInvoiceCredentials: SetProviderCredentialsResult;
  syncGreenInvoiceDocuments: Array<Document>;
  uncategorizePartialBusinessTripExpense: Scalars['Boolean']['output'];
  unlockDynamicReportTemplate: DynamicReportInfo;
  updateAdminBusiness: AdminBusiness;
  updateAdminContext: AdminContextInfo;
  updateBusiness: UpdateBusinessResponse;
  updateBusinessTrip: Scalars['UUID']['output'];
  updateBusinessTripAccommodationsExpense: Scalars['UUID']['output'];
  updateBusinessTripAccountantApproval: AccountantStatus;
  updateBusinessTripAttendee: Scalars['UUID']['output'];
  updateBusinessTripCarRentalExpense: Scalars['UUID']['output'];
  updateBusinessTripFlightsExpense: Scalars['UUID']['output'];
  updateBusinessTripOtherExpense: Scalars['UUID']['output'];
  updateBusinessTripTravelAndSubsistenceExpense: Scalars['UUID']['output'];
  updateCharge: UpdateChargeResult;
  updateChargeAccountantApproval: AccountantStatus;
  updateChargeBusinessTrip?: Maybe<Charge>;
  updateClient: UpdateClientResponse;
  updateContract: Contract;
  updateDeposit: BankDeposit;
  updateDepreciationCategory: UpdateDepreciationCategoryResult;
  updateDepreciationRecord: UpdateDepreciationRecordResult;
  updateDocument: UpdateDocumentResult;
  updateDynamicReportTemplate: DynamicReportInfo;
  updateDynamicReportTemplateName: DynamicReportInfo;
  updateFinancialAccount: FinancialAccount;
  updateMiscExpense: MiscExpense;
  updatePcn874: Scalars['Boolean']['output'];
  updateSalaryRecord: UpdateSalaryRecordResult;
  updateShaam6111: Scalars['Boolean']['output'];
  updateSortCode: Scalars['Boolean']['output'];
  updateTag: Scalars['Boolean']['output'];
  updateTagParent: Scalars['Boolean']['output'];
  updateTagPart: Scalars['Boolean']['output'];
  updateTaxCategory: UpdateTaxCategoryResponse;
  updateTransaction: UpdateTransactionResult;
  updateTransactions: UpdateTransactionsResult;
  uploadAmexTransactions: ScraperUploadResult;
  uploadCalTransactions: ScraperUploadResult;
  uploadCurrencyRates: ScraperUploadResult;
  uploadDiscountTransactions: ScraperUploadResult;
  uploadDocument: UploadDocumentResult;
  uploadIsracardTransactions: ScraperUploadResult;
  uploadMaxTransactions: ScraperUploadResult;
  uploadPoalimForeignTransactions: ScraperUploadResult;
  uploadPoalimIlsTransactions: ScraperUploadResult;
  uploadPoalimSwiftTransactions: ScraperUploadResult;
};


/**  mutation root  */
export type MutationAcceptInvitationArgs = {
  token: Scalars['String']['input'];
};


/**  mutation root  */
export type MutationAddBusinessTripAccommodationsExpenseArgs = {
  fields: AddBusinessTripAccommodationsExpenseInput;
};


/**  mutation root  */
export type MutationAddBusinessTripCarRentalExpenseArgs = {
  fields: AddBusinessTripCarRentalExpenseInput;
};


/**  mutation root  */
export type MutationAddBusinessTripFlightsExpenseArgs = {
  fields: AddBusinessTripFlightsExpenseInput;
};


/**  mutation root  */
export type MutationAddBusinessTripOtherExpenseArgs = {
  fields: AddBusinessTripOtherExpenseInput;
};


/**  mutation root  */
export type MutationAddBusinessTripTravelAndSubsistenceExpenseArgs = {
  fields: AddBusinessTripTravelAndSubsistenceExpenseInput;
};


/**  mutation root  */
export type MutationAddDeelContractArgs = {
  businessId: Scalars['UUID']['input'];
  contractId: Scalars['ID']['input'];
  contractStartDate: Scalars['TimelessDate']['input'];
  contractorId: Scalars['UUID']['input'];
  contractorName: Scalars['String']['input'];
};


/**  mutation root  */
export type MutationAddSortCodeArgs = {
  defaultIrsCode?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};


/**  mutation root  */
export type MutationAddTagArgs = {
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['UUID']['input']>;
};


/**  mutation root  */
export type MutationAssignChargeToDepositArgs = {
  chargeId: Scalars['UUID']['input'];
  depositId: Scalars['String']['input'];
};


/**  mutation root  */
export type MutationBatchUpdateChargesArgs = {
  chargeIds: Array<Scalars['UUID']['input']>;
  fields: UpdateChargeInput;
};


/**  mutation root  */
export type MutationBatchUploadDocumentsArgs = {
  chargeId?: InputMaybe<Scalars['UUID']['input']>;
  documents: Array<Scalars['FileScalar']['input']>;
  isSensitive?: InputMaybe<Scalars['Boolean']['input']>;
};


/**  mutation root  */
export type MutationBatchUploadDocumentsFromGoogleDriveArgs = {
  chargeId?: InputMaybe<Scalars['UUID']['input']>;
  isSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  sharedFolderUrl: Scalars['String']['input'];
};


/**  mutation root  */
export type MutationBootstrapNewClientArgs = {
  input: BootstrapClientInput;
};


/**  mutation root  */
export type MutationCategorizeBusinessTripExpenseArgs = {
  fields: CategorizeBusinessTripExpenseInput;
};


/**  mutation root  */
export type MutationCategorizeIntoExistingBusinessTripExpenseArgs = {
  fields: CategorizeIntoExistingBusinessTripExpenseInput;
};


/**  mutation root  */
export type MutationCloseDocumentArgs = {
  id: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationCreateAdminBusinessArgs = {
  input: CreateAdminBusinessInput;
};


/**  mutation root  */
export type MutationCreateContractArgs = {
  input: CreateContractInput;
};


/**  mutation root  */
export type MutationCreateDepositArgs = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  currency: Currency;
  name: Scalars['String']['input'];
  openDate: Scalars['TimelessDate']['input'];
};


/**  mutation root  */
export type MutationCreateDepositFromChargeArgs = {
  chargeId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};


/**  mutation root  */
export type MutationCreateFinancialAccountArgs = {
  input: CreateFinancialAccountInput;
};


/**  mutation root  */
export type MutationCreateInvitationArgs = {
  email: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
};


/**  mutation root  */
export type MutationCreditShareholdersBusinessTripTravelAndSubsistenceArgs = {
  businessTripId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationDeleteAdminBusinessArgs = {
  businessId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationDeleteBusinessTripAttendeeArgs = {
  fields: DeleteBusinessTripAttendeeInput;
};


/**  mutation root  */
export type MutationDeleteBusinessTripExpenseArgs = {
  businessTripExpenseId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationDeleteChargeArgs = {
  chargeId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationDeleteContractArgs = {
  id: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationDeleteDepreciationCategoryArgs = {
  depreciationCategoryId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationDeleteDepreciationRecordArgs = {
  depreciationRecordId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationDeleteDocumentArgs = {
  documentId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationDeleteDynamicReportTemplateArgs = {
  name: Scalars['String']['input'];
};


/**  mutation root  */
export type MutationDeleteFinancialAccountArgs = {
  id: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationDeleteMiscExpenseArgs = {
  id: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationDeleteProviderCredentialsArgs = {
  provider: ProviderKey;
};


/**  mutation root  */
export type MutationDeleteTagArgs = {
  id: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationGenerateApiKeyArgs = {
  name: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
};


/**  mutation root  */
export type MutationGenerateBalanceChargeArgs = {
  balanceRecords: Array<InsertMiscExpenseInput>;
  description: Scalars['String']['input'];
};


/**  mutation root  */
export type MutationGenerateBankDepositsRevaluationChargeArgs = {
  date: Scalars['TimelessDate']['input'];
  ownerId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationGenerateDepreciationChargeArgs = {
  ownerId: Scalars['UUID']['input'];
  year: Scalars['TimelessDate']['input'];
};


/**  mutation root  */
export type MutationGenerateFinancialChargesArgs = {
  date: Scalars['TimelessDate']['input'];
  ownerId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationGenerateRecoveryReserveChargeArgs = {
  ownerId: Scalars['UUID']['input'];
  year: Scalars['TimelessDate']['input'];
};


/**  mutation root  */
export type MutationGenerateRevaluationChargeArgs = {
  date: Scalars['TimelessDate']['input'];
  ownerId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationGenerateTaxExpensesChargeArgs = {
  ownerId: Scalars['UUID']['input'];
  year: Scalars['TimelessDate']['input'];
};


/**  mutation root  */
export type MutationGenerateVacationReserveChargeArgs = {
  ownerId: Scalars['UUID']['input'];
  year: Scalars['TimelessDate']['input'];
};


/**  mutation root  */
export type MutationInsertBusinessTripArgs = {
  fields: InsertBusinessTripInput;
};


/**  mutation root  */
export type MutationInsertBusinessTripAttendeeArgs = {
  fields: InsertBusinessTripAttendeeInput;
};


/**  mutation root  */
export type MutationInsertClientArgs = {
  fields: ClientInsertInput;
};


/**  mutation root  */
export type MutationInsertDepreciationCategoryArgs = {
  input: InsertDepreciationCategoryInput;
};


/**  mutation root  */
export type MutationInsertDepreciationRecordArgs = {
  input: InsertDepreciationRecordInput;
};


/**  mutation root  */
export type MutationInsertDocumentArgs = {
  record: InsertDocumentInput;
};


/**  mutation root  */
export type MutationInsertDynamicReportTemplateArgs = {
  name: Scalars['String']['input'];
  template: Scalars['String']['input'];
};


/**  mutation root  */
export type MutationInsertEmailDocumentsArgs = {
  businessId?: InputMaybe<Scalars['UUID']['input']>;
  documents: Array<Scalars['FileScalar']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  userDescription: Scalars['String']['input'];
};


/**  mutation root  */
export type MutationInsertMiscExpenseArgs = {
  chargeId: Scalars['UUID']['input'];
  fields: InsertMiscExpenseInput;
};


/**  mutation root  */
export type MutationInsertMiscExpensesArgs = {
  chargeId: Scalars['UUID']['input'];
  expenses: Array<InsertMiscExpenseInput>;
};


/**  mutation root  */
export type MutationInsertNewBusinessArgs = {
  fields: InsertNewBusinessInput;
};


/**  mutation root  */
export type MutationInsertOrUpdateSalaryRecordsArgs = {
  salaryRecords: Array<SalaryRecordInput>;
};


/**  mutation root  */
export type MutationInsertSalaryRecordsArgs = {
  salaryRecords: Array<SalaryRecordInput>;
};


/**  mutation root  */
export type MutationInsertSalaryRecordsFromFileArgs = {
  chargeId: Scalars['UUID']['input'];
  file: Scalars['FileScalar']['input'];
};


/**  mutation root  */
export type MutationInsertTaxCategoryArgs = {
  fields: InsertTaxCategoryInput;
};


/**  mutation root  */
export type MutationIssueGreenInvoiceDocumentArgs = {
  attachment?: InputMaybe<Scalars['Boolean']['input']>;
  chargeId?: InputMaybe<Scalars['UUID']['input']>;
  emailContent?: InputMaybe<Scalars['String']['input']>;
  input: DocumentIssueInput;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
};


/**  mutation root  */
export type MutationIssueGreenInvoiceDocumentsArgs = {
  generateDocumentsInfo: Array<DocumentIssueInput>;
};


/**  mutation root  */
export type MutationLockDynamicReportTemplateArgs = {
  name: Scalars['String']['input'];
};


/**  mutation root  */
export type MutationLockLedgerRecordsArgs = {
  date: Scalars['TimelessDate']['input'];
};


/**  mutation root  */
export type MutationMergeBusinessesArgs = {
  businessIdsToMerge: Array<Scalars['UUID']['input']>;
  targetBusinessId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationMergeChargesArgs = {
  baseChargeID: Scalars['UUID']['input'];
  chargeIdsToMerge: Array<Scalars['UUID']['input']>;
  fields?: InputMaybe<UpdateChargeInput>;
};


/**  mutation root  */
export type MutationPreviewDocumentArgs = {
  input: DocumentIssueInput;
};


/**  mutation root  */
export type MutationRegenerateLedgerRecordsArgs = {
  chargeId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationRevokeApiKeyArgs = {
  id: Scalars['ID']['input'];
};


/**  mutation root  */
export type MutationSetAnnualAuditStep03StatusArgs = {
  input: SetAnnualAuditStep03StatusInput;
};


/**  mutation root  */
export type MutationSetAnnualAuditStep09StatusArgs = {
  input: SetAnnualAuditStep09StatusInput;
};


/**  mutation root  */
export type MutationSetAnnualAuditStepStatusArgs = {
  input: SetAnnualAuditStepStatusInput;
};


/**  mutation root  */
export type MutationSetDeelCredentialsArgs = {
  apiToken: Scalars['String']['input'];
};


/**  mutation root  */
export type MutationSetGreenInvoiceCredentialsArgs = {
  id: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};


/**  mutation root  */
export type MutationSyncGreenInvoiceDocumentsArgs = {
  ownerId: Scalars['UUID']['input'];
  singlePageLimit?: InputMaybe<Scalars['Boolean']['input']>;
};


/**  mutation root  */
export type MutationUncategorizePartialBusinessTripExpenseArgs = {
  businessTripExpenseId: Scalars['UUID']['input'];
  transactionId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationUnlockDynamicReportTemplateArgs = {
  name: Scalars['String']['input'];
};


/**  mutation root  */
export type MutationUpdateAdminBusinessArgs = {
  businessId: Scalars['UUID']['input'];
  fields: UpdateAdminBusinessInput;
};


/**  mutation root  */
export type MutationUpdateAdminContextArgs = {
  context: AdminContextInput;
};


/**  mutation root  */
export type MutationUpdateBusinessArgs = {
  businessId: Scalars['UUID']['input'];
  fields: UpdateBusinessInput;
  ownerId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationUpdateBusinessTripArgs = {
  fields: UpdateBusinessTripInput;
};


/**  mutation root  */
export type MutationUpdateBusinessTripAccommodationsExpenseArgs = {
  fields: UpdateBusinessTripAccommodationsExpenseInput;
};


/**  mutation root  */
export type MutationUpdateBusinessTripAccountantApprovalArgs = {
  approvalStatus: AccountantStatus;
  businessTripId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationUpdateBusinessTripAttendeeArgs = {
  fields: BusinessTripAttendeeUpdateInput;
};


/**  mutation root  */
export type MutationUpdateBusinessTripCarRentalExpenseArgs = {
  fields: UpdateBusinessTripCarRentalExpenseInput;
};


/**  mutation root  */
export type MutationUpdateBusinessTripFlightsExpenseArgs = {
  fields: UpdateBusinessTripFlightsExpenseInput;
};


/**  mutation root  */
export type MutationUpdateBusinessTripOtherExpenseArgs = {
  fields: UpdateBusinessTripOtherExpenseInput;
};


/**  mutation root  */
export type MutationUpdateBusinessTripTravelAndSubsistenceExpenseArgs = {
  fields: UpdateBusinessTripTravelAndSubsistenceExpenseInput;
};


/**  mutation root  */
export type MutationUpdateChargeArgs = {
  chargeId: Scalars['UUID']['input'];
  fields: UpdateChargeInput;
};


/**  mutation root  */
export type MutationUpdateChargeAccountantApprovalArgs = {
  approvalStatus: AccountantStatus;
  chargeId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationUpdateChargeBusinessTripArgs = {
  businessTripId?: InputMaybe<Scalars['UUID']['input']>;
  chargeId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationUpdateClientArgs = {
  businessId: Scalars['UUID']['input'];
  fields: ClientUpdateInput;
};


/**  mutation root  */
export type MutationUpdateContractArgs = {
  contractId: Scalars['UUID']['input'];
  input: UpdateContractInput;
};


/**  mutation root  */
export type MutationUpdateDepositArgs = {
  closeDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  openDate?: InputMaybe<Scalars['TimelessDate']['input']>;
};


/**  mutation root  */
export type MutationUpdateDepreciationCategoryArgs = {
  input: UpdateDepreciationCategoryInput;
};


/**  mutation root  */
export type MutationUpdateDepreciationRecordArgs = {
  input: UpdateDepreciationRecordInput;
};


/**  mutation root  */
export type MutationUpdateDocumentArgs = {
  documentId: Scalars['UUID']['input'];
  fields: UpdateDocumentFieldsInput;
};


/**  mutation root  */
export type MutationUpdateDynamicReportTemplateArgs = {
  name: Scalars['String']['input'];
  template: Scalars['String']['input'];
};


/**  mutation root  */
export type MutationUpdateDynamicReportTemplateNameArgs = {
  name: Scalars['String']['input'];
  newName: Scalars['String']['input'];
};


/**  mutation root  */
export type MutationUpdateFinancialAccountArgs = {
  fields: UpdateFinancialAccountInput;
  id: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationUpdateMiscExpenseArgs = {
  fields: UpdateMiscExpenseInput;
  id: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationUpdatePcn874Args = {
  businessId?: InputMaybe<Scalars['UUID']['input']>;
  content: Scalars['String']['input'];
  monthDate: Scalars['TimelessDate']['input'];
};


/**  mutation root  */
export type MutationUpdateSalaryRecordArgs = {
  salaryRecord: SalaryRecordEditInput;
};


/**  mutation root  */
export type MutationUpdateShaam6111Args = {
  businessId?: InputMaybe<Scalars['UUID']['input']>;
  content: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


/**  mutation root  */
export type MutationUpdateSortCodeArgs = {
  fields: UpdateSortCodeFieldsInput;
  key: Scalars['Int']['input'];
};


/**  mutation root  */
export type MutationUpdateTagArgs = {
  fields: UpdateTagFieldsInput;
  id: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationUpdateTagParentArgs = {
  id: Scalars['UUID']['input'];
  parentId?: InputMaybe<Scalars['UUID']['input']>;
};


/**  mutation root  */
export type MutationUpdateTagPartArgs = {
  chargeId: Scalars['UUID']['input'];
  part: Scalars['Float']['input'];
  tagId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationUpdateTaxCategoryArgs = {
  fields: UpdateTaxCategoryInput;
  taxCategoryId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationUpdateTransactionArgs = {
  fields: UpdateTransactionInput;
  transactionId: Scalars['UUID']['input'];
};


/**  mutation root  */
export type MutationUpdateTransactionsArgs = {
  fields: UpdateTransactionInput;
  transactionIds: Array<Scalars['UUID']['input']>;
};


/**  mutation root  */
export type MutationUploadAmexTransactionsArgs = {
  transactions: Array<AmexTransactionInput>;
};


/**  mutation root  */
export type MutationUploadCalTransactionsArgs = {
  transactions: Array<CalTransactionInput>;
};


/**  mutation root  */
export type MutationUploadCurrencyRatesArgs = {
  rates: Array<CurrencyRateInput>;
};


/**  mutation root  */
export type MutationUploadDiscountTransactionsArgs = {
  transactions: Array<DiscountTransactionInput>;
};


/**  mutation root  */
export type MutationUploadDocumentArgs = {
  chargeId?: InputMaybe<Scalars['UUID']['input']>;
  file: Scalars['FileScalar']['input'];
};


/**  mutation root  */
export type MutationUploadIsracardTransactionsArgs = {
  transactions: Array<IsracardTransactionInput>;
};


/**  mutation root  */
export type MutationUploadMaxTransactionsArgs = {
  transactions: Array<MaxTransactionInput>;
};


/**  mutation root  */
export type MutationUploadPoalimForeignTransactionsArgs = {
  transactions: Array<PoalimForeignTransactionInput>;
};


/**  mutation root  */
export type MutationUploadPoalimIlsTransactionsArgs = {
  transactions: Array<PoalimIlsTransactionInput>;
};


/**  mutation root  */
export type MutationUploadPoalimSwiftTransactionsArgs = {
  swifts: Array<PoalimSwiftTransactionInput>;
};

/**  processed non-financial document  */
export type OtherDocument = Document & Linkable & {
  __typename?: 'OtherDocument';
  charge?: Maybe<Charge>;
  description?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<DocumentType>;
  file?: Maybe<Scalars['URL']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Scalars['URL']['output']>;
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
};

/**  result type for pcnFile  */
export type PcnFileResult = {
  __typename?: 'PCNFileResult';
  fileName: Scalars['String']['output'];
  reportContent: Scalars['String']['output'];
};

/**  config options for generatePCN  */
export type PcnOptionsInput = {
  strict?: InputMaybe<Scalars['Boolean']['input']>;
};

/**  meta info for page pagination  */
export type PageInfo = {
  __typename?: 'PageInfo';
  currentPage?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalPages: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
};

/**  response for paginated Financial Entities  */
export type PaginatedBusinesses = {
  __typename?: 'PaginatedBusinesses';
  nodes: Array<Business>;
  pageInfo: PageInfo;
};

/**  response for paginated charges  */
export type PaginatedCharges = {
  __typename?: 'PaginatedCharges';
  nodes: Array<Charge>;
  pageInfo: PageInfo;
};

/**  response for paginated Financial Entities  */
export type PaginatedFinancialEntities = {
  __typename?: 'PaginatedFinancialEntities';
  nodes: Array<FinancialEntity>;
  pageInfo: PageInfo;
};

/**  payment type enum  */
export const PaymentType = {
  Cash: 'CASH',
  Cheque: 'CHEQUE',
  CreditCard: 'CREDIT_CARD',
  Other: 'OTHER',
  OtherDeduction: 'OTHER_DEDUCTION',
  PaymentApp: 'PAYMENT_APP',
  Paypal: 'PAYPAL',
  TaxDeduction: 'TAX_DEDUCTION',
  WireTransfer: 'WIRE_TRANSFER'
} as const;

export type PaymentType = typeof PaymentType[keyof typeof PaymentType];
/**  record type of PCN874 report  */
export const Pcn874RecordType = {
  C: 'C',
  H: 'H',
  I: 'I',
  K: 'K',
  L1: 'L1',
  L2: 'L2',
  M: 'M',
  P: 'P',
  R: 'R',
  S1: 'S1',
  S2: 'S2',
  T: 'T',
  Y: 'Y'
} as const;

export type Pcn874RecordType = typeof Pcn874RecordType[keyof typeof Pcn874RecordType];
/**  record of PCN874 report  */
export type Pcn874Records = {
  __typename?: 'Pcn874Records';
  business: Business;
  content: Scalars['String']['output'];
  date: Scalars['TimelessDate']['output'];
  diffContent?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/**  represent pension fund */
export type PensionFund = Fund & {
  __typename?: 'PensionFund';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

/**  Financial entity, identifier by ID, represents an actual person  */
export type PersonalFinancialEntity = Business & FinancialEntity & {
  __typename?: 'PersonalFinancialEntity';
  accounts: Array<FinancialAccount>;
  charges: PaginatedCharges;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  irsCode?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pcn874RecordType?: Maybe<Pcn874RecordType>;
  sortCode?: Maybe<SortCode>;
  updatedAt: Scalars['DateTime']['output'];
};


/**  Financial entity, identifier by ID, represents an actual person  */
export type PersonalFinancialEntityChargesArgs = {
  filter?: InputMaybe<ChargeFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/**  Input for a Poalim foreign currency bank account transaction  */
export type PoalimForeignTransactionInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountNumber: Scalars['Int']['input'];
  activityDescription: Scalars['String']['input'];
  activityTypeCode: Scalars['Int']['input'];
  bankNumber: Scalars['Int']['input'];
  branchNumber: Scalars['Int']['input'];
  commentExistenceSwitch: Scalars['Boolean']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  contraAccountFieldNameLable?: InputMaybe<Scalars['String']['input']>;
  contraAccountNumber: Scalars['Int']['input'];
  contraBankNumber: Scalars['Int']['input'];
  contraBranchNumber: Scalars['Int']['input'];
  contraCurrencyCode: Scalars['Int']['input'];
  currency: Currency;
  currencyLongDescription: Scalars['String']['input'];
  currencyRate: Scalars['Float']['input'];
  currencySwiftCode: Scalars['String']['input'];
  currentBalance: Scalars['Float']['input'];
  dataGroupCode: Scalars['Boolean']['input'];
  eventActivityTypeCode: Scalars['Int']['input'];
  eventAmount: Scalars['Float']['input'];
  eventDetails?: InputMaybe<Scalars['String']['input']>;
  eventNumber: Scalars['Int']['input'];
  executingDate: Scalars['String']['input'];
  formattedExecutingDate: Scalars['String']['input'];
  formattedValueDate?: InputMaybe<Scalars['String']['input']>;
  metadataAttributesContraAccountFieldNameLable?: InputMaybe<Scalars['String']['input']>;
  metadataAttributesContraAccountNumber?: InputMaybe<Scalars['String']['input']>;
  metadataAttributesContraBankNumber?: InputMaybe<Scalars['String']['input']>;
  metadataAttributesContraBranchNumber?: InputMaybe<Scalars['String']['input']>;
  metadataAttributesContraCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  metadataAttributesCurrencyRate?: InputMaybe<Scalars['String']['input']>;
  metadataAttributesDataGroupCode?: InputMaybe<Scalars['String']['input']>;
  metadataAttributesOriginalEventKey?: InputMaybe<Scalars['String']['input']>;
  metadataAttributesRateFixingCode?: InputMaybe<Scalars['String']['input']>;
  originalEventKey: Scalars['Boolean']['input'];
  originalSystemId: Scalars['Int']['input'];
  rateFixingCode: Scalars['Int']['input'];
  rateFixingDescription?: InputMaybe<Scalars['String']['input']>;
  rateFixingShortDescription: Scalars['String']['input'];
  referenceCatenatedNumber: Scalars['Int']['input'];
  referenceNumber: Scalars['String']['input'];
  transactionType: Scalars['String']['input'];
  urlAddress?: InputMaybe<Scalars['String']['input']>;
  urlAddressNiar?: InputMaybe<Scalars['String']['input']>;
  validityDate: Scalars['String']['input'];
  valueDate: Scalars['String']['input'];
};

/**  Input for a Poalim ILS (NIS) bank account transaction  */
export type PoalimIlsTransactionInput = {
  accountNumber: Scalars['Int']['input'];
  activityDescription: Scalars['String']['input'];
  activityDescriptionIncludeValueDate?: InputMaybe<Scalars['String']['input']>;
  activityTypeCode: Scalars['Int']['input'];
  bankNumber: Scalars['Int']['input'];
  beneficiaryDetailsData?: InputMaybe<Scalars['String']['input']>;
  beneficiaryDetailsDataMessageDetail?: InputMaybe<Scalars['String']['input']>;
  beneficiaryDetailsDataMessageHeadline?: InputMaybe<Scalars['String']['input']>;
  beneficiaryDetailsDataPartyHeadline?: InputMaybe<Scalars['String']['input']>;
  beneficiaryDetailsDataPartyName?: InputMaybe<Scalars['String']['input']>;
  beneficiaryDetailsDataRecordNumber?: InputMaybe<Scalars['Int']['input']>;
  beneficiaryDetailsDataTableNumber?: InputMaybe<Scalars['Int']['input']>;
  branchNumber: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  commentExistenceSwitch: Scalars['Boolean']['input'];
  contraAccountNumber: Scalars['Int']['input'];
  contraAccountTypeCode: Scalars['Int']['input'];
  contraBankNumber: Scalars['Int']['input'];
  contraBranchNumber: Scalars['Int']['input'];
  currentBalance: Scalars['Float']['input'];
  dataGroupCode: Scalars['Int']['input'];
  details?: InputMaybe<Scalars['String']['input']>;
  differentDateIndication: Scalars['String']['input'];
  englishActionDesc?: InputMaybe<Scalars['String']['input']>;
  eventActivityTypeCode: Scalars['Int']['input'];
  eventAmount: Scalars['Float']['input'];
  eventDate: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
  executingBranchNumber: Scalars['Int']['input'];
  expandedEventDate: Scalars['String']['input'];
  fieldDescDisplaySwitch: Scalars['Boolean']['input'];
  formattedEventDate: Scalars['String']['input'];
  formattedOriginalEventCreateDate?: InputMaybe<Scalars['String']['input']>;
  formattedValueDate?: InputMaybe<Scalars['String']['input']>;
  internalLinkCode: Scalars['Int']['input'];
  marketingOfferContext: Scalars['Boolean']['input'];
  offerActivityContext?: InputMaybe<Scalars['String']['input']>;
  originalEventCreateDate: Scalars['Int']['input'];
  pfmDetails?: InputMaybe<Scalars['String']['input']>;
  recordNumber: Scalars['Int']['input'];
  referenceCatenatedNumber: Scalars['Int']['input'];
  referenceNumber: Scalars['String']['input'];
  rejectedDataEventPertainingIndication?: InputMaybe<Scalars['String']['input']>;
  serialNumber: Scalars['Int']['input'];
  tableNumber: Scalars['Int']['input'];
  textCode: Scalars['Int']['input'];
  transactionType: Scalars['String']['input'];
  urlAddressNiar?: InputMaybe<Scalars['String']['input']>;
  valueDate: Scalars['String']['input'];
};

/**  Input for a Poalim SWIFT international wire transfer  */
export type PoalimSwiftTransactionInput = {
  accountNumber?: InputMaybe<Scalars['Int']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  bankNumber?: InputMaybe<Scalars['Int']['input']>;
  beneficiaryEnglishCityName?: InputMaybe<Scalars['String']['input']>;
  beneficiaryEnglishCountryName?: InputMaybe<Scalars['String']['input']>;
  beneficiaryEnglishStreetName?: InputMaybe<Scalars['String']['input']>;
  branchNumber?: InputMaybe<Scalars['Int']['input']>;
  chargePartyName?: InputMaybe<Scalars['String']['input']>;
  currencyCodeCatenatedKey?: InputMaybe<Scalars['String']['input']>;
  currencyLongDescription?: InputMaybe<Scalars['String']['input']>;
  dataOriginCode?: InputMaybe<Scalars['String']['input']>;
  formattedStartDate?: InputMaybe<Scalars['String']['input']>;
  orderCustomerName?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  swiftAccountWithInstitution57?: InputMaybe<Scalars['String']['input']>;
  swiftBankCode?: InputMaybe<Scalars['String']['input']>;
  swiftBankOperationCode23B?: InputMaybe<Scalars['String']['input']>;
  swiftBeneficiaryCustomer59?: InputMaybe<Scalars['String']['input']>;
  swiftCurrencyInstructedAmount33B?: InputMaybe<Scalars['String']['input']>;
  swiftDetailsOfCharges71A?: InputMaybe<Scalars['String']['input']>;
  swiftExchangeRate36?: InputMaybe<Scalars['String']['input']>;
  swiftInstructionCode23E?: InputMaybe<Scalars['String']['input']>;
  swiftIsnSerialNumber?: InputMaybe<Scalars['String']['input']>;
  swiftOrderingCustomer50K?: InputMaybe<Scalars['String']['input']>;
  swiftOrderingInstitution52A?: InputMaybe<Scalars['String']['input']>;
  swiftOrderingInstitution52D?: InputMaybe<Scalars['String']['input']>;
  swiftReceiversCorrespondent54A?: InputMaybe<Scalars['String']['input']>;
  swiftRegulatoryReporting77B?: InputMaybe<Scalars['String']['input']>;
  swiftRemittanceInformation70?: InputMaybe<Scalars['String']['input']>;
  swiftSendersCharges71F?: InputMaybe<Scalars['String']['input']>;
  swiftSendersCorrespondent53A?: InputMaybe<Scalars['String']['input']>;
  swiftSendersReference20?: InputMaybe<Scalars['String']['input']>;
  swiftSendersToReceiverInformation72?: InputMaybe<Scalars['String']['input']>;
  swiftStatusCode?: InputMaybe<Scalars['String']['input']>;
  swiftStatusDesc?: InputMaybe<Scalars['String']['input']>;
  swiftValueDateCurrencyAmount32A?: InputMaybe<Scalars['String']['input']>;
  transferCatenatedId?: InputMaybe<Scalars['String']['input']>;
};

/**  private or business account type  */
export const PrivateOrBusinessType = {
  Business: 'BUSINESS',
  Private: 'PRIVATE'
} as const;

export type PrivateOrBusinessType = typeof PrivateOrBusinessType[keyof typeof PrivateOrBusinessType];
/**  contract products  */
export const Product = {
  Hive: 'HIVE',
  Stellate: 'STELLATE'
} as const;

export type Product = typeof Product[keyof typeof Product];
/**  result type for profitAndLossReport  */
export type ProfitAndLossReport = {
  __typename?: 'ProfitAndLossReport';
  id: Scalars['ID']['output'];
  reference: Array<ProfitAndLossReportYear>;
  report: ProfitAndLossReportYear;
};

/**  profit and loss data for a single year  */
export type ProfitAndLossReportYear = {
  __typename?: 'ProfitAndLossReportYear';
  costOfSales: ReportCommentary;
  financialExpenses: ReportCommentary;
  grossProfit: FinancialAmount;
  id: Scalars['ID']['output'];
  managementAndGeneralExpenses: ReportCommentary;
  marketingExpenses: ReportCommentary;
  netProfit: FinancialAmount;
  operatingProfit: FinancialAmount;
  otherIncome: ReportCommentary;
  profitBeforeTax: FinancialAmount;
  researchAndDevelopmentExpenses: ReportCommentary;
  revenue: ReportCommentary;
  tax: FinancialAmount;
  year: Scalars['Int']['output'];
};

/**  proforma document  */
export type Proforma = Document & FinancialDocument & Linkable & {
  __typename?: 'Proforma';
  allocationNumber?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<FinancialAmount>;
  charge?: Maybe<Charge>;
  creditor?: Maybe<FinancialEntity>;
  date?: Maybe<Scalars['TimelessDate']['output']>;
  debtor?: Maybe<FinancialEntity>;
  description?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<DocumentType>;
  exchangeRateOverride?: Maybe<Scalars['Float']['output']>;
  file?: Maybe<Scalars['URL']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Scalars['URL']['output']>;
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  issuedDocumentInfo?: Maybe<IssuedDocumentInfo>;
  missingInfoSuggestions?: Maybe<DocumentSuggestions>;
  noVatAmount?: Maybe<Scalars['Float']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<FinancialAmount>;
  vatReportDateOverride?: Maybe<Scalars['TimelessDate']['output']>;
};

/** Result returned after successfully deleting provider credentials */
export type ProviderCredentialDeleteResult = {
  __typename?: 'ProviderCredentialDeleteResult';
  id: Scalars['ID']['output'];
  /** The provider key whose credentials were deleted */
  provider: ProviderKey;
  /** Whether the deletion succeeded */
  success: Scalars['Boolean']['output'];
};

/** Result returned after successfully saving provider credentials */
export type ProviderCredentialResult = {
  __typename?: 'ProviderCredentialResult';
  /** When the credentials were saved */
  configuredAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The provider key whose credentials were saved */
  provider: ProviderKey;
};

/** Current credential configuration status for a provider */
export type ProviderCredentialStatus = {
  __typename?: 'ProviderCredentialStatus';
  /** When the credentials were last updated */
  configuredAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The provider key */
  provider: ProviderKey;
};

/** Supported third-party provider integrations */
export const ProviderKey = {
  /** Deel global payroll platform */
  Deel: 'DEEL',
  /** Green Invoice billing platform */
  GreenInvoice: 'GREEN_INVOICE'
} as const;

export type ProviderKey = typeof ProviderKey[keyof typeof ProviderKey];
/**  query root  */
export type Query = {
  __typename?: 'Query';
  accountantApprovalStatus: AccountantApprovalStatus;
  adminBusiness: AdminBusiness;
  adminContext: AdminContextInfo;
  allAdminBusinesses: Array<AdminBusiness>;
  allBusinessTrips: Array<BusinessTrip>;
  allBusinesses?: Maybe<PaginatedBusinesses>;
  allCharges: PaginatedCharges;
  allClients: Array<Client>;
  allCountries: Array<Country>;
  allDeposits: Array<BankDeposit>;
  allDynamicReports: Array<DynamicReportInfo>;
  allFinancialAccounts: Array<FinancialAccount>;
  /**  TODO: This is temporary, should be replaced after auth and financial entities hierarchy is implemented  */
  allFinancialEntities?: Maybe<PaginatedFinancialEntities>;
  allOpenContracts: Array<Contract>;
  allPensionFunds: Array<PensionFund>;
  allSortCodes: Array<SortCode>;
  allTags: Array<Tag>;
  allTrainingFunds: Array<TrainingFund>;
  annualAuditOpeningBalanceStatus: AnnualAuditOpeningBalanceStatusInfo;
  annualAuditStepStatuses: Array<AnnualAuditStepStatusInfo>;
  annualFinancialCharges: FinancialChargesGenerationResult;
  annualRevenueReport: AnnualRevenueReport;
  business: Business;
  businessEmailConfig?: Maybe<BusinessEmailConfig>;
  businessTransactionsFromLedgerRecords: BusinessTransactionsFromLedgerRecordsResult;
  businessTransactionsSumFromLedgerRecords: BusinessTransactionsSumFromLedgerRecordsResult;
  businessTrip?: Maybe<BusinessTrip>;
  businesses: Array<Business>;
  charge: Charge;
  chargesByIDs: Array<Charge>;
  chargesWithLedgerChanges: Array<ChargesWithLedgerChangesResult>;
  chargesWithMissingRequiredInfo: PaginatedCharges;
  client: Client;
  clientMonthlyChargeDraft: DocumentDraft;
  contractsByAdmin: Array<Contract>;
  contractsByClient: Array<Contract>;
  contractsById: Contract;
  corporateTaxByDate: CorporateTax;
  corporateTaxRulingComplianceReport: Array<CorporateTaxRulingComplianceReport>;
  deposit: BankDeposit;
  depositByCharge?: Maybe<BankDeposit>;
  depreciationCategories: Array<DepreciationCategory>;
  depreciationRecordsByCharge: Array<DepreciationRecord>;
  depreciationReport: DepreciationReportResult;
  documentById?: Maybe<Document>;
  documents: Array<Document>;
  documentsByFilters: Array<Document>;
  dynamicReport: DynamicReportInfo;
  employeesByEmployerId: Array<Employee>;
  /**  get exchage rates by date  */
  exchangeRates?: Maybe<ExchangeRates>;
  financialAccount: FinancialAccount;
  financialAccountsByOwner: Array<FinancialAccount>;
  financialEntity: FinancialEntity;
  /**  Find potential matches for a single unmatched charge  */
  findChargeMatches: ChargeMatchesResult;
  greenInvoiceClient: GreenInvoiceClient;
  incomeExpenseChart: IncomeExpenseChart;
  ledgerRecordsByDates: Array<LedgerRecord>;
  ledgerRecordsByFinancialEntity: Array<LedgerRecord>;
  listApiKeys: Array<ApiKey>;
  miscExpensesByCharge: Array<MiscExpense>;
  newDocumentDraftByCharge: DocumentDraft;
  newDocumentDraftByDocument: DocumentDraft;
  pcnByDate: Array<Pcn874Records>;
  pcnFile: PcnFileResult;
  periodicalDocumentDrafts: Array<DocumentDraft>;
  periodicalDocumentDraftsByContracts: Array<DocumentDraft>;
  ping?: Maybe<Scalars['Boolean']['output']>;
  profitAndLossReport: ProfitAndLossReport;
  providerCredentials: Array<ProviderCredentialStatus>;
  recentDocumentsByBusiness: Array<Document>;
  recentDocumentsByClient: Array<Document>;
  recentIssuedDocumentsByType: Array<Document>;
  relevantDepositsForCharge: RelevantDepositsResult;
  salaryRecordsByCharge: Array<Salary>;
  salaryRecordsByDates: Array<Salary>;
  shaam6111: Shaam6111Report;
  shaam6111ByYear: Array<Shaam6111Report>;
  /**  get similar charges  */
  similarCharges: Array<Charge>;
  similarChargesByBusiness: Array<Charge>;
  /**  get similar transactions  */
  similarTransactions: Array<Transaction>;
  sortCode?: Maybe<SortCode>;
  taxCategories: Array<TaxCategory>;
  taxCategory: TaxCategory;
  taxCategoryByBusinessId?: Maybe<TaxCategory>;
  taxReport: TaxReport;
  transactionsByFinancialEntity: Array<Transaction>;
  transactionsByIDs: Array<Transaction>;
  transactionsForBalanceReport: Array<BalanceTransactions>;
  uniformFormat?: Maybe<UniformFormat>;
  userContext?: Maybe<UserContext>;
  vatReport: VatReportResult;
  yearlyLedgerReport: YearlyLedgerReport;
};


/**  query root  */
export type QueryAccountantApprovalStatusArgs = {
  from: Scalars['TimelessDate']['input'];
  to: Scalars['TimelessDate']['input'];
};


/**  query root  */
export type QueryAdminBusinessArgs = {
  id: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryAdminContextArgs = {
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
};


/**  query root  */
export type QueryAllBusinessesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/**  query root  */
export type QueryAllChargesArgs = {
  filters?: InputMaybe<ChargeFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/**  query root  */
export type QueryAllFinancialEntitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/**  query root  */
export type QueryAnnualAuditOpeningBalanceStatusArgs = {
  ownerId: Scalars['UUID']['input'];
  year: Scalars['Int']['input'];
};


/**  query root  */
export type QueryAnnualAuditStepStatusesArgs = {
  ownerId: Scalars['UUID']['input'];
  year: Scalars['Int']['input'];
};


/**  query root  */
export type QueryAnnualFinancialChargesArgs = {
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  year: Scalars['TimelessDate']['input'];
};


/**  query root  */
export type QueryAnnualRevenueReportArgs = {
  filters: AnnualRevenueReportFilter;
};


/**  query root  */
export type QueryBusinessArgs = {
  id: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryBusinessEmailConfigArgs = {
  email: Scalars['String']['input'];
};


/**  query root  */
export type QueryBusinessTransactionsFromLedgerRecordsArgs = {
  filters?: InputMaybe<BusinessTransactionsFilter>;
};


/**  query root  */
export type QueryBusinessTransactionsSumFromLedgerRecordsArgs = {
  filters?: InputMaybe<BusinessTransactionsFilter>;
};


/**  query root  */
export type QueryBusinessTripArgs = {
  id: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryBusinessesArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


/**  query root  */
export type QueryChargeArgs = {
  chargeId: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryChargesByIDsArgs = {
  chargeIDs: Array<Scalars['UUID']['input']>;
};


/**  query root  */
export type QueryChargesWithLedgerChangesArgs = {
  filters?: InputMaybe<ChargeFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**  query root  */
export type QueryChargesWithMissingRequiredInfoArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/**  query root  */
export type QueryClientArgs = {
  businessId: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryClientMonthlyChargeDraftArgs = {
  clientId: Scalars['UUID']['input'];
  issueMonth: Scalars['TimelessDate']['input'];
};


/**  query root  */
export type QueryContractsByAdminArgs = {
  adminId: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryContractsByClientArgs = {
  clientId: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryContractsByIdArgs = {
  id: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryCorporateTaxByDateArgs = {
  date: Scalars['TimelessDate']['input'];
};


/**  query root  */
export type QueryCorporateTaxRulingComplianceReportArgs = {
  years: Array<Scalars['Int']['input']>;
};


/**  query root  */
export type QueryDepositArgs = {
  id: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryDepositByChargeArgs = {
  chargeId: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryDepreciationRecordsByChargeArgs = {
  chargeId: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryDepreciationReportArgs = {
  filters?: InputMaybe<DepreciationReportFilter>;
};


/**  query root  */
export type QueryDocumentByIdArgs = {
  documentId: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryDocumentsByFiltersArgs = {
  filters: DocumentsFilters;
};


/**  query root  */
export type QueryDynamicReportArgs = {
  name: Scalars['String']['input'];
};


/**  query root  */
export type QueryEmployeesByEmployerIdArgs = {
  employerId: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryExchangeRatesArgs = {
  date?: InputMaybe<Scalars['TimelessDate']['input']>;
};


/**  query root  */
export type QueryFinancialAccountArgs = {
  id: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryFinancialAccountsByOwnerArgs = {
  ownerId: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryFinancialEntityArgs = {
  id: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryFindChargeMatchesArgs = {
  chargeId: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryGreenInvoiceClientArgs = {
  clientId: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryIncomeExpenseChartArgs = {
  filters: IncomeExpenseChartFilters;
};


/**  query root  */
export type QueryLedgerRecordsByDatesArgs = {
  fromDate: Scalars['TimelessDate']['input'];
  toDate: Scalars['TimelessDate']['input'];
};


/**  query root  */
export type QueryLedgerRecordsByFinancialEntityArgs = {
  financialEntityId: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryMiscExpensesByChargeArgs = {
  chargeId: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryNewDocumentDraftByChargeArgs = {
  chargeId: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryNewDocumentDraftByDocumentArgs = {
  documentId: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryPcnByDateArgs = {
  businessId?: InputMaybe<Scalars['UUID']['input']>;
  fromMonthDate: Scalars['TimelessDate']['input'];
  toMonthDate: Scalars['TimelessDate']['input'];
};


/**  query root  */
export type QueryPcnFileArgs = {
  financialEntityId: Scalars['UUID']['input'];
  monthDate: Scalars['TimelessDate']['input'];
  options?: InputMaybe<PcnOptionsInput>;
};


/**  query root  */
export type QueryPeriodicalDocumentDraftsArgs = {
  issueMonth: Scalars['TimelessDate']['input'];
};


/**  query root  */
export type QueryPeriodicalDocumentDraftsByContractsArgs = {
  contractIds: Array<Scalars['UUID']['input']>;
  issueMonth: Scalars['TimelessDate']['input'];
};


/**  query root  */
export type QueryProfitAndLossReportArgs = {
  referenceYears: Array<Scalars['Int']['input']>;
  reportYear: Scalars['Int']['input'];
};


/**  query root  */
export type QueryRecentDocumentsByBusinessArgs = {
  businessId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**  query root  */
export type QueryRecentDocumentsByClientArgs = {
  clientId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**  query root  */
export type QueryRecentIssuedDocumentsByTypeArgs = {
  documentType: DocumentType;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**  query root  */
export type QueryRelevantDepositsForChargeArgs = {
  chargeId: Scalars['UUID']['input'];
};


/**  query root  */
export type QuerySalaryRecordsByChargeArgs = {
  chargeId: Scalars['UUID']['input'];
};


/**  query root  */
export type QuerySalaryRecordsByDatesArgs = {
  employeeIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  fromDate: Scalars['TimelessDate']['input'];
  toDate: Scalars['TimelessDate']['input'];
};


/**  query root  */
export type QueryShaam6111Args = {
  businessId?: InputMaybe<Scalars['UUID']['input']>;
  year: Scalars['Int']['input'];
};


/**  query root  */
export type QueryShaam6111ByYearArgs = {
  businessId?: InputMaybe<Scalars['UUID']['input']>;
  fromYear: Scalars['Int']['input'];
  toYear: Scalars['Int']['input'];
};


/**  query root  */
export type QuerySimilarChargesArgs = {
  chargeId: Scalars['UUID']['input'];
  descriptionDifferentThan?: InputMaybe<Scalars['String']['input']>;
  tagsDifferentThan?: InputMaybe<Array<Scalars['String']['input']>>;
  withMissingDescription?: InputMaybe<Scalars['Boolean']['input']>;
  withMissingTags?: InputMaybe<Scalars['Boolean']['input']>;
};


/**  query root  */
export type QuerySimilarChargesByBusinessArgs = {
  businessId: Scalars['UUID']['input'];
  descriptionDifferentThan?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  tagsDifferentThan?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**  query root  */
export type QuerySimilarTransactionsArgs = {
  transactionId: Scalars['UUID']['input'];
  withMissingInfo?: InputMaybe<Scalars['Boolean']['input']>;
};


/**  query root  */
export type QuerySortCodeArgs = {
  key: Scalars['Int']['input'];
};


/**  query root  */
export type QueryTaxCategoryArgs = {
  id: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryTaxCategoryByBusinessIdArgs = {
  businessId: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryTaxReportArgs = {
  referenceYears: Array<Scalars['Int']['input']>;
  reportYear: Scalars['Int']['input'];
};


/**  query root  */
export type QueryTransactionsByFinancialEntityArgs = {
  financialEntityID: Scalars['UUID']['input'];
};


/**  query root  */
export type QueryTransactionsByIDsArgs = {
  transactionIDs: Array<Scalars['UUID']['input']>;
};


/**  query root  */
export type QueryTransactionsForBalanceReportArgs = {
  fromDate: Scalars['TimelessDate']['input'];
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  toDate: Scalars['TimelessDate']['input'];
};


/**  query root  */
export type QueryUniformFormatArgs = {
  fromDate: Scalars['TimelessDate']['input'];
  toDate: Scalars['TimelessDate']['input'];
};


/**  query root  */
export type QueryVatReportArgs = {
  filters?: InputMaybe<VatReportFilter>;
};


/**  query root  */
export type QueryYearlyLedgerReportArgs = {
  year: Scalars['Int']['input'];
};

/**  receipt document  */
export type Receipt = Document & FinancialDocument & Linkable & {
  __typename?: 'Receipt';
  allocationNumber?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<FinancialAmount>;
  charge?: Maybe<Charge>;
  creditor?: Maybe<FinancialEntity>;
  date?: Maybe<Scalars['TimelessDate']['output']>;
  debtor?: Maybe<FinancialEntity>;
  description?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<DocumentType>;
  exchangeRateOverride?: Maybe<Scalars['Float']['output']>;
  file?: Maybe<Scalars['URL']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Scalars['URL']['output']>;
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  issuedDocumentInfo?: Maybe<IssuedDocumentInfo>;
  missingInfoSuggestions?: Maybe<DocumentSuggestions>;
  noVatAmount?: Maybe<Scalars['Float']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<FinancialAmount>;
  vatReportDateOverride?: Maybe<Scalars['TimelessDate']['output']>;
};

/**  Result of relevantDepositsForCharge: matched open deposits, or an error if the charge has multiple currencies or accounts  */
export type RelevantDepositsResult = {
  __typename?: 'RelevantDepositsResult';
  deposits: Array<BankDeposit>;
  /**  Set when the charge transactions have multiple currencies or multiple accounts  */
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/**  Tax report commentary summary  */
export type ReportCommentary = {
  __typename?: 'ReportCommentary';
  amount: FinancialAmount;
  records: Array<ReportCommentaryRecord>;
};

/**  Report commentary record  */
export type ReportCommentaryRecord = {
  __typename?: 'ReportCommentaryRecord';
  amount: FinancialAmount;
  records: Array<ReportCommentarySubRecord>;
  sortCode: SortCode;
};

/**  Report commentary sub-record  */
export type ReportCommentarySubRecord = {
  __typename?: 'ReportCommentarySubRecord';
  amount: FinancialAmount;
  financialEntity: FinancialEntity;
};

/**  Reporting method enum (שיטת דיווח)  */
export const ReportingMethod = {
  /** Accrual basis (מצטבר) */
  Accrual: 'ACCRUAL',
  /** Cash basis (מזומן) */
  Cash: 'CASH',
  /** According to dollar regulations (לפי תקנות דולריות) */
  DollarRegulations: 'DOLLAR_REGULATIONS'
} as const;

export type ReportingMethod = typeof ReportingMethod[keyof typeof ReportingMethod];
/**  defines salary records for charge arrangement */
export type Salary = {
  __typename?: 'Salary';
  baseAmount?: Maybe<FinancialAmount>;
  bonus?: Maybe<FinancialAmount>;
  charge?: Maybe<SalaryCharge>;
  compensationsAmount?: Maybe<FinancialAmount>;
  compensationsPercentage?: Maybe<Scalars['Float']['output']>;
  directAmount: FinancialAmount;
  employee?: Maybe<LtdFinancialEntity>;
  employer?: Maybe<LtdFinancialEntity>;
  gift?: Maybe<FinancialAmount>;
  globalAdditionalHoursAmount?: Maybe<FinancialAmount>;
  healthInsuranceAmount?: Maybe<FinancialAmount>;
  incomeTaxAmount?: Maybe<FinancialAmount>;
  month: Scalars['String']['output'];
  notionalExpense?: Maybe<FinancialAmount>;
  pensionEmployeeAmount?: Maybe<FinancialAmount>;
  pensionEmployeePercentage?: Maybe<Scalars['Float']['output']>;
  pensionEmployerAmount?: Maybe<FinancialAmount>;
  pensionEmployerPercentage?: Maybe<Scalars['Float']['output']>;
  pensionFund?: Maybe<LtdFinancialEntity>;
  recovery?: Maybe<FinancialAmount>;
  sicknessDays?: Maybe<SicknessDays>;
  socialSecurityEmployeeAmount?: Maybe<FinancialAmount>;
  socialSecurityEmployerAmount?: Maybe<FinancialAmount>;
  trainingFund?: Maybe<LtdFinancialEntity>;
  trainingFundEmployeeAmount?: Maybe<FinancialAmount>;
  trainingFundEmployeePercentage?: Maybe<Scalars['Float']['output']>;
  trainingFundEmployerAmount?: Maybe<FinancialAmount>;
  trainingFundEmployerPercentage?: Maybe<Scalars['Float']['output']>;
  travelAndSubsistence?: Maybe<FinancialAmount>;
  vacationDays?: Maybe<VacationDays>;
  vacationTakeout?: Maybe<FinancialAmount>;
  workDays?: Maybe<Scalars['Float']['output']>;
};

/**  charge with conversion transactions  */
export type SalaryCharge = Charge & {
  __typename?: 'SalaryCharge';
  accountantApproval: AccountantStatus;
  additionalDocuments: Array<Document>;
  counterparty?: Maybe<FinancialEntity>;
  decreasedVAT?: Maybe<Scalars['Boolean']['output']>;
  employees: Array<LtdFinancialEntity>;
  id: Scalars['UUID']['output'];
  isInvoicePaymentDifferentCurrency?: Maybe<Scalars['Boolean']['output']>;
  ledger: Ledger;
  metadata?: Maybe<ChargeMetadata>;
  minDebitDate?: Maybe<Scalars['DateTime']['output']>;
  minDocumentsDate?: Maybe<Scalars['DateTime']['output']>;
  minEventDate?: Maybe<Scalars['DateTime']['output']>;
  miscExpenses: Array<MiscExpense>;
  missingInfoSuggestions?: Maybe<ChargeSuggestions>;
  optionalDocuments?: Maybe<Scalars['Boolean']['output']>;
  optionalVAT?: Maybe<Scalars['Boolean']['output']>;
  owner: Business;
  property?: Maybe<Scalars['Boolean']['output']>;
  salaryRecords: Array<Salary>;
  tags: Array<Tag>;
  taxCategory?: Maybe<TaxCategory>;
  totalAmount?: Maybe<FinancialAmount>;
  transactions: Array<Transaction>;
  userDescription?: Maybe<Scalars['String']['output']>;
  validationData?: Maybe<ValidationData>;
  vat?: Maybe<FinancialAmount>;
  withholdingTax?: Maybe<FinancialAmount>;
  yearsOfRelevance?: Maybe<Array<YearOfRelevance>>;
};

/**  input variables for update salary records  */
export type SalaryRecordEditInput = {
  addedVacationDays?: InputMaybe<Scalars['Float']['input']>;
  baseSalary?: InputMaybe<Scalars['Float']['input']>;
  bonus?: InputMaybe<Scalars['Float']['input']>;
  chargeId?: InputMaybe<Scalars['UUID']['input']>;
  compensationsEmployerAmount?: InputMaybe<Scalars['Float']['input']>;
  compensationsEmployerPercentage?: InputMaybe<Scalars['Float']['input']>;
  directPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
  employeeId: Scalars['UUID']['input'];
  employer?: InputMaybe<Scalars['UUID']['input']>;
  gift?: InputMaybe<Scalars['Float']['input']>;
  globalAdditionalHours?: InputMaybe<Scalars['Float']['input']>;
  healthPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  month: Scalars['String']['input'];
  pensionEmployeeAmount?: InputMaybe<Scalars['Float']['input']>;
  pensionEmployeePercentage?: InputMaybe<Scalars['Float']['input']>;
  pensionEmployerAmount?: InputMaybe<Scalars['Float']['input']>;
  pensionEmployerPercentage?: InputMaybe<Scalars['Float']['input']>;
  pensionFundId?: InputMaybe<Scalars['UUID']['input']>;
  recovery?: InputMaybe<Scalars['Float']['input']>;
  sicknessDaysBalance?: InputMaybe<Scalars['Float']['input']>;
  socialSecurityAmountEmployee?: InputMaybe<Scalars['Float']['input']>;
  socialSecurityAmountEmployer?: InputMaybe<Scalars['Float']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  trainingFundEmployeeAmount?: InputMaybe<Scalars['Float']['input']>;
  trainingFundEmployeePercentage?: InputMaybe<Scalars['Float']['input']>;
  trainingFundEmployerAmount?: InputMaybe<Scalars['Float']['input']>;
  trainingFundEmployerPercentage?: InputMaybe<Scalars['Float']['input']>;
  trainingFundId?: InputMaybe<Scalars['UUID']['input']>;
  travelAndSubsistence?: InputMaybe<Scalars['Float']['input']>;
  vacationDaysBalance?: InputMaybe<Scalars['Float']['input']>;
  vacationTakeout?: InputMaybe<Scalars['Float']['input']>;
  workDays?: InputMaybe<Scalars['Float']['input']>;
  zkufot?: InputMaybe<Scalars['Int']['input']>;
};

/**  input variables for insert salary records  */
export type SalaryRecordInput = {
  addedVacationDays?: InputMaybe<Scalars['Float']['input']>;
  baseSalary?: InputMaybe<Scalars['Float']['input']>;
  bonus?: InputMaybe<Scalars['Float']['input']>;
  chargeId?: InputMaybe<Scalars['UUID']['input']>;
  compensationsEmployerAmount?: InputMaybe<Scalars['Float']['input']>;
  compensationsEmployerPercentage?: InputMaybe<Scalars['Float']['input']>;
  directPaymentAmount: Scalars['Float']['input'];
  employee?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['UUID']['input'];
  employer: Scalars['UUID']['input'];
  gift?: InputMaybe<Scalars['Float']['input']>;
  globalAdditionalHours?: InputMaybe<Scalars['Float']['input']>;
  healthPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  jobPercentage?: InputMaybe<Scalars['Float']['input']>;
  month: Scalars['String']['input'];
  pensionEmployeeAmount?: InputMaybe<Scalars['Float']['input']>;
  pensionEmployeePercentage?: InputMaybe<Scalars['Float']['input']>;
  pensionEmployerAmount?: InputMaybe<Scalars['Float']['input']>;
  pensionEmployerPercentage?: InputMaybe<Scalars['Float']['input']>;
  pensionFundId?: InputMaybe<Scalars['UUID']['input']>;
  recovery?: InputMaybe<Scalars['Float']['input']>;
  sicknessDaysBalance?: InputMaybe<Scalars['Float']['input']>;
  socialSecurityAmountEmployee?: InputMaybe<Scalars['Float']['input']>;
  socialSecurityAmountEmployer?: InputMaybe<Scalars['Float']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  trainingFundEmployeeAmount?: InputMaybe<Scalars['Float']['input']>;
  trainingFundEmployeePercentage?: InputMaybe<Scalars['Float']['input']>;
  trainingFundEmployerAmount?: InputMaybe<Scalars['Float']['input']>;
  trainingFundEmployerPercentage?: InputMaybe<Scalars['Float']['input']>;
  trainingFundId?: InputMaybe<Scalars['UUID']['input']>;
  travelAndSubsistence?: InputMaybe<Scalars['Float']['input']>;
  vacationDaysBalance?: InputMaybe<Scalars['Float']['input']>;
  vacationTakeout?: InputMaybe<Scalars['Float']['input']>;
  workDays?: InputMaybe<Scalars['Float']['input']>;
  zkufot?: InputMaybe<Scalars['Int']['input']>;
};

/**  Result of a scraper upload mutation  */
export type ScraperUploadResult = {
  __typename?: 'ScraperUploadResult';
  changedTransactions: Array<ChangedTransaction>;
  inserted: Scalars['Int']['output'];
  insertedIds: Array<Scalars['String']['output']>;
  insertedTransactions: Array<InsertedTransactionSummary>;
  skipped: Scalars['Int']['output'];
};

/**  Input for setting Step 03 (opening balance) manual status  */
export type SetAnnualAuditStep03StatusInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['UUID']['input'];
  status: AnnualAuditStepStatus;
  year: Scalars['Int']['input'];
};

/**  Input for setting Step 09 (save final dynamic report template) status  */
export type SetAnnualAuditStep09StatusInput = {
  ownerId: Scalars['UUID']['input'];
  /**  The name of the dynamic report template to lock as the final draft  */
  templateName: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

/**  Generic input for manually setting any annual audit step status  */
export type SetAnnualAuditStepStatusInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['UUID']['input'];
  status: AnnualAuditStepStatus;
  stepId: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

/** Result of a set-credentials mutation — either the saved status or an error */
export type SetProviderCredentialsResult = CommonError | ProviderCredentialResult;

/**  Shaam6111 report data  */
export type Shaam6111Data = {
  __typename?: 'Shaam6111Data';
  balanceSheet?: Maybe<Array<Shaam6111ReportEntry>>;
  header: Shaam6111Header;
  id: Scalars['ID']['output'];
  individualOrCompany?: Maybe<IndividualOrCompany>;
  profitAndLoss: Array<Shaam6111ReportEntry>;
  taxAdjustment: Array<Shaam6111ReportEntry>;
};

/**  Shaam6111 file content  */
export type Shaam6111File = {
  __typename?: 'Shaam6111File';
  diffContent?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reportContent: Scalars['String']['output'];
};

/**  Header Record containing metadata about the tax report (כותרת) */
export type Shaam6111Header = {
  __typename?: 'Shaam6111Header';
  /** Accounting method - mandatory field (שיטת חשבונאות) */
  accountingMethod: AccountingMethod;
  /**  Business accounting system - mandatory field (הנח''ש של העסק)  */
  accountingSystem: AccountingSystem;
  /** Are amounts in thousands (הסכום באלפי שקלים/דולרים) */
  amountsInThousands: Scalars['Boolean']['output'];
  /** Audit opinion type (חוות דעת) */
  auditOpinionType?: Maybe<AuditOpinionType>;
  /** Number of entries in balance sheet section (3 digits) - mandatory if entries exist (מספר נגררות פיסקת מאזן) */
  balanceSheetEntryCount?: Maybe<Scalars['Int']['output']>;
  /** Business description (50 characters max) - right-aligned Hebrew text (תאור העסק) */
  businessDescription?: Maybe<Scalars['String']['output']>;
  /** Business type - mandatory field (סוג עסק) */
  businessType: BusinessType;
  /** Currency reporting type (דיווח מטבע) */
  currencyType: CurrencyType;
  /** ID number or company registration number (9 digits) - mandatory field (מס' זהות/ח.פ) */
  idNumber: Scalars['String']['output'];
  /**  Year when IFRS accounting standards were implemented (4 digits) (שנת מס - יישום תקני חשבונאות) Starting from 2006, or 9999 if not applicable  */
  ifrsImplementationYear?: Maybe<Scalars['String']['output']>;
  /** IFRS reporting option (דווח בחלופה - יישום תקני חשבונאות) */
  ifrsReportingOption?: Maybe<IfrsReportingOption>;
  /** Balance sheet included - mandatory field (מצורף דוח מאזן) */
  includesBalanceSheet: Scalars['Boolean']['output'];
  /** Profit and Loss statement included - mandatory field (מצורף דוח רווח הפסד) */
  includesProfitLoss: Scalars['Boolean']['output'];
  /** Tax adjustment statement included - mandatory field (מצורף דוח התאמה) */
  includesTaxAdjustment: Scalars['Boolean']['output'];
  /** Industry code (4 digits) - mandatory field (מס' ענף) */
  industryCode: Scalars['String']['output'];
  /** Is this report for a partnership (דוח זה בגין שותפות) */
  isPartnership?: Maybe<Scalars['Boolean']['output']>;
  /** For partnership reports: number of partners (3 digits) - 999 if not applicable (דוח זה בגין שותפות: מספר השותפים) */
  partnershipCount?: Maybe<Scalars['Int']['output']>;
  /** For partnership reports: share in partnership profits (6 digits, 2 decimal places) - 999999 if not applicable (דוח זה בגין שותפות: חלקי ברווחי השותפות) */
  partnershipProfitShare?: Maybe<Scalars['Int']['output']>;
  /** Number of entries in profit and loss section (3 digits) - mandatory field (מספר נגררות פיסקת רווח הפסד) */
  profitLossEntryCount?: Maybe<Scalars['Int']['output']>;
  /** Reporting method - mandatory field (שיטת דיווח) */
  reportingMethod: ReportingMethod;
  /** Software registration certificate number (8 digits) - 99999999 if not applicable (מספר תעודת רישום - חייב ברישום תוכנה) */
  softwareRegistrationNumber?: Maybe<Scalars['String']['output']>;
  /** Number of entries in tax adjustment section (3 digits) - mandatory if entries exist (מספר נגררות פיסקת התאמה למס) */
  taxAdjustmentEntryCount?: Maybe<Scalars['Int']['output']>;
  /** Tax file number (9 digits) - mandatory field (מספר תיק) */
  taxFileNumber: Scalars['String']['output'];
  /** Tax year (4 digits) - mandatory field (שנת מס) */
  taxYear: Scalars['String']['output'];
  /** VAT file number (9 digits) - if exists (מס' תיק מע''מ) */
  vatFileNumber?: Maybe<Scalars['String']['output']>;
  /** Withholding tax file number (9 digits) - if exists (מס' תיק ניכויים) */
  withholdingTaxFileNumber?: Maybe<Scalars['String']['output']>;
};

/**  record of Shaam6111 report  */
export type Shaam6111Report = {
  __typename?: 'Shaam6111Report';
  business: Business;
  data: Shaam6111Data;
  file: Shaam6111File;
  id: Scalars['ID']['output'];
  year: Scalars['Int']['output'];
};

/**  Report Entry interface representing a single financial data entry in any report section  */
export type Shaam6111ReportEntry = {
  __typename?: 'Shaam6111ReportEntry';
  amount: Scalars['Int']['output'];
  code: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

/**  defines sickness days for salary record  */
export type SicknessDays = {
  __typename?: 'SicknessDays';
  balance?: Maybe<Scalars['Float']['output']>;
};

/**  Ledger record with balance  */
export type SingleSidedLedgerRecord = {
  __typename?: 'SingleSidedLedgerRecord';
  amount: FinancialAmount;
  balance: Scalars['Float']['output'];
  counterParty?: Maybe<FinancialEntity>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  valueDate: Scalars['DateTime']['output'];
};

/**  Sort Code  */
export type SortCode = {
  __typename?: 'SortCode';
  defaultIrsCode?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/**  contract subscription plans  */
export const SubscriptionPlan = {
  Enterprise: 'ENTERPRISE',
  Pro: 'PRO'
} as const;

export type SubscriptionPlan = typeof SubscriptionPlan[keyof typeof SubscriptionPlan];
/**  input for business suggestions  */
export type Suggestions = {
  __typename?: 'Suggestions';
  description?: Maybe<Scalars['String']['output']>;
  emailListener?: Maybe<SuggestionsEmailListenerConfig>;
  emails?: Maybe<Array<Scalars['String']['output']>>;
  phrases: Array<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  tags: Array<Tag>;
};

/**  business suggestions email listener config  */
export type SuggestionsEmailListenerConfig = {
  __typename?: 'SuggestionsEmailListenerConfig';
  attachments?: Maybe<Array<EmailAttachmentType>>;
  emailBody?: Maybe<Scalars['Boolean']['output']>;
  internalEmailLinks?: Maybe<Array<Scalars['String']['output']>>;
};

/**  input for business suggestions email listener config  */
export type SuggestionsEmailListenerConfigInput = {
  attachments?: InputMaybe<Array<EmailAttachmentType>>;
  emailBody?: InputMaybe<Scalars['Boolean']['input']>;
  internalEmailLinks?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**  input for business suggestions  */
export type SuggestionsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  emailListener?: InputMaybe<SuggestionsEmailListenerConfigInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  phrases?: InputMaybe<Array<Scalars['String']['input']>>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<TagInput>>;
};

/**  defines a tag / category for charge arrangement */
export type Tag = {
  __typename?: 'Tag';
  fullPath?: Maybe<Array<Tag>>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  namePath?: Maybe<Array<Scalars['String']['output']>>;
  parent?: Maybe<Tag>;
};

/**  input variables for Tag */
export type TagInput = {
  id: Scalars['String']['input'];
};

/**  Represents the tax advance rate for a specific date.  */
export type TaxAdvancesRate = {
  __typename?: 'TaxAdvancesRate';
  date: Scalars['TimelessDate']['output'];
  rate: Scalars['Float']['output'];
};

/**  Input type representing the tax advance rate for a specific date.  */
export type TaxAdvancesRateInput = {
  date: Scalars['TimelessDate']['input'];
  rate: Scalars['Float']['input'];
};

/**  Tax category entity used for ledger records  */
export type TaxCategory = FinancialEntity & {
  __typename?: 'TaxCategory';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  irsCode?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sortCode?: Maybe<SortCode>;
  updatedAt: Scalars['DateTime']['output'];
};

/**  result type for taxReport  */
export type TaxReport = {
  __typename?: 'TaxReport';
  id: Scalars['ID']['output'];
  reference: Array<TaxReportYear>;
  report: TaxReportYear;
};

/**  tax data for a single year  */
export type TaxReportYear = {
  __typename?: 'TaxReportYear';
  annualTaxExpense: FinancialAmount;
  businessTripsExcessExpensesAmount: FinancialAmount;
  fines: ReportCommentary;
  id: Scalars['ID']['output'];
  nontaxableLinkage: ReportCommentary;
  profitBeforeTax: ReportCommentary;
  researchAndDevelopmentExpensesByRecords: ReportCommentary;
  researchAndDevelopmentExpensesForTax: FinancialAmount;
  reserves: ReportCommentary;
  salaryExcessExpensesAmount: FinancialAmount;
  specialTaxRate: Scalars['Float']['output'];
  specialTaxableIncome: ReportCommentary;
  taxRate: Scalars['Float']['output'];
  taxableIncome: FinancialAmount;
  untaxableGifts: ReportCommentary;
  year: Scalars['Int']['output'];
};

/**  represent training fund */
export type TrainingFund = Fund & {
  __typename?: 'TrainingFund';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

/**  Represent a general transaction object  */
export type Transaction = {
  /**  link to the account  */
  account: FinancialAccount;
  /**  the amount of the transaction  */
  amount: FinancialAmount;
  /**  effective bank / card balance, after the transaction  */
  balance: FinancialAmount;
  /**  containing charge ID  */
  chargeId: Scalars['UUID']['output'];
  /**  calculated counterparty details for the charge  */
  counterparty?: Maybe<FinancialEntity>;
  /**  when the initial transaction was created from the first event we found  */
  createdAt: Scalars['DateTime']['output'];
  cryptoExchangeRate?: Maybe<ConversionRate>;
  debitExchangeRates?: Maybe<ExchangeRates>;
  /**  either credit or debit  */
  direction: TransactionDirection;
  /**  debitDate  */
  effectiveDate?: Maybe<Scalars['TimelessDate']['output']>;
  /**  eventDate  */
  eventDate: Scalars['TimelessDate']['output'];
  eventExchangeRates?: Maybe<ExchangeRates>;
  /**  debitTimeStamp  */
  exactEffectiveDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  /**  is this transaction a fee?  */
  isFee?: Maybe<Scalars['Boolean']['output']>;
  /**  missing info suggestions data  */
  missingInfoSuggestions?: Maybe<TransactionSuggestions>;
  /**  external key / identifier in the bank or card (אסמכתא)  */
  referenceKey?: Maybe<Scalars['String']['output']>;
  /**  description of the transaction, as defined by the bank/card  */
  sourceDescription: Scalars['String']['output'];
  /**  debitDate without user overrides and completions  */
  sourceEffectiveDate?: Maybe<Scalars['TimelessDate']['output']>;
  /**  when the transaction was last updated  */
  updatedAt: Scalars['DateTime']['output'];
};

/**  The direction of the transaction  */
export const TransactionDirection = {
  Credit: 'CREDIT',
  Debit: 'DEBIT'
} as const;

export type TransactionDirection = typeof TransactionDirection[keyof typeof TransactionDirection];
/**  represent transaction suggestions for missing info  */
export type TransactionSuggestions = {
  __typename?: 'TransactionSuggestions';
  business: FinancialEntity;
};

/**  represent transaction not (fully) categorized under business trips  */
export type UncategorizedTransaction = {
  __typename?: 'UncategorizedTransaction';
  categorizedAmount: FinancialAmount;
  errors: Array<Scalars['String']['output']>;
  transaction: Transaction;
};

/**  result type for uniformFormat  */
export type UniformFormat = {
  __typename?: 'UniformFormat';
  bkmvdata: Scalars['FileScalar']['output'];
  ini: Scalars['FileScalar']['output'];
};

/**  document that haven't yet been processed */
export type Unprocessed = Document & Linkable & {
  __typename?: 'Unprocessed';
  charge?: Maybe<Charge>;
  description?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<DocumentType>;
  file?: Maybe<Scalars['URL']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Scalars['URL']['output']>;
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
};

/**  Input type for updating admin business details.  */
export type UpdateAdminBusinessInput = {
  governmentId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  registrationDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  /**  Social Security Info  */
  socialSecurityEmployerIds?: InputMaybe<Array<AnnualIdInput>>;
  /**  Tax Advances Info  */
  taxAdvancesAnnualIds?: InputMaybe<Array<AnnualIdInput>>;
  taxAdvancesRates?: InputMaybe<Array<TaxAdvancesRateInput>>;
  withholdingTaxAnnualIds?: InputMaybe<Array<AnnualIdInput>>;
  /**  Withholding Tax Info  */
  withholdingTaxCompanyId?: InputMaybe<Scalars['String']['input']>;
};

/**  input for updateBusiness  */
export type UpdateBusinessInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['CountryCode']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exemptDealer?: InputMaybe<Scalars['Boolean']['input']>;
  governmentId?: InputMaybe<Scalars['String']['input']>;
  hebrewName?: InputMaybe<Scalars['String']['input']>;
  irsCode?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDocumentsOptional?: InputMaybe<Scalars['Boolean']['input']>;
  isReceiptEnough?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  optionalVAT?: InputMaybe<Scalars['Boolean']['input']>;
  pcn874RecordType?: InputMaybe<Pcn874RecordType>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['Int']['input']>;
  suggestions?: InputMaybe<SuggestionsInput>;
  taxCategory?: InputMaybe<Scalars['UUID']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/**  result type for updateBusiness  */
export type UpdateBusinessResponse = CommonError | LtdFinancialEntity;

/**  the input for updating a business trip accommodation expense  */
export type UpdateBusinessTripAccommodationsExpenseInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  attendeesStay: Array<BusinessTripAttendeeStayInput>;
  businessTripId: Scalars['UUID']['input'];
  country?: InputMaybe<Scalars['CountryCode']['input']>;
  currency?: InputMaybe<Currency>;
  date?: InputMaybe<Scalars['TimelessDate']['input']>;
  employeeBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  nightsCount?: InputMaybe<Scalars['Int']['input']>;
  valueDate?: InputMaybe<Scalars['TimelessDate']['input']>;
};

/**  the input for updating a business trip car rental expense  */
export type UpdateBusinessTripCarRentalExpenseInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  businessTripId: Scalars['UUID']['input'];
  currency?: InputMaybe<Currency>;
  date?: InputMaybe<Scalars['TimelessDate']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  employeeBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  isFuelExpense?: InputMaybe<Scalars['Boolean']['input']>;
  valueDate?: InputMaybe<Scalars['TimelessDate']['input']>;
};

/**  the input for updating a business trip flights expense  */
export type UpdateBusinessTripFlightsExpenseInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  attendeeIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  businessTripId: Scalars['UUID']['input'];
  currency?: InputMaybe<Currency>;
  date?: InputMaybe<Scalars['TimelessDate']['input']>;
  employeeBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  flightClass?: InputMaybe<FlightClass>;
  id: Scalars['UUID']['input'];
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  valueDate?: InputMaybe<Scalars['TimelessDate']['input']>;
};

/**  the input for updating a business trip  */
export type UpdateBusinessTripInput = {
  destinationCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tripPurpose?: InputMaybe<Scalars['String']['input']>;
};

/**  the input for updating a business trip other expense  */
export type UpdateBusinessTripOtherExpenseInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  businessTripId: Scalars['UUID']['input'];
  currency?: InputMaybe<Currency>;
  date?: InputMaybe<Scalars['TimelessDate']['input']>;
  deductibleExpense?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employeeBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  valueDate?: InputMaybe<Scalars['TimelessDate']['input']>;
};

/**  the input for updating a business trip T&S expense  */
export type UpdateBusinessTripTravelAndSubsistenceExpenseInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  businessTripId: Scalars['UUID']['input'];
  currency?: InputMaybe<Currency>;
  date?: InputMaybe<Scalars['TimelessDate']['input']>;
  employeeBusinessId?: InputMaybe<Scalars['UUID']['input']>;
  expenseType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  valueDate?: InputMaybe<Scalars['TimelessDate']['input']>;
};

/**  input variables for updateCharge  */
export type UpdateChargeInput = {
  accountantApproval?: InputMaybe<AccountantStatus>;
  businessTripID?: InputMaybe<Scalars['UUID']['input']>;
  counterpartyId?: InputMaybe<Scalars['UUID']['input']>;
  defaultTaxCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  isDecreasedVAT?: InputMaybe<Scalars['Boolean']['input']>;
  isInvoicePaymentDifferentCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  optionalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  optionalVAT?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<TagInput>>;
  type?: InputMaybe<ChargeType>;
  /**  user custom description  */
  userDescription?: InputMaybe<Scalars['String']['input']>;
  yearsOfRelevance?: InputMaybe<Array<YearOfRelevanceInput>>;
};

/**  result type for updateCharge  */
export type UpdateChargeResult = CommonError | UpdateChargeSuccessfulResult;

/**  successful result type for updateCharge  */
export type UpdateChargeSuccessfulResult = {
  __typename?: 'UpdateChargeSuccessfulResult';
  charge: Charge;
};

/**  result type for updateClient  */
export type UpdateClientResponse = Client | CommonError;

/**  input for updating a contract  */
export type UpdateContractInput = {
  amount?: InputMaybe<FinancialAmountInput>;
  billingCycle?: InputMaybe<BillingCycle>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  documentType?: InputMaybe<DocumentType>;
  endDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  msCloud?: InputMaybe<Scalars['URL']['input']>;
  operationsLimit?: InputMaybe<Scalars['BigInt']['input']>;
  plan?: InputMaybe<SubscriptionPlan>;
  product?: InputMaybe<Product>;
  purchaseOrders?: InputMaybe<Array<Scalars['String']['input']>>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['TimelessDate']['input']>;
};

/**  input variables for updateDepreciationCategory  */
export type UpdateDepreciationCategoryInput = {
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

/**  result type for updateDepreciationCategory  */
export type UpdateDepreciationCategoryResult = CommonError | DepreciationCategory;

/**  input variables for updateDepreciationRecord  */
export type UpdateDepreciationRecordInput = {
  activationDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  chargeId?: InputMaybe<Scalars['UUID']['input']>;
  currency?: InputMaybe<Currency>;
  id: Scalars['UUID']['input'];
  type?: InputMaybe<DepreciationType>;
};

/**  result type for updateDepreciationRecord  */
export type UpdateDepreciationRecordResult = CommonError | DepreciationRecord;

/**  input variables for updateDocument  */
export type UpdateDocumentFieldsInput = {
  allocationNumber?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<FinancialAmountInput>;
  chargeId?: InputMaybe<Scalars['UUID']['input']>;
  creditorId?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['TimelessDate']['input']>;
  debtorId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<DocumentType>;
  exchangeRateOverride?: InputMaybe<Scalars['Float']['input']>;
  file?: InputMaybe<Scalars['URL']['input']>;
  image?: InputMaybe<Scalars['URL']['input']>;
  noVatAmount?: InputMaybe<Scalars['Float']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<FinancialAmountInput>;
  vatReportDateOverride?: InputMaybe<Scalars['TimelessDate']['input']>;
};

/**  result type for updateCharge  */
export type UpdateDocumentResult = CommonError | UpdateDocumentSuccessfulResult;

/**  result type for updateDocument */
export type UpdateDocumentSuccessfulResult = {
  __typename?: 'UpdateDocumentSuccessfulResult';
  document?: Maybe<Document>;
};

/**  input type for updating a financial account  */
export type UpdateFinancialAccountInput = {
  bankAccountDetails?: InputMaybe<BankAccountUpdateInput>;
  currencies?: InputMaybe<Array<FinancialAccountCurrencyInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  privateOrBusiness?: InputMaybe<PrivateOrBusinessType>;
  type?: InputMaybe<FinancialAccountType>;
};

/**  input variables for updateMiscExpense  */
export type UpdateMiscExpenseInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  chargeId?: InputMaybe<Scalars['UUID']['input']>;
  creditorId?: InputMaybe<Scalars['UUID']['input']>;
  currency?: InputMaybe<Currency>;
  debtorId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  invoiceDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  valueDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/**  result type for updateCharge  */
export type UpdateSalaryRecordResult = CommonError | UpdateSalaryRecordSuccessfulResult;

/**  result type for updateSalaryRecord */
export type UpdateSalaryRecordSuccessfulResult = {
  __typename?: 'UpdateSalaryRecordSuccessfulResult';
  salaryRecord: Salary;
};

/**  input variables for updateSortCode  */
export type UpdateSortCodeFieldsInput = {
  defaultIrsCode?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/**  input variables for updateTag  */
export type UpdateTagFieldsInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['UUID']['input']>;
};

/**  input for updateTaxCategory  */
export type UpdateTaxCategoryInput = {
  hashavshevetName?: InputMaybe<Scalars['String']['input']>;
  irsCode?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['Int']['input']>;
  taxExcluded?: InputMaybe<Scalars['Boolean']['input']>;
};

/**  result type for updateBusiness  */
export type UpdateTaxCategoryResponse = CommonError | TaxCategory;

/**  input variables for updateTransaction  */
export type UpdateTransactionInput = {
  chargeId?: InputMaybe<Scalars['UUID']['input']>;
  counterpartyId?: InputMaybe<Scalars['UUID']['input']>;
  effectiveDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  isFee?: InputMaybe<Scalars['Boolean']['input']>;
};

/**  result type for updateTransaction  */
export type UpdateTransactionResult = CommonError | CommonTransaction | ConversionTransaction;

/**  result type for updateTransactions  */
export type UpdateTransactionsResult = CommonError | UpdatedTransactionsSuccessfulResult;

/**  result type for successful updateTransactions mutation  */
export type UpdatedTransaction = CommonTransaction | ConversionTransaction;

/**  result type for successful updateTransactions mutation  */
export type UpdatedTransactionsSuccessfulResult = {
  __typename?: 'UpdatedTransactionsSuccessfulResult';
  transactions: Array<UpdatedTransaction>;
};

/**  result type for uploadDocument  */
export type UploadDocumentResult = CommonError | UploadDocumentSuccessfulResult;

/**  result type for uploadDocument */
export type UploadDocumentSuccessfulResult = {
  __typename?: 'UploadDocumentSuccessfulResult';
  document?: Maybe<Document>;
};

/**  user context  */
export type UserContext = {
  __typename?: 'UserContext';
  adminBusinessId: Scalars['UUID']['output'];
  defaultCryptoConversionFiatCurrency: Currency;
  defaultLocalCurrency: Currency;
  financialAccountsBusinessesIds: Array<Scalars['UUID']['output']>;
  ledgerLock?: Maybe<Scalars['TimelessDate']['output']>;
  locality: Scalars['String']['output'];
};

/**  defines vacation days for salary record  */
export type VacationDays = {
  __typename?: 'VacationDays';
  added?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  taken?: Maybe<Scalars['Float']['output']>;
};

/**  represent a validation data for missing info  */
export type ValidationData = {
  __typename?: 'ValidationData';
  balance?: Maybe<FinancialAmount>;
  isValid: Scalars['Boolean']['output'];
  missingInfo: Array<MissingChargeInfo>;
};

/**  input variables for vatReportRecords  */
export type VatReportFilter = {
  chargesType?: InputMaybe<ChargeFilterType>;
  financialEntityId: Scalars['UUID']['input'];
  monthDate: Scalars['TimelessDate']['input'];
};

/**  Vat report record  */
export type VatReportRecord = {
  __typename?: 'VatReportRecord';
  allocationNumber?: Maybe<Scalars['String']['output']>;
  amount: FinancialAmount;
  business?: Maybe<FinancialEntity>;
  chargeAccountantStatus?: Maybe<AccountantStatus>;
  chargeDate?: Maybe<Scalars['TimelessDate']['output']>;
  chargeId: Scalars['UUID']['output'];
  documentDate?: Maybe<Scalars['TimelessDate']['output']>;
  documentId?: Maybe<Scalars['UUID']['output']>;
  documentSerial?: Maybe<Scalars['String']['output']>;
  foreignVat?: Maybe<FinancialAmount>;
  foreignVatAfterDeduction?: Maybe<FinancialAmount>;
  image?: Maybe<Scalars['String']['output']>;
  isProperty: Scalars['Boolean']['output'];
  localAmount?: Maybe<FinancialAmount>;
  localVat?: Maybe<FinancialAmount>;
  localVatAfterDeduction?: Maybe<FinancialAmount>;
  recordType: Pcn874RecordType;
  /**  Int value */
  roundedLocalVatAfterDeduction?: Maybe<FinancialIntAmount>;
  taxReducedForeignAmount?: Maybe<FinancialIntAmount>;
  taxReducedLocalAmount?: Maybe<FinancialIntAmount>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

/**  vat report result  */
export type VatReportResult = {
  __typename?: 'VatReportResult';
  businessTrips: Array<Charge>;
  differentMonthDoc: Array<Charge>;
  expenses: Array<VatReportRecord>;
  income: Array<VatReportRecord>;
  missingInfo: Array<Charge>;
};

/**  charge spread type  */
export type YearOfRelevance = {
  __typename?: 'YearOfRelevance';
  amount?: Maybe<Scalars['Float']['output']>;
  year: Scalars['String']['output'];
};

/**  input variables for charge spread  */
export type YearOfRelevanceInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  year: Scalars['TimelessDate']['input'];
};

/**  yearly ledger report  */
export type YearlyLedgerReport = {
  __typename?: 'YearlyLedgerReport';
  financialEntitiesInfo: Array<YearlyLedgerReportFinancialEntityInfo>;
  id: Scalars['ID']['output'];
  year: Scalars['Int']['output'];
};

/**  Vat report record  */
export type YearlyLedgerReportFinancialEntityInfo = {
  __typename?: 'YearlyLedgerReportFinancialEntityInfo';
  closingBalance: FinancialAmount;
  entity: FinancialEntity;
  openingBalance: FinancialAmount;
  records: Array<SingleSidedLedgerRecord>;
  totalCredit: FinancialAmount;
  totalDebit: FinancialAmount;
};

type DepositTransactionFields_CommonTransaction_Fragment = { __typename?: 'CommonTransaction', id: string, eventDate: any, chargeId: string, amount: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency }, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null } & { ' $fragmentName'?: 'DepositTransactionFields_CommonTransaction_Fragment' };

type DepositTransactionFields_ConversionTransaction_Fragment = { __typename?: 'ConversionTransaction', id: string, eventDate: any, chargeId: string, amount: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency }, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null } & { ' $fragmentName'?: 'DepositTransactionFields_ConversionTransaction_Fragment' };

export type DepositTransactionFieldsFragment =
  | DepositTransactionFields_CommonTransaction_Fragment
  | DepositTransactionFields_ConversionTransaction_Fragment
;

export type SharedDepositTransactionsQueryVariables = Exact<{
  depositId: Scalars['UUID']['input'];
}>;


export type SharedDepositTransactionsQuery = { __typename?: 'Query', deposit: { __typename?: 'BankDeposit', id: string, currency?: Currency | null, metadata: { __typename?: 'BankDepositMetadata', id: string, transactions: Array<
        | (
          { __typename?: 'CommonTransaction', id: string }
          & { ' $fragmentRefs'?: { 'DepositTransactionFields_CommonTransaction_Fragment': DepositTransactionFields_CommonTransaction_Fragment } }
        )
        | (
          { __typename?: 'ConversionTransaction', id: string }
          & { ' $fragmentRefs'?: { 'DepositTransactionFields_ConversionTransaction_Fragment': DepositTransactionFields_ConversionTransaction_Fragment } }
        )
      > } } };

export type BusinessLedgerInfoQueryVariables = Exact<{
  filters?: InputMaybe<BusinessTransactionsFilter>;
}>;


export type BusinessLedgerInfoQuery = { __typename?: 'Query', businessTransactionsFromLedgerRecords:
    | { __typename?: 'BusinessTransactionsFromLedgerRecordsSuccessfulResult', businessTransactions: Array<{ __typename?: 'BusinessTransaction', invoiceDate: any, reference?: string | null, details?: string | null, chargeId: string, amount: { __typename?: 'FinancialAmount', formatted: string, raw: number }, business:
          | { __typename?: 'LtdFinancialEntity', id: string, name: string }
          | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
          | { __typename?: 'TaxCategory', id: string, name: string }
        , foreignAmount?: { __typename?: 'FinancialAmount', formatted: string, raw: number, currency: Currency } | null, counterAccount?:
          | { __typename: 'LtdFinancialEntity', id: string, name: string }
          | { __typename: 'PersonalFinancialEntity', id: string, name: string }
          | { __typename: 'TaxCategory', id: string, name: string }
         | null }> }
    | { __typename: 'CommonError', message: string }
   };

export type BusinessLedgerRecordsSummeryQueryVariables = Exact<{
  filters?: InputMaybe<BusinessTransactionsFilter>;
}>;


export type BusinessLedgerRecordsSummeryQuery = { __typename?: 'Query', businessTransactionsSumFromLedgerRecords:
    | { __typename?: 'BusinessTransactionsSumFromLedgerRecordsSuccessfulResult', businessTransactionsSum: Array<{ __typename?: 'BusinessTransactionSum', business:
          | { __typename?: 'LtdFinancialEntity', id: string, name: string }
          | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
          | { __typename?: 'TaxCategory', id: string, name: string }
        , credit: { __typename?: 'FinancialAmount', formatted: string }, debit: { __typename?: 'FinancialAmount', formatted: string }, total: { __typename?: 'FinancialAmount', formatted: string, raw: number }, foreignCurrenciesSum: Array<{ __typename?: 'ForeignCurrencySum', currency: Currency, credit: { __typename?: 'FinancialAmount', formatted: string }, debit: { __typename?: 'FinancialAmount', formatted: string }, total: { __typename?: 'FinancialAmount', formatted: string, raw: number } }> }> }
    | { __typename: 'CommonError', message: string }
   };

export type BusinessTripScreenQueryVariables = Exact<{
  businessTripId: Scalars['UUID']['input'];
}>;


export type BusinessTripScreenQuery = { __typename?: 'Query', businessTrip?: { __typename?: 'BusinessTrip', id: string, name: string, dates?: { __typename?: 'DateRange', start: any } | null } | null };

export type BusinessTripsRowFieldsFragment = { __typename?: 'BusinessTrip', id: string, name: string, accountantApproval: AccountantStatus } & { ' $fragmentName'?: 'BusinessTripsRowFieldsFragment' };

export type BusinessTripsRowValidationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type BusinessTripsRowValidationQuery = { __typename?: 'Query', businessTrip?: { __typename?: 'BusinessTrip', id: string, uncategorizedTransactions: Array<{ __typename?: 'UncategorizedTransaction', transaction:
        | { __typename?: 'CommonTransaction', id: string }
        | { __typename?: 'ConversionTransaction', id: string }
       } | null>, summary: { __typename?: 'BusinessTripSummary' } & ({ __typename?: 'BusinessTripSummary', errors?: Array<string> | null } | { __typename?: 'BusinessTripSummary', errors?: never }) } | null };

export type EditableBusinessTripQueryVariables = Exact<{
  businessTripId: Scalars['UUID']['input'];
}>;


export type EditableBusinessTripQuery = { __typename?: 'Query', businessTrip?: (
    { __typename?: 'BusinessTrip', id: string, uncategorizedTransactions: Array<{ __typename?: 'UncategorizedTransaction', transaction:
        | { __typename?: 'CommonTransaction', id: string }
        | { __typename?: 'ConversionTransaction', id: string }
       } | null> }
    & { ' $fragmentRefs'?: { 'BusinessTripReportHeaderFieldsFragment': BusinessTripReportHeaderFieldsFragment;'BusinessTripReportAttendeesFieldsFragment': BusinessTripReportAttendeesFieldsFragment;'BusinessTripUncategorizedTransactionsFieldsFragment': BusinessTripUncategorizedTransactionsFieldsFragment;'BusinessTripReportFlightsFieldsFragment': BusinessTripReportFlightsFieldsFragment;'BusinessTripReportAccommodationsFieldsFragment': BusinessTripReportAccommodationsFieldsFragment;'BusinessTripReportTravelAndSubsistenceFieldsFragment': BusinessTripReportTravelAndSubsistenceFieldsFragment;'BusinessTripReportCarRentalFieldsFragment': BusinessTripReportCarRentalFieldsFragment;'BusinessTripReportOtherFieldsFragment': BusinessTripReportOtherFieldsFragment;'BusinessTripReportSummaryFieldsFragment': BusinessTripReportSummaryFieldsFragment } }
  ) | null };

export type BusinessTripsScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessTripsScreenQuery = { __typename?: 'Query', allBusinessTrips: Array<(
    { __typename?: 'BusinessTrip', id: string, name: string, dates?: { __typename?: 'DateRange', start: any } | null }
    & { ' $fragmentRefs'?: { 'BusinessTripsRowFieldsFragment': BusinessTripsRowFieldsFragment } }
  )> };

type BusinessAdminSection_LtdFinancialEntity_Fragment = { __typename?: 'LtdFinancialEntity', id: string, adminInfo?: { __typename?: 'AdminBusiness', id: string, registrationDate: any, withholdingTaxCompanyId?: string | null, socialSecurityDeductionsId?: string | null, withholdingTaxAnnualIds: Array<{ __typename?: 'AnnualId', id: string, year: number }>, socialSecurityEmployerIds: Array<{ __typename?: 'AnnualId', id: string, year: number }>, taxAdvancesAnnualIds: Array<{ __typename?: 'AnnualId', id: string, year: number }>, taxAdvancesRates: Array<{ __typename?: 'TaxAdvancesRate', date: any, rate: number }> } | null } & { ' $fragmentName'?: 'BusinessAdminSection_LtdFinancialEntity_Fragment' };

type BusinessAdminSection_PersonalFinancialEntity_Fragment = { __typename?: 'PersonalFinancialEntity', id: string } & { ' $fragmentName'?: 'BusinessAdminSection_PersonalFinancialEntity_Fragment' };

export type BusinessAdminSectionFragment =
  | BusinessAdminSection_LtdFinancialEntity_Fragment
  | BusinessAdminSection_PersonalFinancialEntity_Fragment
;

export type AdminFinancialAccountsSectionQueryVariables = Exact<{
  adminId: Scalars['UUID']['input'];
}>;


export type AdminFinancialAccountsSectionQuery = { __typename?: 'Query', financialAccountsByOwner: Array<
    | { __typename: 'BankDepositFinancialAccount', id: string, name: string, number: string, type: FinancialAccountType, privateOrBusiness: PrivateOrBusinessType, accountTaxCategories: Array<{ __typename?: 'CurrencyTaxCategory', id: string, currency: Currency, taxCategory: { __typename?: 'TaxCategory', id: string, name: string } }> }
    | { __typename: 'BankFinancialAccount', bankNumber: number, branchNumber: number, iban?: string | null, swiftCode?: string | null, extendedBankNumber?: number | null, partyPreferredIndication?: number | null, partyAccountInvolvementCode?: number | null, accountDealDate?: number | null, accountUpdateDate?: number | null, metegDoarNet?: number | null, kodHarshaatPeilut?: number | null, accountClosingReasonCode?: number | null, accountAgreementOpeningDate?: number | null, serviceAuthorizationDesc?: string | null, branchTypeCode?: number | null, mymailEntitlementSwitch?: number | null, productLabel?: string | null, id: string, name: string, number: string, type: FinancialAccountType, privateOrBusiness: PrivateOrBusinessType, accountTaxCategories: Array<{ __typename?: 'CurrencyTaxCategory', id: string, currency: Currency, taxCategory: { __typename?: 'TaxCategory', id: string, name: string } }> }
    | { __typename: 'CardFinancialAccount', id: string, name: string, number: string, type: FinancialAccountType, privateOrBusiness: PrivateOrBusinessType, accountTaxCategories: Array<{ __typename?: 'CurrencyTaxCategory', id: string, currency: Currency, taxCategory: { __typename?: 'TaxCategory', id: string, name: string } }> }
    | { __typename: 'CryptoWalletFinancialAccount', id: string, name: string, number: string, type: FinancialAccountType, privateOrBusiness: PrivateOrBusinessType, accountTaxCategories: Array<{ __typename?: 'CurrencyTaxCategory', id: string, currency: Currency, taxCategory: { __typename?: 'TaxCategory', id: string, name: string } }> }
    | { __typename: 'ForeignSecuritiesFinancialAccount', id: string, name: string, number: string, type: FinancialAccountType, privateOrBusiness: PrivateOrBusinessType, accountTaxCategories: Array<{ __typename?: 'CurrencyTaxCategory', id: string, currency: Currency, taxCategory: { __typename?: 'TaxCategory', id: string, name: string } }> }
  > };

type BusinessHeader_LtdFinancialEntity_Fragment = { __typename: 'LtdFinancialEntity', governmentId?: string | null, id: string, name: string, createdAt: any, isActive: boolean, adminInfo?: { __typename?: 'AdminBusiness', id: string } | null, clientInfo?: { __typename?: 'Client', id: string } | null } & { ' $fragmentName'?: 'BusinessHeader_LtdFinancialEntity_Fragment' };

type BusinessHeader_PersonalFinancialEntity_Fragment = { __typename: 'PersonalFinancialEntity', id: string, name: string, createdAt: any, isActive: boolean } & { ' $fragmentName'?: 'BusinessHeader_PersonalFinancialEntity_Fragment' };

export type BusinessHeaderFragment =
  | BusinessHeader_LtdFinancialEntity_Fragment
  | BusinessHeader_PersonalFinancialEntity_Fragment
;

export type BusinessChargesSectionQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ChargeFilter>;
}>;


export type BusinessChargesSectionQuery = { __typename?: 'Query', allCharges: { __typename?: 'PaginatedCharges', nodes: Array<
      | (
        { __typename?: 'BankDepositCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_BankDepositCharge_Fragment': ChargesTableFields_BankDepositCharge_Fragment } }
      )
      | (
        { __typename?: 'BusinessTripCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_BusinessTripCharge_Fragment': ChargesTableFields_BusinessTripCharge_Fragment } }
      )
      | (
        { __typename?: 'CommonCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_CommonCharge_Fragment': ChargesTableFields_CommonCharge_Fragment } }
      )
      | (
        { __typename?: 'ConversionCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_ConversionCharge_Fragment': ChargesTableFields_ConversionCharge_Fragment } }
      )
      | (
        { __typename?: 'CreditcardBankCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_CreditcardBankCharge_Fragment': ChargesTableFields_CreditcardBankCharge_Fragment } }
      )
      | (
        { __typename?: 'DividendCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_DividendCharge_Fragment': ChargesTableFields_DividendCharge_Fragment } }
      )
      | (
        { __typename?: 'FinancialCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_FinancialCharge_Fragment': ChargesTableFields_FinancialCharge_Fragment } }
      )
      | (
        { __typename?: 'ForeignSecuritiesCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_ForeignSecuritiesCharge_Fragment': ChargesTableFields_ForeignSecuritiesCharge_Fragment } }
      )
      | (
        { __typename?: 'InternalTransferCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_InternalTransferCharge_Fragment': ChargesTableFields_InternalTransferCharge_Fragment } }
      )
      | (
        { __typename?: 'MonthlyVatCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_MonthlyVatCharge_Fragment': ChargesTableFields_MonthlyVatCharge_Fragment } }
      )
      | (
        { __typename?: 'SalaryCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_SalaryCharge_Fragment': ChargesTableFields_SalaryCharge_Fragment } }
      )
    >, pageInfo: { __typename?: 'PageInfo', totalPages: number } } };

export type ClientContractsSectionQueryVariables = Exact<{
  clientId: Scalars['UUID']['input'];
}>;


export type ClientContractsSectionQuery = { __typename?: 'Query', contractsByClient: Array<{ __typename?: 'Contract', id: string, purchaseOrders: Array<string>, startDate: any, endDate: any, billingCycle: BillingCycle, isActive: boolean, product?: Product | null, documentType: DocumentType, remarks?: string | null, plan?: SubscriptionPlan | null, msCloud?: any | null, operationsLimit: any, amount: { __typename?: 'FinancialAmount', raw: number, currency: Currency } }> };

export type ClientIntegrationsSectionFragment = { __typename?: 'LtdFinancialEntity', id: string, clientInfo?: { __typename?: 'Client', id: string, integrations: { __typename?: 'ClientIntegrations', id: string, hiveId?: string | null, linearId?: string | null, slackChannelKey?: string | null, notionId?: string | null, workflowyUrl?: string | null, greenInvoiceInfo?: { __typename?: 'GreenInvoiceClient', businessId: string, greenInvoiceId?: string | null } | null } } | null } & { ' $fragmentName'?: 'ClientIntegrationsSectionFragment' };

export type ClientIntegrationsSectionGreenInvoiceQueryVariables = Exact<{
  clientId: Scalars['UUID']['input'];
}>;


export type ClientIntegrationsSectionGreenInvoiceQuery = { __typename?: 'Query', greenInvoiceClient: { __typename?: 'GreenInvoiceClient', businessId: string, greenInvoiceId?: string | null, emails?: Array<string> | null, name?: string | null, phone?: string | null, taxId?: string | null, address?: string | null, city?: string | null, zip?: string | null, fax?: string | null, mobile?: string | null, country?: { __typename?: 'Country', id: string, name: string } | null } };

export type ContractBasedDocumentDraftQueryVariables = Exact<{
  issueMonth: Scalars['TimelessDate']['input'];
  contractId: Scalars['UUID']['input'];
}>;


export type ContractBasedDocumentDraftQuery = { __typename?: 'Query', periodicalDocumentDraftsByContracts: Array<(
    { __typename?: 'DocumentDraft' }
    & { ' $fragmentRefs'?: { 'NewDocumentDraftFragment': NewDocumentDraftFragment } }
  )> };

type BusinessConfigurationSection_LtdFinancialEntity_Fragment = { __typename: 'LtdFinancialEntity', optionalVAT?: boolean | null, exemptDealer?: boolean | null, isReceiptEnough?: boolean | null, isDocumentsOptional?: boolean | null, id: string, pcn874RecordType?: Pcn874RecordType | null, irsCode?: number | null, isActive: boolean, sortCode?: { __typename?: 'SortCode', id: string, key: number, defaultIrsCode?: number | null } | null, taxCategory?: { __typename?: 'TaxCategory', id: string } | null, suggestions?: { __typename?: 'Suggestions', phrases: Array<string>, emails?: Array<string> | null, description?: string | null, tags: Array<{ __typename?: 'Tag', id: string }>, emailListener?: { __typename?: 'SuggestionsEmailListenerConfig', internalEmailLinks?: Array<string> | null, emailBody?: boolean | null, attachments?: Array<EmailAttachmentType> | null } | null } | null, clientInfo?: { __typename?: 'Client', id: string } | null } & { ' $fragmentName'?: 'BusinessConfigurationSection_LtdFinancialEntity_Fragment' };

type BusinessConfigurationSection_PersonalFinancialEntity_Fragment = { __typename: 'PersonalFinancialEntity', id: string, pcn874RecordType?: Pcn874RecordType | null, irsCode?: number | null, isActive: boolean } & { ' $fragmentName'?: 'BusinessConfigurationSection_PersonalFinancialEntity_Fragment' };

export type BusinessConfigurationSectionFragment =
  | BusinessConfigurationSection_LtdFinancialEntity_Fragment
  | BusinessConfigurationSection_PersonalFinancialEntity_Fragment
;

type BusinessContactSection_LtdFinancialEntity_Fragment = { __typename: 'LtdFinancialEntity', name: string, hebrewName?: string | null, governmentId?: string | null, address?: string | null, city?: string | null, zipCode?: string | null, email?: string | null, phoneNumber?: string | null, website?: string | null, id: string, country: { __typename?: 'Country', id: string, code: any }, clientInfo?: { __typename?: 'Client', id: string, emails: Array<string> } | null } & { ' $fragmentName'?: 'BusinessContactSection_LtdFinancialEntity_Fragment' };

type BusinessContactSection_PersonalFinancialEntity_Fragment = { __typename: 'PersonalFinancialEntity', id: string } & { ' $fragmentName'?: 'BusinessContactSection_PersonalFinancialEntity_Fragment' };

export type BusinessContactSectionFragment =
  | BusinessContactSection_LtdFinancialEntity_Fragment
  | BusinessContactSection_PersonalFinancialEntity_Fragment
;

type BusinessPage_LtdFinancialEntity_Fragment = (
  { __typename?: 'LtdFinancialEntity', id: string, clientInfo?: { __typename?: 'Client', id: string } | null, adminInfo?: { __typename?: 'AdminBusiness', id: string } | null }
  & { ' $fragmentRefs'?: { 'ClientIntegrationsSectionFragment': ClientIntegrationsSectionFragment;'BusinessHeader_LtdFinancialEntity_Fragment': BusinessHeader_LtdFinancialEntity_Fragment;'BusinessContactSection_LtdFinancialEntity_Fragment': BusinessContactSection_LtdFinancialEntity_Fragment;'BusinessConfigurationSection_LtdFinancialEntity_Fragment': BusinessConfigurationSection_LtdFinancialEntity_Fragment;'BusinessAdminSection_LtdFinancialEntity_Fragment': BusinessAdminSection_LtdFinancialEntity_Fragment } }
) & { ' $fragmentName'?: 'BusinessPage_LtdFinancialEntity_Fragment' };

type BusinessPage_PersonalFinancialEntity_Fragment = (
  { __typename?: 'PersonalFinancialEntity', id: string }
  & { ' $fragmentRefs'?: { 'BusinessHeader_PersonalFinancialEntity_Fragment': BusinessHeader_PersonalFinancialEntity_Fragment;'BusinessContactSection_PersonalFinancialEntity_Fragment': BusinessContactSection_PersonalFinancialEntity_Fragment;'BusinessConfigurationSection_PersonalFinancialEntity_Fragment': BusinessConfigurationSection_PersonalFinancialEntity_Fragment;'BusinessAdminSection_PersonalFinancialEntity_Fragment': BusinessAdminSection_PersonalFinancialEntity_Fragment } }
) & { ' $fragmentName'?: 'BusinessPage_PersonalFinancialEntity_Fragment' };

export type BusinessPageFragment =
  | BusinessPage_LtdFinancialEntity_Fragment
  | BusinessPage_PersonalFinancialEntity_Fragment
;

export type BusinessLedgerSectionQueryVariables = Exact<{
  businessId: Scalars['UUID']['input'];
}>;


export type BusinessLedgerSectionQuery = { __typename?: 'Query', ledgerRecordsByFinancialEntity: Array<(
    { __typename?: 'LedgerRecord', id: string }
    & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
  )> };

export type BusinessTransactionsSectionQueryVariables = Exact<{
  businessId: Scalars['UUID']['input'];
}>;


export type BusinessTransactionsSectionQuery = { __typename?: 'Query', transactionsByFinancialEntity: Array<
    | (
      { __typename?: 'CommonTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment;'TransactionToDownloadForTransactionsTableFields_CommonTransaction_Fragment': TransactionToDownloadForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { __typename?: 'ConversionTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment;'TransactionToDownloadForTransactionsTableFields_ConversionTransaction_Fragment': TransactionToDownloadForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > };

export type AllBusinessesForScreenQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllBusinessesForScreenQuery = { __typename?: 'Query', allBusinesses?: { __typename?: 'PaginatedBusinesses', nodes: Array<
      | (
        { __typename: 'LtdFinancialEntity', id: string, name: string }
        & { ' $fragmentRefs'?: { 'BusinessHeader_LtdFinancialEntity_Fragment': BusinessHeader_LtdFinancialEntity_Fragment } }
      )
      | { __typename: 'PersonalFinancialEntity', id: string, name: string }
    >, pageInfo: { __typename?: 'PageInfo', totalPages: number, totalRecords: number } } | null };

export type ChargeMatchesTableFieldsFragment = { __typename?: 'ChargeMatch', confidenceScore: number, charge:
    | { __typename: 'BankDepositCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', name: string, id: string }
        | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
        | { __typename?: 'TaxCategory', name: string, id: string }
       | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null }
    | { __typename: 'BusinessTripCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', name: string, id: string }
        | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
        | { __typename?: 'TaxCategory', name: string, id: string }
       | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null }
    | { __typename: 'CommonCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', name: string, id: string }
        | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
        | { __typename?: 'TaxCategory', name: string, id: string }
       | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null }
    | { __typename: 'ConversionCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', name: string, id: string }
        | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
        | { __typename?: 'TaxCategory', name: string, id: string }
       | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null }
    | { __typename: 'CreditcardBankCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', name: string, id: string }
        | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
        | { __typename?: 'TaxCategory', name: string, id: string }
       | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null }
    | { __typename: 'DividendCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', name: string, id: string }
        | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
        | { __typename?: 'TaxCategory', name: string, id: string }
       | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null }
    | { __typename: 'FinancialCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', name: string, id: string }
        | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
        | { __typename?: 'TaxCategory', name: string, id: string }
       | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null }
    | { __typename: 'ForeignSecuritiesCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', name: string, id: string }
        | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
        | { __typename?: 'TaxCategory', name: string, id: string }
       | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null }
    | { __typename: 'InternalTransferCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', name: string, id: string }
        | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
        | { __typename?: 'TaxCategory', name: string, id: string }
       | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null }
    | { __typename: 'MonthlyVatCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', name: string, id: string }
        | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
        | { __typename?: 'TaxCategory', name: string, id: string }
       | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null }
    | { __typename: 'SalaryCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', name: string, id: string }
        | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
        | { __typename?: 'TaxCategory', name: string, id: string }
       | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null }
   } & { ' $fragmentName'?: 'ChargeMatchesTableFieldsFragment' };

export type ChargeExtendedInfoForChargeMatchesQueryVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
}>;


export type ChargeExtendedInfoForChargeMatchesQuery = { __typename?: 'Query', charge:
    | { __typename?: 'BankDepositCharge', id: string, transactions: Array<
        | (
          { __typename?: 'CommonTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { __typename?: 'ConversionTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { __typename?: 'CreditInvoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { __typename?: 'Invoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { __typename?: 'InvoiceReceipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { __typename?: 'OtherDocument', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { __typename?: 'Proforma', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { __typename?: 'Receipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { __typename?: 'Unprocessed', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { __typename?: 'BusinessTripCharge', id: string, transactions: Array<
        | (
          { __typename?: 'CommonTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { __typename?: 'ConversionTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { __typename?: 'CreditInvoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { __typename?: 'Invoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { __typename?: 'InvoiceReceipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { __typename?: 'OtherDocument', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { __typename?: 'Proforma', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { __typename?: 'Receipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { __typename?: 'Unprocessed', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { __typename?: 'CommonCharge', id: string, transactions: Array<
        | (
          { __typename?: 'CommonTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { __typename?: 'ConversionTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { __typename?: 'CreditInvoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { __typename?: 'Invoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { __typename?: 'InvoiceReceipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { __typename?: 'OtherDocument', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { __typename?: 'Proforma', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { __typename?: 'Receipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { __typename?: 'Unprocessed', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { __typename?: 'ConversionCharge', id: string, transactions: Array<
        | (
          { __typename?: 'CommonTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { __typename?: 'ConversionTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { __typename?: 'CreditInvoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { __typename?: 'Invoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { __typename?: 'InvoiceReceipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { __typename?: 'OtherDocument', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { __typename?: 'Proforma', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { __typename?: 'Receipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { __typename?: 'Unprocessed', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { __typename?: 'CreditcardBankCharge', id: string, transactions: Array<
        | (
          { __typename?: 'CommonTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { __typename?: 'ConversionTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { __typename?: 'CreditInvoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { __typename?: 'Invoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { __typename?: 'InvoiceReceipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { __typename?: 'OtherDocument', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { __typename?: 'Proforma', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { __typename?: 'Receipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { __typename?: 'Unprocessed', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { __typename?: 'DividendCharge', id: string, transactions: Array<
        | (
          { __typename?: 'CommonTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { __typename?: 'ConversionTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { __typename?: 'CreditInvoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { __typename?: 'Invoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { __typename?: 'InvoiceReceipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { __typename?: 'OtherDocument', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { __typename?: 'Proforma', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { __typename?: 'Receipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { __typename?: 'Unprocessed', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { __typename?: 'FinancialCharge', id: string, transactions: Array<
        | (
          { __typename?: 'CommonTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { __typename?: 'ConversionTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { __typename?: 'CreditInvoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { __typename?: 'Invoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { __typename?: 'InvoiceReceipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { __typename?: 'OtherDocument', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { __typename?: 'Proforma', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { __typename?: 'Receipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { __typename?: 'Unprocessed', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { __typename?: 'ForeignSecuritiesCharge', id: string, transactions: Array<
        | (
          { __typename?: 'CommonTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { __typename?: 'ConversionTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { __typename?: 'CreditInvoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { __typename?: 'Invoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { __typename?: 'InvoiceReceipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { __typename?: 'OtherDocument', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { __typename?: 'Proforma', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { __typename?: 'Receipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { __typename?: 'Unprocessed', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { __typename?: 'InternalTransferCharge', id: string, transactions: Array<
        | (
          { __typename?: 'CommonTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { __typename?: 'ConversionTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { __typename?: 'CreditInvoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { __typename?: 'Invoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { __typename?: 'InvoiceReceipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { __typename?: 'OtherDocument', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { __typename?: 'Proforma', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { __typename?: 'Receipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { __typename?: 'Unprocessed', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { __typename?: 'MonthlyVatCharge', id: string, transactions: Array<
        | (
          { __typename?: 'CommonTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { __typename?: 'ConversionTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { __typename?: 'CreditInvoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { __typename?: 'Invoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { __typename?: 'InvoiceReceipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { __typename?: 'OtherDocument', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { __typename?: 'Proforma', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { __typename?: 'Receipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { __typename?: 'Unprocessed', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { __typename?: 'SalaryCharge', id: string, transactions: Array<
        | (
          { __typename?: 'CommonTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { __typename?: 'ConversionTransaction', id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { __typename?: 'CreditInvoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { __typename?: 'Invoice', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { __typename?: 'InvoiceReceipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { __typename?: 'OtherDocument', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { __typename?: 'Proforma', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { __typename?: 'Receipt', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { __typename?: 'Unprocessed', id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
   };

export type ChargesLedgerValidationQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ChargeFilter>;
}>;


export type ChargesLedgerValidationQuery = { __typename?: 'Query', chargesWithLedgerChanges: Array<{ __typename?: 'ChargesWithLedgerChangesResult', progress: number, charge?:
      | (
        { __typename?: 'BankDepositCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_BankDepositCharge_Fragment': ChargesTableFields_BankDepositCharge_Fragment } }
      )
      | (
        { __typename?: 'BusinessTripCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_BusinessTripCharge_Fragment': ChargesTableFields_BusinessTripCharge_Fragment } }
      )
      | (
        { __typename?: 'CommonCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_CommonCharge_Fragment': ChargesTableFields_CommonCharge_Fragment } }
      )
      | (
        { __typename?: 'ConversionCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_ConversionCharge_Fragment': ChargesTableFields_ConversionCharge_Fragment } }
      )
      | (
        { __typename?: 'CreditcardBankCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_CreditcardBankCharge_Fragment': ChargesTableFields_CreditcardBankCharge_Fragment } }
      )
      | (
        { __typename?: 'DividendCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_DividendCharge_Fragment': ChargesTableFields_DividendCharge_Fragment } }
      )
      | (
        { __typename?: 'FinancialCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_FinancialCharge_Fragment': ChargesTableFields_FinancialCharge_Fragment } }
      )
      | (
        { __typename?: 'ForeignSecuritiesCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_ForeignSecuritiesCharge_Fragment': ChargesTableFields_ForeignSecuritiesCharge_Fragment } }
      )
      | (
        { __typename?: 'InternalTransferCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_InternalTransferCharge_Fragment': ChargesTableFields_InternalTransferCharge_Fragment } }
      )
      | (
        { __typename?: 'MonthlyVatCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_MonthlyVatCharge_Fragment': ChargesTableFields_MonthlyVatCharge_Fragment } }
      )
      | (
        { __typename?: 'SalaryCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_SalaryCharge_Fragment': ChargesTableFields_SalaryCharge_Fragment } }
      )
     | null }> };

type ChargesTableAccountantApprovalFields_BankDepositCharge_Fragment = { __typename?: 'BankDepositCharge', id: string, accountantApproval: AccountantStatus } & { ' $fragmentName'?: 'ChargesTableAccountantApprovalFields_BankDepositCharge_Fragment' };

type ChargesTableAccountantApprovalFields_BusinessTripCharge_Fragment = { __typename?: 'BusinessTripCharge', id: string, accountantApproval: AccountantStatus } & { ' $fragmentName'?: 'ChargesTableAccountantApprovalFields_BusinessTripCharge_Fragment' };

type ChargesTableAccountantApprovalFields_CommonCharge_Fragment = { __typename?: 'CommonCharge', id: string, accountantApproval: AccountantStatus } & { ' $fragmentName'?: 'ChargesTableAccountantApprovalFields_CommonCharge_Fragment' };

type ChargesTableAccountantApprovalFields_ConversionCharge_Fragment = { __typename?: 'ConversionCharge', id: string, accountantApproval: AccountantStatus } & { ' $fragmentName'?: 'ChargesTableAccountantApprovalFields_ConversionCharge_Fragment' };

type ChargesTableAccountantApprovalFields_CreditcardBankCharge_Fragment = { __typename?: 'CreditcardBankCharge', id: string, accountantApproval: AccountantStatus } & { ' $fragmentName'?: 'ChargesTableAccountantApprovalFields_CreditcardBankCharge_Fragment' };

type ChargesTableAccountantApprovalFields_DividendCharge_Fragment = { __typename?: 'DividendCharge', id: string, accountantApproval: AccountantStatus } & { ' $fragmentName'?: 'ChargesTableAccountantApprovalFields_DividendCharge_Fragment' };

type ChargesTableAccountantApprovalFields_FinancialCharge_Fragment = { __typename?: 'FinancialCharge', id: string, accountantApproval: AccountantStatus } & { ' $fragmentName'?: 'ChargesTableAccountantApprovalFields_FinancialCharge_Fragment' };

type ChargesTableAccountantApprovalFields_ForeignSecuritiesCharge_Fragment = { __typename?: 'ForeignSecuritiesCharge', id: string, accountantApproval: AccountantStatus } & { ' $fragmentName'?: 'ChargesTableAccountantApprovalFields_ForeignSecuritiesCharge_Fragment' };

type ChargesTableAccountantApprovalFields_InternalTransferCharge_Fragment = { __typename?: 'InternalTransferCharge', id: string, accountantApproval: AccountantStatus } & { ' $fragmentName'?: 'ChargesTableAccountantApprovalFields_InternalTransferCharge_Fragment' };

type ChargesTableAccountantApprovalFields_MonthlyVatCharge_Fragment = { __typename?: 'MonthlyVatCharge', id: string, accountantApproval: AccountantStatus } & { ' $fragmentName'?: 'ChargesTableAccountantApprovalFields_MonthlyVatCharge_Fragment' };

type ChargesTableAccountantApprovalFields_SalaryCharge_Fragment = { __typename?: 'SalaryCharge', id: string, accountantApproval: AccountantStatus } & { ' $fragmentName'?: 'ChargesTableAccountantApprovalFields_SalaryCharge_Fragment' };

export type ChargesTableAccountantApprovalFieldsFragment =
  | ChargesTableAccountantApprovalFields_BankDepositCharge_Fragment
  | ChargesTableAccountantApprovalFields_BusinessTripCharge_Fragment
  | ChargesTableAccountantApprovalFields_CommonCharge_Fragment
  | ChargesTableAccountantApprovalFields_ConversionCharge_Fragment
  | ChargesTableAccountantApprovalFields_CreditcardBankCharge_Fragment
  | ChargesTableAccountantApprovalFields_DividendCharge_Fragment
  | ChargesTableAccountantApprovalFields_FinancialCharge_Fragment
  | ChargesTableAccountantApprovalFields_ForeignSecuritiesCharge_Fragment
  | ChargesTableAccountantApprovalFields_InternalTransferCharge_Fragment
  | ChargesTableAccountantApprovalFields_MonthlyVatCharge_Fragment
  | ChargesTableAccountantApprovalFields_SalaryCharge_Fragment
;

type ChargesTableAmountFields_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null } & { ' $fragmentName'?: 'ChargesTableAmountFields_BankDepositCharge_Fragment' };

type ChargesTableAmountFields_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null } & { ' $fragmentName'?: 'ChargesTableAmountFields_BusinessTripCharge_Fragment' };

type ChargesTableAmountFields_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null } & { ' $fragmentName'?: 'ChargesTableAmountFields_CommonCharge_Fragment' };

type ChargesTableAmountFields_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null } & { ' $fragmentName'?: 'ChargesTableAmountFields_ConversionCharge_Fragment' };

type ChargesTableAmountFields_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', validCreditCardAmount: boolean, id: string, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null } & { ' $fragmentName'?: 'ChargesTableAmountFields_CreditcardBankCharge_Fragment' };

type ChargesTableAmountFields_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null } & { ' $fragmentName'?: 'ChargesTableAmountFields_DividendCharge_Fragment' };

type ChargesTableAmountFields_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null } & { ' $fragmentName'?: 'ChargesTableAmountFields_FinancialCharge_Fragment' };

type ChargesTableAmountFields_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null } & { ' $fragmentName'?: 'ChargesTableAmountFields_ForeignSecuritiesCharge_Fragment' };

type ChargesTableAmountFields_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null } & { ' $fragmentName'?: 'ChargesTableAmountFields_InternalTransferCharge_Fragment' };

type ChargesTableAmountFields_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null } & { ' $fragmentName'?: 'ChargesTableAmountFields_MonthlyVatCharge_Fragment' };

type ChargesTableAmountFields_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null } & { ' $fragmentName'?: 'ChargesTableAmountFields_SalaryCharge_Fragment' };

export type ChargesTableAmountFieldsFragment =
  | ChargesTableAmountFields_BankDepositCharge_Fragment
  | ChargesTableAmountFields_BusinessTripCharge_Fragment
  | ChargesTableAmountFields_CommonCharge_Fragment
  | ChargesTableAmountFields_ConversionCharge_Fragment
  | ChargesTableAmountFields_CreditcardBankCharge_Fragment
  | ChargesTableAmountFields_DividendCharge_Fragment
  | ChargesTableAmountFields_FinancialCharge_Fragment
  | ChargesTableAmountFields_ForeignSecuritiesCharge_Fragment
  | ChargesTableAmountFields_InternalTransferCharge_Fragment
  | ChargesTableAmountFields_MonthlyVatCharge_Fragment
  | ChargesTableAmountFields_SalaryCharge_Fragment
;

type ChargesTableBusinessTripFields_BankDepositCharge_Fragment = { __typename?: 'BankDepositCharge', id: string } & { ' $fragmentName'?: 'ChargesTableBusinessTripFields_BankDepositCharge_Fragment' };

type ChargesTableBusinessTripFields_BusinessTripCharge_Fragment = { __typename?: 'BusinessTripCharge', id: string, businessTrip?: { __typename?: 'BusinessTrip', id: string, name: string } | null } & { ' $fragmentName'?: 'ChargesTableBusinessTripFields_BusinessTripCharge_Fragment' };

type ChargesTableBusinessTripFields_CommonCharge_Fragment = { __typename?: 'CommonCharge', id: string } & { ' $fragmentName'?: 'ChargesTableBusinessTripFields_CommonCharge_Fragment' };

type ChargesTableBusinessTripFields_ConversionCharge_Fragment = { __typename?: 'ConversionCharge', id: string } & { ' $fragmentName'?: 'ChargesTableBusinessTripFields_ConversionCharge_Fragment' };

type ChargesTableBusinessTripFields_CreditcardBankCharge_Fragment = { __typename?: 'CreditcardBankCharge', id: string } & { ' $fragmentName'?: 'ChargesTableBusinessTripFields_CreditcardBankCharge_Fragment' };

type ChargesTableBusinessTripFields_DividendCharge_Fragment = { __typename?: 'DividendCharge', id: string } & { ' $fragmentName'?: 'ChargesTableBusinessTripFields_DividendCharge_Fragment' };

type ChargesTableBusinessTripFields_FinancialCharge_Fragment = { __typename?: 'FinancialCharge', id: string } & { ' $fragmentName'?: 'ChargesTableBusinessTripFields_FinancialCharge_Fragment' };

type ChargesTableBusinessTripFields_ForeignSecuritiesCharge_Fragment = { __typename?: 'ForeignSecuritiesCharge', id: string } & { ' $fragmentName'?: 'ChargesTableBusinessTripFields_ForeignSecuritiesCharge_Fragment' };

type ChargesTableBusinessTripFields_InternalTransferCharge_Fragment = { __typename?: 'InternalTransferCharge', id: string } & { ' $fragmentName'?: 'ChargesTableBusinessTripFields_InternalTransferCharge_Fragment' };

type ChargesTableBusinessTripFields_MonthlyVatCharge_Fragment = { __typename?: 'MonthlyVatCharge', id: string } & { ' $fragmentName'?: 'ChargesTableBusinessTripFields_MonthlyVatCharge_Fragment' };

type ChargesTableBusinessTripFields_SalaryCharge_Fragment = { __typename?: 'SalaryCharge', id: string } & { ' $fragmentName'?: 'ChargesTableBusinessTripFields_SalaryCharge_Fragment' };

export type ChargesTableBusinessTripFieldsFragment =
  | ChargesTableBusinessTripFields_BankDepositCharge_Fragment
  | ChargesTableBusinessTripFields_BusinessTripCharge_Fragment
  | ChargesTableBusinessTripFields_CommonCharge_Fragment
  | ChargesTableBusinessTripFields_ConversionCharge_Fragment
  | ChargesTableBusinessTripFields_CreditcardBankCharge_Fragment
  | ChargesTableBusinessTripFields_DividendCharge_Fragment
  | ChargesTableBusinessTripFields_FinancialCharge_Fragment
  | ChargesTableBusinessTripFields_ForeignSecuritiesCharge_Fragment
  | ChargesTableBusinessTripFields_InternalTransferCharge_Fragment
  | ChargesTableBusinessTripFields_MonthlyVatCharge_Fragment
  | ChargesTableBusinessTripFields_SalaryCharge_Fragment
;

type ChargesTableEntityFields_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null } & { ' $fragmentName'?: 'ChargesTableEntityFields_BankDepositCharge_Fragment' };

type ChargesTableEntityFields_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null } & { ' $fragmentName'?: 'ChargesTableEntityFields_BusinessTripCharge_Fragment' };

type ChargesTableEntityFields_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null } & { ' $fragmentName'?: 'ChargesTableEntityFields_CommonCharge_Fragment' };

type ChargesTableEntityFields_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null } & { ' $fragmentName'?: 'ChargesTableEntityFields_ConversionCharge_Fragment' };

type ChargesTableEntityFields_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null } & { ' $fragmentName'?: 'ChargesTableEntityFields_CreditcardBankCharge_Fragment' };

type ChargesTableEntityFields_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null } & { ' $fragmentName'?: 'ChargesTableEntityFields_DividendCharge_Fragment' };

type ChargesTableEntityFields_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null } & { ' $fragmentName'?: 'ChargesTableEntityFields_FinancialCharge_Fragment' };

type ChargesTableEntityFields_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null } & { ' $fragmentName'?: 'ChargesTableEntityFields_ForeignSecuritiesCharge_Fragment' };

type ChargesTableEntityFields_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null } & { ' $fragmentName'?: 'ChargesTableEntityFields_InternalTransferCharge_Fragment' };

type ChargesTableEntityFields_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null } & { ' $fragmentName'?: 'ChargesTableEntityFields_MonthlyVatCharge_Fragment' };

type ChargesTableEntityFields_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null } & { ' $fragmentName'?: 'ChargesTableEntityFields_SalaryCharge_Fragment' };

export type ChargesTableEntityFieldsFragment =
  | ChargesTableEntityFields_BankDepositCharge_Fragment
  | ChargesTableEntityFields_BusinessTripCharge_Fragment
  | ChargesTableEntityFields_CommonCharge_Fragment
  | ChargesTableEntityFields_ConversionCharge_Fragment
  | ChargesTableEntityFields_CreditcardBankCharge_Fragment
  | ChargesTableEntityFields_DividendCharge_Fragment
  | ChargesTableEntityFields_FinancialCharge_Fragment
  | ChargesTableEntityFields_ForeignSecuritiesCharge_Fragment
  | ChargesTableEntityFields_InternalTransferCharge_Fragment
  | ChargesTableEntityFields_MonthlyVatCharge_Fragment
  | ChargesTableEntityFields_SalaryCharge_Fragment
;

type ChargesTableDateFields_BankDepositCharge_Fragment = { __typename?: 'BankDepositCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null } & { ' $fragmentName'?: 'ChargesTableDateFields_BankDepositCharge_Fragment' };

type ChargesTableDateFields_BusinessTripCharge_Fragment = { __typename?: 'BusinessTripCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null } & { ' $fragmentName'?: 'ChargesTableDateFields_BusinessTripCharge_Fragment' };

type ChargesTableDateFields_CommonCharge_Fragment = { __typename?: 'CommonCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null } & { ' $fragmentName'?: 'ChargesTableDateFields_CommonCharge_Fragment' };

type ChargesTableDateFields_ConversionCharge_Fragment = { __typename?: 'ConversionCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null } & { ' $fragmentName'?: 'ChargesTableDateFields_ConversionCharge_Fragment' };

type ChargesTableDateFields_CreditcardBankCharge_Fragment = { __typename?: 'CreditcardBankCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null } & { ' $fragmentName'?: 'ChargesTableDateFields_CreditcardBankCharge_Fragment' };

type ChargesTableDateFields_DividendCharge_Fragment = { __typename?: 'DividendCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null } & { ' $fragmentName'?: 'ChargesTableDateFields_DividendCharge_Fragment' };

type ChargesTableDateFields_FinancialCharge_Fragment = { __typename?: 'FinancialCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null } & { ' $fragmentName'?: 'ChargesTableDateFields_FinancialCharge_Fragment' };

type ChargesTableDateFields_ForeignSecuritiesCharge_Fragment = { __typename?: 'ForeignSecuritiesCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null } & { ' $fragmentName'?: 'ChargesTableDateFields_ForeignSecuritiesCharge_Fragment' };

type ChargesTableDateFields_InternalTransferCharge_Fragment = { __typename?: 'InternalTransferCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null } & { ' $fragmentName'?: 'ChargesTableDateFields_InternalTransferCharge_Fragment' };

type ChargesTableDateFields_MonthlyVatCharge_Fragment = { __typename?: 'MonthlyVatCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null } & { ' $fragmentName'?: 'ChargesTableDateFields_MonthlyVatCharge_Fragment' };

type ChargesTableDateFields_SalaryCharge_Fragment = { __typename?: 'SalaryCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null } & { ' $fragmentName'?: 'ChargesTableDateFields_SalaryCharge_Fragment' };

export type ChargesTableDateFieldsFragment =
  | ChargesTableDateFields_BankDepositCharge_Fragment
  | ChargesTableDateFields_BusinessTripCharge_Fragment
  | ChargesTableDateFields_CommonCharge_Fragment
  | ChargesTableDateFields_ConversionCharge_Fragment
  | ChargesTableDateFields_CreditcardBankCharge_Fragment
  | ChargesTableDateFields_DividendCharge_Fragment
  | ChargesTableDateFields_FinancialCharge_Fragment
  | ChargesTableDateFields_ForeignSecuritiesCharge_Fragment
  | ChargesTableDateFields_InternalTransferCharge_Fragment
  | ChargesTableDateFields_MonthlyVatCharge_Fragment
  | ChargesTableDateFields_SalaryCharge_Fragment
;

type ChargesTableDescriptionFields_BankDepositCharge_Fragment = { __typename?: 'BankDepositCharge', id: string, userDescription?: string | null, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', description?: string | null } | null } & { ' $fragmentName'?: 'ChargesTableDescriptionFields_BankDepositCharge_Fragment' };

type ChargesTableDescriptionFields_BusinessTripCharge_Fragment = { __typename?: 'BusinessTripCharge', id: string, userDescription?: string | null, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', description?: string | null } | null } & { ' $fragmentName'?: 'ChargesTableDescriptionFields_BusinessTripCharge_Fragment' };

type ChargesTableDescriptionFields_CommonCharge_Fragment = { __typename?: 'CommonCharge', id: string, userDescription?: string | null, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', description?: string | null } | null } & { ' $fragmentName'?: 'ChargesTableDescriptionFields_CommonCharge_Fragment' };

type ChargesTableDescriptionFields_ConversionCharge_Fragment = { __typename?: 'ConversionCharge', id: string, userDescription?: string | null, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', description?: string | null } | null } & { ' $fragmentName'?: 'ChargesTableDescriptionFields_ConversionCharge_Fragment' };

type ChargesTableDescriptionFields_CreditcardBankCharge_Fragment = { __typename?: 'CreditcardBankCharge', id: string, userDescription?: string | null, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', description?: string | null } | null } & { ' $fragmentName'?: 'ChargesTableDescriptionFields_CreditcardBankCharge_Fragment' };

type ChargesTableDescriptionFields_DividendCharge_Fragment = { __typename?: 'DividendCharge', id: string, userDescription?: string | null, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', description?: string | null } | null } & { ' $fragmentName'?: 'ChargesTableDescriptionFields_DividendCharge_Fragment' };

type ChargesTableDescriptionFields_FinancialCharge_Fragment = { __typename?: 'FinancialCharge', id: string, userDescription?: string | null, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', description?: string | null } | null } & { ' $fragmentName'?: 'ChargesTableDescriptionFields_FinancialCharge_Fragment' };

type ChargesTableDescriptionFields_ForeignSecuritiesCharge_Fragment = { __typename?: 'ForeignSecuritiesCharge', id: string, userDescription?: string | null, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', description?: string | null } | null } & { ' $fragmentName'?: 'ChargesTableDescriptionFields_ForeignSecuritiesCharge_Fragment' };

type ChargesTableDescriptionFields_InternalTransferCharge_Fragment = { __typename?: 'InternalTransferCharge', id: string, userDescription?: string | null, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', description?: string | null } | null } & { ' $fragmentName'?: 'ChargesTableDescriptionFields_InternalTransferCharge_Fragment' };

type ChargesTableDescriptionFields_MonthlyVatCharge_Fragment = { __typename?: 'MonthlyVatCharge', id: string, userDescription?: string | null, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', description?: string | null } | null } & { ' $fragmentName'?: 'ChargesTableDescriptionFields_MonthlyVatCharge_Fragment' };

type ChargesTableDescriptionFields_SalaryCharge_Fragment = { __typename?: 'SalaryCharge', id: string, userDescription?: string | null, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', description?: string | null } | null } & { ' $fragmentName'?: 'ChargesTableDescriptionFields_SalaryCharge_Fragment' };

export type ChargesTableDescriptionFieldsFragment =
  | ChargesTableDescriptionFields_BankDepositCharge_Fragment
  | ChargesTableDescriptionFields_BusinessTripCharge_Fragment
  | ChargesTableDescriptionFields_CommonCharge_Fragment
  | ChargesTableDescriptionFields_ConversionCharge_Fragment
  | ChargesTableDescriptionFields_CreditcardBankCharge_Fragment
  | ChargesTableDescriptionFields_DividendCharge_Fragment
  | ChargesTableDescriptionFields_FinancialCharge_Fragment
  | ChargesTableDescriptionFields_ForeignSecuritiesCharge_Fragment
  | ChargesTableDescriptionFields_InternalTransferCharge_Fragment
  | ChargesTableDescriptionFields_MonthlyVatCharge_Fragment
  | ChargesTableDescriptionFields_SalaryCharge_Fragment
;

type ChargesTableMoreInfoFields_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ __typename?: 'ChargeMetadata', invalidLedger: LedgerValidationStatus } | { __typename?: 'ChargeMetadata', invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargesTableMoreInfoFields_BankDepositCharge_Fragment' };

type ChargesTableMoreInfoFields_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ __typename?: 'ChargeMetadata', invalidLedger: LedgerValidationStatus } | { __typename?: 'ChargeMetadata', invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargesTableMoreInfoFields_BusinessTripCharge_Fragment' };

type ChargesTableMoreInfoFields_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ __typename?: 'ChargeMetadata', invalidLedger: LedgerValidationStatus } | { __typename?: 'ChargeMetadata', invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargesTableMoreInfoFields_CommonCharge_Fragment' };

type ChargesTableMoreInfoFields_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ __typename?: 'ChargeMetadata', invalidLedger: LedgerValidationStatus } | { __typename?: 'ChargeMetadata', invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargesTableMoreInfoFields_ConversionCharge_Fragment' };

type ChargesTableMoreInfoFields_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ __typename?: 'ChargeMetadata', invalidLedger: LedgerValidationStatus } | { __typename?: 'ChargeMetadata', invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargesTableMoreInfoFields_CreditcardBankCharge_Fragment' };

type ChargesTableMoreInfoFields_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ __typename?: 'ChargeMetadata', invalidLedger: LedgerValidationStatus } | { __typename?: 'ChargeMetadata', invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargesTableMoreInfoFields_DividendCharge_Fragment' };

type ChargesTableMoreInfoFields_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ __typename?: 'ChargeMetadata', invalidLedger: LedgerValidationStatus } | { __typename?: 'ChargeMetadata', invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargesTableMoreInfoFields_FinancialCharge_Fragment' };

type ChargesTableMoreInfoFields_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ __typename?: 'ChargeMetadata', invalidLedger: LedgerValidationStatus } | { __typename?: 'ChargeMetadata', invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargesTableMoreInfoFields_ForeignSecuritiesCharge_Fragment' };

type ChargesTableMoreInfoFields_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ __typename?: 'ChargeMetadata', invalidLedger: LedgerValidationStatus } | { __typename?: 'ChargeMetadata', invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargesTableMoreInfoFields_InternalTransferCharge_Fragment' };

type ChargesTableMoreInfoFields_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ __typename?: 'ChargeMetadata', invalidLedger: LedgerValidationStatus } | { __typename?: 'ChargeMetadata', invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargesTableMoreInfoFields_MonthlyVatCharge_Fragment' };

type ChargesTableMoreInfoFields_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ __typename?: 'ChargeMetadata', invalidLedger: LedgerValidationStatus } | { __typename?: 'ChargeMetadata', invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargesTableMoreInfoFields_SalaryCharge_Fragment' };

export type ChargesTableMoreInfoFieldsFragment =
  | ChargesTableMoreInfoFields_BankDepositCharge_Fragment
  | ChargesTableMoreInfoFields_BusinessTripCharge_Fragment
  | ChargesTableMoreInfoFields_CommonCharge_Fragment
  | ChargesTableMoreInfoFields_ConversionCharge_Fragment
  | ChargesTableMoreInfoFields_CreditcardBankCharge_Fragment
  | ChargesTableMoreInfoFields_DividendCharge_Fragment
  | ChargesTableMoreInfoFields_FinancialCharge_Fragment
  | ChargesTableMoreInfoFields_ForeignSecuritiesCharge_Fragment
  | ChargesTableMoreInfoFields_InternalTransferCharge_Fragment
  | ChargesTableMoreInfoFields_MonthlyVatCharge_Fragment
  | ChargesTableMoreInfoFields_SalaryCharge_Fragment
;

type ChargesTableTagsFields_BankDepositCharge_Fragment = { __typename?: 'BankDepositCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } & { ' $fragmentName'?: 'ChargesTableTagsFields_BankDepositCharge_Fragment' };

type ChargesTableTagsFields_BusinessTripCharge_Fragment = { __typename?: 'BusinessTripCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } & { ' $fragmentName'?: 'ChargesTableTagsFields_BusinessTripCharge_Fragment' };

type ChargesTableTagsFields_CommonCharge_Fragment = { __typename?: 'CommonCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } & { ' $fragmentName'?: 'ChargesTableTagsFields_CommonCharge_Fragment' };

type ChargesTableTagsFields_ConversionCharge_Fragment = { __typename?: 'ConversionCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } & { ' $fragmentName'?: 'ChargesTableTagsFields_ConversionCharge_Fragment' };

type ChargesTableTagsFields_CreditcardBankCharge_Fragment = { __typename?: 'CreditcardBankCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } & { ' $fragmentName'?: 'ChargesTableTagsFields_CreditcardBankCharge_Fragment' };

type ChargesTableTagsFields_DividendCharge_Fragment = { __typename?: 'DividendCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } & { ' $fragmentName'?: 'ChargesTableTagsFields_DividendCharge_Fragment' };

type ChargesTableTagsFields_FinancialCharge_Fragment = { __typename?: 'FinancialCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } & { ' $fragmentName'?: 'ChargesTableTagsFields_FinancialCharge_Fragment' };

type ChargesTableTagsFields_ForeignSecuritiesCharge_Fragment = { __typename?: 'ForeignSecuritiesCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } & { ' $fragmentName'?: 'ChargesTableTagsFields_ForeignSecuritiesCharge_Fragment' };

type ChargesTableTagsFields_InternalTransferCharge_Fragment = { __typename?: 'InternalTransferCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } & { ' $fragmentName'?: 'ChargesTableTagsFields_InternalTransferCharge_Fragment' };

type ChargesTableTagsFields_MonthlyVatCharge_Fragment = { __typename?: 'MonthlyVatCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } & { ' $fragmentName'?: 'ChargesTableTagsFields_MonthlyVatCharge_Fragment' };

type ChargesTableTagsFields_SalaryCharge_Fragment = { __typename?: 'SalaryCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> } & { ' $fragmentName'?: 'ChargesTableTagsFields_SalaryCharge_Fragment' };

export type ChargesTableTagsFieldsFragment =
  | ChargesTableTagsFields_BankDepositCharge_Fragment
  | ChargesTableTagsFields_BusinessTripCharge_Fragment
  | ChargesTableTagsFields_CommonCharge_Fragment
  | ChargesTableTagsFields_ConversionCharge_Fragment
  | ChargesTableTagsFields_CreditcardBankCharge_Fragment
  | ChargesTableTagsFields_DividendCharge_Fragment
  | ChargesTableTagsFields_FinancialCharge_Fragment
  | ChargesTableTagsFields_ForeignSecuritiesCharge_Fragment
  | ChargesTableTagsFields_InternalTransferCharge_Fragment
  | ChargesTableTagsFields_MonthlyVatCharge_Fragment
  | ChargesTableTagsFields_SalaryCharge_Fragment
;

type ChargesTableTaxCategoryFields_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null } & { ' $fragmentName'?: 'ChargesTableTaxCategoryFields_BankDepositCharge_Fragment' };

type ChargesTableTaxCategoryFields_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null } & { ' $fragmentName'?: 'ChargesTableTaxCategoryFields_BusinessTripCharge_Fragment' };

type ChargesTableTaxCategoryFields_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null } & { ' $fragmentName'?: 'ChargesTableTaxCategoryFields_CommonCharge_Fragment' };

type ChargesTableTaxCategoryFields_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null } & { ' $fragmentName'?: 'ChargesTableTaxCategoryFields_ConversionCharge_Fragment' };

type ChargesTableTaxCategoryFields_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null } & { ' $fragmentName'?: 'ChargesTableTaxCategoryFields_CreditcardBankCharge_Fragment' };

type ChargesTableTaxCategoryFields_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null } & { ' $fragmentName'?: 'ChargesTableTaxCategoryFields_DividendCharge_Fragment' };

type ChargesTableTaxCategoryFields_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null } & { ' $fragmentName'?: 'ChargesTableTaxCategoryFields_FinancialCharge_Fragment' };

type ChargesTableTaxCategoryFields_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null } & { ' $fragmentName'?: 'ChargesTableTaxCategoryFields_ForeignSecuritiesCharge_Fragment' };

type ChargesTableTaxCategoryFields_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null } & { ' $fragmentName'?: 'ChargesTableTaxCategoryFields_InternalTransferCharge_Fragment' };

type ChargesTableTaxCategoryFields_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null } & { ' $fragmentName'?: 'ChargesTableTaxCategoryFields_MonthlyVatCharge_Fragment' };

type ChargesTableTaxCategoryFields_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null } & { ' $fragmentName'?: 'ChargesTableTaxCategoryFields_SalaryCharge_Fragment' };

export type ChargesTableTaxCategoryFieldsFragment =
  | ChargesTableTaxCategoryFields_BankDepositCharge_Fragment
  | ChargesTableTaxCategoryFields_BusinessTripCharge_Fragment
  | ChargesTableTaxCategoryFields_CommonCharge_Fragment
  | ChargesTableTaxCategoryFields_ConversionCharge_Fragment
  | ChargesTableTaxCategoryFields_CreditcardBankCharge_Fragment
  | ChargesTableTaxCategoryFields_DividendCharge_Fragment
  | ChargesTableTaxCategoryFields_FinancialCharge_Fragment
  | ChargesTableTaxCategoryFields_ForeignSecuritiesCharge_Fragment
  | ChargesTableTaxCategoryFields_InternalTransferCharge_Fragment
  | ChargesTableTaxCategoryFields_MonthlyVatCharge_Fragment
  | ChargesTableTaxCategoryFields_SalaryCharge_Fragment
;

type ChargesTableTypeFields_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string } & { ' $fragmentName'?: 'ChargesTableTypeFields_BankDepositCharge_Fragment' };

type ChargesTableTypeFields_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string } & { ' $fragmentName'?: 'ChargesTableTypeFields_BusinessTripCharge_Fragment' };

type ChargesTableTypeFields_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string } & { ' $fragmentName'?: 'ChargesTableTypeFields_CommonCharge_Fragment' };

type ChargesTableTypeFields_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string } & { ' $fragmentName'?: 'ChargesTableTypeFields_ConversionCharge_Fragment' };

type ChargesTableTypeFields_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', id: string } & { ' $fragmentName'?: 'ChargesTableTypeFields_CreditcardBankCharge_Fragment' };

type ChargesTableTypeFields_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string } & { ' $fragmentName'?: 'ChargesTableTypeFields_DividendCharge_Fragment' };

type ChargesTableTypeFields_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string } & { ' $fragmentName'?: 'ChargesTableTypeFields_FinancialCharge_Fragment' };

type ChargesTableTypeFields_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string } & { ' $fragmentName'?: 'ChargesTableTypeFields_ForeignSecuritiesCharge_Fragment' };

type ChargesTableTypeFields_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string } & { ' $fragmentName'?: 'ChargesTableTypeFields_InternalTransferCharge_Fragment' };

type ChargesTableTypeFields_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string } & { ' $fragmentName'?: 'ChargesTableTypeFields_MonthlyVatCharge_Fragment' };

type ChargesTableTypeFields_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string } & { ' $fragmentName'?: 'ChargesTableTypeFields_SalaryCharge_Fragment' };

export type ChargesTableTypeFieldsFragment =
  | ChargesTableTypeFields_BankDepositCharge_Fragment
  | ChargesTableTypeFields_BusinessTripCharge_Fragment
  | ChargesTableTypeFields_CommonCharge_Fragment
  | ChargesTableTypeFields_ConversionCharge_Fragment
  | ChargesTableTypeFields_CreditcardBankCharge_Fragment
  | ChargesTableTypeFields_DividendCharge_Fragment
  | ChargesTableTypeFields_FinancialCharge_Fragment
  | ChargesTableTypeFields_ForeignSecuritiesCharge_Fragment
  | ChargesTableTypeFields_InternalTransferCharge_Fragment
  | ChargesTableTypeFields_MonthlyVatCharge_Fragment
  | ChargesTableTypeFields_SalaryCharge_Fragment
;

type ChargesTableVatFields_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null } & { ' $fragmentName'?: 'ChargesTableVatFields_BankDepositCharge_Fragment' };

type ChargesTableVatFields_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null } & { ' $fragmentName'?: 'ChargesTableVatFields_BusinessTripCharge_Fragment' };

type ChargesTableVatFields_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null } & { ' $fragmentName'?: 'ChargesTableVatFields_CommonCharge_Fragment' };

type ChargesTableVatFields_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null } & { ' $fragmentName'?: 'ChargesTableVatFields_ConversionCharge_Fragment' };

type ChargesTableVatFields_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null } & { ' $fragmentName'?: 'ChargesTableVatFields_CreditcardBankCharge_Fragment' };

type ChargesTableVatFields_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null } & { ' $fragmentName'?: 'ChargesTableVatFields_DividendCharge_Fragment' };

type ChargesTableVatFields_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null } & { ' $fragmentName'?: 'ChargesTableVatFields_FinancialCharge_Fragment' };

type ChargesTableVatFields_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null } & { ' $fragmentName'?: 'ChargesTableVatFields_ForeignSecuritiesCharge_Fragment' };

type ChargesTableVatFields_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null } & { ' $fragmentName'?: 'ChargesTableVatFields_InternalTransferCharge_Fragment' };

type ChargesTableVatFields_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null } & { ' $fragmentName'?: 'ChargesTableVatFields_MonthlyVatCharge_Fragment' };

type ChargesTableVatFields_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string, validationData?: { __typename?: 'ValidationData', missingInfo: Array<MissingChargeInfo> } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null } & { ' $fragmentName'?: 'ChargesTableVatFields_SalaryCharge_Fragment' };

export type ChargesTableVatFieldsFragment =
  | ChargesTableVatFields_BankDepositCharge_Fragment
  | ChargesTableVatFields_BusinessTripCharge_Fragment
  | ChargesTableVatFields_CommonCharge_Fragment
  | ChargesTableVatFields_ConversionCharge_Fragment
  | ChargesTableVatFields_CreditcardBankCharge_Fragment
  | ChargesTableVatFields_DividendCharge_Fragment
  | ChargesTableVatFields_FinancialCharge_Fragment
  | ChargesTableVatFields_ForeignSecuritiesCharge_Fragment
  | ChargesTableVatFields_InternalTransferCharge_Fragment
  | ChargesTableVatFields_MonthlyVatCharge_Fragment
  | ChargesTableVatFields_SalaryCharge_Fragment
;

type ChargesTableErrorsFields_BankDepositCharge_Fragment = { __typename?: 'BankDepositCharge', id: string, errorsLedger: { __typename?: 'Ledger' } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', errors: Array<string> } | { __typename?: 'LedgerValidation', errors?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargesTableErrorsFields_BankDepositCharge_Fragment' };

type ChargesTableErrorsFields_BusinessTripCharge_Fragment = { __typename?: 'BusinessTripCharge', id: string, errorsLedger: { __typename?: 'Ledger' } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', errors: Array<string> } | { __typename?: 'LedgerValidation', errors?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargesTableErrorsFields_BusinessTripCharge_Fragment' };

type ChargesTableErrorsFields_CommonCharge_Fragment = { __typename?: 'CommonCharge', id: string, errorsLedger: { __typename?: 'Ledger' } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', errors: Array<string> } | { __typename?: 'LedgerValidation', errors?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargesTableErrorsFields_CommonCharge_Fragment' };

type ChargesTableErrorsFields_ConversionCharge_Fragment = { __typename?: 'ConversionCharge', id: string, errorsLedger: { __typename?: 'Ledger' } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', errors: Array<string> } | { __typename?: 'LedgerValidation', errors?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargesTableErrorsFields_ConversionCharge_Fragment' };

type ChargesTableErrorsFields_CreditcardBankCharge_Fragment = { __typename?: 'CreditcardBankCharge', id: string, errorsLedger: { __typename?: 'Ledger' } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', errors: Array<string> } | { __typename?: 'LedgerValidation', errors?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargesTableErrorsFields_CreditcardBankCharge_Fragment' };

type ChargesTableErrorsFields_DividendCharge_Fragment = { __typename?: 'DividendCharge', id: string, errorsLedger: { __typename?: 'Ledger' } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', errors: Array<string> } | { __typename?: 'LedgerValidation', errors?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargesTableErrorsFields_DividendCharge_Fragment' };

type ChargesTableErrorsFields_FinancialCharge_Fragment = { __typename?: 'FinancialCharge', id: string, errorsLedger: { __typename?: 'Ledger' } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', errors: Array<string> } | { __typename?: 'LedgerValidation', errors?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargesTableErrorsFields_FinancialCharge_Fragment' };

type ChargesTableErrorsFields_ForeignSecuritiesCharge_Fragment = { __typename?: 'ForeignSecuritiesCharge', id: string, errorsLedger: { __typename?: 'Ledger' } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', errors: Array<string> } | { __typename?: 'LedgerValidation', errors?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargesTableErrorsFields_ForeignSecuritiesCharge_Fragment' };

type ChargesTableErrorsFields_InternalTransferCharge_Fragment = { __typename?: 'InternalTransferCharge', id: string, errorsLedger: { __typename?: 'Ledger' } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', errors: Array<string> } | { __typename?: 'LedgerValidation', errors?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargesTableErrorsFields_InternalTransferCharge_Fragment' };

type ChargesTableErrorsFields_MonthlyVatCharge_Fragment = { __typename?: 'MonthlyVatCharge', id: string, errorsLedger: { __typename?: 'Ledger' } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', errors: Array<string> } | { __typename?: 'LedgerValidation', errors?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargesTableErrorsFields_MonthlyVatCharge_Fragment' };

type ChargesTableErrorsFields_SalaryCharge_Fragment = { __typename?: 'SalaryCharge', id: string, errorsLedger: { __typename?: 'Ledger' } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', errors: Array<string> } | { __typename?: 'LedgerValidation', errors?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargesTableErrorsFields_SalaryCharge_Fragment' };

export type ChargesTableErrorsFieldsFragment =
  | ChargesTableErrorsFields_BankDepositCharge_Fragment
  | ChargesTableErrorsFields_BusinessTripCharge_Fragment
  | ChargesTableErrorsFields_CommonCharge_Fragment
  | ChargesTableErrorsFields_ConversionCharge_Fragment
  | ChargesTableErrorsFields_CreditcardBankCharge_Fragment
  | ChargesTableErrorsFields_DividendCharge_Fragment
  | ChargesTableErrorsFields_FinancialCharge_Fragment
  | ChargesTableErrorsFields_ForeignSecuritiesCharge_Fragment
  | ChargesTableErrorsFields_InternalTransferCharge_Fragment
  | ChargesTableErrorsFields_MonthlyVatCharge_Fragment
  | ChargesTableErrorsFields_SalaryCharge_Fragment
;

export type FetchChargeQueryVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
}>;


export type FetchChargeQuery = { __typename?: 'Query', charge:
    | { __typename: 'BankDepositCharge', id: string, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null, miscExpenses: Array<{ __typename?: 'MiscExpense', id: string }> } & (
      { __typename?: 'BankDepositCharge' }
      & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_BankDepositCharge_Fragment': Incremental<DocumentsGalleryFields_BankDepositCharge_Fragment> } }
    ) & (
      { __typename?: 'BankDepositCharge' }
      & { ' $fragmentRefs'?: { 'TableDocumentsFields_BankDepositCharge_Fragment': Incremental<TableDocumentsFields_BankDepositCharge_Fragment> } }
    ) & (
      { __typename?: 'BankDepositCharge' }
      & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_BankDepositCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_BankDepositCharge_Fragment> } }
    ) & (
      { __typename?: 'BankDepositCharge' }
      & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_BankDepositCharge_Fragment': Incremental<ChargeTableTransactionsFields_BankDepositCharge_Fragment> } }
    ) & (
      { __typename?: 'BankDepositCharge' }
      & { ' $fragmentRefs'?: { 'ConversionChargeInfo_BankDepositCharge_Fragment': Incremental<ConversionChargeInfo_BankDepositCharge_Fragment> } }
    ) & (
      { __typename?: 'BankDepositCharge' }
      & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_BankDepositCharge_Fragment': Incremental<CreditcardBankChargeInfo_BankDepositCharge_Fragment> } }
    ) & (
      { __typename?: 'BankDepositCharge' }
      & { ' $fragmentRefs'?: { 'TableSalariesFields_BankDepositCharge_Fragment': Incremental<TableSalariesFields_BankDepositCharge_Fragment> } }
    ) & (
      { __typename?: 'BankDepositCharge' }
      & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_BankDepositCharge_Fragment': Incremental<ChargesTableErrorsFields_BankDepositCharge_Fragment> } }
    ) & (
      { __typename?: 'BankDepositCharge' }
      & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_BankDepositCharge_Fragment': Incremental<TableMiscExpensesFields_BankDepositCharge_Fragment> } }
    ) & (
      { __typename?: 'BankDepositCharge' }
      & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_BankDepositCharge_Fragment': Incremental<ExchangeRatesInfo_BankDepositCharge_Fragment> } }
    )
    | { __typename: 'BusinessTripCharge', id: string, businessTrip?: (
        { __typename?: 'BusinessTrip', id: string }
        & { ' $fragmentRefs'?: { 'BusinessTripReportFieldsFragment': BusinessTripReportFieldsFragment } }
      ) | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null, miscExpenses: Array<{ __typename?: 'MiscExpense', id: string }> } & (
      { __typename?: 'BusinessTripCharge' }
      & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_BusinessTripCharge_Fragment': Incremental<DocumentsGalleryFields_BusinessTripCharge_Fragment> } }
    ) & (
      { __typename?: 'BusinessTripCharge' }
      & { ' $fragmentRefs'?: { 'TableDocumentsFields_BusinessTripCharge_Fragment': Incremental<TableDocumentsFields_BusinessTripCharge_Fragment> } }
    ) & (
      { __typename?: 'BusinessTripCharge' }
      & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_BusinessTripCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_BusinessTripCharge_Fragment> } }
    ) & (
      { __typename?: 'BusinessTripCharge' }
      & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_BusinessTripCharge_Fragment': Incremental<ChargeTableTransactionsFields_BusinessTripCharge_Fragment> } }
    ) & (
      { __typename?: 'BusinessTripCharge' }
      & { ' $fragmentRefs'?: { 'ConversionChargeInfo_BusinessTripCharge_Fragment': Incremental<ConversionChargeInfo_BusinessTripCharge_Fragment> } }
    ) & (
      { __typename?: 'BusinessTripCharge' }
      & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_BusinessTripCharge_Fragment': Incremental<CreditcardBankChargeInfo_BusinessTripCharge_Fragment> } }
    ) & (
      { __typename?: 'BusinessTripCharge' }
      & { ' $fragmentRefs'?: { 'TableSalariesFields_BusinessTripCharge_Fragment': Incremental<TableSalariesFields_BusinessTripCharge_Fragment> } }
    ) & (
      { __typename?: 'BusinessTripCharge' }
      & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_BusinessTripCharge_Fragment': Incremental<ChargesTableErrorsFields_BusinessTripCharge_Fragment> } }
    ) & (
      { __typename?: 'BusinessTripCharge' }
      & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_BusinessTripCharge_Fragment': Incremental<TableMiscExpensesFields_BusinessTripCharge_Fragment> } }
    ) & (
      { __typename?: 'BusinessTripCharge' }
      & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_BusinessTripCharge_Fragment': Incremental<ExchangeRatesInfo_BusinessTripCharge_Fragment> } }
    )
    | { __typename: 'CommonCharge', id: string, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null, miscExpenses: Array<{ __typename?: 'MiscExpense', id: string }> } & (
      { __typename?: 'CommonCharge' }
      & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_CommonCharge_Fragment': Incremental<DocumentsGalleryFields_CommonCharge_Fragment> } }
    ) & (
      { __typename?: 'CommonCharge' }
      & { ' $fragmentRefs'?: { 'TableDocumentsFields_CommonCharge_Fragment': Incremental<TableDocumentsFields_CommonCharge_Fragment> } }
    ) & (
      { __typename?: 'CommonCharge' }
      & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_CommonCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_CommonCharge_Fragment> } }
    ) & (
      { __typename?: 'CommonCharge' }
      & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_CommonCharge_Fragment': Incremental<ChargeTableTransactionsFields_CommonCharge_Fragment> } }
    ) & (
      { __typename?: 'CommonCharge' }
      & { ' $fragmentRefs'?: { 'ConversionChargeInfo_CommonCharge_Fragment': Incremental<ConversionChargeInfo_CommonCharge_Fragment> } }
    ) & (
      { __typename?: 'CommonCharge' }
      & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_CommonCharge_Fragment': Incremental<CreditcardBankChargeInfo_CommonCharge_Fragment> } }
    ) & (
      { __typename?: 'CommonCharge' }
      & { ' $fragmentRefs'?: { 'TableSalariesFields_CommonCharge_Fragment': Incremental<TableSalariesFields_CommonCharge_Fragment> } }
    ) & (
      { __typename?: 'CommonCharge' }
      & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_CommonCharge_Fragment': Incremental<ChargesTableErrorsFields_CommonCharge_Fragment> } }
    ) & (
      { __typename?: 'CommonCharge' }
      & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_CommonCharge_Fragment': Incremental<TableMiscExpensesFields_CommonCharge_Fragment> } }
    ) & (
      { __typename?: 'CommonCharge' }
      & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_CommonCharge_Fragment': Incremental<ExchangeRatesInfo_CommonCharge_Fragment> } }
    )
    | { __typename: 'ConversionCharge', id: string, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null, miscExpenses: Array<{ __typename?: 'MiscExpense', id: string }> } & (
      { __typename?: 'ConversionCharge' }
      & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_ConversionCharge_Fragment': Incremental<DocumentsGalleryFields_ConversionCharge_Fragment> } }
    ) & (
      { __typename?: 'ConversionCharge' }
      & { ' $fragmentRefs'?: { 'TableDocumentsFields_ConversionCharge_Fragment': Incremental<TableDocumentsFields_ConversionCharge_Fragment> } }
    ) & (
      { __typename?: 'ConversionCharge' }
      & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_ConversionCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_ConversionCharge_Fragment> } }
    ) & (
      { __typename?: 'ConversionCharge' }
      & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_ConversionCharge_Fragment': Incremental<ChargeTableTransactionsFields_ConversionCharge_Fragment> } }
    ) & (
      { __typename?: 'ConversionCharge' }
      & { ' $fragmentRefs'?: { 'ConversionChargeInfo_ConversionCharge_Fragment': Incremental<ConversionChargeInfo_ConversionCharge_Fragment> } }
    ) & (
      { __typename?: 'ConversionCharge' }
      & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_ConversionCharge_Fragment': Incremental<CreditcardBankChargeInfo_ConversionCharge_Fragment> } }
    ) & (
      { __typename?: 'ConversionCharge' }
      & { ' $fragmentRefs'?: { 'TableSalariesFields_ConversionCharge_Fragment': Incremental<TableSalariesFields_ConversionCharge_Fragment> } }
    ) & (
      { __typename?: 'ConversionCharge' }
      & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_ConversionCharge_Fragment': Incremental<ChargesTableErrorsFields_ConversionCharge_Fragment> } }
    ) & (
      { __typename?: 'ConversionCharge' }
      & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_ConversionCharge_Fragment': Incremental<TableMiscExpensesFields_ConversionCharge_Fragment> } }
    ) & (
      { __typename?: 'ConversionCharge' }
      & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_ConversionCharge_Fragment': Incremental<ExchangeRatesInfo_ConversionCharge_Fragment> } }
    )
    | { __typename: 'CreditcardBankCharge', id: string, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null, miscExpenses: Array<{ __typename?: 'MiscExpense', id: string }> } & (
      { __typename?: 'CreditcardBankCharge' }
      & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_CreditcardBankCharge_Fragment': Incremental<DocumentsGalleryFields_CreditcardBankCharge_Fragment> } }
    ) & (
      { __typename?: 'CreditcardBankCharge' }
      & { ' $fragmentRefs'?: { 'TableDocumentsFields_CreditcardBankCharge_Fragment': Incremental<TableDocumentsFields_CreditcardBankCharge_Fragment> } }
    ) & (
      { __typename?: 'CreditcardBankCharge' }
      & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_CreditcardBankCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_CreditcardBankCharge_Fragment> } }
    ) & (
      { __typename?: 'CreditcardBankCharge' }
      & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_CreditcardBankCharge_Fragment': Incremental<ChargeTableTransactionsFields_CreditcardBankCharge_Fragment> } }
    ) & (
      { __typename?: 'CreditcardBankCharge' }
      & { ' $fragmentRefs'?: { 'ConversionChargeInfo_CreditcardBankCharge_Fragment': Incremental<ConversionChargeInfo_CreditcardBankCharge_Fragment> } }
    ) & (
      { __typename?: 'CreditcardBankCharge' }
      & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_CreditcardBankCharge_Fragment': Incremental<CreditcardBankChargeInfo_CreditcardBankCharge_Fragment> } }
    ) & (
      { __typename?: 'CreditcardBankCharge' }
      & { ' $fragmentRefs'?: { 'TableSalariesFields_CreditcardBankCharge_Fragment': Incremental<TableSalariesFields_CreditcardBankCharge_Fragment> } }
    ) & (
      { __typename?: 'CreditcardBankCharge' }
      & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_CreditcardBankCharge_Fragment': Incremental<ChargesTableErrorsFields_CreditcardBankCharge_Fragment> } }
    ) & (
      { __typename?: 'CreditcardBankCharge' }
      & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_CreditcardBankCharge_Fragment': Incremental<TableMiscExpensesFields_CreditcardBankCharge_Fragment> } }
    ) & (
      { __typename?: 'CreditcardBankCharge' }
      & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_CreditcardBankCharge_Fragment': Incremental<ExchangeRatesInfo_CreditcardBankCharge_Fragment> } }
    )
    | { __typename: 'DividendCharge', id: string, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null, miscExpenses: Array<{ __typename?: 'MiscExpense', id: string }> } & (
      { __typename?: 'DividendCharge' }
      & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_DividendCharge_Fragment': Incremental<DocumentsGalleryFields_DividendCharge_Fragment> } }
    ) & (
      { __typename?: 'DividendCharge' }
      & { ' $fragmentRefs'?: { 'TableDocumentsFields_DividendCharge_Fragment': Incremental<TableDocumentsFields_DividendCharge_Fragment> } }
    ) & (
      { __typename?: 'DividendCharge' }
      & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_DividendCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_DividendCharge_Fragment> } }
    ) & (
      { __typename?: 'DividendCharge' }
      & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_DividendCharge_Fragment': Incremental<ChargeTableTransactionsFields_DividendCharge_Fragment> } }
    ) & (
      { __typename?: 'DividendCharge' }
      & { ' $fragmentRefs'?: { 'ConversionChargeInfo_DividendCharge_Fragment': Incremental<ConversionChargeInfo_DividendCharge_Fragment> } }
    ) & (
      { __typename?: 'DividendCharge' }
      & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_DividendCharge_Fragment': Incremental<CreditcardBankChargeInfo_DividendCharge_Fragment> } }
    ) & (
      { __typename?: 'DividendCharge' }
      & { ' $fragmentRefs'?: { 'TableSalariesFields_DividendCharge_Fragment': Incremental<TableSalariesFields_DividendCharge_Fragment> } }
    ) & (
      { __typename?: 'DividendCharge' }
      & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_DividendCharge_Fragment': Incremental<ChargesTableErrorsFields_DividendCharge_Fragment> } }
    ) & (
      { __typename?: 'DividendCharge' }
      & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_DividendCharge_Fragment': Incremental<TableMiscExpensesFields_DividendCharge_Fragment> } }
    ) & (
      { __typename?: 'DividendCharge' }
      & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_DividendCharge_Fragment': Incremental<ExchangeRatesInfo_DividendCharge_Fragment> } }
    )
    | { __typename: 'FinancialCharge', id: string, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null, miscExpenses: Array<{ __typename?: 'MiscExpense', id: string }> } & (
      { __typename?: 'FinancialCharge' }
      & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_FinancialCharge_Fragment': Incremental<DocumentsGalleryFields_FinancialCharge_Fragment> } }
    ) & (
      { __typename?: 'FinancialCharge' }
      & { ' $fragmentRefs'?: { 'TableDocumentsFields_FinancialCharge_Fragment': Incremental<TableDocumentsFields_FinancialCharge_Fragment> } }
    ) & (
      { __typename?: 'FinancialCharge' }
      & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_FinancialCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_FinancialCharge_Fragment> } }
    ) & (
      { __typename?: 'FinancialCharge' }
      & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_FinancialCharge_Fragment': Incremental<ChargeTableTransactionsFields_FinancialCharge_Fragment> } }
    ) & (
      { __typename?: 'FinancialCharge' }
      & { ' $fragmentRefs'?: { 'ConversionChargeInfo_FinancialCharge_Fragment': Incremental<ConversionChargeInfo_FinancialCharge_Fragment> } }
    ) & (
      { __typename?: 'FinancialCharge' }
      & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_FinancialCharge_Fragment': Incremental<CreditcardBankChargeInfo_FinancialCharge_Fragment> } }
    ) & (
      { __typename?: 'FinancialCharge' }
      & { ' $fragmentRefs'?: { 'TableSalariesFields_FinancialCharge_Fragment': Incremental<TableSalariesFields_FinancialCharge_Fragment> } }
    ) & (
      { __typename?: 'FinancialCharge' }
      & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_FinancialCharge_Fragment': Incremental<ChargesTableErrorsFields_FinancialCharge_Fragment> } }
    ) & (
      { __typename?: 'FinancialCharge' }
      & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_FinancialCharge_Fragment': Incremental<TableMiscExpensesFields_FinancialCharge_Fragment> } }
    ) & (
      { __typename?: 'FinancialCharge' }
      & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_FinancialCharge_Fragment': Incremental<ExchangeRatesInfo_FinancialCharge_Fragment> } }
    )
    | { __typename: 'ForeignSecuritiesCharge', id: string, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null, miscExpenses: Array<{ __typename?: 'MiscExpense', id: string }> } & (
      { __typename?: 'ForeignSecuritiesCharge' }
      & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_ForeignSecuritiesCharge_Fragment': Incremental<DocumentsGalleryFields_ForeignSecuritiesCharge_Fragment> } }
    ) & (
      { __typename?: 'ForeignSecuritiesCharge' }
      & { ' $fragmentRefs'?: { 'TableDocumentsFields_ForeignSecuritiesCharge_Fragment': Incremental<TableDocumentsFields_ForeignSecuritiesCharge_Fragment> } }
    ) & (
      { __typename?: 'ForeignSecuritiesCharge' }
      & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_ForeignSecuritiesCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_ForeignSecuritiesCharge_Fragment> } }
    ) & (
      { __typename?: 'ForeignSecuritiesCharge' }
      & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_ForeignSecuritiesCharge_Fragment': Incremental<ChargeTableTransactionsFields_ForeignSecuritiesCharge_Fragment> } }
    ) & (
      { __typename?: 'ForeignSecuritiesCharge' }
      & { ' $fragmentRefs'?: { 'ConversionChargeInfo_ForeignSecuritiesCharge_Fragment': Incremental<ConversionChargeInfo_ForeignSecuritiesCharge_Fragment> } }
    ) & (
      { __typename?: 'ForeignSecuritiesCharge' }
      & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_ForeignSecuritiesCharge_Fragment': Incremental<CreditcardBankChargeInfo_ForeignSecuritiesCharge_Fragment> } }
    ) & (
      { __typename?: 'ForeignSecuritiesCharge' }
      & { ' $fragmentRefs'?: { 'TableSalariesFields_ForeignSecuritiesCharge_Fragment': Incremental<TableSalariesFields_ForeignSecuritiesCharge_Fragment> } }
    ) & (
      { __typename?: 'ForeignSecuritiesCharge' }
      & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_ForeignSecuritiesCharge_Fragment': Incremental<ChargesTableErrorsFields_ForeignSecuritiesCharge_Fragment> } }
    ) & (
      { __typename?: 'ForeignSecuritiesCharge' }
      & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_ForeignSecuritiesCharge_Fragment': Incremental<TableMiscExpensesFields_ForeignSecuritiesCharge_Fragment> } }
    ) & (
      { __typename?: 'ForeignSecuritiesCharge' }
      & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_ForeignSecuritiesCharge_Fragment': Incremental<ExchangeRatesInfo_ForeignSecuritiesCharge_Fragment> } }
    )
    | { __typename: 'InternalTransferCharge', id: string, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null, miscExpenses: Array<{ __typename?: 'MiscExpense', id: string }> } & (
      { __typename?: 'InternalTransferCharge' }
      & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_InternalTransferCharge_Fragment': Incremental<DocumentsGalleryFields_InternalTransferCharge_Fragment> } }
    ) & (
      { __typename?: 'InternalTransferCharge' }
      & { ' $fragmentRefs'?: { 'TableDocumentsFields_InternalTransferCharge_Fragment': Incremental<TableDocumentsFields_InternalTransferCharge_Fragment> } }
    ) & (
      { __typename?: 'InternalTransferCharge' }
      & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_InternalTransferCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_InternalTransferCharge_Fragment> } }
    ) & (
      { __typename?: 'InternalTransferCharge' }
      & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_InternalTransferCharge_Fragment': Incremental<ChargeTableTransactionsFields_InternalTransferCharge_Fragment> } }
    ) & (
      { __typename?: 'InternalTransferCharge' }
      & { ' $fragmentRefs'?: { 'ConversionChargeInfo_InternalTransferCharge_Fragment': Incremental<ConversionChargeInfo_InternalTransferCharge_Fragment> } }
    ) & (
      { __typename?: 'InternalTransferCharge' }
      & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_InternalTransferCharge_Fragment': Incremental<CreditcardBankChargeInfo_InternalTransferCharge_Fragment> } }
    ) & (
      { __typename?: 'InternalTransferCharge' }
      & { ' $fragmentRefs'?: { 'TableSalariesFields_InternalTransferCharge_Fragment': Incremental<TableSalariesFields_InternalTransferCharge_Fragment> } }
    ) & (
      { __typename?: 'InternalTransferCharge' }
      & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_InternalTransferCharge_Fragment': Incremental<ChargesTableErrorsFields_InternalTransferCharge_Fragment> } }
    ) & (
      { __typename?: 'InternalTransferCharge' }
      & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_InternalTransferCharge_Fragment': Incremental<TableMiscExpensesFields_InternalTransferCharge_Fragment> } }
    ) & (
      { __typename?: 'InternalTransferCharge' }
      & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_InternalTransferCharge_Fragment': Incremental<ExchangeRatesInfo_InternalTransferCharge_Fragment> } }
    )
    | { __typename: 'MonthlyVatCharge', id: string, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null, miscExpenses: Array<{ __typename?: 'MiscExpense', id: string }> } & (
      { __typename?: 'MonthlyVatCharge' }
      & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_MonthlyVatCharge_Fragment': Incremental<DocumentsGalleryFields_MonthlyVatCharge_Fragment> } }
    ) & (
      { __typename?: 'MonthlyVatCharge' }
      & { ' $fragmentRefs'?: { 'TableDocumentsFields_MonthlyVatCharge_Fragment': Incremental<TableDocumentsFields_MonthlyVatCharge_Fragment> } }
    ) & (
      { __typename?: 'MonthlyVatCharge' }
      & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_MonthlyVatCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_MonthlyVatCharge_Fragment> } }
    ) & (
      { __typename?: 'MonthlyVatCharge' }
      & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_MonthlyVatCharge_Fragment': Incremental<ChargeTableTransactionsFields_MonthlyVatCharge_Fragment> } }
    ) & (
      { __typename?: 'MonthlyVatCharge' }
      & { ' $fragmentRefs'?: { 'ConversionChargeInfo_MonthlyVatCharge_Fragment': Incremental<ConversionChargeInfo_MonthlyVatCharge_Fragment> } }
    ) & (
      { __typename?: 'MonthlyVatCharge' }
      & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_MonthlyVatCharge_Fragment': Incremental<CreditcardBankChargeInfo_MonthlyVatCharge_Fragment> } }
    ) & (
      { __typename?: 'MonthlyVatCharge' }
      & { ' $fragmentRefs'?: { 'TableSalariesFields_MonthlyVatCharge_Fragment': Incremental<TableSalariesFields_MonthlyVatCharge_Fragment> } }
    ) & (
      { __typename?: 'MonthlyVatCharge' }
      & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_MonthlyVatCharge_Fragment': Incremental<ChargesTableErrorsFields_MonthlyVatCharge_Fragment> } }
    ) & (
      { __typename?: 'MonthlyVatCharge' }
      & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_MonthlyVatCharge_Fragment': Incremental<TableMiscExpensesFields_MonthlyVatCharge_Fragment> } }
    ) & (
      { __typename?: 'MonthlyVatCharge' }
      & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_MonthlyVatCharge_Fragment': Incremental<ExchangeRatesInfo_MonthlyVatCharge_Fragment> } }
    )
    | { __typename: 'SalaryCharge', id: string, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null, miscExpenses: Array<{ __typename?: 'MiscExpense', id: string }> } & (
      { __typename?: 'SalaryCharge' }
      & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_SalaryCharge_Fragment': Incremental<DocumentsGalleryFields_SalaryCharge_Fragment> } }
    ) & (
      { __typename?: 'SalaryCharge' }
      & { ' $fragmentRefs'?: { 'TableDocumentsFields_SalaryCharge_Fragment': Incremental<TableDocumentsFields_SalaryCharge_Fragment> } }
    ) & (
      { __typename?: 'SalaryCharge' }
      & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_SalaryCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_SalaryCharge_Fragment> } }
    ) & (
      { __typename?: 'SalaryCharge' }
      & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_SalaryCharge_Fragment': Incremental<ChargeTableTransactionsFields_SalaryCharge_Fragment> } }
    ) & (
      { __typename?: 'SalaryCharge' }
      & { ' $fragmentRefs'?: { 'ConversionChargeInfo_SalaryCharge_Fragment': Incremental<ConversionChargeInfo_SalaryCharge_Fragment> } }
    ) & (
      { __typename?: 'SalaryCharge' }
      & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_SalaryCharge_Fragment': Incremental<CreditcardBankChargeInfo_SalaryCharge_Fragment> } }
    ) & (
      { __typename?: 'SalaryCharge' }
      & { ' $fragmentRefs'?: { 'TableSalariesFields_SalaryCharge_Fragment': Incremental<TableSalariesFields_SalaryCharge_Fragment> } }
    ) & (
      { __typename?: 'SalaryCharge' }
      & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_SalaryCharge_Fragment': Incremental<ChargesTableErrorsFields_SalaryCharge_Fragment> } }
    ) & (
      { __typename?: 'SalaryCharge' }
      & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_SalaryCharge_Fragment': Incremental<TableMiscExpensesFields_SalaryCharge_Fragment> } }
    ) & (
      { __typename?: 'SalaryCharge' }
      & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_SalaryCharge_Fragment': Incremental<ExchangeRatesInfo_SalaryCharge_Fragment> } }
    )
   };

type TableDocumentsFields_BankDepositCharge_Fragment = { __typename?: 'BankDepositCharge', id: string, additionalDocuments: Array<
    | (
      { __typename?: 'CreditInvoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { __typename?: 'Invoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { __typename?: 'InvoiceReceipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { __typename?: 'OtherDocument', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { __typename?: 'Proforma', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { __typename?: 'Receipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { __typename?: 'Unprocessed', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_BankDepositCharge_Fragment' };

type TableDocumentsFields_BusinessTripCharge_Fragment = { __typename?: 'BusinessTripCharge', id: string, additionalDocuments: Array<
    | (
      { __typename?: 'CreditInvoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { __typename?: 'Invoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { __typename?: 'InvoiceReceipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { __typename?: 'OtherDocument', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { __typename?: 'Proforma', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { __typename?: 'Receipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { __typename?: 'Unprocessed', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_BusinessTripCharge_Fragment' };

type TableDocumentsFields_CommonCharge_Fragment = { __typename?: 'CommonCharge', id: string, additionalDocuments: Array<
    | (
      { __typename?: 'CreditInvoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { __typename?: 'Invoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { __typename?: 'InvoiceReceipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { __typename?: 'OtherDocument', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { __typename?: 'Proforma', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { __typename?: 'Receipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { __typename?: 'Unprocessed', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_CommonCharge_Fragment' };

type TableDocumentsFields_ConversionCharge_Fragment = { __typename?: 'ConversionCharge', id: string, additionalDocuments: Array<
    | (
      { __typename?: 'CreditInvoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { __typename?: 'Invoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { __typename?: 'InvoiceReceipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { __typename?: 'OtherDocument', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { __typename?: 'Proforma', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { __typename?: 'Receipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { __typename?: 'Unprocessed', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_ConversionCharge_Fragment' };

type TableDocumentsFields_CreditcardBankCharge_Fragment = { __typename?: 'CreditcardBankCharge', id: string, additionalDocuments: Array<
    | (
      { __typename?: 'CreditInvoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { __typename?: 'Invoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { __typename?: 'InvoiceReceipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { __typename?: 'OtherDocument', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { __typename?: 'Proforma', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { __typename?: 'Receipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { __typename?: 'Unprocessed', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_CreditcardBankCharge_Fragment' };

type TableDocumentsFields_DividendCharge_Fragment = { __typename?: 'DividendCharge', id: string, additionalDocuments: Array<
    | (
      { __typename?: 'CreditInvoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { __typename?: 'Invoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { __typename?: 'InvoiceReceipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { __typename?: 'OtherDocument', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { __typename?: 'Proforma', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { __typename?: 'Receipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { __typename?: 'Unprocessed', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_DividendCharge_Fragment' };

type TableDocumentsFields_FinancialCharge_Fragment = { __typename?: 'FinancialCharge', id: string, additionalDocuments: Array<
    | (
      { __typename?: 'CreditInvoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { __typename?: 'Invoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { __typename?: 'InvoiceReceipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { __typename?: 'OtherDocument', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { __typename?: 'Proforma', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { __typename?: 'Receipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { __typename?: 'Unprocessed', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_FinancialCharge_Fragment' };

type TableDocumentsFields_ForeignSecuritiesCharge_Fragment = { __typename?: 'ForeignSecuritiesCharge', id: string, additionalDocuments: Array<
    | (
      { __typename?: 'CreditInvoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { __typename?: 'Invoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { __typename?: 'InvoiceReceipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { __typename?: 'OtherDocument', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { __typename?: 'Proforma', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { __typename?: 'Receipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { __typename?: 'Unprocessed', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_ForeignSecuritiesCharge_Fragment' };

type TableDocumentsFields_InternalTransferCharge_Fragment = { __typename?: 'InternalTransferCharge', id: string, additionalDocuments: Array<
    | (
      { __typename?: 'CreditInvoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { __typename?: 'Invoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { __typename?: 'InvoiceReceipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { __typename?: 'OtherDocument', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { __typename?: 'Proforma', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { __typename?: 'Receipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { __typename?: 'Unprocessed', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_InternalTransferCharge_Fragment' };

type TableDocumentsFields_MonthlyVatCharge_Fragment = { __typename?: 'MonthlyVatCharge', id: string, additionalDocuments: Array<
    | (
      { __typename?: 'CreditInvoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { __typename?: 'Invoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { __typename?: 'InvoiceReceipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { __typename?: 'OtherDocument', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { __typename?: 'Proforma', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { __typename?: 'Receipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { __typename?: 'Unprocessed', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_MonthlyVatCharge_Fragment' };

type TableDocumentsFields_SalaryCharge_Fragment = { __typename?: 'SalaryCharge', id: string, additionalDocuments: Array<
    | (
      { __typename?: 'CreditInvoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { __typename?: 'Invoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { __typename?: 'InvoiceReceipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { __typename?: 'OtherDocument', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { __typename?: 'Proforma', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { __typename?: 'Receipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { __typename?: 'Unprocessed', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_SalaryCharge_Fragment' };

export type TableDocumentsFieldsFragment =
  | TableDocumentsFields_BankDepositCharge_Fragment
  | TableDocumentsFields_BusinessTripCharge_Fragment
  | TableDocumentsFields_CommonCharge_Fragment
  | TableDocumentsFields_ConversionCharge_Fragment
  | TableDocumentsFields_CreditcardBankCharge_Fragment
  | TableDocumentsFields_DividendCharge_Fragment
  | TableDocumentsFields_FinancialCharge_Fragment
  | TableDocumentsFields_ForeignSecuritiesCharge_Fragment
  | TableDocumentsFields_InternalTransferCharge_Fragment
  | TableDocumentsFields_MonthlyVatCharge_Fragment
  | TableDocumentsFields_SalaryCharge_Fragment
;

type ChargeLedgerRecordsTableFields_BankDepositCharge_Fragment = { __typename?: 'BankDepositCharge', id: string, ledger: { __typename: 'Ledger', records: Array<(
      { __typename?: 'LedgerRecord', id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', matches: Array<string> } | { __typename?: 'LedgerValidation', matches?: never }) & ({ __typename?: 'LedgerValidation', differences: Array<(
        { __typename?: 'LedgerRecord', id: string }
        & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
      )> } | { __typename?: 'LedgerValidation', differences?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_BankDepositCharge_Fragment' };

type ChargeLedgerRecordsTableFields_BusinessTripCharge_Fragment = { __typename?: 'BusinessTripCharge', id: string, ledger: { __typename: 'Ledger', records: Array<(
      { __typename?: 'LedgerRecord', id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', matches: Array<string> } | { __typename?: 'LedgerValidation', matches?: never }) & ({ __typename?: 'LedgerValidation', differences: Array<(
        { __typename?: 'LedgerRecord', id: string }
        & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
      )> } | { __typename?: 'LedgerValidation', differences?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_BusinessTripCharge_Fragment' };

type ChargeLedgerRecordsTableFields_CommonCharge_Fragment = { __typename?: 'CommonCharge', id: string, ledger: { __typename: 'Ledger', records: Array<(
      { __typename?: 'LedgerRecord', id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', matches: Array<string> } | { __typename?: 'LedgerValidation', matches?: never }) & ({ __typename?: 'LedgerValidation', differences: Array<(
        { __typename?: 'LedgerRecord', id: string }
        & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
      )> } | { __typename?: 'LedgerValidation', differences?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_CommonCharge_Fragment' };

type ChargeLedgerRecordsTableFields_ConversionCharge_Fragment = { __typename?: 'ConversionCharge', id: string, ledger: { __typename: 'Ledger', records: Array<(
      { __typename?: 'LedgerRecord', id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', matches: Array<string> } | { __typename?: 'LedgerValidation', matches?: never }) & ({ __typename?: 'LedgerValidation', differences: Array<(
        { __typename?: 'LedgerRecord', id: string }
        & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
      )> } | { __typename?: 'LedgerValidation', differences?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_ConversionCharge_Fragment' };

type ChargeLedgerRecordsTableFields_CreditcardBankCharge_Fragment = { __typename?: 'CreditcardBankCharge', id: string, ledger: { __typename: 'Ledger', records: Array<(
      { __typename?: 'LedgerRecord', id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', matches: Array<string> } | { __typename?: 'LedgerValidation', matches?: never }) & ({ __typename?: 'LedgerValidation', differences: Array<(
        { __typename?: 'LedgerRecord', id: string }
        & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
      )> } | { __typename?: 'LedgerValidation', differences?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_CreditcardBankCharge_Fragment' };

type ChargeLedgerRecordsTableFields_DividendCharge_Fragment = { __typename?: 'DividendCharge', id: string, ledger: { __typename: 'Ledger', records: Array<(
      { __typename?: 'LedgerRecord', id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', matches: Array<string> } | { __typename?: 'LedgerValidation', matches?: never }) & ({ __typename?: 'LedgerValidation', differences: Array<(
        { __typename?: 'LedgerRecord', id: string }
        & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
      )> } | { __typename?: 'LedgerValidation', differences?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_DividendCharge_Fragment' };

type ChargeLedgerRecordsTableFields_FinancialCharge_Fragment = { __typename?: 'FinancialCharge', id: string, ledger: { __typename: 'Ledger', records: Array<(
      { __typename?: 'LedgerRecord', id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', matches: Array<string> } | { __typename?: 'LedgerValidation', matches?: never }) & ({ __typename?: 'LedgerValidation', differences: Array<(
        { __typename?: 'LedgerRecord', id: string }
        & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
      )> } | { __typename?: 'LedgerValidation', differences?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_FinancialCharge_Fragment' };

type ChargeLedgerRecordsTableFields_ForeignSecuritiesCharge_Fragment = { __typename?: 'ForeignSecuritiesCharge', id: string, ledger: { __typename: 'Ledger', records: Array<(
      { __typename?: 'LedgerRecord', id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', matches: Array<string> } | { __typename?: 'LedgerValidation', matches?: never }) & ({ __typename?: 'LedgerValidation', differences: Array<(
        { __typename?: 'LedgerRecord', id: string }
        & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
      )> } | { __typename?: 'LedgerValidation', differences?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_ForeignSecuritiesCharge_Fragment' };

type ChargeLedgerRecordsTableFields_InternalTransferCharge_Fragment = { __typename?: 'InternalTransferCharge', id: string, ledger: { __typename: 'Ledger', records: Array<(
      { __typename?: 'LedgerRecord', id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', matches: Array<string> } | { __typename?: 'LedgerValidation', matches?: never }) & ({ __typename?: 'LedgerValidation', differences: Array<(
        { __typename?: 'LedgerRecord', id: string }
        & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
      )> } | { __typename?: 'LedgerValidation', differences?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_InternalTransferCharge_Fragment' };

type ChargeLedgerRecordsTableFields_MonthlyVatCharge_Fragment = { __typename?: 'MonthlyVatCharge', id: string, ledger: { __typename: 'Ledger', records: Array<(
      { __typename?: 'LedgerRecord', id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', matches: Array<string> } | { __typename?: 'LedgerValidation', matches?: never }) & ({ __typename?: 'LedgerValidation', differences: Array<(
        { __typename?: 'LedgerRecord', id: string }
        & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
      )> } | { __typename?: 'LedgerValidation', differences?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_MonthlyVatCharge_Fragment' };

type ChargeLedgerRecordsTableFields_SalaryCharge_Fragment = { __typename?: 'SalaryCharge', id: string, ledger: { __typename: 'Ledger', records: Array<(
      { __typename?: 'LedgerRecord', id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ __typename?: 'Ledger', validate: { __typename?: 'LedgerValidation' } & ({ __typename?: 'LedgerValidation', matches: Array<string> } | { __typename?: 'LedgerValidation', matches?: never }) & ({ __typename?: 'LedgerValidation', differences: Array<(
        { __typename?: 'LedgerRecord', id: string }
        & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
      )> } | { __typename?: 'LedgerValidation', differences?: never }) } | { __typename?: 'Ledger', validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_SalaryCharge_Fragment' };

export type ChargeLedgerRecordsTableFieldsFragment =
  | ChargeLedgerRecordsTableFields_BankDepositCharge_Fragment
  | ChargeLedgerRecordsTableFields_BusinessTripCharge_Fragment
  | ChargeLedgerRecordsTableFields_CommonCharge_Fragment
  | ChargeLedgerRecordsTableFields_ConversionCharge_Fragment
  | ChargeLedgerRecordsTableFields_CreditcardBankCharge_Fragment
  | ChargeLedgerRecordsTableFields_DividendCharge_Fragment
  | ChargeLedgerRecordsTableFields_FinancialCharge_Fragment
  | ChargeLedgerRecordsTableFields_ForeignSecuritiesCharge_Fragment
  | ChargeLedgerRecordsTableFields_InternalTransferCharge_Fragment
  | ChargeLedgerRecordsTableFields_MonthlyVatCharge_Fragment
  | ChargeLedgerRecordsTableFields_SalaryCharge_Fragment
;

type ChargeTableTransactionsFields_BankDepositCharge_Fragment = { __typename?: 'BankDepositCharge', id: string, transactions: Array<
    | (
      { __typename?: 'CommonTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { __typename?: 'ConversionTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_BankDepositCharge_Fragment' };

type ChargeTableTransactionsFields_BusinessTripCharge_Fragment = { __typename?: 'BusinessTripCharge', id: string, transactions: Array<
    | (
      { __typename?: 'CommonTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { __typename?: 'ConversionTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_BusinessTripCharge_Fragment' };

type ChargeTableTransactionsFields_CommonCharge_Fragment = { __typename?: 'CommonCharge', id: string, transactions: Array<
    | (
      { __typename?: 'CommonTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { __typename?: 'ConversionTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_CommonCharge_Fragment' };

type ChargeTableTransactionsFields_ConversionCharge_Fragment = { __typename?: 'ConversionCharge', id: string, transactions: Array<
    | (
      { __typename?: 'CommonTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { __typename?: 'ConversionTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_ConversionCharge_Fragment' };

type ChargeTableTransactionsFields_CreditcardBankCharge_Fragment = { __typename?: 'CreditcardBankCharge', id: string, transactions: Array<
    | (
      { __typename?: 'CommonTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { __typename?: 'ConversionTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_CreditcardBankCharge_Fragment' };

type ChargeTableTransactionsFields_DividendCharge_Fragment = { __typename?: 'DividendCharge', id: string, transactions: Array<
    | (
      { __typename?: 'CommonTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { __typename?: 'ConversionTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_DividendCharge_Fragment' };

type ChargeTableTransactionsFields_FinancialCharge_Fragment = { __typename?: 'FinancialCharge', id: string, transactions: Array<
    | (
      { __typename?: 'CommonTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { __typename?: 'ConversionTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_FinancialCharge_Fragment' };

type ChargeTableTransactionsFields_ForeignSecuritiesCharge_Fragment = { __typename?: 'ForeignSecuritiesCharge', id: string, transactions: Array<
    | (
      { __typename?: 'CommonTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { __typename?: 'ConversionTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_ForeignSecuritiesCharge_Fragment' };

type ChargeTableTransactionsFields_InternalTransferCharge_Fragment = { __typename?: 'InternalTransferCharge', id: string, transactions: Array<
    | (
      { __typename?: 'CommonTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { __typename?: 'ConversionTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_InternalTransferCharge_Fragment' };

type ChargeTableTransactionsFields_MonthlyVatCharge_Fragment = { __typename?: 'MonthlyVatCharge', id: string, transactions: Array<
    | (
      { __typename?: 'CommonTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { __typename?: 'ConversionTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_MonthlyVatCharge_Fragment' };

type ChargeTableTransactionsFields_SalaryCharge_Fragment = { __typename?: 'SalaryCharge', id: string, transactions: Array<
    | (
      { __typename?: 'CommonTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { __typename?: 'ConversionTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_SalaryCharge_Fragment' };

export type ChargeTableTransactionsFieldsFragment =
  | ChargeTableTransactionsFields_BankDepositCharge_Fragment
  | ChargeTableTransactionsFields_BusinessTripCharge_Fragment
  | ChargeTableTransactionsFields_CommonCharge_Fragment
  | ChargeTableTransactionsFields_ConversionCharge_Fragment
  | ChargeTableTransactionsFields_CreditcardBankCharge_Fragment
  | ChargeTableTransactionsFields_DividendCharge_Fragment
  | ChargeTableTransactionsFields_FinancialCharge_Fragment
  | ChargeTableTransactionsFields_ForeignSecuritiesCharge_Fragment
  | ChargeTableTransactionsFields_InternalTransferCharge_Fragment
  | ChargeTableTransactionsFields_MonthlyVatCharge_Fragment
  | ChargeTableTransactionsFields_SalaryCharge_Fragment
;

type ChargesTableRowFields_BankDepositCharge_Fragment = (
  { __typename: 'BankDepositCharge', id: string, metadata?: { __typename?: 'ChargeMetadata' } & ({ __typename?: 'ChargeMetadata', documentsCount: number } | { __typename?: 'ChargeMetadata', documentsCount?: never }) & ({ __typename?: 'ChargeMetadata', ledgerCount: number } | { __typename?: 'ChargeMetadata', ledgerCount?: never }) & ({ __typename?: 'ChargeMetadata', transactionsCount: number } | { __typename?: 'ChargeMetadata', transactionsCount?: never }) & ({ __typename?: 'ChargeMetadata', miscExpensesCount: number } | { __typename?: 'ChargeMetadata', miscExpensesCount?: never }) | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null }
  & { ' $fragmentRefs'?: { 'ChargesTableAccountantApprovalFields_BankDepositCharge_Fragment': ChargesTableAccountantApprovalFields_BankDepositCharge_Fragment;'ChargesTableAmountFields_BankDepositCharge_Fragment': ChargesTableAmountFields_BankDepositCharge_Fragment;'ChargesTableDateFields_BankDepositCharge_Fragment': ChargesTableDateFields_BankDepositCharge_Fragment;'ChargesTableDescriptionFields_BankDepositCharge_Fragment': ChargesTableDescriptionFields_BankDepositCharge_Fragment;'ChargesTableMoreInfoFields_BankDepositCharge_Fragment': ChargesTableMoreInfoFields_BankDepositCharge_Fragment;'ChargesTableTypeFields_BankDepositCharge_Fragment': ChargesTableTypeFields_BankDepositCharge_Fragment;'ChargesTableVatFields_BankDepositCharge_Fragment': ChargesTableVatFields_BankDepositCharge_Fragment } }
) & (
  { __typename?: 'BankDepositCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableBusinessTripFields_BankDepositCharge_Fragment': Incremental<ChargesTableBusinessTripFields_BankDepositCharge_Fragment> } }
) & (
  { __typename?: 'BankDepositCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableEntityFields_BankDepositCharge_Fragment': Incremental<ChargesTableEntityFields_BankDepositCharge_Fragment> } }
) & (
  { __typename?: 'BankDepositCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTagsFields_BankDepositCharge_Fragment': Incremental<ChargesTableTagsFields_BankDepositCharge_Fragment> } }
) & (
  { __typename?: 'BankDepositCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTaxCategoryFields_BankDepositCharge_Fragment': Incremental<ChargesTableTaxCategoryFields_BankDepositCharge_Fragment> } }
) & { ' $fragmentName'?: 'ChargesTableRowFields_BankDepositCharge_Fragment' };

type ChargesTableRowFields_BusinessTripCharge_Fragment = (
  { __typename: 'BusinessTripCharge', id: string, metadata?: { __typename?: 'ChargeMetadata' } & ({ __typename?: 'ChargeMetadata', documentsCount: number } | { __typename?: 'ChargeMetadata', documentsCount?: never }) & ({ __typename?: 'ChargeMetadata', ledgerCount: number } | { __typename?: 'ChargeMetadata', ledgerCount?: never }) & ({ __typename?: 'ChargeMetadata', transactionsCount: number } | { __typename?: 'ChargeMetadata', transactionsCount?: never }) & ({ __typename?: 'ChargeMetadata', miscExpensesCount: number } | { __typename?: 'ChargeMetadata', miscExpensesCount?: never }) | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null }
  & { ' $fragmentRefs'?: { 'ChargesTableAccountantApprovalFields_BusinessTripCharge_Fragment': ChargesTableAccountantApprovalFields_BusinessTripCharge_Fragment;'ChargesTableAmountFields_BusinessTripCharge_Fragment': ChargesTableAmountFields_BusinessTripCharge_Fragment;'ChargesTableDateFields_BusinessTripCharge_Fragment': ChargesTableDateFields_BusinessTripCharge_Fragment;'ChargesTableDescriptionFields_BusinessTripCharge_Fragment': ChargesTableDescriptionFields_BusinessTripCharge_Fragment;'ChargesTableMoreInfoFields_BusinessTripCharge_Fragment': ChargesTableMoreInfoFields_BusinessTripCharge_Fragment;'ChargesTableTypeFields_BusinessTripCharge_Fragment': ChargesTableTypeFields_BusinessTripCharge_Fragment;'ChargesTableVatFields_BusinessTripCharge_Fragment': ChargesTableVatFields_BusinessTripCharge_Fragment } }
) & (
  { __typename?: 'BusinessTripCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableBusinessTripFields_BusinessTripCharge_Fragment': Incremental<ChargesTableBusinessTripFields_BusinessTripCharge_Fragment> } }
) & (
  { __typename?: 'BusinessTripCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableEntityFields_BusinessTripCharge_Fragment': Incremental<ChargesTableEntityFields_BusinessTripCharge_Fragment> } }
) & (
  { __typename?: 'BusinessTripCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTagsFields_BusinessTripCharge_Fragment': Incremental<ChargesTableTagsFields_BusinessTripCharge_Fragment> } }
) & (
  { __typename?: 'BusinessTripCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTaxCategoryFields_BusinessTripCharge_Fragment': Incremental<ChargesTableTaxCategoryFields_BusinessTripCharge_Fragment> } }
) & { ' $fragmentName'?: 'ChargesTableRowFields_BusinessTripCharge_Fragment' };

type ChargesTableRowFields_CommonCharge_Fragment = (
  { __typename: 'CommonCharge', id: string, metadata?: { __typename?: 'ChargeMetadata' } & ({ __typename?: 'ChargeMetadata', documentsCount: number } | { __typename?: 'ChargeMetadata', documentsCount?: never }) & ({ __typename?: 'ChargeMetadata', ledgerCount: number } | { __typename?: 'ChargeMetadata', ledgerCount?: never }) & ({ __typename?: 'ChargeMetadata', transactionsCount: number } | { __typename?: 'ChargeMetadata', transactionsCount?: never }) & ({ __typename?: 'ChargeMetadata', miscExpensesCount: number } | { __typename?: 'ChargeMetadata', miscExpensesCount?: never }) | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null }
  & { ' $fragmentRefs'?: { 'ChargesTableAccountantApprovalFields_CommonCharge_Fragment': ChargesTableAccountantApprovalFields_CommonCharge_Fragment;'ChargesTableAmountFields_CommonCharge_Fragment': ChargesTableAmountFields_CommonCharge_Fragment;'ChargesTableDateFields_CommonCharge_Fragment': ChargesTableDateFields_CommonCharge_Fragment;'ChargesTableDescriptionFields_CommonCharge_Fragment': ChargesTableDescriptionFields_CommonCharge_Fragment;'ChargesTableMoreInfoFields_CommonCharge_Fragment': ChargesTableMoreInfoFields_CommonCharge_Fragment;'ChargesTableTypeFields_CommonCharge_Fragment': ChargesTableTypeFields_CommonCharge_Fragment;'ChargesTableVatFields_CommonCharge_Fragment': ChargesTableVatFields_CommonCharge_Fragment } }
) & (
  { __typename?: 'CommonCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableBusinessTripFields_CommonCharge_Fragment': Incremental<ChargesTableBusinessTripFields_CommonCharge_Fragment> } }
) & (
  { __typename?: 'CommonCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableEntityFields_CommonCharge_Fragment': Incremental<ChargesTableEntityFields_CommonCharge_Fragment> } }
) & (
  { __typename?: 'CommonCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTagsFields_CommonCharge_Fragment': Incremental<ChargesTableTagsFields_CommonCharge_Fragment> } }
) & (
  { __typename?: 'CommonCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTaxCategoryFields_CommonCharge_Fragment': Incremental<ChargesTableTaxCategoryFields_CommonCharge_Fragment> } }
) & { ' $fragmentName'?: 'ChargesTableRowFields_CommonCharge_Fragment' };

type ChargesTableRowFields_ConversionCharge_Fragment = (
  { __typename: 'ConversionCharge', id: string, metadata?: { __typename?: 'ChargeMetadata' } & ({ __typename?: 'ChargeMetadata', documentsCount: number } | { __typename?: 'ChargeMetadata', documentsCount?: never }) & ({ __typename?: 'ChargeMetadata', ledgerCount: number } | { __typename?: 'ChargeMetadata', ledgerCount?: never }) & ({ __typename?: 'ChargeMetadata', transactionsCount: number } | { __typename?: 'ChargeMetadata', transactionsCount?: never }) & ({ __typename?: 'ChargeMetadata', miscExpensesCount: number } | { __typename?: 'ChargeMetadata', miscExpensesCount?: never }) | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null }
  & { ' $fragmentRefs'?: { 'ChargesTableAccountantApprovalFields_ConversionCharge_Fragment': ChargesTableAccountantApprovalFields_ConversionCharge_Fragment;'ChargesTableAmountFields_ConversionCharge_Fragment': ChargesTableAmountFields_ConversionCharge_Fragment;'ChargesTableDateFields_ConversionCharge_Fragment': ChargesTableDateFields_ConversionCharge_Fragment;'ChargesTableDescriptionFields_ConversionCharge_Fragment': ChargesTableDescriptionFields_ConversionCharge_Fragment;'ChargesTableMoreInfoFields_ConversionCharge_Fragment': ChargesTableMoreInfoFields_ConversionCharge_Fragment;'ChargesTableTypeFields_ConversionCharge_Fragment': ChargesTableTypeFields_ConversionCharge_Fragment;'ChargesTableVatFields_ConversionCharge_Fragment': ChargesTableVatFields_ConversionCharge_Fragment } }
) & (
  { __typename?: 'ConversionCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableBusinessTripFields_ConversionCharge_Fragment': Incremental<ChargesTableBusinessTripFields_ConversionCharge_Fragment> } }
) & (
  { __typename?: 'ConversionCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableEntityFields_ConversionCharge_Fragment': Incremental<ChargesTableEntityFields_ConversionCharge_Fragment> } }
) & (
  { __typename?: 'ConversionCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTagsFields_ConversionCharge_Fragment': Incremental<ChargesTableTagsFields_ConversionCharge_Fragment> } }
) & (
  { __typename?: 'ConversionCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTaxCategoryFields_ConversionCharge_Fragment': Incremental<ChargesTableTaxCategoryFields_ConversionCharge_Fragment> } }
) & { ' $fragmentName'?: 'ChargesTableRowFields_ConversionCharge_Fragment' };

type ChargesTableRowFields_CreditcardBankCharge_Fragment = (
  { __typename: 'CreditcardBankCharge', id: string, metadata?: { __typename?: 'ChargeMetadata' } & ({ __typename?: 'ChargeMetadata', documentsCount: number } | { __typename?: 'ChargeMetadata', documentsCount?: never }) & ({ __typename?: 'ChargeMetadata', ledgerCount: number } | { __typename?: 'ChargeMetadata', ledgerCount?: never }) & ({ __typename?: 'ChargeMetadata', transactionsCount: number } | { __typename?: 'ChargeMetadata', transactionsCount?: never }) & ({ __typename?: 'ChargeMetadata', miscExpensesCount: number } | { __typename?: 'ChargeMetadata', miscExpensesCount?: never }) | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null }
  & { ' $fragmentRefs'?: { 'ChargesTableAccountantApprovalFields_CreditcardBankCharge_Fragment': ChargesTableAccountantApprovalFields_CreditcardBankCharge_Fragment;'ChargesTableAmountFields_CreditcardBankCharge_Fragment': ChargesTableAmountFields_CreditcardBankCharge_Fragment;'ChargesTableDateFields_CreditcardBankCharge_Fragment': ChargesTableDateFields_CreditcardBankCharge_Fragment;'ChargesTableDescriptionFields_CreditcardBankCharge_Fragment': ChargesTableDescriptionFields_CreditcardBankCharge_Fragment;'ChargesTableMoreInfoFields_CreditcardBankCharge_Fragment': ChargesTableMoreInfoFields_CreditcardBankCharge_Fragment;'ChargesTableTypeFields_CreditcardBankCharge_Fragment': ChargesTableTypeFields_CreditcardBankCharge_Fragment;'ChargesTableVatFields_CreditcardBankCharge_Fragment': ChargesTableVatFields_CreditcardBankCharge_Fragment } }
) & (
  { __typename?: 'CreditcardBankCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableBusinessTripFields_CreditcardBankCharge_Fragment': Incremental<ChargesTableBusinessTripFields_CreditcardBankCharge_Fragment> } }
) & (
  { __typename?: 'CreditcardBankCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableEntityFields_CreditcardBankCharge_Fragment': Incremental<ChargesTableEntityFields_CreditcardBankCharge_Fragment> } }
) & (
  { __typename?: 'CreditcardBankCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTagsFields_CreditcardBankCharge_Fragment': Incremental<ChargesTableTagsFields_CreditcardBankCharge_Fragment> } }
) & (
  { __typename?: 'CreditcardBankCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTaxCategoryFields_CreditcardBankCharge_Fragment': Incremental<ChargesTableTaxCategoryFields_CreditcardBankCharge_Fragment> } }
) & { ' $fragmentName'?: 'ChargesTableRowFields_CreditcardBankCharge_Fragment' };

type ChargesTableRowFields_DividendCharge_Fragment = (
  { __typename: 'DividendCharge', id: string, metadata?: { __typename?: 'ChargeMetadata' } & ({ __typename?: 'ChargeMetadata', documentsCount: number } | { __typename?: 'ChargeMetadata', documentsCount?: never }) & ({ __typename?: 'ChargeMetadata', ledgerCount: number } | { __typename?: 'ChargeMetadata', ledgerCount?: never }) & ({ __typename?: 'ChargeMetadata', transactionsCount: number } | { __typename?: 'ChargeMetadata', transactionsCount?: never }) & ({ __typename?: 'ChargeMetadata', miscExpensesCount: number } | { __typename?: 'ChargeMetadata', miscExpensesCount?: never }) | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null }
  & { ' $fragmentRefs'?: { 'ChargesTableAccountantApprovalFields_DividendCharge_Fragment': ChargesTableAccountantApprovalFields_DividendCharge_Fragment;'ChargesTableAmountFields_DividendCharge_Fragment': ChargesTableAmountFields_DividendCharge_Fragment;'ChargesTableDateFields_DividendCharge_Fragment': ChargesTableDateFields_DividendCharge_Fragment;'ChargesTableDescriptionFields_DividendCharge_Fragment': ChargesTableDescriptionFields_DividendCharge_Fragment;'ChargesTableMoreInfoFields_DividendCharge_Fragment': ChargesTableMoreInfoFields_DividendCharge_Fragment;'ChargesTableTypeFields_DividendCharge_Fragment': ChargesTableTypeFields_DividendCharge_Fragment;'ChargesTableVatFields_DividendCharge_Fragment': ChargesTableVatFields_DividendCharge_Fragment } }
) & (
  { __typename?: 'DividendCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableBusinessTripFields_DividendCharge_Fragment': Incremental<ChargesTableBusinessTripFields_DividendCharge_Fragment> } }
) & (
  { __typename?: 'DividendCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableEntityFields_DividendCharge_Fragment': Incremental<ChargesTableEntityFields_DividendCharge_Fragment> } }
) & (
  { __typename?: 'DividendCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTagsFields_DividendCharge_Fragment': Incremental<ChargesTableTagsFields_DividendCharge_Fragment> } }
) & (
  { __typename?: 'DividendCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTaxCategoryFields_DividendCharge_Fragment': Incremental<ChargesTableTaxCategoryFields_DividendCharge_Fragment> } }
) & { ' $fragmentName'?: 'ChargesTableRowFields_DividendCharge_Fragment' };

type ChargesTableRowFields_FinancialCharge_Fragment = (
  { __typename: 'FinancialCharge', id: string, metadata?: { __typename?: 'ChargeMetadata' } & ({ __typename?: 'ChargeMetadata', documentsCount: number } | { __typename?: 'ChargeMetadata', documentsCount?: never }) & ({ __typename?: 'ChargeMetadata', ledgerCount: number } | { __typename?: 'ChargeMetadata', ledgerCount?: never }) & ({ __typename?: 'ChargeMetadata', transactionsCount: number } | { __typename?: 'ChargeMetadata', transactionsCount?: never }) & ({ __typename?: 'ChargeMetadata', miscExpensesCount: number } | { __typename?: 'ChargeMetadata', miscExpensesCount?: never }) | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null }
  & { ' $fragmentRefs'?: { 'ChargesTableAccountantApprovalFields_FinancialCharge_Fragment': ChargesTableAccountantApprovalFields_FinancialCharge_Fragment;'ChargesTableAmountFields_FinancialCharge_Fragment': ChargesTableAmountFields_FinancialCharge_Fragment;'ChargesTableDateFields_FinancialCharge_Fragment': ChargesTableDateFields_FinancialCharge_Fragment;'ChargesTableDescriptionFields_FinancialCharge_Fragment': ChargesTableDescriptionFields_FinancialCharge_Fragment;'ChargesTableMoreInfoFields_FinancialCharge_Fragment': ChargesTableMoreInfoFields_FinancialCharge_Fragment;'ChargesTableTypeFields_FinancialCharge_Fragment': ChargesTableTypeFields_FinancialCharge_Fragment;'ChargesTableVatFields_FinancialCharge_Fragment': ChargesTableVatFields_FinancialCharge_Fragment } }
) & (
  { __typename?: 'FinancialCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableBusinessTripFields_FinancialCharge_Fragment': Incremental<ChargesTableBusinessTripFields_FinancialCharge_Fragment> } }
) & (
  { __typename?: 'FinancialCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableEntityFields_FinancialCharge_Fragment': Incremental<ChargesTableEntityFields_FinancialCharge_Fragment> } }
) & (
  { __typename?: 'FinancialCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTagsFields_FinancialCharge_Fragment': Incremental<ChargesTableTagsFields_FinancialCharge_Fragment> } }
) & (
  { __typename?: 'FinancialCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTaxCategoryFields_FinancialCharge_Fragment': Incremental<ChargesTableTaxCategoryFields_FinancialCharge_Fragment> } }
) & { ' $fragmentName'?: 'ChargesTableRowFields_FinancialCharge_Fragment' };

type ChargesTableRowFields_ForeignSecuritiesCharge_Fragment = (
  { __typename: 'ForeignSecuritiesCharge', id: string, metadata?: { __typename?: 'ChargeMetadata' } & ({ __typename?: 'ChargeMetadata', documentsCount: number } | { __typename?: 'ChargeMetadata', documentsCount?: never }) & ({ __typename?: 'ChargeMetadata', ledgerCount: number } | { __typename?: 'ChargeMetadata', ledgerCount?: never }) & ({ __typename?: 'ChargeMetadata', transactionsCount: number } | { __typename?: 'ChargeMetadata', transactionsCount?: never }) & ({ __typename?: 'ChargeMetadata', miscExpensesCount: number } | { __typename?: 'ChargeMetadata', miscExpensesCount?: never }) | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null }
  & { ' $fragmentRefs'?: { 'ChargesTableAccountantApprovalFields_ForeignSecuritiesCharge_Fragment': ChargesTableAccountantApprovalFields_ForeignSecuritiesCharge_Fragment;'ChargesTableAmountFields_ForeignSecuritiesCharge_Fragment': ChargesTableAmountFields_ForeignSecuritiesCharge_Fragment;'ChargesTableDateFields_ForeignSecuritiesCharge_Fragment': ChargesTableDateFields_ForeignSecuritiesCharge_Fragment;'ChargesTableDescriptionFields_ForeignSecuritiesCharge_Fragment': ChargesTableDescriptionFields_ForeignSecuritiesCharge_Fragment;'ChargesTableMoreInfoFields_ForeignSecuritiesCharge_Fragment': ChargesTableMoreInfoFields_ForeignSecuritiesCharge_Fragment;'ChargesTableTypeFields_ForeignSecuritiesCharge_Fragment': ChargesTableTypeFields_ForeignSecuritiesCharge_Fragment;'ChargesTableVatFields_ForeignSecuritiesCharge_Fragment': ChargesTableVatFields_ForeignSecuritiesCharge_Fragment } }
) & (
  { __typename?: 'ForeignSecuritiesCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableBusinessTripFields_ForeignSecuritiesCharge_Fragment': Incremental<ChargesTableBusinessTripFields_ForeignSecuritiesCharge_Fragment> } }
) & (
  { __typename?: 'ForeignSecuritiesCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableEntityFields_ForeignSecuritiesCharge_Fragment': Incremental<ChargesTableEntityFields_ForeignSecuritiesCharge_Fragment> } }
) & (
  { __typename?: 'ForeignSecuritiesCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTagsFields_ForeignSecuritiesCharge_Fragment': Incremental<ChargesTableTagsFields_ForeignSecuritiesCharge_Fragment> } }
) & (
  { __typename?: 'ForeignSecuritiesCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTaxCategoryFields_ForeignSecuritiesCharge_Fragment': Incremental<ChargesTableTaxCategoryFields_ForeignSecuritiesCharge_Fragment> } }
) & { ' $fragmentName'?: 'ChargesTableRowFields_ForeignSecuritiesCharge_Fragment' };

type ChargesTableRowFields_InternalTransferCharge_Fragment = (
  { __typename: 'InternalTransferCharge', id: string, metadata?: { __typename?: 'ChargeMetadata' } & ({ __typename?: 'ChargeMetadata', documentsCount: number } | { __typename?: 'ChargeMetadata', documentsCount?: never }) & ({ __typename?: 'ChargeMetadata', ledgerCount: number } | { __typename?: 'ChargeMetadata', ledgerCount?: never }) & ({ __typename?: 'ChargeMetadata', transactionsCount: number } | { __typename?: 'ChargeMetadata', transactionsCount?: never }) & ({ __typename?: 'ChargeMetadata', miscExpensesCount: number } | { __typename?: 'ChargeMetadata', miscExpensesCount?: never }) | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null }
  & { ' $fragmentRefs'?: { 'ChargesTableAccountantApprovalFields_InternalTransferCharge_Fragment': ChargesTableAccountantApprovalFields_InternalTransferCharge_Fragment;'ChargesTableAmountFields_InternalTransferCharge_Fragment': ChargesTableAmountFields_InternalTransferCharge_Fragment;'ChargesTableDateFields_InternalTransferCharge_Fragment': ChargesTableDateFields_InternalTransferCharge_Fragment;'ChargesTableDescriptionFields_InternalTransferCharge_Fragment': ChargesTableDescriptionFields_InternalTransferCharge_Fragment;'ChargesTableMoreInfoFields_InternalTransferCharge_Fragment': ChargesTableMoreInfoFields_InternalTransferCharge_Fragment;'ChargesTableTypeFields_InternalTransferCharge_Fragment': ChargesTableTypeFields_InternalTransferCharge_Fragment;'ChargesTableVatFields_InternalTransferCharge_Fragment': ChargesTableVatFields_InternalTransferCharge_Fragment } }
) & (
  { __typename?: 'InternalTransferCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableBusinessTripFields_InternalTransferCharge_Fragment': Incremental<ChargesTableBusinessTripFields_InternalTransferCharge_Fragment> } }
) & (
  { __typename?: 'InternalTransferCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableEntityFields_InternalTransferCharge_Fragment': Incremental<ChargesTableEntityFields_InternalTransferCharge_Fragment> } }
) & (
  { __typename?: 'InternalTransferCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTagsFields_InternalTransferCharge_Fragment': Incremental<ChargesTableTagsFields_InternalTransferCharge_Fragment> } }
) & (
  { __typename?: 'InternalTransferCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTaxCategoryFields_InternalTransferCharge_Fragment': Incremental<ChargesTableTaxCategoryFields_InternalTransferCharge_Fragment> } }
) & { ' $fragmentName'?: 'ChargesTableRowFields_InternalTransferCharge_Fragment' };

type ChargesTableRowFields_MonthlyVatCharge_Fragment = (
  { __typename: 'MonthlyVatCharge', id: string, metadata?: { __typename?: 'ChargeMetadata' } & ({ __typename?: 'ChargeMetadata', documentsCount: number } | { __typename?: 'ChargeMetadata', documentsCount?: never }) & ({ __typename?: 'ChargeMetadata', ledgerCount: number } | { __typename?: 'ChargeMetadata', ledgerCount?: never }) & ({ __typename?: 'ChargeMetadata', transactionsCount: number } | { __typename?: 'ChargeMetadata', transactionsCount?: never }) & ({ __typename?: 'ChargeMetadata', miscExpensesCount: number } | { __typename?: 'ChargeMetadata', miscExpensesCount?: never }) | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null }
  & { ' $fragmentRefs'?: { 'ChargesTableAccountantApprovalFields_MonthlyVatCharge_Fragment': ChargesTableAccountantApprovalFields_MonthlyVatCharge_Fragment;'ChargesTableAmountFields_MonthlyVatCharge_Fragment': ChargesTableAmountFields_MonthlyVatCharge_Fragment;'ChargesTableDateFields_MonthlyVatCharge_Fragment': ChargesTableDateFields_MonthlyVatCharge_Fragment;'ChargesTableDescriptionFields_MonthlyVatCharge_Fragment': ChargesTableDescriptionFields_MonthlyVatCharge_Fragment;'ChargesTableMoreInfoFields_MonthlyVatCharge_Fragment': ChargesTableMoreInfoFields_MonthlyVatCharge_Fragment;'ChargesTableTypeFields_MonthlyVatCharge_Fragment': ChargesTableTypeFields_MonthlyVatCharge_Fragment;'ChargesTableVatFields_MonthlyVatCharge_Fragment': ChargesTableVatFields_MonthlyVatCharge_Fragment } }
) & (
  { __typename?: 'MonthlyVatCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableBusinessTripFields_MonthlyVatCharge_Fragment': Incremental<ChargesTableBusinessTripFields_MonthlyVatCharge_Fragment> } }
) & (
  { __typename?: 'MonthlyVatCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableEntityFields_MonthlyVatCharge_Fragment': Incremental<ChargesTableEntityFields_MonthlyVatCharge_Fragment> } }
) & (
  { __typename?: 'MonthlyVatCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTagsFields_MonthlyVatCharge_Fragment': Incremental<ChargesTableTagsFields_MonthlyVatCharge_Fragment> } }
) & (
  { __typename?: 'MonthlyVatCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTaxCategoryFields_MonthlyVatCharge_Fragment': Incremental<ChargesTableTaxCategoryFields_MonthlyVatCharge_Fragment> } }
) & { ' $fragmentName'?: 'ChargesTableRowFields_MonthlyVatCharge_Fragment' };

type ChargesTableRowFields_SalaryCharge_Fragment = (
  { __typename: 'SalaryCharge', id: string, metadata?: { __typename?: 'ChargeMetadata' } & ({ __typename?: 'ChargeMetadata', documentsCount: number } | { __typename?: 'ChargeMetadata', documentsCount?: never }) & ({ __typename?: 'ChargeMetadata', ledgerCount: number } | { __typename?: 'ChargeMetadata', ledgerCount?: never }) & ({ __typename?: 'ChargeMetadata', transactionsCount: number } | { __typename?: 'ChargeMetadata', transactionsCount?: never }) & ({ __typename?: 'ChargeMetadata', miscExpensesCount: number } | { __typename?: 'ChargeMetadata', miscExpensesCount?: never }) | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number } | null }
  & { ' $fragmentRefs'?: { 'ChargesTableAccountantApprovalFields_SalaryCharge_Fragment': ChargesTableAccountantApprovalFields_SalaryCharge_Fragment;'ChargesTableAmountFields_SalaryCharge_Fragment': ChargesTableAmountFields_SalaryCharge_Fragment;'ChargesTableDateFields_SalaryCharge_Fragment': ChargesTableDateFields_SalaryCharge_Fragment;'ChargesTableDescriptionFields_SalaryCharge_Fragment': ChargesTableDescriptionFields_SalaryCharge_Fragment;'ChargesTableMoreInfoFields_SalaryCharge_Fragment': ChargesTableMoreInfoFields_SalaryCharge_Fragment;'ChargesTableTypeFields_SalaryCharge_Fragment': ChargesTableTypeFields_SalaryCharge_Fragment;'ChargesTableVatFields_SalaryCharge_Fragment': ChargesTableVatFields_SalaryCharge_Fragment } }
) & (
  { __typename?: 'SalaryCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableBusinessTripFields_SalaryCharge_Fragment': Incremental<ChargesTableBusinessTripFields_SalaryCharge_Fragment> } }
) & (
  { __typename?: 'SalaryCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableEntityFields_SalaryCharge_Fragment': Incremental<ChargesTableEntityFields_SalaryCharge_Fragment> } }
) & (
  { __typename?: 'SalaryCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTagsFields_SalaryCharge_Fragment': Incremental<ChargesTableTagsFields_SalaryCharge_Fragment> } }
) & (
  { __typename?: 'SalaryCharge' }
  & { ' $fragmentRefs'?: { 'ChargesTableTaxCategoryFields_SalaryCharge_Fragment': Incremental<ChargesTableTaxCategoryFields_SalaryCharge_Fragment> } }
) & { ' $fragmentName'?: 'ChargesTableRowFields_SalaryCharge_Fragment' };

export type ChargesTableRowFieldsFragment =
  | ChargesTableRowFields_BankDepositCharge_Fragment
  | ChargesTableRowFields_BusinessTripCharge_Fragment
  | ChargesTableRowFields_CommonCharge_Fragment
  | ChargesTableRowFields_ConversionCharge_Fragment
  | ChargesTableRowFields_CreditcardBankCharge_Fragment
  | ChargesTableRowFields_DividendCharge_Fragment
  | ChargesTableRowFields_FinancialCharge_Fragment
  | ChargesTableRowFields_ForeignSecuritiesCharge_Fragment
  | ChargesTableRowFields_InternalTransferCharge_Fragment
  | ChargesTableRowFields_MonthlyVatCharge_Fragment
  | ChargesTableRowFields_SalaryCharge_Fragment
;

export type ChargeForRowQueryVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
}>;


export type ChargeForRowQuery = { __typename?: 'Query', charge:
    | (
      { __typename?: 'BankDepositCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableRowFields_BankDepositCharge_Fragment': ChargesTableRowFields_BankDepositCharge_Fragment } }
    )
    | (
      { __typename?: 'BusinessTripCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableRowFields_BusinessTripCharge_Fragment': ChargesTableRowFields_BusinessTripCharge_Fragment } }
    )
    | (
      { __typename?: 'CommonCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableRowFields_CommonCharge_Fragment': ChargesTableRowFields_CommonCharge_Fragment } }
    )
    | (
      { __typename?: 'ConversionCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableRowFields_ConversionCharge_Fragment': ChargesTableRowFields_ConversionCharge_Fragment } }
    )
    | (
      { __typename?: 'CreditcardBankCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableRowFields_CreditcardBankCharge_Fragment': ChargesTableRowFields_CreditcardBankCharge_Fragment } }
    )
    | (
      { __typename?: 'DividendCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableRowFields_DividendCharge_Fragment': ChargesTableRowFields_DividendCharge_Fragment } }
    )
    | (
      { __typename?: 'FinancialCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableRowFields_FinancialCharge_Fragment': ChargesTableRowFields_FinancialCharge_Fragment } }
    )
    | (
      { __typename?: 'ForeignSecuritiesCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableRowFields_ForeignSecuritiesCharge_Fragment': ChargesTableRowFields_ForeignSecuritiesCharge_Fragment } }
    )
    | (
      { __typename?: 'InternalTransferCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableRowFields_InternalTransferCharge_Fragment': ChargesTableRowFields_InternalTransferCharge_Fragment } }
    )
    | (
      { __typename?: 'MonthlyVatCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableRowFields_MonthlyVatCharge_Fragment': ChargesTableRowFields_MonthlyVatCharge_Fragment } }
    )
    | (
      { __typename?: 'SalaryCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableRowFields_SalaryCharge_Fragment': ChargesTableRowFields_SalaryCharge_Fragment } }
    )
   };

type ChargesTableFields_BankDepositCharge_Fragment = (
  { __typename?: 'BankDepositCharge', id: string, owner:
    | { __typename?: 'LtdFinancialEntity', id: string }
    | { __typename?: 'PersonalFinancialEntity', id: string }
   }
  & { ' $fragmentRefs'?: { 'ChargesTableRowFields_BankDepositCharge_Fragment': ChargesTableRowFields_BankDepositCharge_Fragment } }
) & { ' $fragmentName'?: 'ChargesTableFields_BankDepositCharge_Fragment' };

type ChargesTableFields_BusinessTripCharge_Fragment = (
  { __typename?: 'BusinessTripCharge', id: string, owner:
    | { __typename?: 'LtdFinancialEntity', id: string }
    | { __typename?: 'PersonalFinancialEntity', id: string }
   }
  & { ' $fragmentRefs'?: { 'ChargesTableRowFields_BusinessTripCharge_Fragment': ChargesTableRowFields_BusinessTripCharge_Fragment } }
) & { ' $fragmentName'?: 'ChargesTableFields_BusinessTripCharge_Fragment' };

type ChargesTableFields_CommonCharge_Fragment = (
  { __typename?: 'CommonCharge', id: string, owner:
    | { __typename?: 'LtdFinancialEntity', id: string }
    | { __typename?: 'PersonalFinancialEntity', id: string }
   }
  & { ' $fragmentRefs'?: { 'ChargesTableRowFields_CommonCharge_Fragment': ChargesTableRowFields_CommonCharge_Fragment } }
) & { ' $fragmentName'?: 'ChargesTableFields_CommonCharge_Fragment' };

type ChargesTableFields_ConversionCharge_Fragment = (
  { __typename?: 'ConversionCharge', id: string, owner:
    | { __typename?: 'LtdFinancialEntity', id: string }
    | { __typename?: 'PersonalFinancialEntity', id: string }
   }
  & { ' $fragmentRefs'?: { 'ChargesTableRowFields_ConversionCharge_Fragment': ChargesTableRowFields_ConversionCharge_Fragment } }
) & { ' $fragmentName'?: 'ChargesTableFields_ConversionCharge_Fragment' };

type ChargesTableFields_CreditcardBankCharge_Fragment = (
  { __typename?: 'CreditcardBankCharge', id: string, owner:
    | { __typename?: 'LtdFinancialEntity', id: string }
    | { __typename?: 'PersonalFinancialEntity', id: string }
   }
  & { ' $fragmentRefs'?: { 'ChargesTableRowFields_CreditcardBankCharge_Fragment': ChargesTableRowFields_CreditcardBankCharge_Fragment } }
) & { ' $fragmentName'?: 'ChargesTableFields_CreditcardBankCharge_Fragment' };

type ChargesTableFields_DividendCharge_Fragment = (
  { __typename?: 'DividendCharge', id: string, owner:
    | { __typename?: 'LtdFinancialEntity', id: string }
    | { __typename?: 'PersonalFinancialEntity', id: string }
   }
  & { ' $fragmentRefs'?: { 'ChargesTableRowFields_DividendCharge_Fragment': ChargesTableRowFields_DividendCharge_Fragment } }
) & { ' $fragmentName'?: 'ChargesTableFields_DividendCharge_Fragment' };

type ChargesTableFields_FinancialCharge_Fragment = (
  { __typename?: 'FinancialCharge', id: string, owner:
    | { __typename?: 'LtdFinancialEntity', id: string }
    | { __typename?: 'PersonalFinancialEntity', id: string }
   }
  & { ' $fragmentRefs'?: { 'ChargesTableRowFields_FinancialCharge_Fragment': ChargesTableRowFields_FinancialCharge_Fragment } }
) & { ' $fragmentName'?: 'ChargesTableFields_FinancialCharge_Fragment' };

type ChargesTableFields_ForeignSecuritiesCharge_Fragment = (
  { __typename?: 'ForeignSecuritiesCharge', id: string, owner:
    | { __typename?: 'LtdFinancialEntity', id: string }
    | { __typename?: 'PersonalFinancialEntity', id: string }
   }
  & { ' $fragmentRefs'?: { 'ChargesTableRowFields_ForeignSecuritiesCharge_Fragment': ChargesTableRowFields_ForeignSecuritiesCharge_Fragment } }
) & { ' $fragmentName'?: 'ChargesTableFields_ForeignSecuritiesCharge_Fragment' };

type ChargesTableFields_InternalTransferCharge_Fragment = (
  { __typename?: 'InternalTransferCharge', id: string, owner:
    | { __typename?: 'LtdFinancialEntity', id: string }
    | { __typename?: 'PersonalFinancialEntity', id: string }
   }
  & { ' $fragmentRefs'?: { 'ChargesTableRowFields_InternalTransferCharge_Fragment': ChargesTableRowFields_InternalTransferCharge_Fragment } }
) & { ' $fragmentName'?: 'ChargesTableFields_InternalTransferCharge_Fragment' };

type ChargesTableFields_MonthlyVatCharge_Fragment = (
  { __typename?: 'MonthlyVatCharge', id: string, owner:
    | { __typename?: 'LtdFinancialEntity', id: string }
    | { __typename?: 'PersonalFinancialEntity', id: string }
   }
  & { ' $fragmentRefs'?: { 'ChargesTableRowFields_MonthlyVatCharge_Fragment': ChargesTableRowFields_MonthlyVatCharge_Fragment } }
) & { ' $fragmentName'?: 'ChargesTableFields_MonthlyVatCharge_Fragment' };

type ChargesTableFields_SalaryCharge_Fragment = (
  { __typename?: 'SalaryCharge', id: string, owner:
    | { __typename?: 'LtdFinancialEntity', id: string }
    | { __typename?: 'PersonalFinancialEntity', id: string }
   }
  & { ' $fragmentRefs'?: { 'ChargesTableRowFields_SalaryCharge_Fragment': ChargesTableRowFields_SalaryCharge_Fragment } }
) & { ' $fragmentName'?: 'ChargesTableFields_SalaryCharge_Fragment' };

export type ChargesTableFieldsFragment =
  | ChargesTableFields_BankDepositCharge_Fragment
  | ChargesTableFields_BusinessTripCharge_Fragment
  | ChargesTableFields_CommonCharge_Fragment
  | ChargesTableFields_ConversionCharge_Fragment
  | ChargesTableFields_CreditcardBankCharge_Fragment
  | ChargesTableFields_DividendCharge_Fragment
  | ChargesTableFields_FinancialCharge_Fragment
  | ChargesTableFields_ForeignSecuritiesCharge_Fragment
  | ChargesTableFields_InternalTransferCharge_Fragment
  | ChargesTableFields_MonthlyVatCharge_Fragment
  | ChargesTableFields_SalaryCharge_Fragment
;

export type BankDepositInfoQueryVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
}>;


export type BankDepositInfoQuery = { __typename?: 'Query', depositByCharge?: { __typename?: 'BankDeposit', id: string, name: string, isOpen: boolean, metadata: { __typename?: 'BankDepositMetadata', id: string, currentBalance: { __typename?: 'FinancialAmount', formatted: string }, transactions: Array<
        | (
          { __typename?: 'CommonTransaction', id: string, chargeId: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { __typename?: 'ConversionTransaction', id: string, chargeId: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      > } } | null };

export type ChargeMatchesQueryVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
}>;


export type ChargeMatchesQuery = { __typename?: 'Query', findChargeMatches: { __typename?: 'ChargeMatchesResult', matches: Array<(
      { __typename?: 'ChargeMatch', chargeId: string }
      & { ' $fragmentRefs'?: { 'ChargeMatchesTableFieldsFragment': ChargeMatchesTableFieldsFragment } }
    )> } };

type ConversionChargeInfo_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_BankDepositCharge_Fragment' };

type ConversionChargeInfo_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_BusinessTripCharge_Fragment' };

type ConversionChargeInfo_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_CommonCharge_Fragment' };

type ConversionChargeInfo_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string, eventRate?: { __typename?: 'ConversionRate', from: Currency, to: Currency, rate: number } | null, officialRate?: { __typename?: 'ConversionRate', from: Currency, to: Currency, rate: number } | null } & { ' $fragmentName'?: 'ConversionChargeInfo_ConversionCharge_Fragment' };

type ConversionChargeInfo_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_CreditcardBankCharge_Fragment' };

type ConversionChargeInfo_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_DividendCharge_Fragment' };

type ConversionChargeInfo_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_FinancialCharge_Fragment' };

type ConversionChargeInfo_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_ForeignSecuritiesCharge_Fragment' };

type ConversionChargeInfo_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_InternalTransferCharge_Fragment' };

type ConversionChargeInfo_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_MonthlyVatCharge_Fragment' };

type ConversionChargeInfo_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_SalaryCharge_Fragment' };

export type ConversionChargeInfoFragment =
  | ConversionChargeInfo_BankDepositCharge_Fragment
  | ConversionChargeInfo_BusinessTripCharge_Fragment
  | ConversionChargeInfo_CommonCharge_Fragment
  | ConversionChargeInfo_ConversionCharge_Fragment
  | ConversionChargeInfo_CreditcardBankCharge_Fragment
  | ConversionChargeInfo_DividendCharge_Fragment
  | ConversionChargeInfo_FinancialCharge_Fragment
  | ConversionChargeInfo_ForeignSecuritiesCharge_Fragment
  | ConversionChargeInfo_InternalTransferCharge_Fragment
  | ConversionChargeInfo_MonthlyVatCharge_Fragment
  | ConversionChargeInfo_SalaryCharge_Fragment
;

type CreditcardBankChargeInfo_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_BankDepositCharge_Fragment' };

type CreditcardBankChargeInfo_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_BusinessTripCharge_Fragment' };

type CreditcardBankChargeInfo_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_CommonCharge_Fragment' };

type CreditcardBankChargeInfo_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_ConversionCharge_Fragment' };

type CreditcardBankChargeInfo_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', id: string, creditCardTransactions: Array<
    | (
      { __typename?: 'CommonTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { __typename?: 'ConversionTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_CreditcardBankCharge_Fragment' };

type CreditcardBankChargeInfo_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_DividendCharge_Fragment' };

type CreditcardBankChargeInfo_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_FinancialCharge_Fragment' };

type CreditcardBankChargeInfo_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_ForeignSecuritiesCharge_Fragment' };

type CreditcardBankChargeInfo_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_InternalTransferCharge_Fragment' };

type CreditcardBankChargeInfo_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_MonthlyVatCharge_Fragment' };

type CreditcardBankChargeInfo_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_SalaryCharge_Fragment' };

export type CreditcardBankChargeInfoFragment =
  | CreditcardBankChargeInfo_BankDepositCharge_Fragment
  | CreditcardBankChargeInfo_BusinessTripCharge_Fragment
  | CreditcardBankChargeInfo_CommonCharge_Fragment
  | CreditcardBankChargeInfo_ConversionCharge_Fragment
  | CreditcardBankChargeInfo_CreditcardBankCharge_Fragment
  | CreditcardBankChargeInfo_DividendCharge_Fragment
  | CreditcardBankChargeInfo_FinancialCharge_Fragment
  | CreditcardBankChargeInfo_ForeignSecuritiesCharge_Fragment
  | CreditcardBankChargeInfo_InternalTransferCharge_Fragment
  | CreditcardBankChargeInfo_MonthlyVatCharge_Fragment
  | CreditcardBankChargeInfo_SalaryCharge_Fragment
;

type ExchangeRatesInfo_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_BankDepositCharge_Fragment' };

type ExchangeRatesInfo_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_BusinessTripCharge_Fragment' };

type ExchangeRatesInfo_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_CommonCharge_Fragment' };

type ExchangeRatesInfo_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_ConversionCharge_Fragment' };

type ExchangeRatesInfo_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_CreditcardBankCharge_Fragment' };

type ExchangeRatesInfo_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_DividendCharge_Fragment' };

type ExchangeRatesInfo_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string, exchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, ils?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, eth?: number | null, grt?: number | null, usdc?: number | null } | null } & { ' $fragmentName'?: 'ExchangeRatesInfo_FinancialCharge_Fragment' };

type ExchangeRatesInfo_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_ForeignSecuritiesCharge_Fragment' };

type ExchangeRatesInfo_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_InternalTransferCharge_Fragment' };

type ExchangeRatesInfo_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_MonthlyVatCharge_Fragment' };

type ExchangeRatesInfo_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_SalaryCharge_Fragment' };

export type ExchangeRatesInfoFragment =
  | ExchangeRatesInfo_BankDepositCharge_Fragment
  | ExchangeRatesInfo_BusinessTripCharge_Fragment
  | ExchangeRatesInfo_CommonCharge_Fragment
  | ExchangeRatesInfo_ConversionCharge_Fragment
  | ExchangeRatesInfo_CreditcardBankCharge_Fragment
  | ExchangeRatesInfo_DividendCharge_Fragment
  | ExchangeRatesInfo_FinancialCharge_Fragment
  | ExchangeRatesInfo_ForeignSecuritiesCharge_Fragment
  | ExchangeRatesInfo_InternalTransferCharge_Fragment
  | ExchangeRatesInfo_MonthlyVatCharge_Fragment
  | ExchangeRatesInfo_SalaryCharge_Fragment
;

type TableMiscExpensesFields_BankDepositCharge_Fragment = { __typename?: 'BankDepositCharge', id: string, miscExpenses: Array<(
    { __typename?: 'MiscExpense', id: string, description?: string | null, invoiceDate: any, valueDate: any, chargeId: string, amount: { __typename?: 'FinancialAmount', formatted: string }, creditor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
    , debtor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_BankDepositCharge_Fragment' };

type TableMiscExpensesFields_BusinessTripCharge_Fragment = { __typename?: 'BusinessTripCharge', id: string, miscExpenses: Array<(
    { __typename?: 'MiscExpense', id: string, description?: string | null, invoiceDate: any, valueDate: any, chargeId: string, amount: { __typename?: 'FinancialAmount', formatted: string }, creditor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
    , debtor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_BusinessTripCharge_Fragment' };

type TableMiscExpensesFields_CommonCharge_Fragment = { __typename?: 'CommonCharge', id: string, miscExpenses: Array<(
    { __typename?: 'MiscExpense', id: string, description?: string | null, invoiceDate: any, valueDate: any, chargeId: string, amount: { __typename?: 'FinancialAmount', formatted: string }, creditor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
    , debtor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_CommonCharge_Fragment' };

type TableMiscExpensesFields_ConversionCharge_Fragment = { __typename?: 'ConversionCharge', id: string, miscExpenses: Array<(
    { __typename?: 'MiscExpense', id: string, description?: string | null, invoiceDate: any, valueDate: any, chargeId: string, amount: { __typename?: 'FinancialAmount', formatted: string }, creditor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
    , debtor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_ConversionCharge_Fragment' };

type TableMiscExpensesFields_CreditcardBankCharge_Fragment = { __typename?: 'CreditcardBankCharge', id: string, miscExpenses: Array<(
    { __typename?: 'MiscExpense', id: string, description?: string | null, invoiceDate: any, valueDate: any, chargeId: string, amount: { __typename?: 'FinancialAmount', formatted: string }, creditor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
    , debtor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_CreditcardBankCharge_Fragment' };

type TableMiscExpensesFields_DividendCharge_Fragment = { __typename?: 'DividendCharge', id: string, miscExpenses: Array<(
    { __typename?: 'MiscExpense', id: string, description?: string | null, invoiceDate: any, valueDate: any, chargeId: string, amount: { __typename?: 'FinancialAmount', formatted: string }, creditor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
    , debtor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_DividendCharge_Fragment' };

type TableMiscExpensesFields_FinancialCharge_Fragment = { __typename?: 'FinancialCharge', id: string, miscExpenses: Array<(
    { __typename?: 'MiscExpense', id: string, description?: string | null, invoiceDate: any, valueDate: any, chargeId: string, amount: { __typename?: 'FinancialAmount', formatted: string }, creditor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
    , debtor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_FinancialCharge_Fragment' };

type TableMiscExpensesFields_ForeignSecuritiesCharge_Fragment = { __typename?: 'ForeignSecuritiesCharge', id: string, miscExpenses: Array<(
    { __typename?: 'MiscExpense', id: string, description?: string | null, invoiceDate: any, valueDate: any, chargeId: string, amount: { __typename?: 'FinancialAmount', formatted: string }, creditor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
    , debtor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_ForeignSecuritiesCharge_Fragment' };

type TableMiscExpensesFields_InternalTransferCharge_Fragment = { __typename?: 'InternalTransferCharge', id: string, miscExpenses: Array<(
    { __typename?: 'MiscExpense', id: string, description?: string | null, invoiceDate: any, valueDate: any, chargeId: string, amount: { __typename?: 'FinancialAmount', formatted: string }, creditor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
    , debtor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_InternalTransferCharge_Fragment' };

type TableMiscExpensesFields_MonthlyVatCharge_Fragment = { __typename?: 'MonthlyVatCharge', id: string, miscExpenses: Array<(
    { __typename?: 'MiscExpense', id: string, description?: string | null, invoiceDate: any, valueDate: any, chargeId: string, amount: { __typename?: 'FinancialAmount', formatted: string }, creditor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
    , debtor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_MonthlyVatCharge_Fragment' };

type TableMiscExpensesFields_SalaryCharge_Fragment = { __typename?: 'SalaryCharge', id: string, miscExpenses: Array<(
    { __typename?: 'MiscExpense', id: string, description?: string | null, invoiceDate: any, valueDate: any, chargeId: string, amount: { __typename?: 'FinancialAmount', formatted: string }, creditor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
    , debtor:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_SalaryCharge_Fragment' };

export type TableMiscExpensesFieldsFragment =
  | TableMiscExpensesFields_BankDepositCharge_Fragment
  | TableMiscExpensesFields_BusinessTripCharge_Fragment
  | TableMiscExpensesFields_CommonCharge_Fragment
  | TableMiscExpensesFields_ConversionCharge_Fragment
  | TableMiscExpensesFields_CreditcardBankCharge_Fragment
  | TableMiscExpensesFields_DividendCharge_Fragment
  | TableMiscExpensesFields_FinancialCharge_Fragment
  | TableMiscExpensesFields_ForeignSecuritiesCharge_Fragment
  | TableMiscExpensesFields_InternalTransferCharge_Fragment
  | TableMiscExpensesFields_MonthlyVatCharge_Fragment
  | TableMiscExpensesFields_SalaryCharge_Fragment
;

type TableSalariesFields_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_BankDepositCharge_Fragment' };

type TableSalariesFields_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_BusinessTripCharge_Fragment' };

type TableSalariesFields_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_CommonCharge_Fragment' };

type TableSalariesFields_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_ConversionCharge_Fragment' };

type TableSalariesFields_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_CreditcardBankCharge_Fragment' };

type TableSalariesFields_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_DividendCharge_Fragment' };

type TableSalariesFields_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_FinancialCharge_Fragment' };

type TableSalariesFields_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_ForeignSecuritiesCharge_Fragment' };

type TableSalariesFields_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_InternalTransferCharge_Fragment' };

type TableSalariesFields_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_MonthlyVatCharge_Fragment' };

type TableSalariesFields_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string, salaryRecords: Array<{ __typename?: 'Salary', directAmount: { __typename?: 'FinancialAmount', formatted: string }, baseAmount?: { __typename?: 'FinancialAmount', formatted: string } | null, employee?: { __typename?: 'LtdFinancialEntity', id: string, name: string } | null, pensionFund?: { __typename?: 'LtdFinancialEntity', id: string, name: string } | null, pensionEmployeeAmount?: { __typename?: 'FinancialAmount', formatted: string } | null, pensionEmployerAmount?: { __typename?: 'FinancialAmount', formatted: string } | null, compensationsAmount?: { __typename?: 'FinancialAmount', formatted: string } | null, trainingFund?: { __typename?: 'LtdFinancialEntity', id: string, name: string } | null, trainingFundEmployeeAmount?: { __typename?: 'FinancialAmount', formatted: string } | null, trainingFundEmployerAmount?: { __typename?: 'FinancialAmount', formatted: string } | null, socialSecurityEmployeeAmount?: { __typename?: 'FinancialAmount', formatted: string } | null, socialSecurityEmployerAmount?: { __typename?: 'FinancialAmount', formatted: string } | null, incomeTaxAmount?: { __typename?: 'FinancialAmount', formatted: string } | null, healthInsuranceAmount?: { __typename?: 'FinancialAmount', formatted: string } | null }> } & { ' $fragmentName'?: 'TableSalariesFields_SalaryCharge_Fragment' };

export type TableSalariesFieldsFragment =
  | TableSalariesFields_BankDepositCharge_Fragment
  | TableSalariesFields_BusinessTripCharge_Fragment
  | TableSalariesFields_CommonCharge_Fragment
  | TableSalariesFields_ConversionCharge_Fragment
  | TableSalariesFields_CreditcardBankCharge_Fragment
  | TableSalariesFields_DividendCharge_Fragment
  | TableSalariesFields_FinancialCharge_Fragment
  | TableSalariesFields_ForeignSecuritiesCharge_Fragment
  | TableSalariesFields_InternalTransferCharge_Fragment
  | TableSalariesFields_MonthlyVatCharge_Fragment
  | TableSalariesFields_SalaryCharge_Fragment
;

export type IncomeChargesChartQueryVariables = Exact<{
  filters?: InputMaybe<ChargeFilter>;
}>;


export type IncomeChargesChartQuery = { __typename?: 'Query', allCharges: { __typename?: 'PaginatedCharges', nodes: Array<
      | { __typename?: 'BankDepositCharge', id: string, transactions: Array<
          | { __typename?: 'CommonTransaction', id: string, eventDate: any, effectiveDate?: any | null, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
          | { __typename?: 'ConversionTransaction', id: string, eventDate: any, effectiveDate: any, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
        > }
      | { __typename?: 'BusinessTripCharge', id: string, transactions: Array<
          | { __typename?: 'CommonTransaction', id: string, eventDate: any, effectiveDate?: any | null, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
          | { __typename?: 'ConversionTransaction', id: string, eventDate: any, effectiveDate: any, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
        > }
      | { __typename?: 'CommonCharge', id: string, transactions: Array<
          | { __typename?: 'CommonTransaction', id: string, eventDate: any, effectiveDate?: any | null, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
          | { __typename?: 'ConversionTransaction', id: string, eventDate: any, effectiveDate: any, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
        > }
      | { __typename?: 'ConversionCharge', id: string, transactions: Array<
          | { __typename?: 'CommonTransaction', id: string, eventDate: any, effectiveDate?: any | null, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
          | { __typename?: 'ConversionTransaction', id: string, eventDate: any, effectiveDate: any, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
        > }
      | { __typename?: 'CreditcardBankCharge', id: string, transactions: Array<
          | { __typename?: 'CommonTransaction', id: string, eventDate: any, effectiveDate?: any | null, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
          | { __typename?: 'ConversionTransaction', id: string, eventDate: any, effectiveDate: any, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
        > }
      | { __typename?: 'DividendCharge', id: string, transactions: Array<
          | { __typename?: 'CommonTransaction', id: string, eventDate: any, effectiveDate?: any | null, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
          | { __typename?: 'ConversionTransaction', id: string, eventDate: any, effectiveDate: any, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
        > }
      | { __typename?: 'FinancialCharge', id: string, transactions: Array<
          | { __typename?: 'CommonTransaction', id: string, eventDate: any, effectiveDate?: any | null, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
          | { __typename?: 'ConversionTransaction', id: string, eventDate: any, effectiveDate: any, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
        > }
      | { __typename?: 'ForeignSecuritiesCharge', id: string, transactions: Array<
          | { __typename?: 'CommonTransaction', id: string, eventDate: any, effectiveDate?: any | null, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
          | { __typename?: 'ConversionTransaction', id: string, eventDate: any, effectiveDate: any, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
        > }
      | { __typename?: 'InternalTransferCharge', id: string, transactions: Array<
          | { __typename?: 'CommonTransaction', id: string, eventDate: any, effectiveDate?: any | null, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
          | { __typename?: 'ConversionTransaction', id: string, eventDate: any, effectiveDate: any, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
        > }
      | { __typename?: 'MonthlyVatCharge', id: string, transactions: Array<
          | { __typename?: 'CommonTransaction', id: string, eventDate: any, effectiveDate?: any | null, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
          | { __typename?: 'ConversionTransaction', id: string, eventDate: any, effectiveDate: any, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
        > }
      | { __typename?: 'SalaryCharge', id: string, transactions: Array<
          | { __typename?: 'CommonTransaction', id: string, eventDate: any, effectiveDate?: any | null, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
          | { __typename?: 'ConversionTransaction', id: string, eventDate: any, effectiveDate: any, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, eventExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null, debitExchangeRates?: { __typename?: 'ExchangeRates', aud?: number | null, cad?: number | null, eur?: number | null, gbp?: number | null, jpy?: number | null, sek?: number | null, usd?: number | null, date: any } | null }
        > }
    > } };

export type MonthlyIncomeExpenseChartInfoFragment = { __typename?: 'IncomeExpenseChart', monthlyData: Array<{ __typename?: 'IncomeExpenseChartMonthData', date: any, income: { __typename?: 'FinancialAmount', formatted: string, raw: number }, expense: { __typename?: 'FinancialAmount', formatted: string, raw: number }, balance: { __typename?: 'FinancialAmount', formatted: string, raw: number } }> } & { ' $fragmentName'?: 'MonthlyIncomeExpenseChartInfoFragment' };

export type MonthlyIncomeExpenseChartQueryVariables = Exact<{
  filters: IncomeExpenseChartFilters;
}>;


export type MonthlyIncomeExpenseChartQuery = { __typename?: 'Query', incomeExpenseChart: (
    { __typename?: 'IncomeExpenseChart', fromDate: any, toDate: any, currency: Currency }
    & { ' $fragmentRefs'?: { 'MonthlyIncomeExpenseChartInfoFragment': MonthlyIncomeExpenseChartInfoFragment } }
  ) };

export type ContractsEditModalQueryVariables = Exact<{
  contractId: Scalars['UUID']['input'];
}>;


export type ContractsEditModalQuery = { __typename?: 'Query', contractsById: { __typename?: 'Contract', id: string, startDate: any, endDate: any, purchaseOrders: Array<string>, product?: Product | null, msCloud?: any | null, billingCycle: BillingCycle, plan?: SubscriptionPlan | null, isActive: boolean, remarks?: string | null, documentType: DocumentType, operationsLimit: any, amount: { __typename?: 'FinancialAmount', raw: number, currency: Currency } } };

export type BusinessTripReportFieldsFragment = (
  { __typename?: 'BusinessTrip', id: string }
  & { ' $fragmentRefs'?: { 'BusinessTripReportHeaderFieldsFragment': BusinessTripReportHeaderFieldsFragment;'BusinessTripReportSummaryFieldsFragment': BusinessTripReportSummaryFieldsFragment } }
) & { ' $fragmentName'?: 'BusinessTripReportFieldsFragment' };

export type BusinessTripAccountantApprovalFieldsFragment = { __typename?: 'BusinessTrip', id: string, accountantApproval: AccountantStatus } & { ' $fragmentName'?: 'BusinessTripAccountantApprovalFieldsFragment' };

export type UncategorizedTransactionsByBusinessTripQueryVariables = Exact<{
  businessTripId: Scalars['UUID']['input'];
}>;


export type UncategorizedTransactionsByBusinessTripQuery = { __typename?: 'Query', businessTrip?: { __typename?: 'BusinessTrip', id: string, uncategorizedTransactions: Array<{ __typename?: 'UncategorizedTransaction', transaction:
        | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, referenceKey?: string | null, counterparty?:
            | { __typename?: 'LtdFinancialEntity', id: string, name: string }
            | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
            | { __typename?: 'TaxCategory', id: string, name: string }
           | null, amount: { __typename?: 'FinancialAmount', formatted: string, raw: number } }
        | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, referenceKey?: string | null, counterparty?:
            | { __typename?: 'LtdFinancialEntity', id: string, name: string }
            | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
            | { __typename?: 'TaxCategory', id: string, name: string }
           | null, amount: { __typename?: 'FinancialAmount', formatted: string, raw: number } }
       } | null> } | null };

export type BusinessTripReportAccommodationsRowFieldsFragment = (
  { __typename?: 'BusinessTripAccommodationExpense', id: string, payedByEmployee?: boolean | null, nightsCount?: number | null, country?: { __typename?: 'Country', id: string, name: string } | null, attendeesStay: Array<{ __typename?: 'BusinessTripAttendeeStay', id: string, nightsCount: number, attendee: { __typename?: 'BusinessTripAttendee', id: string, name: string } }> }
  & { ' $fragmentRefs'?: { 'BusinessTripReportCoreExpenseRowFields_BusinessTripAccommodationExpense_Fragment': BusinessTripReportCoreExpenseRowFields_BusinessTripAccommodationExpense_Fragment } }
) & { ' $fragmentName'?: 'BusinessTripReportAccommodationsRowFieldsFragment' };

export type BusinessTripReportAccommodationsTableFieldsFragment = (
  { __typename?: 'BusinessTripAccommodationExpense', id: string, date?: any | null }
  & { ' $fragmentRefs'?: { 'BusinessTripReportAccommodationsRowFieldsFragment': BusinessTripReportAccommodationsRowFieldsFragment } }
) & { ' $fragmentName'?: 'BusinessTripReportAccommodationsTableFieldsFragment' };

export type BusinessTripReportAccommodationsFieldsFragment = { __typename?: 'BusinessTrip', id: string, accommodationExpenses: Array<(
    { __typename?: 'BusinessTripAccommodationExpense', id: string }
    & { ' $fragmentRefs'?: { 'BusinessTripReportAccommodationsTableFieldsFragment': BusinessTripReportAccommodationsTableFieldsFragment } }
  )> } & { ' $fragmentName'?: 'BusinessTripReportAccommodationsFieldsFragment' };

export type BusinessTripReportAttendeeRowFieldsFragment = { __typename?: 'BusinessTripAttendee', id: string, name: string, arrivalDate?: any | null, departureDate?: any | null, flights: Array<(
    { __typename?: 'BusinessTripFlightExpense', id: string }
    & { ' $fragmentRefs'?: { 'BusinessTripReportFlightsTableFieldsFragment': BusinessTripReportFlightsTableFieldsFragment } }
  )>, accommodations: Array<(
    { __typename?: 'BusinessTripAccommodationExpense', id: string }
    & { ' $fragmentRefs'?: { 'BusinessTripReportAccommodationsTableFieldsFragment': BusinessTripReportAccommodationsTableFieldsFragment } }
  )> } & { ' $fragmentName'?: 'BusinessTripReportAttendeeRowFieldsFragment' };

export type BusinessTripReportAttendeesFieldsFragment = { __typename?: 'BusinessTrip', id: string, attendees: Array<(
    { __typename?: 'BusinessTripAttendee', id: string, name: string }
    & { ' $fragmentRefs'?: { 'BusinessTripReportAttendeeRowFieldsFragment': BusinessTripReportAttendeeRowFieldsFragment } }
  )> } & { ' $fragmentName'?: 'BusinessTripReportAttendeesFieldsFragment' };

export type BusinessTripReportCarRentalRowFieldsFragment = (
  { __typename?: 'BusinessTripCarRentalExpense', id: string, payedByEmployee?: boolean | null, days: number, isFuelExpense: boolean }
  & { ' $fragmentRefs'?: { 'BusinessTripReportCoreExpenseRowFields_BusinessTripCarRentalExpense_Fragment': BusinessTripReportCoreExpenseRowFields_BusinessTripCarRentalExpense_Fragment } }
) & { ' $fragmentName'?: 'BusinessTripReportCarRentalRowFieldsFragment' };

export type BusinessTripReportCarRentalFieldsFragment = { __typename?: 'BusinessTrip', id: string, carRentalExpenses: Array<(
    { __typename?: 'BusinessTripCarRentalExpense', id: string, date?: any | null }
    & { ' $fragmentRefs'?: { 'BusinessTripReportCarRentalRowFieldsFragment': BusinessTripReportCarRentalRowFieldsFragment } }
  )> } & { ' $fragmentName'?: 'BusinessTripReportCarRentalFieldsFragment' };

type BusinessTripReportCoreExpenseRowFields_BusinessTripAccommodationExpense_Fragment = { __typename?: 'BusinessTripAccommodationExpense', id: string, date?: any | null, valueDate?: any | null, payedByEmployee?: boolean | null, amount?: { __typename?: 'FinancialAmount', formatted: string, raw: number, currency: Currency } | null, employee?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null, charges?: Array<
    | { __typename?: 'BankDepositCharge', id: string }
    | { __typename?: 'BusinessTripCharge', id: string }
    | { __typename?: 'CommonCharge', id: string }
    | { __typename?: 'ConversionCharge', id: string }
    | { __typename?: 'CreditcardBankCharge', id: string }
    | { __typename?: 'DividendCharge', id: string }
    | { __typename?: 'FinancialCharge', id: string }
    | { __typename?: 'ForeignSecuritiesCharge', id: string }
    | { __typename?: 'InternalTransferCharge', id: string }
    | { __typename?: 'MonthlyVatCharge', id: string }
    | { __typename?: 'SalaryCharge', id: string }
  > | null } & { ' $fragmentName'?: 'BusinessTripReportCoreExpenseRowFields_BusinessTripAccommodationExpense_Fragment' };

type BusinessTripReportCoreExpenseRowFields_BusinessTripCarRentalExpense_Fragment = { __typename?: 'BusinessTripCarRentalExpense', id: string, date?: any | null, valueDate?: any | null, payedByEmployee?: boolean | null, amount?: { __typename?: 'FinancialAmount', formatted: string, raw: number, currency: Currency } | null, employee?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null, charges?: Array<
    | { __typename?: 'BankDepositCharge', id: string }
    | { __typename?: 'BusinessTripCharge', id: string }
    | { __typename?: 'CommonCharge', id: string }
    | { __typename?: 'ConversionCharge', id: string }
    | { __typename?: 'CreditcardBankCharge', id: string }
    | { __typename?: 'DividendCharge', id: string }
    | { __typename?: 'FinancialCharge', id: string }
    | { __typename?: 'ForeignSecuritiesCharge', id: string }
    | { __typename?: 'InternalTransferCharge', id: string }
    | { __typename?: 'MonthlyVatCharge', id: string }
    | { __typename?: 'SalaryCharge', id: string }
  > | null } & { ' $fragmentName'?: 'BusinessTripReportCoreExpenseRowFields_BusinessTripCarRentalExpense_Fragment' };

type BusinessTripReportCoreExpenseRowFields_BusinessTripFlightExpense_Fragment = { __typename?: 'BusinessTripFlightExpense', id: string, date?: any | null, valueDate?: any | null, payedByEmployee?: boolean | null, amount?: { __typename?: 'FinancialAmount', formatted: string, raw: number, currency: Currency } | null, employee?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null, charges?: Array<
    | { __typename?: 'BankDepositCharge', id: string }
    | { __typename?: 'BusinessTripCharge', id: string }
    | { __typename?: 'CommonCharge', id: string }
    | { __typename?: 'ConversionCharge', id: string }
    | { __typename?: 'CreditcardBankCharge', id: string }
    | { __typename?: 'DividendCharge', id: string }
    | { __typename?: 'FinancialCharge', id: string }
    | { __typename?: 'ForeignSecuritiesCharge', id: string }
    | { __typename?: 'InternalTransferCharge', id: string }
    | { __typename?: 'MonthlyVatCharge', id: string }
    | { __typename?: 'SalaryCharge', id: string }
  > | null } & { ' $fragmentName'?: 'BusinessTripReportCoreExpenseRowFields_BusinessTripFlightExpense_Fragment' };

type BusinessTripReportCoreExpenseRowFields_BusinessTripOtherExpense_Fragment = { __typename?: 'BusinessTripOtherExpense', id: string, date?: any | null, valueDate?: any | null, payedByEmployee?: boolean | null, amount?: { __typename?: 'FinancialAmount', formatted: string, raw: number, currency: Currency } | null, employee?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null, charges?: Array<
    | { __typename?: 'BankDepositCharge', id: string }
    | { __typename?: 'BusinessTripCharge', id: string }
    | { __typename?: 'CommonCharge', id: string }
    | { __typename?: 'ConversionCharge', id: string }
    | { __typename?: 'CreditcardBankCharge', id: string }
    | { __typename?: 'DividendCharge', id: string }
    | { __typename?: 'FinancialCharge', id: string }
    | { __typename?: 'ForeignSecuritiesCharge', id: string }
    | { __typename?: 'InternalTransferCharge', id: string }
    | { __typename?: 'MonthlyVatCharge', id: string }
    | { __typename?: 'SalaryCharge', id: string }
  > | null } & { ' $fragmentName'?: 'BusinessTripReportCoreExpenseRowFields_BusinessTripOtherExpense_Fragment' };

type BusinessTripReportCoreExpenseRowFields_BusinessTripTravelAndSubsistenceExpense_Fragment = { __typename?: 'BusinessTripTravelAndSubsistenceExpense', id: string, date?: any | null, valueDate?: any | null, payedByEmployee?: boolean | null, amount?: { __typename?: 'FinancialAmount', formatted: string, raw: number, currency: Currency } | null, employee?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null, charges?: Array<
    | { __typename?: 'BankDepositCharge', id: string }
    | { __typename?: 'BusinessTripCharge', id: string }
    | { __typename?: 'CommonCharge', id: string }
    | { __typename?: 'ConversionCharge', id: string }
    | { __typename?: 'CreditcardBankCharge', id: string }
    | { __typename?: 'DividendCharge', id: string }
    | { __typename?: 'FinancialCharge', id: string }
    | { __typename?: 'ForeignSecuritiesCharge', id: string }
    | { __typename?: 'InternalTransferCharge', id: string }
    | { __typename?: 'MonthlyVatCharge', id: string }
    | { __typename?: 'SalaryCharge', id: string }
  > | null } & { ' $fragmentName'?: 'BusinessTripReportCoreExpenseRowFields_BusinessTripTravelAndSubsistenceExpense_Fragment' };

export type BusinessTripReportCoreExpenseRowFieldsFragment =
  | BusinessTripReportCoreExpenseRowFields_BusinessTripAccommodationExpense_Fragment
  | BusinessTripReportCoreExpenseRowFields_BusinessTripCarRentalExpense_Fragment
  | BusinessTripReportCoreExpenseRowFields_BusinessTripFlightExpense_Fragment
  | BusinessTripReportCoreExpenseRowFields_BusinessTripOtherExpense_Fragment
  | BusinessTripReportCoreExpenseRowFields_BusinessTripTravelAndSubsistenceExpense_Fragment
;

export type BusinessTripReportFlightsRowFieldsFragment = (
  { __typename?: 'BusinessTripFlightExpense', id: string, payedByEmployee?: boolean | null, path?: Array<string> | null, class?: string | null, attendees: Array<{ __typename?: 'BusinessTripAttendee', id: string, name: string }> }
  & { ' $fragmentRefs'?: { 'BusinessTripReportCoreExpenseRowFields_BusinessTripFlightExpense_Fragment': BusinessTripReportCoreExpenseRowFields_BusinessTripFlightExpense_Fragment } }
) & { ' $fragmentName'?: 'BusinessTripReportFlightsRowFieldsFragment' };

export type BusinessTripReportFlightsTableFieldsFragment = (
  { __typename?: 'BusinessTripFlightExpense', id: string, date?: any | null }
  & { ' $fragmentRefs'?: { 'BusinessTripReportFlightsRowFieldsFragment': BusinessTripReportFlightsRowFieldsFragment } }
) & { ' $fragmentName'?: 'BusinessTripReportFlightsTableFieldsFragment' };

export type BusinessTripReportFlightsFieldsFragment = { __typename?: 'BusinessTrip', id: string, flightExpenses: Array<(
    { __typename?: 'BusinessTripFlightExpense', id: string }
    & { ' $fragmentRefs'?: { 'BusinessTripReportFlightsTableFieldsFragment': BusinessTripReportFlightsTableFieldsFragment } }
  )>, attendees: Array<{ __typename?: 'BusinessTripAttendee', id: string, name: string }> } & { ' $fragmentName'?: 'BusinessTripReportFlightsFieldsFragment' };

export type BusinessTripReportOtherRowFieldsFragment = (
  { __typename?: 'BusinessTripOtherExpense', id: string, payedByEmployee?: boolean | null, description?: string | null, deductibleExpense?: boolean | null }
  & { ' $fragmentRefs'?: { 'BusinessTripReportCoreExpenseRowFields_BusinessTripOtherExpense_Fragment': BusinessTripReportCoreExpenseRowFields_BusinessTripOtherExpense_Fragment } }
) & { ' $fragmentName'?: 'BusinessTripReportOtherRowFieldsFragment' };

export type BusinessTripReportOtherFieldsFragment = { __typename?: 'BusinessTrip', id: string, otherExpenses: Array<(
    { __typename?: 'BusinessTripOtherExpense', id: string, date?: any | null }
    & { ' $fragmentRefs'?: { 'BusinessTripReportOtherRowFieldsFragment': BusinessTripReportOtherRowFieldsFragment } }
  )> } & { ' $fragmentName'?: 'BusinessTripReportOtherFieldsFragment' };

export type BusinessTripReportHeaderFieldsFragment = (
  { __typename?: 'BusinessTrip', id: string, name: string, purpose?: string | null, dates?: { __typename?: 'DateRange', start: any, end: any } | null, destination?: { __typename?: 'Country', id: string, name: string } | null }
  & { ' $fragmentRefs'?: { 'BusinessTripAccountantApprovalFieldsFragment': BusinessTripAccountantApprovalFieldsFragment } }
) & { ' $fragmentName'?: 'BusinessTripReportHeaderFieldsFragment' };

export type BusinessTripReportSummaryFieldsFragment = { __typename?: 'BusinessTrip', id: string } & ({ __typename?: 'BusinessTrip', summary: { __typename?: 'BusinessTripSummary', excessTax?: number | null, errors?: Array<string> | null, excessExpenditure?: { __typename?: 'FinancialAmount', formatted: string } | null, rows: Array<{ __typename?: 'BusinessTripSummaryRow', type: BusinessTripSummaryCategories, totalForeignCurrency: { __typename?: 'FinancialAmount', formatted: string }, totalLocalCurrency?: { __typename?: 'FinancialAmount', formatted: string } | null, taxableForeignCurrency: { __typename?: 'FinancialAmount', formatted: string }, taxableLocalCurrency?: { __typename?: 'FinancialAmount', formatted: string } | null, maxTaxableForeignCurrency: { __typename?: 'FinancialAmount', formatted: string }, maxTaxableLocalCurrency?: { __typename?: 'FinancialAmount', formatted: string } | null, excessExpenditure?: { __typename?: 'FinancialAmount', formatted: string } | null }> } } | { __typename?: 'BusinessTrip', summary?: never }) & { ' $fragmentName'?: 'BusinessTripReportSummaryFieldsFragment' };

export type BusinessTripReportTravelAndSubsistenceRowFieldsFragment = (
  { __typename?: 'BusinessTripTravelAndSubsistenceExpense', id: string, payedByEmployee?: boolean | null, expenseType?: string | null }
  & { ' $fragmentRefs'?: { 'BusinessTripReportCoreExpenseRowFields_BusinessTripTravelAndSubsistenceExpense_Fragment': BusinessTripReportCoreExpenseRowFields_BusinessTripTravelAndSubsistenceExpense_Fragment } }
) & { ' $fragmentName'?: 'BusinessTripReportTravelAndSubsistenceRowFieldsFragment' };

export type BusinessTripReportTravelAndSubsistenceFieldsFragment = { __typename?: 'BusinessTrip', id: string, travelAndSubsistenceExpenses: Array<(
    { __typename?: 'BusinessTripTravelAndSubsistenceExpense', id: string, date?: any | null }
    & { ' $fragmentRefs'?: { 'BusinessTripReportTravelAndSubsistenceRowFieldsFragment': BusinessTripReportTravelAndSubsistenceRowFieldsFragment } }
  )> } & { ' $fragmentName'?: 'BusinessTripReportTravelAndSubsistenceFieldsFragment' };

export type BusinessTripUncategorizedTransactionsFieldsFragment = { __typename?: 'BusinessTrip', id: string, uncategorizedTransactions: Array<(
    { __typename?: 'UncategorizedTransaction', transaction:
      | (
        { __typename?: 'CommonTransaction', id: string, eventDate: any, chargeId: string, amount: { __typename?: 'FinancialAmount', raw: number } }
        & { ' $fragmentRefs'?: { 'TransactionsTableEventDateFields_CommonTransaction_Fragment': TransactionsTableEventDateFields_CommonTransaction_Fragment;'TransactionsTableDebitDateFields_CommonTransaction_Fragment': TransactionsTableDebitDateFields_CommonTransaction_Fragment;'TransactionsTableAccountFields_CommonTransaction_Fragment': TransactionsTableAccountFields_CommonTransaction_Fragment;'TransactionsTableDescriptionFields_CommonTransaction_Fragment': TransactionsTableDescriptionFields_CommonTransaction_Fragment;'TransactionsTableSourceIdFields_CommonTransaction_Fragment': TransactionsTableSourceIdFields_CommonTransaction_Fragment;'TransactionsTableEntityFields_CommonTransaction_Fragment': TransactionsTableEntityFields_CommonTransaction_Fragment } }
      )
      | (
        { __typename?: 'ConversionTransaction', id: string, eventDate: any, chargeId: string, amount: { __typename?: 'FinancialAmount', raw: number } }
        & { ' $fragmentRefs'?: { 'TransactionsTableEventDateFields_ConversionTransaction_Fragment': TransactionsTableEventDateFields_ConversionTransaction_Fragment;'TransactionsTableDebitDateFields_ConversionTransaction_Fragment': TransactionsTableDebitDateFields_ConversionTransaction_Fragment;'TransactionsTableAccountFields_ConversionTransaction_Fragment': TransactionsTableAccountFields_ConversionTransaction_Fragment;'TransactionsTableDescriptionFields_ConversionTransaction_Fragment': TransactionsTableDescriptionFields_ConversionTransaction_Fragment;'TransactionsTableSourceIdFields_ConversionTransaction_Fragment': TransactionsTableSourceIdFields_ConversionTransaction_Fragment;'TransactionsTableEntityFields_ConversionTransaction_Fragment': TransactionsTableEntityFields_ConversionTransaction_Fragment } }
      )
     }
    & { ' $fragmentRefs'?: { 'UncategorizedTransactionsTableAmountFieldsFragment': UncategorizedTransactionsTableAmountFieldsFragment } }
  ) | null> } & { ' $fragmentName'?: 'BusinessTripUncategorizedTransactionsFieldsFragment' };

export type UncategorizedTransactionsTableAmountFieldsFragment = { __typename?: 'UncategorizedTransaction', errors: Array<string>, transaction:
    | { __typename?: 'CommonTransaction', id: string, amount: { __typename?: 'FinancialAmount', raw: number, formatted: string }, cryptoExchangeRate?: { __typename?: 'ConversionRate', rate: number } | null }
    | { __typename?: 'ConversionTransaction', id: string, amount: { __typename?: 'FinancialAmount', raw: number, formatted: string }, cryptoExchangeRate?: { __typename?: 'ConversionRate', rate: number } | null }
  , categorizedAmount: { __typename?: 'FinancialAmount', raw: number, formatted: string } } & { ' $fragmentName'?: 'UncategorizedTransactionsTableAmountFieldsFragment' };

export type DepreciationRecordRowFieldsFragment = { __typename?: 'DepreciationRecord', id: string, activationDate: any, type?: DepreciationType | null, amount: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number }, category: { __typename?: 'DepreciationCategory', id: string, name: string, percentage: number }, charge:
    | { __typename?: 'BankDepositCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number } | null }
    | { __typename?: 'BusinessTripCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number } | null }
    | { __typename?: 'CommonCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number } | null }
    | { __typename?: 'ConversionCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number } | null }
    | { __typename?: 'CreditcardBankCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number } | null }
    | { __typename?: 'DividendCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number } | null }
    | { __typename?: 'FinancialCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number } | null }
    | { __typename?: 'ForeignSecuritiesCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number } | null }
    | { __typename?: 'InternalTransferCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number } | null }
    | { __typename?: 'MonthlyVatCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number } | null }
    | { __typename?: 'SalaryCharge', id: string, totalAmount?: { __typename?: 'FinancialAmount', currency: Currency, formatted: string, raw: number } | null }
   } & { ' $fragmentName'?: 'DepreciationRecordRowFieldsFragment' };

export type ChargeDepreciationQueryVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
}>;


export type ChargeDepreciationQuery = { __typename?: 'Query', depreciationRecordsByCharge: Array<(
    { __typename?: 'DepreciationRecord', id: string }
    & { ' $fragmentRefs'?: { 'DepreciationRecordRowFieldsFragment': DepreciationRecordRowFieldsFragment } }
  )> };

export type RecentBusinessIssuedDocumentsQueryVariables = Exact<{
  businessId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecentBusinessIssuedDocumentsQuery = { __typename?: 'Query', recentDocumentsByBusiness: Array<
    | (
      { __typename?: 'CreditInvoice', id: string, issuedDocumentInfo?: { __typename?: 'IssuedDocumentInfo', id: string, status: DocumentStatus, externalId: string } | null }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { __typename?: 'Invoice', id: string, issuedDocumentInfo?: { __typename?: 'IssuedDocumentInfo', id: string, status: DocumentStatus, externalId: string } | null }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { __typename?: 'InvoiceReceipt', id: string, issuedDocumentInfo?: { __typename?: 'IssuedDocumentInfo', id: string, status: DocumentStatus, externalId: string } | null }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { __typename?: 'OtherDocument', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { __typename?: 'Proforma', id: string, issuedDocumentInfo?: { __typename?: 'IssuedDocumentInfo', id: string, status: DocumentStatus, externalId: string } | null }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { __typename?: 'Receipt', id: string, issuedDocumentInfo?: { __typename?: 'IssuedDocumentInfo', id: string, status: DocumentStatus, externalId: string } | null }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { __typename?: 'Unprocessed', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > };

export type RecentIssuedDocumentsOfSameTypeQueryVariables = Exact<{
  documentType: DocumentType;
}>;


export type RecentIssuedDocumentsOfSameTypeQuery = { __typename?: 'Query', recentIssuedDocumentsByType: Array<
    | (
      { __typename?: 'CreditInvoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { __typename?: 'Invoice', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { __typename?: 'InvoiceReceipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { __typename?: 'OtherDocument', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { __typename?: 'Proforma', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { __typename?: 'Receipt', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { __typename?: 'Unprocessed', id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > };

export type EditDocumentQueryVariables = Exact<{
  documentId: Scalars['UUID']['input'];
}>;


export type EditDocumentQuery = { __typename?: 'Query', documentById?:
    | { __typename: 'CreditInvoice', serialNumber?: string | null, date?: any | null, vatReportDateOverride?: any | null, noVatAmount?: number | null, allocationNumber?: string | null, exchangeRateOverride?: number | null, id: string, image?: any | null, file?: any | null, documentType?: DocumentType | null, description?: string | null, remarks?: string | null, vat?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null, amount?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null, debtor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, creditor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename: 'Invoice', serialNumber?: string | null, date?: any | null, vatReportDateOverride?: any | null, noVatAmount?: number | null, allocationNumber?: string | null, exchangeRateOverride?: number | null, id: string, image?: any | null, file?: any | null, documentType?: DocumentType | null, description?: string | null, remarks?: string | null, vat?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null, amount?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null, debtor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, creditor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename: 'InvoiceReceipt', serialNumber?: string | null, date?: any | null, vatReportDateOverride?: any | null, noVatAmount?: number | null, allocationNumber?: string | null, exchangeRateOverride?: number | null, id: string, image?: any | null, file?: any | null, documentType?: DocumentType | null, description?: string | null, remarks?: string | null, vat?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null, amount?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null, debtor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, creditor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename: 'OtherDocument', id: string, image?: any | null, file?: any | null, documentType?: DocumentType | null, description?: string | null, remarks?: string | null }
    | { __typename: 'Proforma', serialNumber?: string | null, date?: any | null, vatReportDateOverride?: any | null, noVatAmount?: number | null, allocationNumber?: string | null, exchangeRateOverride?: number | null, id: string, image?: any | null, file?: any | null, documentType?: DocumentType | null, description?: string | null, remarks?: string | null, vat?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null, amount?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null, debtor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, creditor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename: 'Receipt', serialNumber?: string | null, date?: any | null, vatReportDateOverride?: any | null, noVatAmount?: number | null, allocationNumber?: string | null, exchangeRateOverride?: number | null, id: string, image?: any | null, file?: any | null, documentType?: DocumentType | null, description?: string | null, remarks?: string | null, vat?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null, amount?: { __typename?: 'FinancialAmount', raw: number, currency: Currency } | null, debtor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, creditor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename: 'Unprocessed', id: string, image?: any | null, file?: any | null, documentType?: DocumentType | null, description?: string | null, remarks?: string | null }
   | null };

export type EditMiscExpenseFieldsFragment = { __typename?: 'MiscExpense', id: string, description?: string | null, invoiceDate: any, valueDate: any, amount: { __typename?: 'FinancialAmount', raw: number, currency: Currency }, creditor:
    | { __typename?: 'LtdFinancialEntity', id: string }
    | { __typename?: 'PersonalFinancialEntity', id: string }
    | { __typename?: 'TaxCategory', id: string }
  , debtor:
    | { __typename?: 'LtdFinancialEntity', id: string }
    | { __typename?: 'PersonalFinancialEntity', id: string }
    | { __typename?: 'TaxCategory', id: string }
   } & { ' $fragmentName'?: 'EditMiscExpenseFieldsFragment' };

export type EditTagFieldsFragment = { __typename?: 'Tag', id: string, name: string, parent?: { __typename?: 'Tag', id: string, name: string } | null } & { ' $fragmentName'?: 'EditTagFieldsFragment' };

export type EditTransactionQueryVariables = Exact<{
  transactionIDs: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type EditTransactionQuery = { __typename?: 'Query', transactionsByIDs: Array<
    | { __typename?: 'CommonTransaction', id: string, effectiveDate?: any | null, isFee?: boolean | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, account:
        | { __typename?: 'BankDepositFinancialAccount', type: FinancialAccountType, id: string }
        | { __typename?: 'BankFinancialAccount', type: FinancialAccountType, id: string }
        | { __typename?: 'CardFinancialAccount', type: FinancialAccountType, id: string }
        | { __typename?: 'CryptoWalletFinancialAccount', type: FinancialAccountType, id: string }
        | { __typename?: 'ForeignSecuritiesFinancialAccount', type: FinancialAccountType, id: string }
       }
    | { __typename?: 'ConversionTransaction', id: string, effectiveDate: any, isFee?: boolean | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, account:
        | { __typename?: 'BankDepositFinancialAccount', type: FinancialAccountType, id: string }
        | { __typename?: 'BankFinancialAccount', type: FinancialAccountType, id: string }
        | { __typename?: 'CardFinancialAccount', type: FinancialAccountType, id: string }
        | { __typename?: 'CryptoWalletFinancialAccount', type: FinancialAccountType, id: string }
        | { __typename?: 'ForeignSecuritiesFinancialAccount', type: FinancialAccountType, id: string }
       }
  > };

export type ClientInfoForDocumentIssuingQueryVariables = Exact<{
  businessId: Scalars['UUID']['input'];
}>;


export type ClientInfoForDocumentIssuingQuery = { __typename?: 'Query', client: (
    { __typename?: 'Client', id: string, integrations: { __typename?: 'ClientIntegrations', id: string, greenInvoiceInfo?: { __typename?: 'GreenInvoiceClient', greenInvoiceId?: string | null, businessId: string, name?: string | null } | null } }
    & { ' $fragmentRefs'?: { 'IssueDocumentClientFieldsFragment': IssueDocumentClientFieldsFragment } }
  ) };

export type AllBusinessTripsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllBusinessTripsQuery = { __typename?: 'Query', allBusinessTrips: Array<{ __typename?: 'BusinessTrip', id: string, name: string }> };

export type AllDepreciationCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDepreciationCategoriesQuery = { __typename?: 'Query', depreciationCategories: Array<{ __typename?: 'DepreciationCategory', id: string, name: string, percentage: number }> };

export type AllEmployeesByEmployerQueryVariables = Exact<{
  employerId: Scalars['UUID']['input'];
}>;


export type AllEmployeesByEmployerQuery = { __typename?: 'Query', employeesByEmployerId: Array<{ __typename?: 'Employee', id: string, name: string }> };

export type AllPensionFundsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPensionFundsQuery = { __typename?: 'Query', allPensionFunds: Array<{ __typename?: 'PensionFund', id: string, name: string }> };

export type AllTrainingFundsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTrainingFundsQuery = { __typename?: 'Query', allTrainingFunds: Array<{ __typename?: 'TrainingFund', id: string, name: string }> };

export type AttendeesByBusinessTripQueryVariables = Exact<{
  businessTripId: Scalars['UUID']['input'];
}>;


export type AttendeesByBusinessTripQuery = { __typename?: 'Query', businessTrip?: { __typename?: 'BusinessTrip', id: string, attendees: Array<{ __typename?: 'BusinessTripAttendee', id: string, name: string }> } | null };

export type FetchMultipleBusinessesQueryVariables = Exact<{
  businessIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type FetchMultipleBusinessesQuery = { __typename?: 'Query', businesses: Array<
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
  > };

export type FetchMultipleChargesQueryVariables = Exact<{
  chargeIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type FetchMultipleChargesQuery = { __typename?: 'Query', chargesByIDs: Array<
    | { __typename: 'BankDepositCharge', id: string, decreasedVAT?: boolean | null, property?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, invoicesCount: number } | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> }
    | { __typename: 'BusinessTripCharge', id: string, decreasedVAT?: boolean | null, property?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, invoicesCount: number } | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> }
    | { __typename: 'CommonCharge', id: string, decreasedVAT?: boolean | null, property?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, invoicesCount: number } | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> }
    | { __typename: 'ConversionCharge', id: string, decreasedVAT?: boolean | null, property?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, invoicesCount: number } | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> }
    | { __typename: 'CreditcardBankCharge', id: string, decreasedVAT?: boolean | null, property?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, invoicesCount: number } | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> }
    | { __typename: 'DividendCharge', id: string, decreasedVAT?: boolean | null, property?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, invoicesCount: number } | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> }
    | { __typename: 'FinancialCharge', id: string, decreasedVAT?: boolean | null, property?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, invoicesCount: number } | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> }
    | { __typename: 'ForeignSecuritiesCharge', id: string, decreasedVAT?: boolean | null, property?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, invoicesCount: number } | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> }
    | { __typename: 'InternalTransferCharge', id: string, decreasedVAT?: boolean | null, property?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, invoicesCount: number } | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> }
    | { __typename: 'MonthlyVatCharge', id: string, decreasedVAT?: boolean | null, property?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, invoicesCount: number } | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> }
    | { __typename: 'SalaryCharge', id: string, decreasedVAT?: boolean | null, property?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, invoicesCount: number } | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , tags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> }
  > };

export type EditChargeQueryVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
}>;


export type EditChargeQuery = { __typename?: 'Query', charge:
    | { __typename: 'BankDepositCharge', id: string, property?: boolean | null, decreasedVAT?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string }>, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string }> } | null, yearsOfRelevance?: Array<{ __typename?: 'YearOfRelevance', year: string, amount?: number | null }> | null }
    | { __typename: 'BusinessTripCharge', id: string, property?: boolean | null, decreasedVAT?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, businessTrip?: { __typename?: 'BusinessTrip', id: string, name: string } | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string }>, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string }> } | null, yearsOfRelevance?: Array<{ __typename?: 'YearOfRelevance', year: string, amount?: number | null }> | null }
    | { __typename: 'CommonCharge', id: string, property?: boolean | null, decreasedVAT?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string }>, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string }> } | null, yearsOfRelevance?: Array<{ __typename?: 'YearOfRelevance', year: string, amount?: number | null }> | null }
    | { __typename: 'ConversionCharge', id: string, property?: boolean | null, decreasedVAT?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string }>, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string }> } | null, yearsOfRelevance?: Array<{ __typename?: 'YearOfRelevance', year: string, amount?: number | null }> | null }
    | { __typename: 'CreditcardBankCharge', id: string, property?: boolean | null, decreasedVAT?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string }>, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string }> } | null, yearsOfRelevance?: Array<{ __typename?: 'YearOfRelevance', year: string, amount?: number | null }> | null }
    | { __typename: 'DividendCharge', id: string, property?: boolean | null, decreasedVAT?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string }>, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string }> } | null, yearsOfRelevance?: Array<{ __typename?: 'YearOfRelevance', year: string, amount?: number | null }> | null }
    | { __typename: 'FinancialCharge', id: string, property?: boolean | null, decreasedVAT?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string }>, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string }> } | null, yearsOfRelevance?: Array<{ __typename?: 'YearOfRelevance', year: string, amount?: number | null }> | null }
    | { __typename: 'ForeignSecuritiesCharge', id: string, property?: boolean | null, decreasedVAT?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string }>, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string }> } | null, yearsOfRelevance?: Array<{ __typename?: 'YearOfRelevance', year: string, amount?: number | null }> | null }
    | { __typename: 'InternalTransferCharge', id: string, property?: boolean | null, decreasedVAT?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string }>, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string }> } | null, yearsOfRelevance?: Array<{ __typename?: 'YearOfRelevance', year: string, amount?: number | null }> | null }
    | { __typename: 'MonthlyVatCharge', id: string, property?: boolean | null, decreasedVAT?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string }>, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string }> } | null, yearsOfRelevance?: Array<{ __typename?: 'YearOfRelevance', year: string, amount?: number | null }> | null }
    | { __typename: 'SalaryCharge', id: string, property?: boolean | null, decreasedVAT?: boolean | null, isInvoicePaymentDifferentCurrency?: boolean | null, userDescription?: string | null, optionalVAT?: boolean | null, optionalDocuments?: boolean | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, owner:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      , taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string }>, missingInfoSuggestions?: { __typename?: 'ChargeSuggestions', tags: Array<{ __typename?: 'Tag', id: string }> } | null, yearsOfRelevance?: Array<{ __typename?: 'YearOfRelevance', year: string, amount?: number | null }> | null }
   };

export type EditSalaryRecordQueryVariables = Exact<{
  month: Scalars['TimelessDate']['input'];
  employeeIDs: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type EditSalaryRecordQuery = { __typename?: 'Query', salaryRecordsByDates: Array<{ __typename?: 'Salary', month: string, pensionEmployeePercentage?: number | null, pensionEmployerPercentage?: number | null, compensationsPercentage?: number | null, trainingFundEmployeePercentage?: number | null, trainingFundEmployerPercentage?: number | null, workDays?: number | null, charge?: { __typename?: 'SalaryCharge', id: string } | null, directAmount: { __typename?: 'FinancialAmount', raw: number }, baseAmount?: { __typename?: 'FinancialAmount', raw: number } | null, employee?: { __typename?: 'LtdFinancialEntity', id: string, name: string } | null, employer?: { __typename?: 'LtdFinancialEntity', id: string, name: string } | null, pensionFund?: { __typename?: 'LtdFinancialEntity', id: string, name: string } | null, pensionEmployeeAmount?: { __typename?: 'FinancialAmount', raw: number } | null, pensionEmployerAmount?: { __typename?: 'FinancialAmount', raw: number } | null, compensationsAmount?: { __typename?: 'FinancialAmount', raw: number } | null, trainingFund?: { __typename?: 'LtdFinancialEntity', id: string, name: string } | null, trainingFundEmployeeAmount?: { __typename?: 'FinancialAmount', raw: number } | null, trainingFundEmployerAmount?: { __typename?: 'FinancialAmount', raw: number } | null, socialSecurityEmployeeAmount?: { __typename?: 'FinancialAmount', raw: number } | null, socialSecurityEmployerAmount?: { __typename?: 'FinancialAmount', raw: number } | null, incomeTaxAmount?: { __typename?: 'FinancialAmount', raw: number } | null, healthInsuranceAmount?: { __typename?: 'FinancialAmount', raw: number } | null, globalAdditionalHoursAmount?: { __typename?: 'FinancialAmount', raw: number } | null, bonus?: { __typename?: 'FinancialAmount', raw: number } | null, gift?: { __typename?: 'FinancialAmount', raw: number } | null, travelAndSubsistence?: { __typename?: 'FinancialAmount', raw: number } | null, recovery?: { __typename?: 'FinancialAmount', raw: number } | null, notionalExpense?: { __typename?: 'FinancialAmount', raw: number } | null, vacationDays?: { __typename?: 'VacationDays', added?: number | null, balance?: number | null } | null, vacationTakeout?: { __typename?: 'FinancialAmount', raw: number } | null, sicknessDays?: { __typename?: 'SicknessDays', balance?: number | null } | null }> };

export type SortCodeToUpdateQueryVariables = Exact<{
  key: Scalars['Int']['input'];
}>;


export type SortCodeToUpdateQuery = { __typename?: 'Query', sortCode?: { __typename?: 'SortCode', id: string, key: number, name?: string | null, defaultIrsCode?: number | null } | null };

export type TaxCategoryToUpdateQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TaxCategoryToUpdateQuery = { __typename?: 'Query', taxCategory: { __typename?: 'TaxCategory', id: string, name: string, irsCode?: number | null, sortCode?: { __typename?: 'SortCode', id: string, key: number, name?: string | null } | null } };

export type MiscExpenseTransactionFieldsQueryVariables = Exact<{
  transactionId: Scalars['UUID']['input'];
}>;


export type MiscExpenseTransactionFieldsQuery = { __typename?: 'Query', transactionsByIDs: Array<
    | { __typename?: 'CommonTransaction', id: string, chargeId: string, eventDate: any, effectiveDate?: any | null, exactEffectiveDate?: any | null, amount: { __typename?: 'FinancialAmount', raw: number, currency: Currency }, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string }
        | { __typename?: 'PersonalFinancialEntity', id: string }
        | { __typename?: 'TaxCategory', id: string }
       | null }
    | { __typename?: 'ConversionTransaction', id: string, chargeId: string, eventDate: any, effectiveDate: any, exactEffectiveDate?: any | null, amount: { __typename?: 'FinancialAmount', raw: number, currency: Currency }, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string }
        | { __typename?: 'PersonalFinancialEntity', id: string }
        | { __typename?: 'TaxCategory', id: string }
       | null }
  > };

export type IssueDocumentClientFieldsFragment = { __typename?: 'Client', id: string, emails: Array<string>, originalBusiness: { __typename?: 'LtdFinancialEntity', id: string, address?: string | null, city?: string | null, zipCode?: string | null, governmentId?: string | null, name: string, phoneNumber?: string | null, country: { __typename?: 'Country', id: string, code: any } } } & { ' $fragmentName'?: 'IssueDocumentClientFieldsFragment' };

export type NewDocumentDraftByChargeQueryVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
}>;


export type NewDocumentDraftByChargeQuery = { __typename?: 'Query', newDocumentDraftByCharge: (
    { __typename?: 'DocumentDraft' }
    & { ' $fragmentRefs'?: { 'NewDocumentDraftFragment': NewDocumentDraftFragment } }
  ) };

export type NewDocumentDraftByDocumentQueryVariables = Exact<{
  documentId: Scalars['UUID']['input'];
}>;


export type NewDocumentDraftByDocumentQuery = { __typename?: 'Query', newDocumentDraftByDocument: (
    { __typename?: 'DocumentDraft' }
    & { ' $fragmentRefs'?: { 'NewDocumentDraftFragment': NewDocumentDraftFragment } }
  ) };

export type NewDocumentDraftFragment = { __typename?: 'DocumentDraft', description?: string | null, remarks?: string | null, footer?: string | null, type: DocumentType, date?: string | null, dueDate?: string | null, language: DocumentLanguage, currency: Currency, vatType: DocumentVatType, rounding?: boolean | null, signed?: boolean | null, maxPayments?: number | null, linkedDocumentIds?: Array<string> | null, linkedPaymentId?: string | null, discount?: { __typename?: 'DocumentDiscount', amount: number, type: DocumentDiscountType } | null, client?: (
    { __typename?: 'Client', id: string, emails: Array<string>, originalBusiness: { __typename?: 'LtdFinancialEntity', id: string, name: string }, integrations: { __typename?: 'ClientIntegrations', id: string } }
    & { ' $fragmentRefs'?: { 'IssueDocumentClientFieldsFragment': IssueDocumentClientFieldsFragment } }
  ) | null, income?: Array<{ __typename?: 'DocumentIncomeRecord', currency: Currency, currencyRate?: number | null, description: string, itemId?: string | null, price: number, quantity: number, vatRate?: number | null, vatType: DocumentVatType }> | null, payment?: Array<{ __typename?: 'DocumentPaymentRecord', currency: Currency, currencyRate?: number | null, date?: string | null, price: number, type: PaymentType, bankName?: string | null, bankBranch?: string | null, bankAccount?: string | null, chequeNum?: string | null, accountId?: string | null, transactionId?: string | null, cardType?: DocumentPaymentRecordCardType | null, cardNum?: string | null, numPayments?: number | null, firstPayment?: number | null }> | null } & { ' $fragmentName'?: 'NewDocumentDraftFragment' };

export type SimilarChargesByBusinessQueryVariables = Exact<{
  businessId: Scalars['UUID']['input'];
  tagsDifferentThan?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  descriptionDifferentThan?: InputMaybe<Scalars['String']['input']>;
}>;


export type SimilarChargesByBusinessQuery = { __typename?: 'Query', similarChargesByBusiness: Array<
    | (
      { __typename?: 'BankDepositCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_BankDepositCharge_Fragment': SimilarChargesTable_BankDepositCharge_Fragment } }
    )
    | (
      { __typename?: 'BusinessTripCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_BusinessTripCharge_Fragment': SimilarChargesTable_BusinessTripCharge_Fragment } }
    )
    | (
      { __typename?: 'CommonCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_CommonCharge_Fragment': SimilarChargesTable_CommonCharge_Fragment } }
    )
    | (
      { __typename?: 'ConversionCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_ConversionCharge_Fragment': SimilarChargesTable_ConversionCharge_Fragment } }
    )
    | (
      { __typename?: 'CreditcardBankCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_CreditcardBankCharge_Fragment': SimilarChargesTable_CreditcardBankCharge_Fragment } }
    )
    | (
      { __typename?: 'DividendCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_DividendCharge_Fragment': SimilarChargesTable_DividendCharge_Fragment } }
    )
    | (
      { __typename?: 'FinancialCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_FinancialCharge_Fragment': SimilarChargesTable_FinancialCharge_Fragment } }
    )
    | (
      { __typename?: 'ForeignSecuritiesCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_ForeignSecuritiesCharge_Fragment': SimilarChargesTable_ForeignSecuritiesCharge_Fragment } }
    )
    | (
      { __typename?: 'InternalTransferCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_InternalTransferCharge_Fragment': SimilarChargesTable_InternalTransferCharge_Fragment } }
    )
    | (
      { __typename?: 'MonthlyVatCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_MonthlyVatCharge_Fragment': SimilarChargesTable_MonthlyVatCharge_Fragment } }
    )
    | (
      { __typename?: 'SalaryCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_SalaryCharge_Fragment': SimilarChargesTable_SalaryCharge_Fragment } }
    )
  > };

export type SimilarChargesQueryVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
  withMissingTags: Scalars['Boolean']['input'];
  withMissingDescription: Scalars['Boolean']['input'];
  tagsDifferentThan?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  descriptionDifferentThan?: InputMaybe<Scalars['String']['input']>;
}>;


export type SimilarChargesQuery = { __typename?: 'Query', similarCharges: Array<
    | (
      { __typename?: 'BankDepositCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_BankDepositCharge_Fragment': SimilarChargesTable_BankDepositCharge_Fragment } }
    )
    | (
      { __typename?: 'BusinessTripCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_BusinessTripCharge_Fragment': SimilarChargesTable_BusinessTripCharge_Fragment } }
    )
    | (
      { __typename?: 'CommonCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_CommonCharge_Fragment': SimilarChargesTable_CommonCharge_Fragment } }
    )
    | (
      { __typename?: 'ConversionCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_ConversionCharge_Fragment': SimilarChargesTable_ConversionCharge_Fragment } }
    )
    | (
      { __typename?: 'CreditcardBankCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_CreditcardBankCharge_Fragment': SimilarChargesTable_CreditcardBankCharge_Fragment } }
    )
    | (
      { __typename?: 'DividendCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_DividendCharge_Fragment': SimilarChargesTable_DividendCharge_Fragment } }
    )
    | (
      { __typename?: 'FinancialCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_FinancialCharge_Fragment': SimilarChargesTable_FinancialCharge_Fragment } }
    )
    | (
      { __typename?: 'ForeignSecuritiesCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_ForeignSecuritiesCharge_Fragment': SimilarChargesTable_ForeignSecuritiesCharge_Fragment } }
    )
    | (
      { __typename?: 'InternalTransferCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_InternalTransferCharge_Fragment': SimilarChargesTable_InternalTransferCharge_Fragment } }
    )
    | (
      { __typename?: 'MonthlyVatCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_MonthlyVatCharge_Fragment': SimilarChargesTable_MonthlyVatCharge_Fragment } }
    )
    | (
      { __typename?: 'SalaryCharge', id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_SalaryCharge_Fragment': SimilarChargesTable_SalaryCharge_Fragment } }
    )
  > };

type SimilarChargesTable_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_BankDepositCharge_Fragment' };

type SimilarChargesTable_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, businessTrip?: { __typename?: 'BusinessTrip', id: string, name: string } | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_BusinessTripCharge_Fragment' };

type SimilarChargesTable_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_CommonCharge_Fragment' };

type SimilarChargesTable_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_ConversionCharge_Fragment' };

type SimilarChargesTable_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_CreditcardBankCharge_Fragment' };

type SimilarChargesTable_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_DividendCharge_Fragment' };

type SimilarChargesTable_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_FinancialCharge_Fragment' };

type SimilarChargesTable_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_ForeignSecuritiesCharge_Fragment' };

type SimilarChargesTable_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_InternalTransferCharge_Fragment' };

type SimilarChargesTable_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_MonthlyVatCharge_Fragment' };

type SimilarChargesTable_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string, minEventDate?: any | null, minDebitDate?: any | null, minDocumentsDate?: any | null, userDescription?: string | null, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null, totalAmount?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, taxCategory?: { __typename?: 'TaxCategory', id: string, name: string } | null, metadata?: { __typename?: 'ChargeMetadata', transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_SalaryCharge_Fragment' };

export type SimilarChargesTableFragment =
  | SimilarChargesTable_BankDepositCharge_Fragment
  | SimilarChargesTable_BusinessTripCharge_Fragment
  | SimilarChargesTable_CommonCharge_Fragment
  | SimilarChargesTable_ConversionCharge_Fragment
  | SimilarChargesTable_CreditcardBankCharge_Fragment
  | SimilarChargesTable_DividendCharge_Fragment
  | SimilarChargesTable_FinancialCharge_Fragment
  | SimilarChargesTable_ForeignSecuritiesCharge_Fragment
  | SimilarChargesTable_InternalTransferCharge_Fragment
  | SimilarChargesTable_MonthlyVatCharge_Fragment
  | SimilarChargesTable_SalaryCharge_Fragment
;

export type SimilarTransactionsQueryVariables = Exact<{
  transactionId: Scalars['UUID']['input'];
  withMissingInfo: Scalars['Boolean']['input'];
}>;


export type SimilarTransactionsQuery = { __typename?: 'Query', similarTransactions: Array<
    | { __typename?: 'CommonTransaction', id: string, effectiveDate?: any | null, eventDate: any, sourceDescription: string, account:
        | { __typename?: 'BankDepositFinancialAccount', id: string, name: string, type: FinancialAccountType }
        | { __typename?: 'BankFinancialAccount', id: string, name: string, type: FinancialAccountType }
        | { __typename?: 'CardFinancialAccount', id: string, name: string, type: FinancialAccountType }
        | { __typename?: 'CryptoWalletFinancialAccount', id: string, name: string, type: FinancialAccountType }
        | { __typename?: 'ForeignSecuritiesFinancialAccount', id: string, name: string, type: FinancialAccountType }
      , amount: { __typename?: 'FinancialAmount', formatted: string, raw: number } }
    | { __typename?: 'ConversionTransaction', id: string, effectiveDate: any, eventDate: any, sourceDescription: string, account:
        | { __typename?: 'BankDepositFinancialAccount', id: string, name: string, type: FinancialAccountType }
        | { __typename?: 'BankFinancialAccount', id: string, name: string, type: FinancialAccountType }
        | { __typename?: 'CardFinancialAccount', id: string, name: string, type: FinancialAccountType }
        | { __typename?: 'CryptoWalletFinancialAccount', id: string, name: string, type: FinancialAccountType }
        | { __typename?: 'ForeignSecuritiesFinancialAccount', id: string, name: string, type: FinancialAccountType }
      , amount: { __typename?: 'FinancialAmount', formatted: string, raw: number } }
  > };

export type UniformFormatQueryVariables = Exact<{
  fromDate: Scalars['TimelessDate']['input'];
  toDate: Scalars['TimelessDate']['input'];
}>;


export type UniformFormatQuery = { __typename?: 'Query', uniformFormat?: { __typename?: 'UniformFormat', bkmvdata: string, ini: string } | null };

type NewFetchedDocumentFields_CreditInvoice_Fragment = { __typename?: 'CreditInvoice', id: string, documentType?: DocumentType | null, charge?:
    | { __typename?: 'BankDepositCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'BusinessTripCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'CommonCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'ConversionCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'CreditcardBankCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'DividendCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'FinancialCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'ForeignSecuritiesCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'InternalTransferCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'MonthlyVatCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'SalaryCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
   | null } & { ' $fragmentName'?: 'NewFetchedDocumentFields_CreditInvoice_Fragment' };

type NewFetchedDocumentFields_Invoice_Fragment = { __typename?: 'Invoice', id: string, documentType?: DocumentType | null, charge?:
    | { __typename?: 'BankDepositCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'BusinessTripCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'CommonCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'ConversionCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'CreditcardBankCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'DividendCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'FinancialCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'ForeignSecuritiesCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'InternalTransferCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'MonthlyVatCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'SalaryCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
   | null } & { ' $fragmentName'?: 'NewFetchedDocumentFields_Invoice_Fragment' };

type NewFetchedDocumentFields_InvoiceReceipt_Fragment = { __typename?: 'InvoiceReceipt', id: string, documentType?: DocumentType | null, charge?:
    | { __typename?: 'BankDepositCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'BusinessTripCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'CommonCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'ConversionCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'CreditcardBankCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'DividendCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'FinancialCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'ForeignSecuritiesCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'InternalTransferCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'MonthlyVatCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'SalaryCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
   | null } & { ' $fragmentName'?: 'NewFetchedDocumentFields_InvoiceReceipt_Fragment' };

type NewFetchedDocumentFields_OtherDocument_Fragment = { __typename?: 'OtherDocument', id: string, documentType?: DocumentType | null, charge?:
    | { __typename?: 'BankDepositCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'BusinessTripCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'CommonCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'ConversionCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'CreditcardBankCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'DividendCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'FinancialCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'ForeignSecuritiesCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'InternalTransferCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'MonthlyVatCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'SalaryCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
   | null } & { ' $fragmentName'?: 'NewFetchedDocumentFields_OtherDocument_Fragment' };

type NewFetchedDocumentFields_Proforma_Fragment = { __typename?: 'Proforma', id: string, documentType?: DocumentType | null, charge?:
    | { __typename?: 'BankDepositCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'BusinessTripCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'CommonCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'ConversionCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'CreditcardBankCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'DividendCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'FinancialCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'ForeignSecuritiesCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'InternalTransferCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'MonthlyVatCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'SalaryCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
   | null } & { ' $fragmentName'?: 'NewFetchedDocumentFields_Proforma_Fragment' };

type NewFetchedDocumentFields_Receipt_Fragment = { __typename?: 'Receipt', id: string, documentType?: DocumentType | null, charge?:
    | { __typename?: 'BankDepositCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'BusinessTripCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'CommonCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'ConversionCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'CreditcardBankCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'DividendCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'FinancialCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'ForeignSecuritiesCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'InternalTransferCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'MonthlyVatCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'SalaryCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
   | null } & { ' $fragmentName'?: 'NewFetchedDocumentFields_Receipt_Fragment' };

type NewFetchedDocumentFields_Unprocessed_Fragment = { __typename?: 'Unprocessed', id: string, documentType?: DocumentType | null, charge?:
    | { __typename?: 'BankDepositCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'BusinessTripCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'CommonCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'ConversionCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'CreditcardBankCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'DividendCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'FinancialCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'ForeignSecuritiesCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'InternalTransferCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'MonthlyVatCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
    | { __typename?: 'SalaryCharge', id: string, userDescription?: string | null, counterparty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }
   | null } & { ' $fragmentName'?: 'NewFetchedDocumentFields_Unprocessed_Fragment' };

export type NewFetchedDocumentFieldsFragment =
  | NewFetchedDocumentFields_CreditInvoice_Fragment
  | NewFetchedDocumentFields_Invoice_Fragment
  | NewFetchedDocumentFields_InvoiceReceipt_Fragment
  | NewFetchedDocumentFields_OtherDocument_Fragment
  | NewFetchedDocumentFields_Proforma_Fragment
  | NewFetchedDocumentFields_Receipt_Fragment
  | NewFetchedDocumentFields_Unprocessed_Fragment
;

export type ContractForContractsTableFieldsFragment = { __typename?: 'Contract', id: string, isActive: boolean, purchaseOrders: Array<string>, startDate: any, endDate: any, billingCycle: BillingCycle, product?: Product | null, plan?: SubscriptionPlan | null, operationsLimit: any, msCloud?: any | null, client: { __typename?: 'Client', id: string, originalBusiness: { __typename?: 'LtdFinancialEntity', id: string, name: string } }, amount: { __typename?: 'FinancialAmount', raw: number, formatted: string } } & { ' $fragmentName'?: 'ContractForContractsTableFieldsFragment' };

export type ContractBasedDocumentDraftsQueryVariables = Exact<{
  issueMonth: Scalars['TimelessDate']['input'];
  contractIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type ContractBasedDocumentDraftsQuery = { __typename?: 'Query', periodicalDocumentDraftsByContracts: Array<(
    { __typename?: 'DocumentDraft' }
    & { ' $fragmentRefs'?: { 'NewDocumentDraftFragment': NewDocumentDraftFragment } }
  )> };

type TableDocumentsRowFields_CreditInvoice_Fragment = { __typename?: 'CreditInvoice', date?: any | null, serialNumber?: string | null, allocationNumber?: string | null, id: string, documentType?: DocumentType | null, image?: any | null, file?: any | null, description?: string | null, remarks?: string | null, amount?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, missingInfoSuggestions?: { __typename?: 'DocumentSuggestions', isIncome?: boolean | null, amount?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, counterparty?:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     | null, owner?:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     | null } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, creditor?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null, debtor?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null, issuedDocumentInfo?: { __typename?: 'IssuedDocumentInfo', id: string, status: DocumentStatus, originalDocument?: { __typename?: 'DocumentDraft', income?: Array<{ __typename?: 'DocumentIncomeRecord', description: string }> | null } | null } | null, charge?:
    | { __typename?: 'BankDepositCharge', id: string }
    | { __typename?: 'BusinessTripCharge', id: string }
    | { __typename?: 'CommonCharge', id: string }
    | { __typename?: 'ConversionCharge', id: string }
    | { __typename?: 'CreditcardBankCharge', id: string }
    | { __typename?: 'DividendCharge', id: string }
    | { __typename?: 'FinancialCharge', id: string }
    | { __typename?: 'ForeignSecuritiesCharge', id: string }
    | { __typename?: 'InternalTransferCharge', id: string }
    | { __typename?: 'MonthlyVatCharge', id: string }
    | { __typename?: 'SalaryCharge', id: string }
   | null } & { ' $fragmentName'?: 'TableDocumentsRowFields_CreditInvoice_Fragment' };

type TableDocumentsRowFields_Invoice_Fragment = { __typename?: 'Invoice', date?: any | null, serialNumber?: string | null, allocationNumber?: string | null, id: string, documentType?: DocumentType | null, image?: any | null, file?: any | null, description?: string | null, remarks?: string | null, amount?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, missingInfoSuggestions?: { __typename?: 'DocumentSuggestions', isIncome?: boolean | null, amount?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, counterparty?:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     | null, owner?:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     | null } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, creditor?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null, debtor?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null, issuedDocumentInfo?: { __typename?: 'IssuedDocumentInfo', id: string, status: DocumentStatus, originalDocument?: { __typename?: 'DocumentDraft', income?: Array<{ __typename?: 'DocumentIncomeRecord', description: string }> | null } | null } | null, charge?:
    | { __typename?: 'BankDepositCharge', id: string }
    | { __typename?: 'BusinessTripCharge', id: string }
    | { __typename?: 'CommonCharge', id: string }
    | { __typename?: 'ConversionCharge', id: string }
    | { __typename?: 'CreditcardBankCharge', id: string }
    | { __typename?: 'DividendCharge', id: string }
    | { __typename?: 'FinancialCharge', id: string }
    | { __typename?: 'ForeignSecuritiesCharge', id: string }
    | { __typename?: 'InternalTransferCharge', id: string }
    | { __typename?: 'MonthlyVatCharge', id: string }
    | { __typename?: 'SalaryCharge', id: string }
   | null } & { ' $fragmentName'?: 'TableDocumentsRowFields_Invoice_Fragment' };

type TableDocumentsRowFields_InvoiceReceipt_Fragment = { __typename?: 'InvoiceReceipt', date?: any | null, serialNumber?: string | null, allocationNumber?: string | null, id: string, documentType?: DocumentType | null, image?: any | null, file?: any | null, description?: string | null, remarks?: string | null, amount?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, missingInfoSuggestions?: { __typename?: 'DocumentSuggestions', isIncome?: boolean | null, amount?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, counterparty?:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     | null, owner?:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     | null } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, creditor?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null, debtor?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null, issuedDocumentInfo?: { __typename?: 'IssuedDocumentInfo', id: string, status: DocumentStatus, originalDocument?: { __typename?: 'DocumentDraft', income?: Array<{ __typename?: 'DocumentIncomeRecord', description: string }> | null } | null } | null, charge?:
    | { __typename?: 'BankDepositCharge', id: string }
    | { __typename?: 'BusinessTripCharge', id: string }
    | { __typename?: 'CommonCharge', id: string }
    | { __typename?: 'ConversionCharge', id: string }
    | { __typename?: 'CreditcardBankCharge', id: string }
    | { __typename?: 'DividendCharge', id: string }
    | { __typename?: 'FinancialCharge', id: string }
    | { __typename?: 'ForeignSecuritiesCharge', id: string }
    | { __typename?: 'InternalTransferCharge', id: string }
    | { __typename?: 'MonthlyVatCharge', id: string }
    | { __typename?: 'SalaryCharge', id: string }
   | null } & { ' $fragmentName'?: 'TableDocumentsRowFields_InvoiceReceipt_Fragment' };

type TableDocumentsRowFields_OtherDocument_Fragment = { __typename?: 'OtherDocument', id: string, documentType?: DocumentType | null, image?: any | null, file?: any | null, description?: string | null, remarks?: string | null, charge?:
    | { __typename?: 'BankDepositCharge', id: string }
    | { __typename?: 'BusinessTripCharge', id: string }
    | { __typename?: 'CommonCharge', id: string }
    | { __typename?: 'ConversionCharge', id: string }
    | { __typename?: 'CreditcardBankCharge', id: string }
    | { __typename?: 'DividendCharge', id: string }
    | { __typename?: 'FinancialCharge', id: string }
    | { __typename?: 'ForeignSecuritiesCharge', id: string }
    | { __typename?: 'InternalTransferCharge', id: string }
    | { __typename?: 'MonthlyVatCharge', id: string }
    | { __typename?: 'SalaryCharge', id: string }
   | null } & { ' $fragmentName'?: 'TableDocumentsRowFields_OtherDocument_Fragment' };

type TableDocumentsRowFields_Proforma_Fragment = { __typename?: 'Proforma', date?: any | null, serialNumber?: string | null, allocationNumber?: string | null, id: string, documentType?: DocumentType | null, image?: any | null, file?: any | null, description?: string | null, remarks?: string | null, amount?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, missingInfoSuggestions?: { __typename?: 'DocumentSuggestions', isIncome?: boolean | null, amount?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, counterparty?:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     | null, owner?:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     | null } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, creditor?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null, debtor?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null, issuedDocumentInfo?: { __typename?: 'IssuedDocumentInfo', id: string, status: DocumentStatus, originalDocument?: { __typename?: 'DocumentDraft', income?: Array<{ __typename?: 'DocumentIncomeRecord', description: string }> | null } | null } | null, charge?:
    | { __typename?: 'BankDepositCharge', id: string }
    | { __typename?: 'BusinessTripCharge', id: string }
    | { __typename?: 'CommonCharge', id: string }
    | { __typename?: 'ConversionCharge', id: string }
    | { __typename?: 'CreditcardBankCharge', id: string }
    | { __typename?: 'DividendCharge', id: string }
    | { __typename?: 'FinancialCharge', id: string }
    | { __typename?: 'ForeignSecuritiesCharge', id: string }
    | { __typename?: 'InternalTransferCharge', id: string }
    | { __typename?: 'MonthlyVatCharge', id: string }
    | { __typename?: 'SalaryCharge', id: string }
   | null } & { ' $fragmentName'?: 'TableDocumentsRowFields_Proforma_Fragment' };

type TableDocumentsRowFields_Receipt_Fragment = { __typename?: 'Receipt', date?: any | null, serialNumber?: string | null, allocationNumber?: string | null, id: string, documentType?: DocumentType | null, image?: any | null, file?: any | null, description?: string | null, remarks?: string | null, amount?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, missingInfoSuggestions?: { __typename?: 'DocumentSuggestions', isIncome?: boolean | null, amount?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, counterparty?:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     | null, owner?:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     | null } | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, creditor?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null, debtor?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null, issuedDocumentInfo?: { __typename?: 'IssuedDocumentInfo', id: string, status: DocumentStatus, originalDocument?: { __typename?: 'DocumentDraft', income?: Array<{ __typename?: 'DocumentIncomeRecord', description: string }> | null } | null } | null, charge?:
    | { __typename?: 'BankDepositCharge', id: string }
    | { __typename?: 'BusinessTripCharge', id: string }
    | { __typename?: 'CommonCharge', id: string }
    | { __typename?: 'ConversionCharge', id: string }
    | { __typename?: 'CreditcardBankCharge', id: string }
    | { __typename?: 'DividendCharge', id: string }
    | { __typename?: 'FinancialCharge', id: string }
    | { __typename?: 'ForeignSecuritiesCharge', id: string }
    | { __typename?: 'InternalTransferCharge', id: string }
    | { __typename?: 'MonthlyVatCharge', id: string }
    | { __typename?: 'SalaryCharge', id: string }
   | null } & { ' $fragmentName'?: 'TableDocumentsRowFields_Receipt_Fragment' };

type TableDocumentsRowFields_Unprocessed_Fragment = { __typename?: 'Unprocessed', id: string, documentType?: DocumentType | null, image?: any | null, file?: any | null, description?: string | null, remarks?: string | null, charge?:
    | { __typename?: 'BankDepositCharge', id: string }
    | { __typename?: 'BusinessTripCharge', id: string }
    | { __typename?: 'CommonCharge', id: string }
    | { __typename?: 'ConversionCharge', id: string }
    | { __typename?: 'CreditcardBankCharge', id: string }
    | { __typename?: 'DividendCharge', id: string }
    | { __typename?: 'FinancialCharge', id: string }
    | { __typename?: 'ForeignSecuritiesCharge', id: string }
    | { __typename?: 'InternalTransferCharge', id: string }
    | { __typename?: 'MonthlyVatCharge', id: string }
    | { __typename?: 'SalaryCharge', id: string }
   | null } & { ' $fragmentName'?: 'TableDocumentsRowFields_Unprocessed_Fragment' };

export type TableDocumentsRowFieldsFragment =
  | TableDocumentsRowFields_CreditInvoice_Fragment
  | TableDocumentsRowFields_Invoice_Fragment
  | TableDocumentsRowFields_InvoiceReceipt_Fragment
  | TableDocumentsRowFields_OtherDocument_Fragment
  | TableDocumentsRowFields_Proforma_Fragment
  | TableDocumentsRowFields_Receipt_Fragment
  | TableDocumentsRowFields_Unprocessed_Fragment
;

type DocumentsGalleryFields_BankDepositCharge_Fragment = { __typename?: 'BankDepositCharge', id: string, additionalDocuments: Array<
    | { __typename?: 'CreditInvoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Invoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'InvoiceReceipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'OtherDocument', id: string, image?: any | null }
    | { __typename?: 'Proforma', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Receipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Unprocessed', id: string, image?: any | null }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_BankDepositCharge_Fragment' };

type DocumentsGalleryFields_BusinessTripCharge_Fragment = { __typename?: 'BusinessTripCharge', id: string, additionalDocuments: Array<
    | { __typename?: 'CreditInvoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Invoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'InvoiceReceipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'OtherDocument', id: string, image?: any | null }
    | { __typename?: 'Proforma', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Receipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Unprocessed', id: string, image?: any | null }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_BusinessTripCharge_Fragment' };

type DocumentsGalleryFields_CommonCharge_Fragment = { __typename?: 'CommonCharge', id: string, additionalDocuments: Array<
    | { __typename?: 'CreditInvoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Invoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'InvoiceReceipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'OtherDocument', id: string, image?: any | null }
    | { __typename?: 'Proforma', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Receipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Unprocessed', id: string, image?: any | null }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_CommonCharge_Fragment' };

type DocumentsGalleryFields_ConversionCharge_Fragment = { __typename?: 'ConversionCharge', id: string, additionalDocuments: Array<
    | { __typename?: 'CreditInvoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Invoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'InvoiceReceipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'OtherDocument', id: string, image?: any | null }
    | { __typename?: 'Proforma', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Receipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Unprocessed', id: string, image?: any | null }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_ConversionCharge_Fragment' };

type DocumentsGalleryFields_CreditcardBankCharge_Fragment = { __typename?: 'CreditcardBankCharge', id: string, additionalDocuments: Array<
    | { __typename?: 'CreditInvoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Invoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'InvoiceReceipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'OtherDocument', id: string, image?: any | null }
    | { __typename?: 'Proforma', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Receipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Unprocessed', id: string, image?: any | null }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_CreditcardBankCharge_Fragment' };

type DocumentsGalleryFields_DividendCharge_Fragment = { __typename?: 'DividendCharge', id: string, additionalDocuments: Array<
    | { __typename?: 'CreditInvoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Invoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'InvoiceReceipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'OtherDocument', id: string, image?: any | null }
    | { __typename?: 'Proforma', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Receipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Unprocessed', id: string, image?: any | null }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_DividendCharge_Fragment' };

type DocumentsGalleryFields_FinancialCharge_Fragment = { __typename?: 'FinancialCharge', id: string, additionalDocuments: Array<
    | { __typename?: 'CreditInvoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Invoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'InvoiceReceipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'OtherDocument', id: string, image?: any | null }
    | { __typename?: 'Proforma', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Receipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Unprocessed', id: string, image?: any | null }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_FinancialCharge_Fragment' };

type DocumentsGalleryFields_ForeignSecuritiesCharge_Fragment = { __typename?: 'ForeignSecuritiesCharge', id: string, additionalDocuments: Array<
    | { __typename?: 'CreditInvoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Invoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'InvoiceReceipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'OtherDocument', id: string, image?: any | null }
    | { __typename?: 'Proforma', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Receipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Unprocessed', id: string, image?: any | null }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_ForeignSecuritiesCharge_Fragment' };

type DocumentsGalleryFields_InternalTransferCharge_Fragment = { __typename?: 'InternalTransferCharge', id: string, additionalDocuments: Array<
    | { __typename?: 'CreditInvoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Invoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'InvoiceReceipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'OtherDocument', id: string, image?: any | null }
    | { __typename?: 'Proforma', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Receipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Unprocessed', id: string, image?: any | null }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_InternalTransferCharge_Fragment' };

type DocumentsGalleryFields_MonthlyVatCharge_Fragment = { __typename?: 'MonthlyVatCharge', id: string, additionalDocuments: Array<
    | { __typename?: 'CreditInvoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Invoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'InvoiceReceipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'OtherDocument', id: string, image?: any | null }
    | { __typename?: 'Proforma', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Receipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Unprocessed', id: string, image?: any | null }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_MonthlyVatCharge_Fragment' };

type DocumentsGalleryFields_SalaryCharge_Fragment = { __typename?: 'SalaryCharge', id: string, additionalDocuments: Array<
    | { __typename?: 'CreditInvoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Invoice', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'InvoiceReceipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'OtherDocument', id: string, image?: any | null }
    | { __typename?: 'Proforma', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Receipt', documentType?: DocumentType | null, id: string, image?: any | null }
    | { __typename?: 'Unprocessed', id: string, image?: any | null }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_SalaryCharge_Fragment' };

export type DocumentsGalleryFieldsFragment =
  | DocumentsGalleryFields_BankDepositCharge_Fragment
  | DocumentsGalleryFields_BusinessTripCharge_Fragment
  | DocumentsGalleryFields_CommonCharge_Fragment
  | DocumentsGalleryFields_ConversionCharge_Fragment
  | DocumentsGalleryFields_CreditcardBankCharge_Fragment
  | DocumentsGalleryFields_DividendCharge_Fragment
  | DocumentsGalleryFields_FinancialCharge_Fragment
  | DocumentsGalleryFields_ForeignSecuritiesCharge_Fragment
  | DocumentsGalleryFields_InternalTransferCharge_Fragment
  | DocumentsGalleryFields_MonthlyVatCharge_Fragment
  | DocumentsGalleryFields_SalaryCharge_Fragment
;

export type LedgerRecordsTableFieldsFragment = { __typename?: 'LedgerRecord', id: string, invoiceDate: any, valueDate: any, description?: string | null, reference?: string | null, creditAccount1?:
    | { __typename: 'LtdFinancialEntity', id: string, name: string }
    | { __typename: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename: 'TaxCategory', id: string, name: string }
   | null, creditAccount2?:
    | { __typename: 'LtdFinancialEntity', id: string, name: string }
    | { __typename: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename: 'TaxCategory', id: string, name: string }
   | null, debitAccount1?:
    | { __typename: 'LtdFinancialEntity', id: string, name: string }
    | { __typename: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename: 'TaxCategory', id: string, name: string }
   | null, debitAccount2?:
    | { __typename: 'LtdFinancialEntity', id: string, name: string }
    | { __typename: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename: 'TaxCategory', id: string, name: string }
   | null, creditAmount1?: { __typename?: 'FinancialAmount', formatted: string, currency: Currency } | null, creditAmount2?: { __typename?: 'FinancialAmount', formatted: string, currency: Currency } | null, debitAmount1?: { __typename?: 'FinancialAmount', formatted: string, currency: Currency } | null, debitAmount2?: { __typename?: 'FinancialAmount', formatted: string, currency: Currency } | null, localCurrencyCreditAmount1: { __typename?: 'FinancialAmount', formatted: string, raw: number }, localCurrencyCreditAmount2?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null, localCurrencyDebitAmount1: { __typename?: 'FinancialAmount', formatted: string, raw: number }, localCurrencyDebitAmount2?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null } & { ' $fragmentName'?: 'LedgerRecordsTableFieldsFragment' };

export type AccountantApprovalsChargesTableQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ChargeFilter>;
}>;


export type AccountantApprovalsChargesTableQuery = { __typename?: 'Query', allCharges: { __typename?: 'PaginatedCharges', nodes: Array<
      | { __typename?: 'BankDepositCharge', id: string, accountantApproval: AccountantStatus }
      | { __typename?: 'BusinessTripCharge', id: string, accountantApproval: AccountantStatus }
      | { __typename?: 'CommonCharge', id: string, accountantApproval: AccountantStatus }
      | { __typename?: 'ConversionCharge', id: string, accountantApproval: AccountantStatus }
      | { __typename?: 'CreditcardBankCharge', id: string, accountantApproval: AccountantStatus }
      | { __typename?: 'DividendCharge', id: string, accountantApproval: AccountantStatus }
      | { __typename?: 'FinancialCharge', id: string, accountantApproval: AccountantStatus }
      | { __typename?: 'ForeignSecuritiesCharge', id: string, accountantApproval: AccountantStatus }
      | { __typename?: 'InternalTransferCharge', id: string, accountantApproval: AccountantStatus }
      | { __typename?: 'MonthlyVatCharge', id: string, accountantApproval: AccountantStatus }
      | { __typename?: 'SalaryCharge', id: string, accountantApproval: AccountantStatus }
    > } };

export type CorporateTaxRulingComplianceReportQueryVariables = Exact<{
  years: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type CorporateTaxRulingComplianceReportQuery = { __typename?: 'Query', corporateTaxRulingComplianceReport: Array<{ __typename?: 'CorporateTaxRulingComplianceReport', id: string, year: number, totalIncome: { __typename?: 'FinancialAmount', formatted: string, raw: number, currency: Currency }, researchAndDevelopmentExpenses: { __typename?: 'FinancialAmount', formatted: string, raw: number, currency: Currency }, rndRelativeToIncome: (
      { __typename?: 'CorporateTaxRule', rule: string }
      & { ' $fragmentRefs'?: { 'CorporateTaxRulingReportRuleCellFieldsFragment': CorporateTaxRulingReportRuleCellFieldsFragment } }
    ), localDevelopmentExpenses: { __typename?: 'FinancialAmount', formatted: string, raw: number, currency: Currency }, localDevelopmentRelativeToRnd: (
      { __typename?: 'CorporateTaxRule', rule: string }
      & { ' $fragmentRefs'?: { 'CorporateTaxRulingReportRuleCellFieldsFragment': CorporateTaxRulingReportRuleCellFieldsFragment } }
    ), foreignDevelopmentExpenses: { __typename?: 'FinancialAmount', formatted: string, raw: number, currency: Currency }, foreignDevelopmentRelativeToRnd: (
      { __typename?: 'CorporateTaxRule', rule: string }
      & { ' $fragmentRefs'?: { 'CorporateTaxRulingReportRuleCellFieldsFragment': CorporateTaxRulingReportRuleCellFieldsFragment } }
    ), businessTripRndExpenses: { __typename?: 'FinancialAmount', formatted: string, raw: number, currency: Currency } } & ({ __typename?: 'CorporateTaxRulingComplianceReport', differences: { __typename?: 'CorporateTaxRulingComplianceReportDifferences', id: string, totalIncome?: { __typename?: 'FinancialAmount', formatted: string, raw: number, currency: Currency } | null, researchAndDevelopmentExpenses?: { __typename?: 'FinancialAmount', formatted: string, raw: number, currency: Currency } | null, rndRelativeToIncome?: (
        { __typename?: 'CorporateTaxRule' }
        & { ' $fragmentRefs'?: { 'CorporateTaxRulingReportRuleCellFieldsFragment': CorporateTaxRulingReportRuleCellFieldsFragment } }
      ) | null, localDevelopmentExpenses?: { __typename?: 'FinancialAmount', formatted: string, raw: number, currency: Currency } | null, localDevelopmentRelativeToRnd?: (
        { __typename?: 'CorporateTaxRule' }
        & { ' $fragmentRefs'?: { 'CorporateTaxRulingReportRuleCellFieldsFragment': CorporateTaxRulingReportRuleCellFieldsFragment } }
      ) | null, foreignDevelopmentExpenses?: { __typename?: 'FinancialAmount', formatted: string, raw: number, currency: Currency } | null, foreignDevelopmentRelativeToRnd?: (
        { __typename?: 'CorporateTaxRule' }
        & { ' $fragmentRefs'?: { 'CorporateTaxRulingReportRuleCellFieldsFragment': CorporateTaxRulingReportRuleCellFieldsFragment } }
      ) | null, businessTripRndExpenses?: { __typename?: 'FinancialAmount', formatted: string, raw: number, currency: Currency } | null } } | { __typename?: 'CorporateTaxRulingComplianceReport', differences?: never })> };

export type CorporateTaxRulingReportRuleCellFieldsFragment = { __typename?: 'CorporateTaxRule', id: string, rule: string, isCompliant: boolean, percentage: { __typename?: 'CorporateTaxRulePercentage', formatted: string } } & { ' $fragmentName'?: 'CorporateTaxRulingReportRuleCellFieldsFragment' };

export type AllDynamicReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDynamicReportsQuery = { __typename?: 'Query', allDynamicReports: Array<{ __typename?: 'DynamicReportInfo', id: string, name: string, isLocked: boolean, updated: any }> };

export type DynamicReportQueryVariables = Exact<{
  filters?: InputMaybe<BusinessTransactionsFilter>;
}>;


export type DynamicReportQuery = { __typename?: 'Query', businessTransactionsSumFromLedgerRecords:
    | { __typename: 'BusinessTransactionsSumFromLedgerRecordsSuccessfulResult', businessTransactionsSum: Array<{ __typename?: 'BusinessTransactionSum', business:
          | { __typename?: 'LtdFinancialEntity', id: string, name: string, sortCode?: { __typename?: 'SortCode', id: string, key: number, name?: string | null } | null }
          | { __typename?: 'PersonalFinancialEntity', id: string, name: string, sortCode?: { __typename?: 'SortCode', id: string, key: number, name?: string | null } | null }
          | { __typename?: 'TaxCategory', id: string, name: string, sortCode?: { __typename?: 'SortCode', id: string, key: number, name?: string | null } | null }
        , credit: { __typename?: 'FinancialAmount', formatted: string, raw: number }, debit: { __typename?: 'FinancialAmount', formatted: string, raw: number }, total: { __typename?: 'FinancialAmount', formatted: string, raw: number } }> }
    | { __typename: 'CommonError' }
   };

export type DynamicReportTemplateQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DynamicReportTemplateQuery = { __typename?: 'Query', dynamicReport: { __typename?: 'DynamicReportInfo', id: string, name: string, isLocked: boolean, updated: any, template: Array<{ __typename?: 'DynamicReportNode', id: string, parent: string, text: string, droppable: boolean, data: { __typename?: 'DynamicReportNodeData', nodeType: string, isOpen: boolean, hebrewText?: string | null } }> } };

export type ProfitAndLossReportQueryVariables = Exact<{
  reportYear: Scalars['Int']['input'];
  referenceYears: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type ProfitAndLossReportQuery = { __typename?: 'Query', profitAndLossReport: { __typename?: 'ProfitAndLossReport', id: string, report: { __typename?: 'ProfitAndLossReportYear', id: string, year: number, revenue: (
        { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), costOfSales: (
        { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), grossProfit: { __typename?: 'FinancialAmount', formatted: string }, researchAndDevelopmentExpenses: (
        { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), marketingExpenses: (
        { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), managementAndGeneralExpenses: (
        { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), operatingProfit: { __typename?: 'FinancialAmount', formatted: string }, financialExpenses: (
        { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), otherIncome: (
        { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), profitBeforeTax: { __typename?: 'FinancialAmount', formatted: string }, tax: { __typename?: 'FinancialAmount', formatted: string }, netProfit: { __typename?: 'FinancialAmount', formatted: string } }, reference: Array<{ __typename?: 'ProfitAndLossReportYear', id: string, year: number, revenue: { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }, costOfSales: { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }, grossProfit: { __typename?: 'FinancialAmount', formatted: string }, researchAndDevelopmentExpenses: { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }, marketingExpenses: { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }, managementAndGeneralExpenses: { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }, operatingProfit: { __typename?: 'FinancialAmount', formatted: string }, financialExpenses: { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }, otherIncome: { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }, profitBeforeTax: { __typename?: 'FinancialAmount', formatted: string }, tax: { __typename?: 'FinancialAmount', formatted: string }, netProfit: { __typename?: 'FinancialAmount', formatted: string } }> } };

export type ReportCommentaryTableFieldsFragment = { __typename?: 'ReportCommentary', records: Array<{ __typename?: 'ReportCommentaryRecord', sortCode: { __typename?: 'SortCode', id: string, key: number, name?: string | null }, amount: { __typename?: 'FinancialAmount', formatted: string }, records: Array<(
      { __typename?: 'ReportCommentarySubRecord' }
      & { ' $fragmentRefs'?: { 'ReportSubCommentaryTableFieldsFragment': ReportSubCommentaryTableFieldsFragment } }
    )> }> } & { ' $fragmentName'?: 'ReportCommentaryTableFieldsFragment' };

export type ReportSubCommentaryTableFieldsFragment = { __typename?: 'ReportCommentarySubRecord', financialEntity:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
  , amount: { __typename?: 'FinancialAmount', formatted: string } } & { ' $fragmentName'?: 'ReportSubCommentaryTableFieldsFragment' };

export type TaxReportQueryVariables = Exact<{
  reportYear: Scalars['Int']['input'];
  referenceYears: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type TaxReportQuery = { __typename?: 'Query', taxReport: { __typename?: 'TaxReport', id: string, report: { __typename?: 'TaxReportYear', id: string, year: number, taxRate: number, specialTaxRate: number, profitBeforeTax: (
        { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), researchAndDevelopmentExpensesByRecords: (
        { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), researchAndDevelopmentExpensesForTax: { __typename?: 'FinancialAmount', formatted: string }, fines: (
        { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), untaxableGifts: (
        { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), businessTripsExcessExpensesAmount: { __typename?: 'FinancialAmount', formatted: string }, salaryExcessExpensesAmount: { __typename?: 'FinancialAmount', formatted: string }, reserves: (
        { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), nontaxableLinkage: (
        { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), taxableIncome: { __typename?: 'FinancialAmount', formatted: string }, specialTaxableIncome: (
        { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), annualTaxExpense: { __typename?: 'FinancialAmount', formatted: string } }, reference: Array<{ __typename?: 'TaxReportYear', id: string, year: number, taxRate: number, specialTaxRate: number, profitBeforeTax: { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }, researchAndDevelopmentExpensesByRecords: { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }, researchAndDevelopmentExpensesForTax: { __typename?: 'FinancialAmount', formatted: string }, fines: { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }, untaxableGifts: { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }, businessTripsExcessExpensesAmount: { __typename?: 'FinancialAmount', formatted: string }, salaryExcessExpensesAmount: { __typename?: 'FinancialAmount', formatted: string }, reserves: { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }, nontaxableLinkage: { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }, taxableIncome: { __typename?: 'FinancialAmount', formatted: string }, specialTaxableIncome: (
        { __typename?: 'ReportCommentary', amount: { __typename?: 'FinancialAmount', formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), annualTaxExpense: { __typename?: 'FinancialAmount', formatted: string } }> } };

export type TrialBalanceReportQueryVariables = Exact<{
  filters?: InputMaybe<BusinessTransactionsFilter>;
}>;


export type TrialBalanceReportQuery = { __typename?: 'Query', businessTransactionsSumFromLedgerRecords:
    | (
      { __typename?: 'BusinessTransactionsSumFromLedgerRecordsSuccessfulResult' }
      & { ' $fragmentRefs'?: { 'TrialBalanceTableFieldsFragment': TrialBalanceTableFieldsFragment } }
    )
    | { __typename: 'CommonError' }
   };

export type TrialBalanceTableFieldsFragment = { __typename?: 'BusinessTransactionsSumFromLedgerRecordsSuccessfulResult', businessTransactionsSum: Array<{ __typename?: 'BusinessTransactionSum', business:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string, sortCode?: { __typename?: 'SortCode', id: string, key: number, name?: string | null } | null }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string, sortCode?: { __typename?: 'SortCode', id: string, key: number, name?: string | null } | null }
      | { __typename?: 'TaxCategory', id: string, name: string, sortCode?: { __typename?: 'SortCode', id: string, key: number, name?: string | null } | null }
    , credit: { __typename?: 'FinancialAmount', formatted: string, raw: number }, debit: { __typename?: 'FinancialAmount', formatted: string, raw: number }, total: { __typename?: 'FinancialAmount', formatted: string, raw: number } }> } & { ' $fragmentName'?: 'TrialBalanceTableFieldsFragment' };

export type ValidatePcn874ReportsQueryVariables = Exact<{
  businessId?: InputMaybe<Scalars['UUID']['input']>;
  fromMonthDate: Scalars['TimelessDate']['input'];
  toMonthDate: Scalars['TimelessDate']['input'];
}>;


export type ValidatePcn874ReportsQuery = { __typename?: 'Query', pcnByDate: Array<{ __typename?: 'Pcn874Records', id: string, date: any, content: string, diffContent?: string | null, business:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
     }> };

export type VatReportBusinessTripsFieldsFragment = { __typename?: 'VatReportResult', businessTrips: Array<
    | (
      { __typename?: 'BankDepositCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_BankDepositCharge_Fragment': ChargesTableFields_BankDepositCharge_Fragment } }
    )
    | (
      { __typename?: 'BusinessTripCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_BusinessTripCharge_Fragment': ChargesTableFields_BusinessTripCharge_Fragment } }
    )
    | (
      { __typename?: 'CommonCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_CommonCharge_Fragment': ChargesTableFields_CommonCharge_Fragment } }
    )
    | (
      { __typename?: 'ConversionCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_ConversionCharge_Fragment': ChargesTableFields_ConversionCharge_Fragment } }
    )
    | (
      { __typename?: 'CreditcardBankCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_CreditcardBankCharge_Fragment': ChargesTableFields_CreditcardBankCharge_Fragment } }
    )
    | (
      { __typename?: 'DividendCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_DividendCharge_Fragment': ChargesTableFields_DividendCharge_Fragment } }
    )
    | (
      { __typename?: 'FinancialCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_FinancialCharge_Fragment': ChargesTableFields_FinancialCharge_Fragment } }
    )
    | (
      { __typename?: 'ForeignSecuritiesCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_ForeignSecuritiesCharge_Fragment': ChargesTableFields_ForeignSecuritiesCharge_Fragment } }
    )
    | (
      { __typename?: 'InternalTransferCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_InternalTransferCharge_Fragment': ChargesTableFields_InternalTransferCharge_Fragment } }
    )
    | (
      { __typename?: 'MonthlyVatCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_MonthlyVatCharge_Fragment': ChargesTableFields_MonthlyVatCharge_Fragment } }
    )
    | (
      { __typename?: 'SalaryCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_SalaryCharge_Fragment': ChargesTableFields_SalaryCharge_Fragment } }
    )
  > } & { ' $fragmentName'?: 'VatReportBusinessTripsFieldsFragment' };

export type VatReportAccountantApprovalFieldsFragment = { __typename?: 'VatReportRecord', chargeId: string, chargeAccountantStatus?: AccountantStatus | null } & { ' $fragmentName'?: 'VatReportAccountantApprovalFieldsFragment' };

export type VatReportExpensesRowFieldsFragment = (
  { __typename?: 'VatReportRecord', vatNumber?: string | null, image?: string | null, allocationNumber?: string | null, documentSerial?: string | null, documentDate?: any | null, chargeDate?: any | null, chargeId: string, recordType: Pcn874RecordType, business?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null, amount: { __typename?: 'FinancialAmount', formatted: string, raw: number }, localAmount?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null, localVat?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null, foreignVatAfterDeduction?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null, localVatAfterDeduction?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null, roundedLocalVatAfterDeduction?: { __typename?: 'FinancialIntAmount', formatted: string, raw: number } | null, taxReducedLocalAmount?: { __typename?: 'FinancialIntAmount', formatted: string, raw: number } | null }
  & { ' $fragmentRefs'?: { 'VatReportAccountantApprovalFieldsFragment': VatReportAccountantApprovalFieldsFragment } }
) & { ' $fragmentName'?: 'VatReportExpensesRowFieldsFragment' };

export type VatReportExpensesFieldsFragment = { __typename?: 'VatReportResult', expenses: Array<(
    { __typename?: 'VatReportRecord', recordType: Pcn874RecordType, roundedLocalVatAfterDeduction?: { __typename?: 'FinancialIntAmount', raw: number } | null, taxReducedLocalAmount?: { __typename?: 'FinancialIntAmount', raw: number } | null }
    & { ' $fragmentRefs'?: { 'VatReportExpensesRowFieldsFragment': VatReportExpensesRowFieldsFragment } }
  )> } & { ' $fragmentName'?: 'VatReportExpensesFieldsFragment' };

export type VatReportIncomeRowFieldsFragment = (
  { __typename?: 'VatReportRecord', chargeId: string, vatNumber?: string | null, image?: string | null, allocationNumber?: string | null, documentSerial?: string | null, documentDate?: any | null, chargeDate?: any | null, recordType: Pcn874RecordType, business?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null, taxReducedForeignAmount?: { __typename?: 'FinancialIntAmount', formatted: string, raw: number } | null, taxReducedLocalAmount?: { __typename?: 'FinancialIntAmount', formatted: string, raw: number } | null }
  & { ' $fragmentRefs'?: { 'VatReportAccountantApprovalFieldsFragment': VatReportAccountantApprovalFieldsFragment } }
) & { ' $fragmentName'?: 'VatReportIncomeRowFieldsFragment' };

export type VatReportIncomeFieldsFragment = { __typename?: 'VatReportResult', income: Array<(
    { __typename?: 'VatReportRecord', recordType: Pcn874RecordType, taxReducedLocalAmount?: { __typename?: 'FinancialIntAmount', raw: number } | null }
    & { ' $fragmentRefs'?: { 'VatReportIncomeRowFieldsFragment': VatReportIncomeRowFieldsFragment } }
  )> } & { ' $fragmentName'?: 'VatReportIncomeFieldsFragment' };

export type VatMonthlyReportQueryVariables = Exact<{
  filters?: InputMaybe<VatReportFilter>;
}>;


export type VatMonthlyReportQuery = { __typename?: 'Query', vatReport: (
    { __typename?: 'VatReportResult' }
    & { ' $fragmentRefs'?: { 'VatReportSummaryFieldsFragment': VatReportSummaryFieldsFragment;'VatReportIncomeFieldsFragment': VatReportIncomeFieldsFragment;'VatReportExpensesFieldsFragment': VatReportExpensesFieldsFragment;'VatReportMissingInfoFieldsFragment': VatReportMissingInfoFieldsFragment;'VatReportMiscTableFieldsFragment': VatReportMiscTableFieldsFragment;'VatReportBusinessTripsFieldsFragment': VatReportBusinessTripsFieldsFragment } }
  ) };

export type VatReportMiscTableFieldsFragment = { __typename?: 'VatReportResult', differentMonthDoc: Array<
    | (
      { __typename?: 'BankDepositCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_BankDepositCharge_Fragment': ChargesTableFields_BankDepositCharge_Fragment } }
    )
    | (
      { __typename?: 'BusinessTripCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_BusinessTripCharge_Fragment': ChargesTableFields_BusinessTripCharge_Fragment } }
    )
    | (
      { __typename?: 'CommonCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_CommonCharge_Fragment': ChargesTableFields_CommonCharge_Fragment } }
    )
    | (
      { __typename?: 'ConversionCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_ConversionCharge_Fragment': ChargesTableFields_ConversionCharge_Fragment } }
    )
    | (
      { __typename?: 'CreditcardBankCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_CreditcardBankCharge_Fragment': ChargesTableFields_CreditcardBankCharge_Fragment } }
    )
    | (
      { __typename?: 'DividendCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_DividendCharge_Fragment': ChargesTableFields_DividendCharge_Fragment } }
    )
    | (
      { __typename?: 'FinancialCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_FinancialCharge_Fragment': ChargesTableFields_FinancialCharge_Fragment } }
    )
    | (
      { __typename?: 'ForeignSecuritiesCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_ForeignSecuritiesCharge_Fragment': ChargesTableFields_ForeignSecuritiesCharge_Fragment } }
    )
    | (
      { __typename?: 'InternalTransferCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_InternalTransferCharge_Fragment': ChargesTableFields_InternalTransferCharge_Fragment } }
    )
    | (
      { __typename?: 'MonthlyVatCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_MonthlyVatCharge_Fragment': ChargesTableFields_MonthlyVatCharge_Fragment } }
    )
    | (
      { __typename?: 'SalaryCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_SalaryCharge_Fragment': ChargesTableFields_SalaryCharge_Fragment } }
    )
  > } & { ' $fragmentName'?: 'VatReportMiscTableFieldsFragment' };

export type VatReportMissingInfoFieldsFragment = { __typename?: 'VatReportResult', missingInfo: Array<
    | (
      { __typename?: 'BankDepositCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_BankDepositCharge_Fragment': ChargesTableFields_BankDepositCharge_Fragment } }
    )
    | (
      { __typename?: 'BusinessTripCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_BusinessTripCharge_Fragment': ChargesTableFields_BusinessTripCharge_Fragment } }
    )
    | (
      { __typename?: 'CommonCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_CommonCharge_Fragment': ChargesTableFields_CommonCharge_Fragment } }
    )
    | (
      { __typename?: 'ConversionCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_ConversionCharge_Fragment': ChargesTableFields_ConversionCharge_Fragment } }
    )
    | (
      { __typename?: 'CreditcardBankCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_CreditcardBankCharge_Fragment': ChargesTableFields_CreditcardBankCharge_Fragment } }
    )
    | (
      { __typename?: 'DividendCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_DividendCharge_Fragment': ChargesTableFields_DividendCharge_Fragment } }
    )
    | (
      { __typename?: 'FinancialCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_FinancialCharge_Fragment': ChargesTableFields_FinancialCharge_Fragment } }
    )
    | (
      { __typename?: 'ForeignSecuritiesCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_ForeignSecuritiesCharge_Fragment': ChargesTableFields_ForeignSecuritiesCharge_Fragment } }
    )
    | (
      { __typename?: 'InternalTransferCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_InternalTransferCharge_Fragment': ChargesTableFields_InternalTransferCharge_Fragment } }
    )
    | (
      { __typename?: 'MonthlyVatCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_MonthlyVatCharge_Fragment': ChargesTableFields_MonthlyVatCharge_Fragment } }
    )
    | (
      { __typename?: 'SalaryCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_SalaryCharge_Fragment': ChargesTableFields_SalaryCharge_Fragment } }
    )
  > } & { ' $fragmentName'?: 'VatReportMissingInfoFieldsFragment' };

export type GeneratePcnQueryVariables = Exact<{
  monthDate: Scalars['TimelessDate']['input'];
  financialEntityId: Scalars['UUID']['input'];
}>;


export type GeneratePcnQuery = { __typename?: 'Query', pcnFile: { __typename?: 'PCNFileResult', reportContent: string, fileName: string } };

export type VatReportSummaryFieldsFragment = { __typename?: 'VatReportResult', expenses: Array<{ __typename?: 'VatReportRecord', recordType: Pcn874RecordType, isProperty: boolean, roundedLocalVatAfterDeduction?: { __typename?: 'FinancialIntAmount', raw: number } | null, taxReducedLocalAmount?: { __typename?: 'FinancialIntAmount', raw: number } | null }>, income: Array<{ __typename?: 'VatReportRecord', recordType: Pcn874RecordType, roundedLocalVatAfterDeduction?: { __typename?: 'FinancialIntAmount', raw: number } | null, taxReducedLocalAmount?: { __typename?: 'FinancialIntAmount', raw: number } | null }> } & { ' $fragmentName'?: 'VatReportSummaryFieldsFragment' };

export type LedgerCsvFieldsFragment = { __typename?: 'YearlyLedgerReport', id: string, year: number, financialEntitiesInfo: Array<{ __typename?: 'YearlyLedgerReportFinancialEntityInfo', entity:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string, sortCode?: { __typename?: 'SortCode', id: string, key: number } | null }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string, sortCode?: { __typename?: 'SortCode', id: string, key: number } | null }
      | { __typename?: 'TaxCategory', id: string, name: string, sortCode?: { __typename?: 'SortCode', id: string, key: number } | null }
    , openingBalance: { __typename?: 'FinancialAmount', raw: number }, totalCredit: { __typename?: 'FinancialAmount', raw: number }, totalDebit: { __typename?: 'FinancialAmount', raw: number }, closingBalance: { __typename?: 'FinancialAmount', raw: number }, records: Array<{ __typename?: 'SingleSidedLedgerRecord', id: string, invoiceDate: any, valueDate: any, description?: string | null, reference?: string | null, balance: number, amount: { __typename?: 'FinancialAmount', raw: number, formatted: string }, counterParty?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null }> }> } & { ' $fragmentName'?: 'LedgerCsvFieldsFragment' };

export type YearlyLedgerQueryVariables = Exact<{
  year: Scalars['Int']['input'];
}>;


export type YearlyLedgerQuery = { __typename?: 'Query', yearlyLedgerReport: (
    { __typename?: 'YearlyLedgerReport', id: string, year: number, financialEntitiesInfo: Array<{ __typename?: 'YearlyLedgerReportFinancialEntityInfo', entity:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string, sortCode?: { __typename?: 'SortCode', id: string, key: number } | null }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string, sortCode?: { __typename?: 'SortCode', id: string, key: number } | null }
        | { __typename?: 'TaxCategory', id: string, name: string, sortCode?: { __typename?: 'SortCode', id: string, key: number } | null }
      , openingBalance: { __typename?: 'FinancialAmount', raw: number }, totalCredit: { __typename?: 'FinancialAmount', raw: number }, totalDebit: { __typename?: 'FinancialAmount', raw: number }, closingBalance: { __typename?: 'FinancialAmount', raw: number }, records: Array<{ __typename?: 'SingleSidedLedgerRecord', id: string, invoiceDate: any, valueDate: any, description?: string | null, reference?: string | null, balance: number, amount: { __typename?: 'FinancialAmount', raw: number, formatted: string }, counterParty?:
          | { __typename?: 'LtdFinancialEntity', id: string, name: string }
          | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
          | { __typename?: 'TaxCategory', id: string, name: string }
         | null }> }> }
    & { ' $fragmentRefs'?: { 'LedgerCsvFieldsFragment': LedgerCsvFieldsFragment } }
  ) };

export type SalaryScreenRecordsQueryVariables = Exact<{
  fromDate: Scalars['TimelessDate']['input'];
  toDate: Scalars['TimelessDate']['input'];
  employeeIDs?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type SalaryScreenRecordsQuery = { __typename?: 'Query', salaryRecordsByDates: Array<(
    { __typename?: 'Salary', month: string, employee?: { __typename?: 'LtdFinancialEntity', id: string } | null }
    & { ' $fragmentRefs'?: { 'SalariesTableFieldsFragment': SalariesTableFieldsFragment } }
  )> };

export type SalariesRecordEmployeeFieldsFragment = { __typename?: 'Salary', month: string, employee?: { __typename?: 'LtdFinancialEntity', id: string, name: string } | null } & { ' $fragmentName'?: 'SalariesRecordEmployeeFieldsFragment' };

export type SalariesRecordFundsFieldsFragment = { __typename?: 'Salary', month: string, pensionEmployeePercentage?: number | null, pensionEmployerPercentage?: number | null, compensationsPercentage?: number | null, trainingFundEmployeePercentage?: number | null, trainingFundEmployerPercentage?: number | null, employee?: { __typename?: 'LtdFinancialEntity', id: string } | null, pensionFund?: { __typename?: 'LtdFinancialEntity', id: string, name: string } | null, pensionEmployeeAmount?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null, pensionEmployerAmount?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null, compensationsAmount?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null, trainingFund?: { __typename?: 'LtdFinancialEntity', id: string, name: string } | null, trainingFundEmployeeAmount?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null, trainingFundEmployerAmount?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null } & { ' $fragmentName'?: 'SalariesRecordFundsFieldsFragment' };

export type SalariesRecordInsurancesAndTaxesFieldsFragment = { __typename?: 'Salary', month: string, employee?: { __typename?: 'LtdFinancialEntity', id: string } | null, healthInsuranceAmount?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null, socialSecurityEmployeeAmount?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null, socialSecurityEmployerAmount?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null, incomeTaxAmount?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null, notionalExpense?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null } & { ' $fragmentName'?: 'SalariesRecordInsurancesAndTaxesFieldsFragment' };

export type SalariesRecordMainSalaryFieldsFragment = { __typename?: 'Salary', month: string, employee?: { __typename?: 'LtdFinancialEntity', id: string } | null, baseAmount?: { __typename?: 'FinancialAmount', formatted: string } | null, directAmount: { __typename?: 'FinancialAmount', formatted: string }, globalAdditionalHoursAmount?: { __typename?: 'FinancialAmount', formatted: string } | null, bonus?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null, gift?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null, recovery?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null, vacationTakeout?: { __typename?: 'FinancialAmount', formatted: string, raw: number } | null } & { ' $fragmentName'?: 'SalariesRecordMainSalaryFieldsFragment' };

export type SalariesRecordWorkFrameFieldsFragment = { __typename?: 'Salary', month: string, workDays?: number | null, employee?: { __typename?: 'LtdFinancialEntity', id: string } | null, vacationDays?: { __typename?: 'VacationDays', added?: number | null, taken?: number | null, balance?: number | null } | null, sicknessDays?: { __typename?: 'SicknessDays', balance?: number | null } | null } & { ' $fragmentName'?: 'SalariesRecordWorkFrameFieldsFragment' };

export type SalariesMonthFieldsFragment = (
  { __typename?: 'Salary', month: string, employee?: { __typename?: 'LtdFinancialEntity', id: string } | null }
  & { ' $fragmentRefs'?: { 'SalariesRecordFieldsFragment': SalariesRecordFieldsFragment } }
) & { ' $fragmentName'?: 'SalariesMonthFieldsFragment' };

export type SalariesTableFieldsFragment = (
  { __typename?: 'Salary', month: string, employee?: { __typename?: 'LtdFinancialEntity', id: string } | null }
  & { ' $fragmentRefs'?: { 'SalariesMonthFieldsFragment': SalariesMonthFieldsFragment } }
) & { ' $fragmentName'?: 'SalariesTableFieldsFragment' };

export type SalariesRecordFieldsFragment = (
  { __typename?: 'Salary', month: string, employee?: { __typename?: 'LtdFinancialEntity', id: string } | null }
  & { ' $fragmentRefs'?: { 'SalariesRecordEmployeeFieldsFragment': SalariesRecordEmployeeFieldsFragment;'SalariesRecordMainSalaryFieldsFragment': SalariesRecordMainSalaryFieldsFragment;'SalariesRecordFundsFieldsFragment': SalariesRecordFundsFieldsFragment;'SalariesRecordInsurancesAndTaxesFieldsFragment': SalariesRecordInsurancesAndTaxesFieldsFragment;'SalariesRecordWorkFrameFieldsFragment': SalariesRecordWorkFrameFieldsFragment } }
) & { ' $fragmentName'?: 'SalariesRecordFieldsFragment' };

export type AllDepositsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDepositsQuery = { __typename?: 'Query', allDeposits: Array<{ __typename?: 'BankDeposit', id: string, name: string, currency?: Currency | null, openDate?: any | null, closeDate?: any | null, isOpen: boolean, metadata: { __typename?: 'BankDepositMetadata', id: string, currentBalance: { __typename?: 'FinancialAmount', raw: number, formatted: string }, totalDeposit: { __typename?: 'FinancialAmount', raw: number, formatted: string }, totalInterest: { __typename?: 'FinancialAmount', raw: number, formatted: string } } }> };

export type BusinessScreenQueryVariables = Exact<{
  businessId: Scalars['UUID']['input'];
}>;


export type BusinessScreenQuery = { __typename?: 'Query', business:
    | (
      { __typename?: 'LtdFinancialEntity', id: string }
      & { ' $fragmentRefs'?: { 'BusinessPage_LtdFinancialEntity_Fragment': BusinessPage_LtdFinancialEntity_Fragment } }
    )
    | (
      { __typename?: 'PersonalFinancialEntity', id: string }
      & { ' $fragmentRefs'?: { 'BusinessPage_PersonalFinancialEntity_Fragment': BusinessPage_PersonalFinancialEntity_Fragment } }
    )
   };

export type ContractsScreenQueryVariables = Exact<{
  adminId: Scalars['UUID']['input'];
}>;


export type ContractsScreenQuery = { __typename?: 'Query', contractsByAdmin: Array<(
    { __typename?: 'Contract', id: string }
    & { ' $fragmentRefs'?: { 'ContractForContractsTableFieldsFragment': ContractForContractsTableFieldsFragment } }
  )> };

export type AllChargesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ChargeFilter>;
}>;


export type AllChargesQuery = { __typename?: 'Query', allCharges: { __typename?: 'PaginatedCharges', nodes: Array<
      | (
        { __typename?: 'BankDepositCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_BankDepositCharge_Fragment': ChargesTableFields_BankDepositCharge_Fragment } }
      )
      | (
        { __typename?: 'BusinessTripCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_BusinessTripCharge_Fragment': ChargesTableFields_BusinessTripCharge_Fragment } }
      )
      | (
        { __typename?: 'CommonCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_CommonCharge_Fragment': ChargesTableFields_CommonCharge_Fragment } }
      )
      | (
        { __typename?: 'ConversionCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_ConversionCharge_Fragment': ChargesTableFields_ConversionCharge_Fragment } }
      )
      | (
        { __typename?: 'CreditcardBankCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_CreditcardBankCharge_Fragment': ChargesTableFields_CreditcardBankCharge_Fragment } }
      )
      | (
        { __typename?: 'DividendCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_DividendCharge_Fragment': ChargesTableFields_DividendCharge_Fragment } }
      )
      | (
        { __typename?: 'FinancialCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_FinancialCharge_Fragment': ChargesTableFields_FinancialCharge_Fragment } }
      )
      | (
        { __typename?: 'ForeignSecuritiesCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_ForeignSecuritiesCharge_Fragment': ChargesTableFields_ForeignSecuritiesCharge_Fragment } }
      )
      | (
        { __typename?: 'InternalTransferCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_InternalTransferCharge_Fragment': ChargesTableFields_InternalTransferCharge_Fragment } }
      )
      | (
        { __typename?: 'MonthlyVatCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_MonthlyVatCharge_Fragment': ChargesTableFields_MonthlyVatCharge_Fragment } }
      )
      | (
        { __typename?: 'SalaryCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_SalaryCharge_Fragment': ChargesTableFields_SalaryCharge_Fragment } }
      )
    >, pageInfo: { __typename?: 'PageInfo', totalPages: number } } };

export type ChargeScreenQueryVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
}>;


export type ChargeScreenQuery = { __typename?: 'Query', charge:
    | (
      { __typename?: 'BankDepositCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_BankDepositCharge_Fragment': ChargesTableFields_BankDepositCharge_Fragment } }
    )
    | (
      { __typename?: 'BusinessTripCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_BusinessTripCharge_Fragment': ChargesTableFields_BusinessTripCharge_Fragment } }
    )
    | (
      { __typename?: 'CommonCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_CommonCharge_Fragment': ChargesTableFields_CommonCharge_Fragment } }
    )
    | (
      { __typename?: 'ConversionCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_ConversionCharge_Fragment': ChargesTableFields_ConversionCharge_Fragment } }
    )
    | (
      { __typename?: 'CreditcardBankCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_CreditcardBankCharge_Fragment': ChargesTableFields_CreditcardBankCharge_Fragment } }
    )
    | (
      { __typename?: 'DividendCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_DividendCharge_Fragment': ChargesTableFields_DividendCharge_Fragment } }
    )
    | (
      { __typename?: 'FinancialCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_FinancialCharge_Fragment': ChargesTableFields_FinancialCharge_Fragment } }
    )
    | (
      { __typename?: 'ForeignSecuritiesCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_ForeignSecuritiesCharge_Fragment': ChargesTableFields_ForeignSecuritiesCharge_Fragment } }
    )
    | (
      { __typename?: 'InternalTransferCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_InternalTransferCharge_Fragment': ChargesTableFields_InternalTransferCharge_Fragment } }
    )
    | (
      { __typename?: 'MonthlyVatCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_MonthlyVatCharge_Fragment': ChargesTableFields_MonthlyVatCharge_Fragment } }
    )
    | (
      { __typename?: 'SalaryCharge', id: string }
      & { ' $fragmentRefs'?: { 'ChargesTableFields_SalaryCharge_Fragment': ChargesTableFields_SalaryCharge_Fragment } }
    )
   };

export type MissingInfoChargesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MissingInfoChargesQuery = { __typename?: 'Query', chargesWithMissingRequiredInfo: { __typename?: 'PaginatedCharges', nodes: Array<
      | (
        { __typename?: 'BankDepositCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_BankDepositCharge_Fragment': ChargesTableFields_BankDepositCharge_Fragment } }
      )
      | (
        { __typename?: 'BusinessTripCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_BusinessTripCharge_Fragment': ChargesTableFields_BusinessTripCharge_Fragment } }
      )
      | (
        { __typename?: 'CommonCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_CommonCharge_Fragment': ChargesTableFields_CommonCharge_Fragment } }
      )
      | (
        { __typename?: 'ConversionCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_ConversionCharge_Fragment': ChargesTableFields_ConversionCharge_Fragment } }
      )
      | (
        { __typename?: 'CreditcardBankCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_CreditcardBankCharge_Fragment': ChargesTableFields_CreditcardBankCharge_Fragment } }
      )
      | (
        { __typename?: 'DividendCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_DividendCharge_Fragment': ChargesTableFields_DividendCharge_Fragment } }
      )
      | (
        { __typename?: 'FinancialCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_FinancialCharge_Fragment': ChargesTableFields_FinancialCharge_Fragment } }
      )
      | (
        { __typename?: 'ForeignSecuritiesCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_ForeignSecuritiesCharge_Fragment': ChargesTableFields_ForeignSecuritiesCharge_Fragment } }
      )
      | (
        { __typename?: 'InternalTransferCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_InternalTransferCharge_Fragment': ChargesTableFields_InternalTransferCharge_Fragment } }
      )
      | (
        { __typename?: 'MonthlyVatCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_MonthlyVatCharge_Fragment': ChargesTableFields_MonthlyVatCharge_Fragment } }
      )
      | (
        { __typename?: 'SalaryCharge', id: string }
        & { ' $fragmentRefs'?: { 'ChargesTableFields_SalaryCharge_Fragment': ChargesTableFields_SalaryCharge_Fragment } }
      )
    >, pageInfo: { __typename?: 'PageInfo', totalPages: number } } };

export type DocumentsScreenQueryVariables = Exact<{
  filters: DocumentsFilters;
}>;


export type DocumentsScreenQuery = { __typename?: 'Query', documentsByFilters: Array<
    | { __typename: 'CreditInvoice', serialNumber?: string | null, date?: any | null, id: string, image?: any | null, file?: any | null, creditor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, debtor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, amount?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, charge?:
        | { __typename: 'BankDepositCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'BusinessTripCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CommonCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ConversionCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CreditcardBankCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'DividendCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'FinancialCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ForeignSecuritiesCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'InternalTransferCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'MonthlyVatCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'SalaryCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
       | null }
    | { __typename: 'Invoice', serialNumber?: string | null, date?: any | null, id: string, image?: any | null, file?: any | null, creditor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, debtor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, amount?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, charge?:
        | { __typename: 'BankDepositCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'BusinessTripCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CommonCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ConversionCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CreditcardBankCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'DividendCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'FinancialCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ForeignSecuritiesCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'InternalTransferCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'MonthlyVatCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'SalaryCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
       | null }
    | { __typename: 'InvoiceReceipt', serialNumber?: string | null, date?: any | null, id: string, image?: any | null, file?: any | null, creditor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, debtor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, amount?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, charge?:
        | { __typename: 'BankDepositCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'BusinessTripCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CommonCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ConversionCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CreditcardBankCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'DividendCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'FinancialCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ForeignSecuritiesCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'InternalTransferCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'MonthlyVatCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'SalaryCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
       | null }
    | { __typename: 'OtherDocument', id: string, image?: any | null, file?: any | null, charge?:
        | { __typename: 'BankDepositCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'BusinessTripCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CommonCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ConversionCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CreditcardBankCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'DividendCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'FinancialCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ForeignSecuritiesCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'InternalTransferCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'MonthlyVatCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'SalaryCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
       | null }
    | { __typename: 'Proforma', serialNumber?: string | null, date?: any | null, id: string, image?: any | null, file?: any | null, creditor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, debtor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, amount?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, charge?:
        | { __typename: 'BankDepositCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'BusinessTripCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CommonCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ConversionCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CreditcardBankCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'DividendCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'FinancialCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ForeignSecuritiesCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'InternalTransferCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'MonthlyVatCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'SalaryCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
       | null }
    | { __typename: 'Receipt', serialNumber?: string | null, date?: any | null, id: string, image?: any | null, file?: any | null, creditor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, debtor?:
        | { __typename?: 'LtdFinancialEntity', id: string, name: string }
        | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
        | { __typename?: 'TaxCategory', id: string, name: string }
       | null, vat?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, amount?: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } | null, charge?:
        | { __typename: 'BankDepositCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'BusinessTripCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CommonCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ConversionCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CreditcardBankCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'DividendCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'FinancialCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ForeignSecuritiesCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'InternalTransferCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'MonthlyVatCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'SalaryCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
       | null }
    | { __typename: 'Unprocessed', id: string, image?: any | null, file?: any | null, charge?:
        | { __typename: 'BankDepositCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'BusinessTripCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CommonCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ConversionCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CreditcardBankCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'DividendCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'FinancialCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ForeignSecuritiesCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'InternalTransferCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'MonthlyVatCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'SalaryCharge', id: string, userDescription?: string | null, vat?: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { __typename?: 'CommonTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate?: any | null, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { __typename?: 'ConversionTransaction', id: string, eventDate: any, sourceDescription: string, effectiveDate: any, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
       | null }
  > };

export type MonthlyDocumentDraftByClientQueryVariables = Exact<{
  clientId: Scalars['UUID']['input'];
  issueMonth: Scalars['TimelessDate']['input'];
}>;


export type MonthlyDocumentDraftByClientQuery = { __typename?: 'Query', clientMonthlyChargeDraft: (
    { __typename?: 'DocumentDraft' }
    & { ' $fragmentRefs'?: { 'NewDocumentDraftFragment': NewDocumentDraftFragment } }
  ) };

export type MonthlyDocumentsDraftsQueryVariables = Exact<{
  issueMonth: Scalars['TimelessDate']['input'];
}>;


export type MonthlyDocumentsDraftsQuery = { __typename?: 'Query', periodicalDocumentDrafts: Array<(
    { __typename?: 'DocumentDraft' }
    & { ' $fragmentRefs'?: { 'NewDocumentDraftFragment': NewDocumentDraftFragment } }
  )> };

export type AllOpenContractsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllOpenContractsQuery = { __typename?: 'Query', allOpenContracts: Array<{ __typename?: 'Contract', id: string, billingCycle: BillingCycle, client: { __typename?: 'Client', id: string, originalBusiness: { __typename?: 'LtdFinancialEntity', id: string, name: string } } }> };

export type AnnualAuditStepsStatusQueryVariables = Exact<{
  ownerId: Scalars['UUID']['input'];
  year: Scalars['Int']['input'];
}>;


export type AnnualAuditStepsStatusQuery = { __typename?: 'Query', annualAuditStepStatuses: Array<{ __typename?: 'AnnualAuditStepStatusInfo', id: string, stepId: string, status: AnnualAuditStepStatus, notes?: string | null }> };

export type AccountantApprovalStatusQueryVariables = Exact<{
  fromDate: Scalars['TimelessDate']['input'];
  toDate: Scalars['TimelessDate']['input'];
}>;


export type AccountantApprovalStatusQuery = { __typename?: 'Query', accountantApprovalStatus: { __typename?: 'AccountantApprovalStatus', totalCharges: number, approvedCount: number, pendingCount: number, unapprovedCount: number } };

export type LedgerValidationStatusQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ChargeFilter>;
}>;


export type LedgerValidationStatusQuery = { __typename?: 'Query', chargesWithLedgerChanges: Array<{ __typename?: 'ChargesWithLedgerChangesResult', charge?:
      | { __typename?: 'BankDepositCharge', id: string }
      | { __typename?: 'BusinessTripCharge', id: string }
      | { __typename?: 'CommonCharge', id: string }
      | { __typename?: 'ConversionCharge', id: string }
      | { __typename?: 'CreditcardBankCharge', id: string }
      | { __typename?: 'DividendCharge', id: string }
      | { __typename?: 'FinancialCharge', id: string }
      | { __typename?: 'ForeignSecuritiesCharge', id: string }
      | { __typename?: 'InternalTransferCharge', id: string }
      | { __typename?: 'MonthlyVatCharge', id: string }
      | { __typename?: 'SalaryCharge', id: string }
     | null }> };

export type AnnualAuditOpeningBalanceStatusQueryVariables = Exact<{
  ownerId: Scalars['UUID']['input'];
  year: Scalars['Int']['input'];
}>;


export type AnnualAuditOpeningBalanceStatusQuery = { __typename?: 'Query', annualAuditOpeningBalanceStatus: { __typename?: 'AnnualAuditOpeningBalanceStatusInfo', id: string, userType: AnnualAuditOpeningBalanceUserType, balanceChargeId?: string | null, derivedStatus: AnnualAuditStepStatus, errorMessage?: string | null } };

export type AnnualFinancialChargesQueryVariables = Exact<{
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
  year: Scalars['TimelessDate']['input'];
}>;


export type AnnualFinancialChargesQuery = { __typename?: 'Query', annualFinancialCharges: { __typename?: 'FinancialChargesGenerationResult', id: string, revaluationCharge?: { __typename?: 'FinancialCharge', id: string } | null, taxExpensesCharge?: { __typename?: 'FinancialCharge', id: string } | null, depreciationCharge?: { __typename?: 'FinancialCharge', id: string } | null, recoveryReserveCharge?: { __typename?: 'FinancialCharge', id: string } | null, vacationReserveCharge?: { __typename?: 'FinancialCharge', id: string } | null, bankDepositsRevaluationCharge?: { __typename?: 'FinancialCharge', id: string } | null } };

export type Step05PrevYearTemplateQueryVariables = Exact<{
  ownerId: Scalars['UUID']['input'];
  year: Scalars['Int']['input'];
}>;


export type Step05PrevYearTemplateQuery = { __typename?: 'Query', annualAuditStepStatuses: Array<{ __typename?: 'AnnualAuditStepStatusInfo', id: string, stepId: string, status: AnnualAuditStepStatus, evidence?: string | null }> };

export type AdminLedgerLockDateQueryVariables = Exact<{
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type AdminLedgerLockDateQuery = { __typename?: 'Query', adminContext: { __typename?: 'AdminContextInfo', id: string, ledgerLock?: any | null } };

export type Step09SaveTemplateStatusQueryVariables = Exact<{
  ownerId: Scalars['UUID']['input'];
  year: Scalars['Int']['input'];
}>;


export type Step09SaveTemplateStatusQuery = { __typename?: 'Query', annualAuditStepStatuses: Array<{ __typename?: 'AnnualAuditStepStatusInfo', id: string, stepId: string, status: AnnualAuditStepStatus, evidence?: string | null }> };

export type AnnualRevenueReportClientFragment = { __typename?: 'AnnualRevenueReportCountryClient', id: string, name: string, revenueLocal: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency }, revenueDefaultForeign: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency }, records: Array<(
    { __typename?: 'AnnualRevenueReportClientRecord', id: string, date: any }
    & { ' $fragmentRefs'?: { 'AnnualRevenueReportRecordFragment': AnnualRevenueReportRecordFragment } }
  )> } & { ' $fragmentName'?: 'AnnualRevenueReportClientFragment' };

export type AnnualRevenueReportCountryFragment = { __typename?: 'AnnualRevenueReportCountry', id: string, code: string, name: string, revenueLocal: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency }, revenueDefaultForeign: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency }, clients: Array<(
    { __typename?: 'AnnualRevenueReportCountryClient', id: string, revenueDefaultForeign: { __typename?: 'FinancialAmount', raw: number } }
    & { ' $fragmentRefs'?: { 'AnnualRevenueReportClientFragment': AnnualRevenueReportClientFragment } }
  )> } & { ' $fragmentName'?: 'AnnualRevenueReportCountryFragment' };

export type AnnualRevenueReportScreenQueryVariables = Exact<{
  filters: AnnualRevenueReportFilter;
}>;


export type AnnualRevenueReportScreenQuery = { __typename?: 'Query', annualRevenueReport: { __typename?: 'AnnualRevenueReport', id: string, year: number, countries: Array<(
      { __typename?: 'AnnualRevenueReportCountry', id: string, name: string, revenueLocal: { __typename?: 'FinancialAmount', raw: number, currency: Currency }, revenueDefaultForeign: { __typename?: 'FinancialAmount', raw: number, currency: Currency }, clients: Array<{ __typename?: 'AnnualRevenueReportCountryClient', id: string, name: string, revenueLocal: { __typename?: 'FinancialAmount', raw: number }, revenueDefaultForeign: { __typename?: 'FinancialAmount', raw: number }, records: Array<{ __typename?: 'AnnualRevenueReportClientRecord', id: string, date: any, description?: string | null, reference?: string | null, chargeId: string, revenueLocal: { __typename?: 'FinancialAmount', raw: number }, revenueDefaultForeign: { __typename?: 'FinancialAmount', raw: number } }> }> }
      & { ' $fragmentRefs'?: { 'AnnualRevenueReportCountryFragment': AnnualRevenueReportCountryFragment } }
    )> } };

export type AnnualRevenueReportRecordFragment = { __typename?: 'AnnualRevenueReportClientRecord', id: string, chargeId: string, date: any, description?: string | null, reference?: string | null, revenueLocal: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency }, revenueDefaultForeign: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency }, revenueOriginal: { __typename?: 'FinancialAmount', raw: number, formatted: string, currency: Currency } } & { ' $fragmentName'?: 'AnnualRevenueReportRecordFragment' };

export type BalanceReportExtendedTransactionsQueryVariables = Exact<{
  transactionIDs: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type BalanceReportExtendedTransactionsQuery = { __typename?: 'Query', transactionsByIDs: Array<
    | (
      { __typename?: 'CommonTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment;'TransactionToDownloadForTransactionsTableFields_CommonTransaction_Fragment': TransactionToDownloadForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { __typename?: 'ConversionTransaction', id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment;'TransactionToDownloadForTransactionsTableFields_ConversionTransaction_Fragment': TransactionToDownloadForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > };

export type BalanceReportScreenQueryVariables = Exact<{
  fromDate: Scalars['TimelessDate']['input'];
  toDate: Scalars['TimelessDate']['input'];
  ownerId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type BalanceReportScreenQuery = { __typename?: 'Query', transactionsForBalanceReport: Array<{ __typename?: 'BalanceTransactions', id: string, date: any, month: number, year: number, isFee: boolean, description?: string | null, amountUsd: { __typename?: 'FinancialAmount', formatted: string, raw: number }, amount: { __typename?: 'FinancialAmount', currency: Currency, raw: number }, counterparty?:
      | { __typename?: 'LtdFinancialEntity', id: string }
      | { __typename?: 'PersonalFinancialEntity', id: string }
      | { __typename?: 'TaxCategory', id: string }
     | null, account:
      | { __typename?: 'BankDepositFinancialAccount', id: string, name: string }
      | { __typename?: 'BankFinancialAccount', id: string, name: string }
      | { __typename?: 'CardFinancialAccount', id: string, name: string }
      | { __typename?: 'CryptoWalletFinancialAccount', id: string, name: string }
      | { __typename?: 'ForeignSecuritiesFinancialAccount', id: string, name: string }
    , charge:
      | { __typename?: 'BankDepositCharge', id: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }
      | { __typename?: 'BusinessTripCharge', id: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }
      | { __typename?: 'CommonCharge', id: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }
      | { __typename?: 'ConversionCharge', id: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }
      | { __typename?: 'CreditcardBankCharge', id: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }
      | { __typename?: 'DividendCharge', id: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }
      | { __typename?: 'FinancialCharge', id: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }
      | { __typename?: 'ForeignSecuritiesCharge', id: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }
      | { __typename?: 'InternalTransferCharge', id: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }
      | { __typename?: 'MonthlyVatCharge', id: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }
      | { __typename?: 'SalaryCharge', id: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }
     }> };

type DepreciationReportRecordCore_DepreciationReportRecord_Fragment = { __typename?: 'DepreciationReportRecord', id: string, originalCost?: number | null, reportYearDelta?: number | null, totalDepreciableCosts: number, reportYearClaimedDepreciation: number, pastYearsAccumulatedDepreciation: number, totalDepreciation: number, netValue: number } & { ' $fragmentName'?: 'DepreciationReportRecordCore_DepreciationReportRecord_Fragment' };

type DepreciationReportRecordCore_DepreciationReportSummaryRecord_Fragment = { __typename?: 'DepreciationReportSummaryRecord', id: string, originalCost?: number | null, reportYearDelta?: number | null, totalDepreciableCosts: number, reportYearClaimedDepreciation: number, pastYearsAccumulatedDepreciation: number, totalDepreciation: number, netValue: number } & { ' $fragmentName'?: 'DepreciationReportRecordCore_DepreciationReportSummaryRecord_Fragment' };

export type DepreciationReportRecordCoreFragment =
  | DepreciationReportRecordCore_DepreciationReportRecord_Fragment
  | DepreciationReportRecordCore_DepreciationReportSummaryRecord_Fragment
;

export type DepreciationReportScreenQueryVariables = Exact<{
  filters: DepreciationReportFilter;
}>;


export type DepreciationReportScreenQuery = { __typename?: 'Query', depreciationReport: { __typename?: 'DepreciationReportResult', id: string, year: number, categories: Array<{ __typename?: 'DepreciationReportCategory', id: string, category: { __typename?: 'DepreciationCategory', id: string, name: string, percentage: number }, records: Array<(
        { __typename?: 'DepreciationReportRecord', id: string, chargeId: string, description?: string | null, purchaseDate: any, activationDate?: any | null, statutoryDepreciationRate: number, claimedDepreciationRate?: number | null }
        & { ' $fragmentRefs'?: { 'DepreciationReportRecordCore_DepreciationReportRecord_Fragment': DepreciationReportRecordCore_DepreciationReportRecord_Fragment } }
      )>, summary: (
        { __typename?: 'DepreciationReportSummaryRecord', id: string }
        & { ' $fragmentRefs'?: { 'DepreciationReportRecordCore_DepreciationReportSummaryRecord_Fragment': DepreciationReportRecordCore_DepreciationReportSummaryRecord_Fragment } }
      ) }>, summary: (
      { __typename?: 'DepreciationReportSummaryRecord', id: string }
      & { ' $fragmentRefs'?: { 'DepreciationReportRecordCore_DepreciationReportSummaryRecord_Fragment': DepreciationReportRecordCore_DepreciationReportSummaryRecord_Fragment } }
    ) } };

export type Shaam6111DataContentBalanceSheetFragment = { __typename?: 'Shaam6111Data', id: string, balanceSheet?: Array<{ __typename?: 'Shaam6111ReportEntry', code: number, amount: number, label: string }> | null } & { ' $fragmentName'?: 'Shaam6111DataContentBalanceSheetFragment' };

export type Shaam6111DataContentHeaderFragment = { __typename?: 'Shaam6111Data', id: string, header: { __typename?: 'Shaam6111Header', taxYear: string, businessDescription?: string | null, taxFileNumber: string, idNumber: string, vatFileNumber?: string | null, withholdingTaxFileNumber?: string | null, businessType: BusinessType, reportingMethod: ReportingMethod, currencyType: CurrencyType, amountsInThousands: boolean, accountingMethod: AccountingMethod, accountingSystem: AccountingSystem, softwareRegistrationNumber?: string | null, isPartnership?: boolean | null, partnershipCount?: number | null, partnershipProfitShare?: number | null, ifrsImplementationYear?: string | null, ifrsReportingOption?: IfrsReportingOption | null, includesProfitLoss: boolean, includesTaxAdjustment: boolean, includesBalanceSheet: boolean, industryCode: string, auditOpinionType?: AuditOpinionType | null } } & { ' $fragmentName'?: 'Shaam6111DataContentHeaderFragment' };

type Shaam6111DataContentHeaderBusiness_LtdFinancialEntity_Fragment = { __typename?: 'LtdFinancialEntity', id: string, name: string } & { ' $fragmentName'?: 'Shaam6111DataContentHeaderBusiness_LtdFinancialEntity_Fragment' };

type Shaam6111DataContentHeaderBusiness_PersonalFinancialEntity_Fragment = { __typename?: 'PersonalFinancialEntity', id: string, name: string } & { ' $fragmentName'?: 'Shaam6111DataContentHeaderBusiness_PersonalFinancialEntity_Fragment' };

export type Shaam6111DataContentHeaderBusinessFragment =
  | Shaam6111DataContentHeaderBusiness_LtdFinancialEntity_Fragment
  | Shaam6111DataContentHeaderBusiness_PersonalFinancialEntity_Fragment
;

export type Shaam6111ReportScreenQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  businessId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type Shaam6111ReportScreenQuery = { __typename?: 'Query', shaam6111: { __typename?: 'Shaam6111Report', id: string, year: number, data: (
      { __typename?: 'Shaam6111Data', id: string }
      & { ' $fragmentRefs'?: { 'Shaam6111DataContentFragment': Shaam6111DataContentFragment } }
    ), business:
      | (
        { __typename?: 'LtdFinancialEntity', id: string }
        & { ' $fragmentRefs'?: { 'Shaam6111DataContentHeaderBusiness_LtdFinancialEntity_Fragment': Shaam6111DataContentHeaderBusiness_LtdFinancialEntity_Fragment } }
      )
      | (
        { __typename?: 'PersonalFinancialEntity', id: string }
        & { ' $fragmentRefs'?: { 'Shaam6111DataContentHeaderBusiness_PersonalFinancialEntity_Fragment': Shaam6111DataContentHeaderBusiness_PersonalFinancialEntity_Fragment } }
      )
     } };

export type Shaam6111DataContentProfitLossFragment = { __typename?: 'Shaam6111Data', id: string, profitAndLoss: Array<{ __typename?: 'Shaam6111ReportEntry', code: number, amount: number, label: string }> } & { ' $fragmentName'?: 'Shaam6111DataContentProfitLossFragment' };

export type Shaam6111DataContentFragment = (
  { __typename?: 'Shaam6111Data', id: string }
  & { ' $fragmentRefs'?: { 'Shaam6111DataContentHeaderFragment': Shaam6111DataContentHeaderFragment;'Shaam6111DataContentProfitLossFragment': Shaam6111DataContentProfitLossFragment;'Shaam6111DataContentTaxAdjustmentFragment': Shaam6111DataContentTaxAdjustmentFragment;'Shaam6111DataContentBalanceSheetFragment': Shaam6111DataContentBalanceSheetFragment } }
) & { ' $fragmentName'?: 'Shaam6111DataContentFragment' };

export type Shaam6111DataContentTaxAdjustmentFragment = { __typename?: 'Shaam6111Data', id: string, taxAdjustment: Array<{ __typename?: 'Shaam6111ReportEntry', code: number, amount: number, label: string }> } & { ' $fragmentName'?: 'Shaam6111DataContentTaxAdjustmentFragment' };

export type AllSortCodesForScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSortCodesForScreenQuery = { __typename?: 'Query', allSortCodes: Array<{ __typename?: 'SortCode', id: string, key: number, name?: string | null, defaultIrsCode?: number | null }> };

export type AllTagsScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTagsScreenQuery = { __typename?: 'Query', allTags: Array<(
    { __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null, parent?: { __typename?: 'Tag', id: string } | null }
    & { ' $fragmentRefs'?: { 'EditTagFieldsFragment': EditTagFieldsFragment } }
  )> };

export type AllTaxCategoriesForScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTaxCategoriesForScreenQuery = { __typename?: 'Query', taxCategories: Array<{ __typename?: 'TaxCategory', id: string, name: string, sortCode?: { __typename?: 'SortCode', id: string, key: number, name?: string | null } | null }> };

type TransactionsTableAccountFields_CommonTransaction_Fragment = { __typename?: 'CommonTransaction', id: string, account:
    | { __typename?: 'BankDepositFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'BankFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'CardFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'CryptoWalletFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'ForeignSecuritiesFinancialAccount', id: string, name: string, type: FinancialAccountType }
   } & { ' $fragmentName'?: 'TransactionsTableAccountFields_CommonTransaction_Fragment' };

type TransactionsTableAccountFields_ConversionTransaction_Fragment = { __typename?: 'ConversionTransaction', id: string, account:
    | { __typename?: 'BankDepositFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'BankFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'CardFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'CryptoWalletFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'ForeignSecuritiesFinancialAccount', id: string, name: string, type: FinancialAccountType }
   } & { ' $fragmentName'?: 'TransactionsTableAccountFields_ConversionTransaction_Fragment' };

export type TransactionsTableAccountFieldsFragment =
  | TransactionsTableAccountFields_CommonTransaction_Fragment
  | TransactionsTableAccountFields_ConversionTransaction_Fragment
;

type TransactionsTableEntityFields_CommonTransaction_Fragment = { __typename?: 'CommonTransaction', id: string, sourceDescription: string, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null, missingInfoSuggestions?: { __typename?: 'TransactionSuggestions', business:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     } | null } & { ' $fragmentName'?: 'TransactionsTableEntityFields_CommonTransaction_Fragment' };

type TransactionsTableEntityFields_ConversionTransaction_Fragment = { __typename?: 'ConversionTransaction', id: string, sourceDescription: string, counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null, missingInfoSuggestions?: { __typename?: 'TransactionSuggestions', business:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     } | null } & { ' $fragmentName'?: 'TransactionsTableEntityFields_ConversionTransaction_Fragment' };

export type TransactionsTableEntityFieldsFragment =
  | TransactionsTableEntityFields_CommonTransaction_Fragment
  | TransactionsTableEntityFields_ConversionTransaction_Fragment
;

type TransactionsTableDebitDateFields_CommonTransaction_Fragment = { __typename?: 'CommonTransaction', id: string, effectiveDate?: any | null, sourceEffectiveDate?: any | null } & { ' $fragmentName'?: 'TransactionsTableDebitDateFields_CommonTransaction_Fragment' };

type TransactionsTableDebitDateFields_ConversionTransaction_Fragment = { __typename?: 'ConversionTransaction', id: string, effectiveDate: any, sourceEffectiveDate?: any | null } & { ' $fragmentName'?: 'TransactionsTableDebitDateFields_ConversionTransaction_Fragment' };

export type TransactionsTableDebitDateFieldsFragment =
  | TransactionsTableDebitDateFields_CommonTransaction_Fragment
  | TransactionsTableDebitDateFields_ConversionTransaction_Fragment
;

type TransactionsTableDescriptionFields_CommonTransaction_Fragment = { __typename?: 'CommonTransaction', id: string, sourceDescription: string } & { ' $fragmentName'?: 'TransactionsTableDescriptionFields_CommonTransaction_Fragment' };

type TransactionsTableDescriptionFields_ConversionTransaction_Fragment = { __typename?: 'ConversionTransaction', id: string, sourceDescription: string } & { ' $fragmentName'?: 'TransactionsTableDescriptionFields_ConversionTransaction_Fragment' };

export type TransactionsTableDescriptionFieldsFragment =
  | TransactionsTableDescriptionFields_CommonTransaction_Fragment
  | TransactionsTableDescriptionFields_ConversionTransaction_Fragment
;

type TransactionsTableEventDateFields_CommonTransaction_Fragment = { __typename?: 'CommonTransaction', id: string, eventDate: any } & { ' $fragmentName'?: 'TransactionsTableEventDateFields_CommonTransaction_Fragment' };

type TransactionsTableEventDateFields_ConversionTransaction_Fragment = { __typename?: 'ConversionTransaction', id: string, eventDate: any } & { ' $fragmentName'?: 'TransactionsTableEventDateFields_ConversionTransaction_Fragment' };

export type TransactionsTableEventDateFieldsFragment =
  | TransactionsTableEventDateFields_CommonTransaction_Fragment
  | TransactionsTableEventDateFields_ConversionTransaction_Fragment
;

type TransactionsTableSourceIdFields_CommonTransaction_Fragment = { __typename?: 'CommonTransaction', id: string, referenceKey?: string | null } & { ' $fragmentName'?: 'TransactionsTableSourceIdFields_CommonTransaction_Fragment' };

type TransactionsTableSourceIdFields_ConversionTransaction_Fragment = { __typename?: 'ConversionTransaction', id: string, referenceKey?: string | null } & { ' $fragmentName'?: 'TransactionsTableSourceIdFields_ConversionTransaction_Fragment' };

export type TransactionsTableSourceIdFieldsFragment =
  | TransactionsTableSourceIdFields_CommonTransaction_Fragment
  | TransactionsTableSourceIdFields_ConversionTransaction_Fragment
;

type TransactionForTransactionsTableFields_CommonTransaction_Fragment = { __typename?: 'CommonTransaction', id: string, isFee?: boolean | null, chargeId: string, eventDate: any, effectiveDate?: any | null, sourceEffectiveDate?: any | null, sourceDescription: string, referenceKey?: string | null, amount: { __typename?: 'FinancialAmount', raw: number, formatted: string }, cryptoExchangeRate?: { __typename?: 'ConversionRate', rate: number } | null, account:
    | { __typename?: 'BankDepositFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'BankFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'CardFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'CryptoWalletFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'ForeignSecuritiesFinancialAccount', id: string, name: string, type: FinancialAccountType }
  , counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null, missingInfoSuggestions?: { __typename?: 'TransactionSuggestions', business:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     } | null } & { ' $fragmentName'?: 'TransactionForTransactionsTableFields_CommonTransaction_Fragment' };

type TransactionForTransactionsTableFields_ConversionTransaction_Fragment = { __typename?: 'ConversionTransaction', id: string, isFee?: boolean | null, chargeId: string, eventDate: any, effectiveDate: any, sourceEffectiveDate?: any | null, sourceDescription: string, referenceKey?: string | null, amount: { __typename?: 'FinancialAmount', raw: number, formatted: string }, cryptoExchangeRate?: { __typename?: 'ConversionRate', rate: number } | null, account:
    | { __typename?: 'BankDepositFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'BankFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'CardFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'CryptoWalletFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'ForeignSecuritiesFinancialAccount', id: string, name: string, type: FinancialAccountType }
  , counterparty?:
    | { __typename?: 'LtdFinancialEntity', name: string, id: string }
    | { __typename?: 'PersonalFinancialEntity', name: string, id: string }
    | { __typename?: 'TaxCategory', name: string, id: string }
   | null, missingInfoSuggestions?: { __typename?: 'TransactionSuggestions', business:
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
     } | null } & { ' $fragmentName'?: 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment' };

export type TransactionForTransactionsTableFieldsFragment =
  | TransactionForTransactionsTableFields_CommonTransaction_Fragment
  | TransactionForTransactionsTableFields_ConversionTransaction_Fragment
;

type TransactionToDownloadForTransactionsTableFields_CommonTransaction_Fragment = { __typename?: 'CommonTransaction', id: string, effectiveDate?: any | null, eventDate: any, referenceKey?: string | null, sourceDescription: string, account:
    | { __typename?: 'BankDepositFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'BankFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'CardFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'CryptoWalletFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'ForeignSecuritiesFinancialAccount', id: string, name: string, type: FinancialAccountType }
  , amount: { __typename?: 'FinancialAmount', currency: Currency, raw: number }, counterparty?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null } & { ' $fragmentName'?: 'TransactionToDownloadForTransactionsTableFields_CommonTransaction_Fragment' };

type TransactionToDownloadForTransactionsTableFields_ConversionTransaction_Fragment = { __typename?: 'ConversionTransaction', id: string, effectiveDate: any, eventDate: any, referenceKey?: string | null, sourceDescription: string, account:
    | { __typename?: 'BankDepositFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'BankFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'CardFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'CryptoWalletFinancialAccount', id: string, name: string, type: FinancialAccountType }
    | { __typename?: 'ForeignSecuritiesFinancialAccount', id: string, name: string, type: FinancialAccountType }
  , amount: { __typename?: 'FinancialAmount', currency: Currency, raw: number }, counterparty?:
    | { __typename?: 'LtdFinancialEntity', id: string, name: string }
    | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename?: 'TaxCategory', id: string, name: string }
   | null } & { ' $fragmentName'?: 'TransactionToDownloadForTransactionsTableFields_ConversionTransaction_Fragment' };

export type TransactionToDownloadForTransactionsTableFieldsFragment =
  | TransactionToDownloadForTransactionsTableFields_CommonTransaction_Fragment
  | TransactionToDownloadForTransactionsTableFields_ConversionTransaction_Fragment
;

export type AcceptInvitationMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type AcceptInvitationMutation = { __typename?: 'Mutation', acceptInvitation: { __typename?: 'AcceptInvitationPayload', success: boolean, businessId: string, roleId: string } };

export type AddBusinessTripAccommodationsExpenseMutationVariables = Exact<{
  fields: AddBusinessTripAccommodationsExpenseInput;
}>;


export type AddBusinessTripAccommodationsExpenseMutation = { __typename?: 'Mutation', addBusinessTripAccommodationsExpense: string };

export type AddBusinessTripCarRentalExpenseMutationVariables = Exact<{
  fields: AddBusinessTripCarRentalExpenseInput;
}>;


export type AddBusinessTripCarRentalExpenseMutation = { __typename?: 'Mutation', addBusinessTripCarRentalExpense: string };

export type AddBusinessTripFlightsExpenseMutationVariables = Exact<{
  fields: AddBusinessTripFlightsExpenseInput;
}>;


export type AddBusinessTripFlightsExpenseMutation = { __typename?: 'Mutation', addBusinessTripFlightsExpense: string };

export type AddBusinessTripOtherExpenseMutationVariables = Exact<{
  fields: AddBusinessTripOtherExpenseInput;
}>;


export type AddBusinessTripOtherExpenseMutation = { __typename?: 'Mutation', addBusinessTripOtherExpense: string };

export type AddBusinessTripTravelAndSubsistenceExpenseMutationVariables = Exact<{
  fields: AddBusinessTripTravelAndSubsistenceExpenseInput;
}>;


export type AddBusinessTripTravelAndSubsistenceExpenseMutation = { __typename?: 'Mutation', addBusinessTripTravelAndSubsistenceExpense: string };

export type AddDepreciationRecordMutationVariables = Exact<{
  fields: InsertDepreciationRecordInput;
}>;


export type AddDepreciationRecordMutation = { __typename?: 'Mutation', insertDepreciationRecord:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'DepreciationRecord', id: string }
   };

export type AddSortCodeMutationVariables = Exact<{
  key: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  defaultIrsCode?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddSortCodeMutation = { __typename?: 'Mutation', addSortCode: boolean };

export type AddTagMutationVariables = Exact<{
  tagName: Scalars['String']['input'];
  parentTag?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type AddTagMutation = { __typename?: 'Mutation', addTag: boolean };

export type AnnualAuditStepStatusQueryVariables = Exact<{
  ownerId: Scalars['UUID']['input'];
  year: Scalars['Int']['input'];
}>;


export type AnnualAuditStepStatusQuery = { __typename?: 'Query', annualAuditStepStatuses: Array<{ __typename?: 'AnnualAuditStepStatusInfo', id: string, stepId: string, status: AnnualAuditStepStatus }> };

export type AssignChargeToDepositMutationVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
  depositId: Scalars['String']['input'];
}>;


export type AssignChargeToDepositMutation = { __typename?: 'Mutation', assignChargeToDeposit: { __typename?: 'BankDeposit', id: string } };

export type GenerateBalanceChargeMutationVariables = Exact<{
  description: Scalars['String']['input'];
  balanceRecords: Array<InsertMiscExpenseInput> | InsertMiscExpenseInput;
}>;


export type GenerateBalanceChargeMutation = { __typename?: 'Mutation', generateBalanceCharge: { __typename?: 'FinancialCharge', id: string } };

export type BatchUpdateChargesMutationVariables = Exact<{
  chargeIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  fields: UpdateChargeInput;
}>;


export type BatchUpdateChargesMutation = { __typename?: 'Mutation', batchUpdateCharges:
    | { __typename: 'BatchUpdateChargesSuccessfulResult', charges: Array<
        | { __typename?: 'BankDepositCharge', id: string }
        | { __typename?: 'BusinessTripCharge', id: string }
        | { __typename?: 'CommonCharge', id: string }
        | { __typename?: 'ConversionCharge', id: string }
        | { __typename?: 'CreditcardBankCharge', id: string }
        | { __typename?: 'DividendCharge', id: string }
        | { __typename?: 'FinancialCharge', id: string }
        | { __typename?: 'ForeignSecuritiesCharge', id: string }
        | { __typename?: 'InternalTransferCharge', id: string }
        | { __typename?: 'MonthlyVatCharge', id: string }
        | { __typename?: 'SalaryCharge', id: string }
      > }
    | { __typename: 'CommonError', message: string }
   };

export type CategorizeBusinessTripExpenseMutationVariables = Exact<{
  fields: CategorizeBusinessTripExpenseInput;
}>;


export type CategorizeBusinessTripExpenseMutation = { __typename?: 'Mutation', categorizeBusinessTripExpense: string };

export type CategorizeIntoExistingBusinessTripExpenseMutationVariables = Exact<{
  fields: CategorizeIntoExistingBusinessTripExpenseInput;
}>;


export type CategorizeIntoExistingBusinessTripExpenseMutation = { __typename?: 'Mutation', categorizeIntoExistingBusinessTripExpense: string };

export type CloseDocumentMutationVariables = Exact<{
  documentId: Scalars['UUID']['input'];
}>;


export type CloseDocumentMutation = { __typename?: 'Mutation', closeDocument: boolean };

export type FlagForeignFeeTransactionsMutationVariables = Exact<{ [key: string]: never; }>;


export type FlagForeignFeeTransactionsMutation = { __typename?: 'Mutation', flagForeignFeeTransactions: { __typename?: 'FlagForeignFeeTransactionsResult', success: boolean, errors?: Array<string> | null } };

export type MergeChargesByTransactionReferenceMutationVariables = Exact<{ [key: string]: never; }>;


export type MergeChargesByTransactionReferenceMutation = { __typename?: 'Mutation', mergeChargesByTransactionReference: { __typename?: 'MergeChargesByTransactionReferenceResult', success: boolean, errors?: Array<string> | null } };

export type CalculateCreditcardTransactionsDebitDateMutationVariables = Exact<{ [key: string]: never; }>;


export type CalculateCreditcardTransactionsDebitDateMutation = { __typename?: 'Mutation', calculateCreditcardTransactionsDebitDate: boolean };

export type CreateContractMutationVariables = Exact<{
  input: CreateContractInput;
}>;


export type CreateContractMutation = { __typename?: 'Mutation', createContract: { __typename?: 'Contract', id: string } };

export type CreateDepositFromChargeMutationVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateDepositFromChargeMutation = { __typename?: 'Mutation', createDepositFromCharge: { __typename?: 'BankDeposit', id: string, name: string, currency?: Currency | null, isOpen: boolean } };

export type CreateDepositMutationVariables = Exact<{
  name: Scalars['String']['input'];
  currency: Currency;
  openDate: Scalars['TimelessDate']['input'];
  accountId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type CreateDepositMutation = { __typename?: 'Mutation', createDeposit: { __typename?: 'BankDeposit', id: string, currency?: Currency | null, isOpen: boolean } };

export type CreateFinancialAccountMutationVariables = Exact<{
  input: CreateFinancialAccountInput;
}>;


export type CreateFinancialAccountMutation = { __typename?: 'Mutation', createFinancialAccount:
    | { __typename?: 'BankDepositFinancialAccount', id: string }
    | { __typename?: 'BankFinancialAccount', id: string }
    | { __typename?: 'CardFinancialAccount', id: string }
    | { __typename?: 'CryptoWalletFinancialAccount', id: string }
    | { __typename?: 'ForeignSecuritiesFinancialAccount', id: string }
   };

export type CreditShareholdersBusinessTripTravelAndSubsistenceMutationVariables = Exact<{
  businessTripId: Scalars['UUID']['input'];
}>;


export type CreditShareholdersBusinessTripTravelAndSubsistenceMutation = { __typename?: 'Mutation', creditShareholdersBusinessTripTravelAndSubsistence: Array<string> };

export type DeleteBusinessTripAttendeeMutationVariables = Exact<{
  fields: DeleteBusinessTripAttendeeInput;
}>;


export type DeleteBusinessTripAttendeeMutation = { __typename?: 'Mutation', deleteBusinessTripAttendee: boolean };

export type DeleteBusinessTripExpenseMutationVariables = Exact<{
  businessTripExpenseId: Scalars['UUID']['input'];
}>;


export type DeleteBusinessTripExpenseMutation = { __typename?: 'Mutation', deleteBusinessTripExpense: boolean };

export type DeleteChargeMutationVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
}>;


export type DeleteChargeMutation = { __typename?: 'Mutation', deleteCharge: boolean };

export type DeleteContractMutationVariables = Exact<{
  contractId: Scalars['UUID']['input'];
}>;


export type DeleteContractMutation = { __typename?: 'Mutation', deleteContract: boolean };

export type DeleteDepreciationRecordMutationVariables = Exact<{
  depreciationRecordId: Scalars['UUID']['input'];
}>;


export type DeleteDepreciationRecordMutation = { __typename?: 'Mutation', deleteDepreciationRecord: boolean };

export type DeleteDocumentMutationVariables = Exact<{
  documentId: Scalars['UUID']['input'];
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument: boolean };

export type DeleteDynamicReportTemplateMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DeleteDynamicReportTemplateMutation = { __typename?: 'Mutation', deleteDynamicReportTemplate: string };

export type DeleteMiscExpenseMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteMiscExpenseMutation = { __typename?: 'Mutation', deleteMiscExpense: boolean };

export type DeleteProviderCredentialsMutationVariables = Exact<{
  provider: ProviderKey;
}>;


export type DeleteProviderCredentialsMutation = { __typename?: 'Mutation', deleteProviderCredentials:
    | { __typename?: 'CommonError', message: string }
    | { __typename?: 'ProviderCredentialDeleteResult', id: string, provider: ProviderKey, success: boolean }
   };

export type DeleteTagMutationVariables = Exact<{
  tagId: Scalars['UUID']['input'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag: boolean };

export type GenerateRevaluationChargeMutationVariables = Exact<{
  ownerId: Scalars['UUID']['input'];
  date: Scalars['TimelessDate']['input'];
}>;


export type GenerateRevaluationChargeMutation = { __typename?: 'Mutation', generateRevaluationCharge: { __typename?: 'FinancialCharge', id: string } };

export type GenerateBankDepositsRevaluationChargeMutationVariables = Exact<{
  ownerId: Scalars['UUID']['input'];
  date: Scalars['TimelessDate']['input'];
}>;


export type GenerateBankDepositsRevaluationChargeMutation = { __typename?: 'Mutation', generateBankDepositsRevaluationCharge: { __typename?: 'FinancialCharge', id: string } };

export type GenerateTaxExpensesChargeMutationVariables = Exact<{
  ownerId: Scalars['UUID']['input'];
  date: Scalars['TimelessDate']['input'];
}>;


export type GenerateTaxExpensesChargeMutation = { __typename?: 'Mutation', generateTaxExpensesCharge: { __typename?: 'FinancialCharge', id: string } };

export type GenerateDepreciationChargeMutationVariables = Exact<{
  ownerId: Scalars['UUID']['input'];
  date: Scalars['TimelessDate']['input'];
}>;


export type GenerateDepreciationChargeMutation = { __typename?: 'Mutation', generateDepreciationCharge: { __typename?: 'FinancialCharge', id: string } };

export type GenerateRecoveryReserveChargeMutationVariables = Exact<{
  ownerId: Scalars['UUID']['input'];
  date: Scalars['TimelessDate']['input'];
}>;


export type GenerateRecoveryReserveChargeMutation = { __typename?: 'Mutation', generateRecoveryReserveCharge: { __typename?: 'FinancialCharge', id: string } };

export type GenerateVacationReserveChargeMutationVariables = Exact<{
  ownerId: Scalars['UUID']['input'];
  date: Scalars['TimelessDate']['input'];
}>;


export type GenerateVacationReserveChargeMutation = { __typename?: 'Mutation', generateVacationReserveCharge: { __typename?: 'FinancialCharge', id: string } };

export type AllAdminBusinessesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAdminBusinessesQuery = { __typename?: 'Query', allAdminBusinesses: Array<{ __typename?: 'AdminBusiness', id: string, name: string, governmentId: string }> };

export type AllClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllClientsQuery = { __typename?: 'Query', allClients: Array<{ __typename?: 'Client', id: string, originalBusiness: { __typename?: 'LtdFinancialEntity', id: string, name: string } }> };

export type AllBusinessesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllBusinessesQuery = { __typename?: 'Query', allBusinesses?: { __typename?: 'PaginatedBusinesses', nodes: Array<
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
    > } | null };

export type AllCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCountriesQuery = { __typename?: 'Query', allCountries: Array<{ __typename?: 'Country', id: string, name: string, code: any }> };

export type AllFinancialAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllFinancialAccountsQuery = { __typename?: 'Query', allFinancialAccounts: Array<
    | { __typename?: 'BankDepositFinancialAccount', id: string, name: string }
    | { __typename?: 'BankFinancialAccount', id: string, name: string }
    | { __typename?: 'CardFinancialAccount', id: string, name: string }
    | { __typename?: 'CryptoWalletFinancialAccount', id: string, name: string }
    | { __typename?: 'ForeignSecuritiesFinancialAccount', id: string, name: string }
  > };

export type AllFinancialEntitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllFinancialEntitiesQuery = { __typename?: 'Query', allFinancialEntities?: { __typename?: 'PaginatedFinancialEntities', nodes: Array<
      | { __typename?: 'LtdFinancialEntity', id: string, name: string }
      | { __typename?: 'PersonalFinancialEntity', id: string, name: string }
      | { __typename?: 'TaxCategory', id: string, name: string }
    > } | null };

export type AllSortCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSortCodesQuery = { __typename?: 'Query', allSortCodes: Array<{ __typename?: 'SortCode', id: string, key: number, name?: string | null, defaultIrsCode?: number | null }> };

export type AllTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTagsQuery = { __typename?: 'Query', allTags: Array<{ __typename?: 'Tag', id: string, name: string, namePath?: Array<string> | null }> };

export type AllTaxCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTaxCategoriesQuery = { __typename?: 'Query', taxCategories: Array<{ __typename?: 'TaxCategory', id: string, name: string }> };

export type InsertBusinessTripAttendeeMutationVariables = Exact<{
  fields: InsertBusinessTripAttendeeInput;
}>;


export type InsertBusinessTripAttendeeMutation = { __typename?: 'Mutation', insertBusinessTripAttendee: string };

export type InsertBusinessTripMutationVariables = Exact<{
  fields: InsertBusinessTripInput;
}>;


export type InsertBusinessTripMutation = { __typename?: 'Mutation', insertBusinessTrip: string };

export type InsertBusinessMutationVariables = Exact<{
  fields: InsertNewBusinessInput;
}>;


export type InsertBusinessMutation = { __typename?: 'Mutation', insertNewBusiness:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'LtdFinancialEntity', id: string }
   };

export type InsertClientMutationVariables = Exact<{
  fields: ClientInsertInput;
}>;


export type InsertClientMutation = { __typename?: 'Mutation', insertClient:
    | { __typename: 'Client', id: string }
    | { __typename: 'CommonError', message: string }
   };

export type InsertDocumentMutationVariables = Exact<{
  record: InsertDocumentInput;
}>;


export type InsertDocumentMutation = { __typename?: 'Mutation', insertDocument:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'InsertDocumentSuccessfulResult', document?:
        | { __typename?: 'CreditInvoice', id: string }
        | { __typename?: 'Invoice', id: string }
        | { __typename?: 'InvoiceReceipt', id: string }
        | { __typename?: 'OtherDocument', id: string }
        | { __typename?: 'Proforma', id: string }
        | { __typename?: 'Receipt', id: string }
        | { __typename?: 'Unprocessed', id: string }
       | null }
   };

export type InsertDynamicReportTemplateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  template: Scalars['String']['input'];
}>;


export type InsertDynamicReportTemplateMutation = { __typename?: 'Mutation', insertDynamicReportTemplate: { __typename?: 'DynamicReportInfo', id: string, name: string } };

export type InsertMiscExpenseMutationVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
  fields: InsertMiscExpenseInput;
}>;


export type InsertMiscExpenseMutation = { __typename?: 'Mutation', insertMiscExpense: { __typename?: 'MiscExpense', id: string } };

export type InsertMiscExpensesMutationVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
  expenses: Array<InsertMiscExpenseInput> | InsertMiscExpenseInput;
}>;


export type InsertMiscExpensesMutation = { __typename?: 'Mutation', insertMiscExpenses:
    | { __typename?: 'BankDepositCharge', id: string }
    | { __typename?: 'BusinessTripCharge', id: string }
    | { __typename?: 'CommonCharge', id: string }
    | { __typename?: 'ConversionCharge', id: string }
    | { __typename?: 'CreditcardBankCharge', id: string }
    | { __typename?: 'DividendCharge', id: string }
    | { __typename?: 'FinancialCharge', id: string }
    | { __typename?: 'ForeignSecuritiesCharge', id: string }
    | { __typename?: 'InternalTransferCharge', id: string }
    | { __typename?: 'MonthlyVatCharge', id: string }
    | { __typename?: 'SalaryCharge', id: string }
   };

export type InsertSalaryRecordMutationVariables = Exact<{
  salaryRecords: Array<SalaryRecordInput> | SalaryRecordInput;
}>;


export type InsertSalaryRecordMutation = { __typename?: 'Mutation', insertSalaryRecords:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'InsertSalaryRecordsSuccessfulResult', salaryRecords: Array<{ __typename?: 'Salary', month: string, employee?: { __typename?: 'LtdFinancialEntity', id: string } | null }> }
   };

export type InsertTaxCategoryMutationVariables = Exact<{
  fields: InsertTaxCategoryInput;
}>;


export type InsertTaxCategoryMutation = { __typename?: 'Mutation', insertTaxCategory: { __typename?: 'TaxCategory', id: string, name: string } };

export type IssueGreenInvoiceDocumentMutationVariables = Exact<{
  input: DocumentIssueInput;
  emailContent?: InputMaybe<Scalars['String']['input']>;
  attachment?: InputMaybe<Scalars['Boolean']['input']>;
  chargeId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type IssueGreenInvoiceDocumentMutation = { __typename?: 'Mutation', issueGreenInvoiceDocument:
    | { __typename?: 'BankDepositCharge', id: string }
    | { __typename?: 'BusinessTripCharge', id: string }
    | { __typename?: 'CommonCharge', id: string }
    | { __typename?: 'ConversionCharge', id: string }
    | { __typename?: 'CreditcardBankCharge', id: string }
    | { __typename?: 'DividendCharge', id: string }
    | { __typename?: 'FinancialCharge', id: string }
    | { __typename?: 'ForeignSecuritiesCharge', id: string }
    | { __typename?: 'InternalTransferCharge', id: string }
    | { __typename?: 'MonthlyVatCharge', id: string }
    | { __typename?: 'SalaryCharge', id: string }
   };

export type IssueMonthlyDocumentsMutationVariables = Exact<{
  generateDocumentsInfo: Array<DocumentIssueInput> | DocumentIssueInput;
}>;


export type IssueMonthlyDocumentsMutation = { __typename?: 'Mutation', issueGreenInvoiceDocuments: { __typename?: 'GenerateDocumentsResult', success: boolean, errors?: Array<string> | null } };

export type LedgerLockMutationVariables = Exact<{
  date: Scalars['TimelessDate']['input'];
}>;


export type LedgerLockMutation = { __typename?: 'Mutation', lockLedgerRecords: boolean };

export type LockDynamicReportTemplateMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type LockDynamicReportTemplateMutation = { __typename?: 'Mutation', lockDynamicReportTemplate: { __typename?: 'DynamicReportInfo', id: string, name: string, isLocked: boolean, updated: any } };

export type MergeBusinessesMutationVariables = Exact<{
  targetBusinessId: Scalars['UUID']['input'];
  businessIdsToMerge: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type MergeBusinessesMutation = { __typename?: 'Mutation', mergeBusinesses:
    | { __typename: 'LtdFinancialEntity', id: string }
    | { __typename: 'PersonalFinancialEntity', id: string }
   };

export type MergeChargesMutationVariables = Exact<{
  baseChargeID: Scalars['UUID']['input'];
  chargeIdsToMerge: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  fields?: InputMaybe<UpdateChargeInput>;
}>;


export type MergeChargesMutation = { __typename?: 'Mutation', mergeCharges:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'MergeChargeSuccessfulResult', charge:
        | { __typename?: 'BankDepositCharge', id: string }
        | { __typename?: 'BusinessTripCharge', id: string }
        | { __typename?: 'CommonCharge', id: string }
        | { __typename?: 'ConversionCharge', id: string }
        | { __typename?: 'CreditcardBankCharge', id: string }
        | { __typename?: 'DividendCharge', id: string }
        | { __typename?: 'FinancialCharge', id: string }
        | { __typename?: 'ForeignSecuritiesCharge', id: string }
        | { __typename?: 'InternalTransferCharge', id: string }
        | { __typename?: 'MonthlyVatCharge', id: string }
        | { __typename?: 'SalaryCharge', id: string }
       }
   };

export type PreviewDocumentMutationVariables = Exact<{
  input: DocumentIssueInput;
}>;


export type PreviewDocumentMutation = { __typename?: 'Mutation', previewDocument: string };

export type ProviderCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderCredentialsQuery = { __typename?: 'Query', providerCredentials: Array<{ __typename?: 'ProviderCredentialStatus', id: string, provider: ProviderKey, configuredAt: any }> };

export type RegenerateLedgerMutationVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
}>;


export type RegenerateLedgerMutation = { __typename?: 'Mutation', regenerateLedgerRecords:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'Ledger', records: Array<{ __typename?: 'LedgerRecord', id: string }> }
   };

export type RelevantDepositsForChargeQueryVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
}>;


export type RelevantDepositsForChargeQuery = { __typename?: 'Query', relevantDepositsForCharge: { __typename?: 'RelevantDepositsResult', id: string, error?: string | null, deposits: Array<{ __typename?: 'BankDeposit', id: string, name: string, currency?: Currency | null, isOpen: boolean }> } };

export type SetAnnualAuditStepStatusMutationVariables = Exact<{
  input: SetAnnualAuditStepStatusInput;
}>;


export type SetAnnualAuditStepStatusMutation = { __typename?: 'Mutation', setAnnualAuditStepStatus: { __typename?: 'AnnualAuditStepStatusInfo', id: string, ownerId: string, year: number, stepId: string, status: AnnualAuditStepStatus, notes?: string | null, evidence?: string | null, updatedAt: any, completedAt?: any | null } };

export type SetAnnualAuditStep03StatusMutationVariables = Exact<{
  input: SetAnnualAuditStep03StatusInput;
}>;


export type SetAnnualAuditStep03StatusMutation = { __typename?: 'Mutation', setAnnualAuditStep03Status: { __typename?: 'AnnualAuditStepStatusInfo', id: string, ownerId: string, year: number, stepId: string, status: AnnualAuditStepStatus, notes?: string | null, updatedAt: any, completedAt?: any | null } };

export type SetAnnualAuditStep09StatusMutationVariables = Exact<{
  input: SetAnnualAuditStep09StatusInput;
}>;


export type SetAnnualAuditStep09StatusMutation = { __typename?: 'Mutation', setAnnualAuditStep09Status: { __typename?: 'AnnualAuditStepStatusInfo', id: string, ownerId: string, year: number, stepId: string, status: AnnualAuditStepStatus, notes?: string | null, evidence?: string | null, updatedAt: any, completedAt?: any | null } };

export type SetDeelCredentialsMutationVariables = Exact<{
  apiToken: Scalars['String']['input'];
}>;


export type SetDeelCredentialsMutation = { __typename?: 'Mutation', setDeelCredentials:
    | { __typename?: 'CommonError', message: string }
    | { __typename?: 'ProviderCredentialResult', id: string, provider: ProviderKey, configuredAt: any }
   };

export type SetGreenInvoiceCredentialsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  secret: Scalars['String']['input'];
}>;


export type SetGreenInvoiceCredentialsMutation = { __typename?: 'Mutation', setGreenInvoiceCredentials:
    | { __typename?: 'CommonError', message: string }
    | { __typename?: 'ProviderCredentialResult', id: string, provider: ProviderKey, configuredAt: any }
   };

export type SyncGreenInvoiceDocumentsMutationVariables = Exact<{
  ownerId: Scalars['UUID']['input'];
}>;


export type SyncGreenInvoiceDocumentsMutation = { __typename?: 'Mutation', syncGreenInvoiceDocuments: Array<
    | (
      { __typename?: 'CreditInvoice', id: string }
      & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_CreditInvoice_Fragment': NewFetchedDocumentFields_CreditInvoice_Fragment } }
    )
    | (
      { __typename?: 'Invoice', id: string }
      & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Invoice_Fragment': NewFetchedDocumentFields_Invoice_Fragment } }
    )
    | (
      { __typename?: 'InvoiceReceipt', id: string }
      & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_InvoiceReceipt_Fragment': NewFetchedDocumentFields_InvoiceReceipt_Fragment } }
    )
    | (
      { __typename?: 'OtherDocument', id: string }
      & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_OtherDocument_Fragment': NewFetchedDocumentFields_OtherDocument_Fragment } }
    )
    | (
      { __typename?: 'Proforma', id: string }
      & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Proforma_Fragment': NewFetchedDocumentFields_Proforma_Fragment } }
    )
    | (
      { __typename?: 'Receipt', id: string }
      & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Receipt_Fragment': NewFetchedDocumentFields_Receipt_Fragment } }
    )
    | (
      { __typename?: 'Unprocessed', id: string }
      & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Unprocessed_Fragment': NewFetchedDocumentFields_Unprocessed_Fragment } }
    )
  > };

export type UnlockDynamicReportTemplateMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type UnlockDynamicReportTemplateMutation = { __typename?: 'Mutation', unlockDynamicReportTemplate: { __typename?: 'DynamicReportInfo', id: string, name: string, isLocked: boolean, updated: any } };

export type UpdateAdminBusinessMutationVariables = Exact<{
  adminBusinessId: Scalars['UUID']['input'];
  fields: UpdateAdminBusinessInput;
}>;


export type UpdateAdminBusinessMutation = { __typename?: 'Mutation', updateAdminBusiness: { __typename?: 'AdminBusiness', id: string } };

export type UpdateBusinessTripAccommodationsExpenseMutationVariables = Exact<{
  fields: UpdateBusinessTripAccommodationsExpenseInput;
}>;


export type UpdateBusinessTripAccommodationsExpenseMutation = { __typename?: 'Mutation', updateBusinessTripAccommodationsExpense: string };

export type UpdateBusinessTripAccountantApprovalMutationVariables = Exact<{
  businessTripId: Scalars['UUID']['input'];
  status: AccountantStatus;
}>;


export type UpdateBusinessTripAccountantApprovalMutation = { __typename?: 'Mutation', updateBusinessTripAccountantApproval: AccountantStatus };

export type UpdateBusinessTripAttendeeMutationVariables = Exact<{
  fields: BusinessTripAttendeeUpdateInput;
}>;


export type UpdateBusinessTripAttendeeMutation = { __typename?: 'Mutation', updateBusinessTripAttendee: string };

export type UpdateBusinessTripCarRentalExpenseMutationVariables = Exact<{
  fields: UpdateBusinessTripCarRentalExpenseInput;
}>;


export type UpdateBusinessTripCarRentalExpenseMutation = { __typename?: 'Mutation', updateBusinessTripCarRentalExpense: string };

export type UpdateBusinessTripFlightsExpenseMutationVariables = Exact<{
  fields: UpdateBusinessTripFlightsExpenseInput;
}>;


export type UpdateBusinessTripFlightsExpenseMutation = { __typename?: 'Mutation', updateBusinessTripFlightsExpense: string };

export type UpdateBusinessTripOtherExpenseMutationVariables = Exact<{
  fields: UpdateBusinessTripOtherExpenseInput;
}>;


export type UpdateBusinessTripOtherExpenseMutation = { __typename?: 'Mutation', updateBusinessTripOtherExpense: string };

export type UpdateBusinessTripTravelAndSubsistenceExpenseMutationVariables = Exact<{
  fields: UpdateBusinessTripTravelAndSubsistenceExpenseInput;
}>;


export type UpdateBusinessTripTravelAndSubsistenceExpenseMutation = { __typename?: 'Mutation', updateBusinessTripTravelAndSubsistenceExpense: string };

export type UpdateBusinessMutationVariables = Exact<{
  businessId: Scalars['UUID']['input'];
  ownerId: Scalars['UUID']['input'];
  fields: UpdateBusinessInput;
}>;


export type UpdateBusinessMutation = { __typename?: 'Mutation', updateBusiness:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'LtdFinancialEntity', id: string, name: string }
   };

export type UpdateChargeAccountantApprovalMutationVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
  status: AccountantStatus;
}>;


export type UpdateChargeAccountantApprovalMutation = { __typename?: 'Mutation', updateChargeAccountantApproval: AccountantStatus };

export type UpdateChargeMutationVariables = Exact<{
  chargeId: Scalars['UUID']['input'];
  fields: UpdateChargeInput;
}>;


export type UpdateChargeMutation = { __typename?: 'Mutation', updateCharge:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'UpdateChargeSuccessfulResult', charge:
        | { __typename?: 'BankDepositCharge', id: string }
        | { __typename?: 'BusinessTripCharge', id: string }
        | { __typename?: 'CommonCharge', id: string }
        | { __typename?: 'ConversionCharge', id: string }
        | { __typename?: 'CreditcardBankCharge', id: string }
        | { __typename?: 'DividendCharge', id: string }
        | { __typename?: 'FinancialCharge', id: string }
        | { __typename?: 'ForeignSecuritiesCharge', id: string }
        | { __typename?: 'InternalTransferCharge', id: string }
        | { __typename?: 'MonthlyVatCharge', id: string }
        | { __typename?: 'SalaryCharge', id: string }
       }
   };

export type UpdateClientMutationVariables = Exact<{
  businessId: Scalars['UUID']['input'];
  fields: ClientUpdateInput;
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateClient:
    | { __typename: 'Client', id: string }
    | { __typename: 'CommonError', message: string }
   };

export type UpdateContractMutationVariables = Exact<{
  contractId: Scalars['UUID']['input'];
  input: UpdateContractInput;
}>;


export type UpdateContractMutation = { __typename?: 'Mutation', updateContract: { __typename?: 'Contract', id: string } };

export type UpdateDepositMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  openDate?: InputMaybe<Scalars['TimelessDate']['input']>;
  closeDate?: InputMaybe<Scalars['TimelessDate']['input']>;
}>;


export type UpdateDepositMutation = { __typename?: 'Mutation', updateDeposit: { __typename?: 'BankDeposit', id: string, name: string, openDate?: any | null, closeDate?: any | null, isOpen: boolean } };

export type UpdateDepreciationRecordMutationVariables = Exact<{
  fields: UpdateDepreciationRecordInput;
}>;


export type UpdateDepreciationRecordMutation = { __typename?: 'Mutation', updateDepreciationRecord:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'DepreciationRecord', id: string }
   };

export type UpdateDocumentMutationVariables = Exact<{
  documentId: Scalars['UUID']['input'];
  fields: UpdateDocumentFieldsInput;
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'UpdateDocumentSuccessfulResult', document?:
        | { __typename?: 'CreditInvoice', id: string }
        | { __typename?: 'Invoice', id: string }
        | { __typename?: 'InvoiceReceipt', id: string }
        | { __typename?: 'OtherDocument', id: string }
        | { __typename?: 'Proforma', id: string }
        | { __typename?: 'Receipt', id: string }
        | { __typename?: 'Unprocessed', id: string }
       | null }
   };

export type UpdateDynamicReportTemplateNameMutationVariables = Exact<{
  name: Scalars['String']['input'];
  newName: Scalars['String']['input'];
}>;


export type UpdateDynamicReportTemplateNameMutation = { __typename?: 'Mutation', updateDynamicReportTemplateName: { __typename?: 'DynamicReportInfo', id: string, name: string } };

export type UpdateDynamicReportTemplateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  template: Scalars['String']['input'];
}>;


export type UpdateDynamicReportTemplateMutation = { __typename?: 'Mutation', updateDynamicReportTemplate: { __typename?: 'DynamicReportInfo', id: string, name: string } };

export type UpdateFinancialAccountMutationVariables = Exact<{
  financialAccountId: Scalars['UUID']['input'];
  fields: UpdateFinancialAccountInput;
}>;


export type UpdateFinancialAccountMutation = { __typename?: 'Mutation', updateFinancialAccount:
    | { __typename?: 'BankDepositFinancialAccount', id: string }
    | { __typename?: 'BankFinancialAccount', id: string }
    | { __typename?: 'CardFinancialAccount', id: string }
    | { __typename?: 'CryptoWalletFinancialAccount', id: string }
    | { __typename?: 'ForeignSecuritiesFinancialAccount', id: string }
   };

export type UpdateMiscExpenseMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  fields: UpdateMiscExpenseInput;
}>;


export type UpdateMiscExpenseMutation = { __typename?: 'Mutation', updateMiscExpense: { __typename?: 'MiscExpense', id: string } };

export type UpdateOrInsertSalaryRecordsMutationVariables = Exact<{
  salaryRecords: Array<SalaryRecordInput> | SalaryRecordInput;
}>;


export type UpdateOrInsertSalaryRecordsMutation = { __typename?: 'Mutation', insertOrUpdateSalaryRecords:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'InsertSalaryRecordsSuccessfulResult', salaryRecords: Array<{ __typename?: 'Salary', month: string, employee?: { __typename?: 'LtdFinancialEntity', id: string } | null }> }
   };

export type UpdateSalaryRecordMutationVariables = Exact<{
  salaryRecord: SalaryRecordEditInput;
}>;


export type UpdateSalaryRecordMutation = { __typename?: 'Mutation', updateSalaryRecord:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'UpdateSalaryRecordSuccessfulResult', salaryRecord: { __typename?: 'Salary', month: string, employee?: { __typename?: 'LtdFinancialEntity', id: string } | null } }
   };

export type UpdateSortCodeMutationVariables = Exact<{
  key: Scalars['Int']['input'];
  fields: UpdateSortCodeFieldsInput;
}>;


export type UpdateSortCodeMutation = { __typename?: 'Mutation', updateSortCode: boolean };

export type UpdateTagMutationVariables = Exact<{
  tagId: Scalars['UUID']['input'];
  fields: UpdateTagFieldsInput;
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag: boolean };

export type UpdateTaxCategoryMutationVariables = Exact<{
  taxCategoryId: Scalars['UUID']['input'];
  fields: UpdateTaxCategoryInput;
}>;


export type UpdateTaxCategoryMutation = { __typename?: 'Mutation', updateTaxCategory:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'TaxCategory', id: string, name: string }
   };

export type UpdateTransactionMutationVariables = Exact<{
  transactionId: Scalars['UUID']['input'];
  fields: UpdateTransactionInput;
}>;


export type UpdateTransactionMutation = { __typename?: 'Mutation', updateTransaction:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'CommonTransaction', id: string }
    | { __typename: 'ConversionTransaction', id: string }
   };

export type UpdateTransactionsMutationVariables = Exact<{
  transactionIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  fields: UpdateTransactionInput;
}>;


export type UpdateTransactionsMutation = { __typename?: 'Mutation', updateTransactions:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'UpdatedTransactionsSuccessfulResult', transactions: Array<
        | { __typename?: 'CommonTransaction', id: string }
        | { __typename?: 'ConversionTransaction', id: string }
      > }
   };

export type UploadDocumentMutationVariables = Exact<{
  file: Scalars['FileScalar']['input'];
  chargeId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type UploadDocumentMutation = { __typename?: 'Mutation', uploadDocument:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'UploadDocumentSuccessfulResult', document?:
        | { __typename?: 'CreditInvoice', id: string, charge?:
            | { __typename?: 'BankDepositCharge', id: string }
            | { __typename?: 'BusinessTripCharge', id: string }
            | { __typename?: 'CommonCharge', id: string }
            | { __typename?: 'ConversionCharge', id: string }
            | { __typename?: 'CreditcardBankCharge', id: string }
            | { __typename?: 'DividendCharge', id: string }
            | { __typename?: 'FinancialCharge', id: string }
            | { __typename?: 'ForeignSecuritiesCharge', id: string }
            | { __typename?: 'InternalTransferCharge', id: string }
            | { __typename?: 'MonthlyVatCharge', id: string }
            | { __typename?: 'SalaryCharge', id: string }
           | null }
        | { __typename?: 'Invoice', id: string, charge?:
            | { __typename?: 'BankDepositCharge', id: string }
            | { __typename?: 'BusinessTripCharge', id: string }
            | { __typename?: 'CommonCharge', id: string }
            | { __typename?: 'ConversionCharge', id: string }
            | { __typename?: 'CreditcardBankCharge', id: string }
            | { __typename?: 'DividendCharge', id: string }
            | { __typename?: 'FinancialCharge', id: string }
            | { __typename?: 'ForeignSecuritiesCharge', id: string }
            | { __typename?: 'InternalTransferCharge', id: string }
            | { __typename?: 'MonthlyVatCharge', id: string }
            | { __typename?: 'SalaryCharge', id: string }
           | null }
        | { __typename?: 'InvoiceReceipt', id: string, charge?:
            | { __typename?: 'BankDepositCharge', id: string }
            | { __typename?: 'BusinessTripCharge', id: string }
            | { __typename?: 'CommonCharge', id: string }
            | { __typename?: 'ConversionCharge', id: string }
            | { __typename?: 'CreditcardBankCharge', id: string }
            | { __typename?: 'DividendCharge', id: string }
            | { __typename?: 'FinancialCharge', id: string }
            | { __typename?: 'ForeignSecuritiesCharge', id: string }
            | { __typename?: 'InternalTransferCharge', id: string }
            | { __typename?: 'MonthlyVatCharge', id: string }
            | { __typename?: 'SalaryCharge', id: string }
           | null }
        | { __typename?: 'OtherDocument', id: string, charge?:
            | { __typename?: 'BankDepositCharge', id: string }
            | { __typename?: 'BusinessTripCharge', id: string }
            | { __typename?: 'CommonCharge', id: string }
            | { __typename?: 'ConversionCharge', id: string }
            | { __typename?: 'CreditcardBankCharge', id: string }
            | { __typename?: 'DividendCharge', id: string }
            | { __typename?: 'FinancialCharge', id: string }
            | { __typename?: 'ForeignSecuritiesCharge', id: string }
            | { __typename?: 'InternalTransferCharge', id: string }
            | { __typename?: 'MonthlyVatCharge', id: string }
            | { __typename?: 'SalaryCharge', id: string }
           | null }
        | { __typename?: 'Proforma', id: string, charge?:
            | { __typename?: 'BankDepositCharge', id: string }
            | { __typename?: 'BusinessTripCharge', id: string }
            | { __typename?: 'CommonCharge', id: string }
            | { __typename?: 'ConversionCharge', id: string }
            | { __typename?: 'CreditcardBankCharge', id: string }
            | { __typename?: 'DividendCharge', id: string }
            | { __typename?: 'FinancialCharge', id: string }
            | { __typename?: 'ForeignSecuritiesCharge', id: string }
            | { __typename?: 'InternalTransferCharge', id: string }
            | { __typename?: 'MonthlyVatCharge', id: string }
            | { __typename?: 'SalaryCharge', id: string }
           | null }
        | { __typename?: 'Receipt', id: string, charge?:
            | { __typename?: 'BankDepositCharge', id: string }
            | { __typename?: 'BusinessTripCharge', id: string }
            | { __typename?: 'CommonCharge', id: string }
            | { __typename?: 'ConversionCharge', id: string }
            | { __typename?: 'CreditcardBankCharge', id: string }
            | { __typename?: 'DividendCharge', id: string }
            | { __typename?: 'FinancialCharge', id: string }
            | { __typename?: 'ForeignSecuritiesCharge', id: string }
            | { __typename?: 'InternalTransferCharge', id: string }
            | { __typename?: 'MonthlyVatCharge', id: string }
            | { __typename?: 'SalaryCharge', id: string }
           | null }
        | { __typename?: 'Unprocessed', id: string, charge?:
            | { __typename?: 'BankDepositCharge', id: string }
            | { __typename?: 'BusinessTripCharge', id: string }
            | { __typename?: 'CommonCharge', id: string }
            | { __typename?: 'ConversionCharge', id: string }
            | { __typename?: 'CreditcardBankCharge', id: string }
            | { __typename?: 'DividendCharge', id: string }
            | { __typename?: 'FinancialCharge', id: string }
            | { __typename?: 'ForeignSecuritiesCharge', id: string }
            | { __typename?: 'InternalTransferCharge', id: string }
            | { __typename?: 'MonthlyVatCharge', id: string }
            | { __typename?: 'SalaryCharge', id: string }
           | null }
       | null }
   };

export type UploadDocumentsFromGoogleDriveMutationVariables = Exact<{
  sharedFolderUrl: Scalars['String']['input'];
  chargeId?: InputMaybe<Scalars['UUID']['input']>;
  isSensitive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UploadDocumentsFromGoogleDriveMutation = { __typename?: 'Mutation', batchUploadDocumentsFromGoogleDrive: Array<
    | { __typename?: 'CommonError', message: string }
    | { __typename?: 'UploadDocumentSuccessfulResult', document?:
        | (
          { __typename?: 'CreditInvoice', id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_CreditInvoice_Fragment': NewFetchedDocumentFields_CreditInvoice_Fragment } }
        )
        | (
          { __typename?: 'Invoice', id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Invoice_Fragment': NewFetchedDocumentFields_Invoice_Fragment } }
        )
        | (
          { __typename?: 'InvoiceReceipt', id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_InvoiceReceipt_Fragment': NewFetchedDocumentFields_InvoiceReceipt_Fragment } }
        )
        | (
          { __typename?: 'OtherDocument', id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_OtherDocument_Fragment': NewFetchedDocumentFields_OtherDocument_Fragment } }
        )
        | (
          { __typename?: 'Proforma', id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Proforma_Fragment': NewFetchedDocumentFields_Proforma_Fragment } }
        )
        | (
          { __typename?: 'Receipt', id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Receipt_Fragment': NewFetchedDocumentFields_Receipt_Fragment } }
        )
        | (
          { __typename?: 'Unprocessed', id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Unprocessed_Fragment': NewFetchedDocumentFields_Unprocessed_Fragment } }
        )
       | null }
  > };

export type UploadMultipleDocumentsMutationVariables = Exact<{
  documents: Array<Scalars['FileScalar']['input']> | Scalars['FileScalar']['input'];
  chargeId?: InputMaybe<Scalars['UUID']['input']>;
  isSensitive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UploadMultipleDocumentsMutation = { __typename?: 'Mutation', batchUploadDocuments: Array<
    | { __typename?: 'CommonError', message: string }
    | { __typename?: 'UploadDocumentSuccessfulResult', document?:
        | (
          { __typename?: 'CreditInvoice', id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_CreditInvoice_Fragment': NewFetchedDocumentFields_CreditInvoice_Fragment } }
        )
        | (
          { __typename?: 'Invoice', id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Invoice_Fragment': NewFetchedDocumentFields_Invoice_Fragment } }
        )
        | (
          { __typename?: 'InvoiceReceipt', id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_InvoiceReceipt_Fragment': NewFetchedDocumentFields_InvoiceReceipt_Fragment } }
        )
        | (
          { __typename?: 'OtherDocument', id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_OtherDocument_Fragment': NewFetchedDocumentFields_OtherDocument_Fragment } }
        )
        | (
          { __typename?: 'Proforma', id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Proforma_Fragment': NewFetchedDocumentFields_Proforma_Fragment } }
        )
        | (
          { __typename?: 'Receipt', id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Receipt_Fragment': NewFetchedDocumentFields_Receipt_Fragment } }
        )
        | (
          { __typename?: 'Unprocessed', id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Unprocessed_Fragment': NewFetchedDocumentFields_Unprocessed_Fragment } }
        )
       | null }
  > };

export type UploadPayrollFileMutationVariables = Exact<{
  file: Scalars['FileScalar']['input'];
  chargeId: Scalars['UUID']['input'];
}>;


export type UploadPayrollFileMutation = { __typename?: 'Mutation', insertSalaryRecordsFromFile: boolean };

export type UserContextQueryVariables = Exact<{ [key: string]: never; }>;


export type UserContextQuery = { __typename?: 'Query', userContext?: { __typename?: 'UserContext', adminBusinessId: string, defaultLocalCurrency: Currency, defaultCryptoConversionFiatCurrency: Currency, ledgerLock?: any | null, financialAccountsBusinessesIds: Array<string>, locality: string } | null };

export type BusinessEmailConfigQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type BusinessEmailConfigQuery = { __typename?: 'Query', businessEmailConfig?: { __typename?: 'BusinessEmailConfig', businessId: string, internalEmailLinks?: Array<string> | null, emailBody?: boolean | null, attachments?: Array<EmailAttachmentType> | null } | null };

export type InsertEmailDocumentsMutationVariables = Exact<{
  documents: Array<Scalars['FileScalar']['input']> | Scalars['FileScalar']['input'];
  userDescription: Scalars['String']['input'];
  messageId?: InputMaybe<Scalars['String']['input']>;
  businessId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type InsertEmailDocumentsMutation = { __typename?: 'Mutation', insertEmailDocuments: boolean };

export type UploadPoalimIlsTransactionsMutationVariables = Exact<{
  transactions: Array<PoalimIlsTransactionInput> | PoalimIlsTransactionInput;
}>;


export type UploadPoalimIlsTransactionsMutation = { __typename?: 'Mutation', uploadPoalimIlsTransactions: { __typename?: 'ScraperUploadResult', inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ __typename?: 'InsertedTransactionSummary', id: string, date?: string | null, description?: string | null, amount?: string | null, account?: string | null }>, changedTransactions: Array<{ __typename?: 'ChangedTransaction', id: string, changedFields: Array<{ __typename?: 'ChangedField', field: string, oldValue?: string | null, newValue?: string | null }> }> } };

export type UploadPoalimForeignTransactionsMutationVariables = Exact<{
  transactions: Array<PoalimForeignTransactionInput> | PoalimForeignTransactionInput;
}>;


export type UploadPoalimForeignTransactionsMutation = { __typename?: 'Mutation', uploadPoalimForeignTransactions: { __typename?: 'ScraperUploadResult', inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ __typename?: 'InsertedTransactionSummary', id: string, date?: string | null, description?: string | null, amount?: string | null, account?: string | null }>, changedTransactions: Array<{ __typename?: 'ChangedTransaction', id: string, changedFields: Array<{ __typename?: 'ChangedField', field: string, oldValue?: string | null, newValue?: string | null }> }> } };

export type UploadPoalimSwiftTransactionsMutationVariables = Exact<{
  swifts: Array<PoalimSwiftTransactionInput> | PoalimSwiftTransactionInput;
}>;


export type UploadPoalimSwiftTransactionsMutation = { __typename?: 'Mutation', uploadPoalimSwiftTransactions: { __typename?: 'ScraperUploadResult', inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ __typename?: 'InsertedTransactionSummary', id: string, date?: string | null, description?: string | null, amount?: string | null, account?: string | null }>, changedTransactions: Array<{ __typename?: 'ChangedTransaction', id: string, changedFields: Array<{ __typename?: 'ChangedField', field: string, oldValue?: string | null, newValue?: string | null }> }> } };

export type UploadIsracardTransactionsMutationVariables = Exact<{
  transactions: Array<IsracardTransactionInput> | IsracardTransactionInput;
}>;


export type UploadIsracardTransactionsMutation = { __typename?: 'Mutation', uploadIsracardTransactions: { __typename?: 'ScraperUploadResult', inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ __typename?: 'InsertedTransactionSummary', id: string, date?: string | null, description?: string | null, amount?: string | null, account?: string | null }>, changedTransactions: Array<{ __typename?: 'ChangedTransaction', id: string, changedFields: Array<{ __typename?: 'ChangedField', field: string, oldValue?: string | null, newValue?: string | null }> }> } };

export type UploadAmexTransactionsMutationVariables = Exact<{
  transactions: Array<AmexTransactionInput> | AmexTransactionInput;
}>;


export type UploadAmexTransactionsMutation = { __typename?: 'Mutation', uploadAmexTransactions: { __typename?: 'ScraperUploadResult', inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ __typename?: 'InsertedTransactionSummary', id: string, date?: string | null, description?: string | null, amount?: string | null, account?: string | null }>, changedTransactions: Array<{ __typename?: 'ChangedTransaction', id: string, changedFields: Array<{ __typename?: 'ChangedField', field: string, oldValue?: string | null, newValue?: string | null }> }> } };

export type UploadCalTransactionsMutationVariables = Exact<{
  transactions: Array<CalTransactionInput> | CalTransactionInput;
}>;


export type UploadCalTransactionsMutation = { __typename?: 'Mutation', uploadCalTransactions: { __typename?: 'ScraperUploadResult', inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ __typename?: 'InsertedTransactionSummary', id: string, date?: string | null, description?: string | null, amount?: string | null, account?: string | null }>, changedTransactions: Array<{ __typename?: 'ChangedTransaction', id: string, changedFields: Array<{ __typename?: 'ChangedField', field: string, oldValue?: string | null, newValue?: string | null }> }> } };

export type UploadDiscountTransactionsMutationVariables = Exact<{
  transactions: Array<DiscountTransactionInput> | DiscountTransactionInput;
}>;


export type UploadDiscountTransactionsMutation = { __typename?: 'Mutation', uploadDiscountTransactions: { __typename?: 'ScraperUploadResult', inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ __typename?: 'InsertedTransactionSummary', id: string, date?: string | null, description?: string | null, amount?: string | null, account?: string | null }>, changedTransactions: Array<{ __typename?: 'ChangedTransaction', id: string, changedFields: Array<{ __typename?: 'ChangedField', field: string, oldValue?: string | null, newValue?: string | null }> }> } };

export type UploadMaxTransactionsMutationVariables = Exact<{
  transactions: Array<MaxTransactionInput> | MaxTransactionInput;
}>;


export type UploadMaxTransactionsMutation = { __typename?: 'Mutation', uploadMaxTransactions: { __typename?: 'ScraperUploadResult', inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ __typename?: 'InsertedTransactionSummary', id: string, date?: string | null, description?: string | null, amount?: string | null, account?: string | null }>, changedTransactions: Array<{ __typename?: 'ChangedTransaction', id: string, changedFields: Array<{ __typename?: 'ChangedField', field: string, oldValue?: string | null, newValue?: string | null }> }> } };

export type UploadCurrencyRatesMutationVariables = Exact<{
  rates: Array<CurrencyRateInput> | CurrencyRateInput;
}>;


export type UploadCurrencyRatesMutation = { __typename?: 'Mutation', uploadCurrencyRates: { __typename?: 'ScraperUploadResult', inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ __typename?: 'InsertedTransactionSummary', id: string, date?: string | null, description?: string | null, amount?: string | null, account?: string | null }>, changedTransactions: Array<{ __typename?: 'ChangedTransaction', id: string, changedFields: Array<{ __typename?: 'ChangedField', field: string, oldValue?: string | null, newValue?: string | null }> }> } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const DepositTransactionFieldsFragmentDoc = new TypedDocumentString(`
    fragment DepositTransactionFields on Transaction {
  id
  eventDate
  chargeId
  amount {
    raw
    formatted
    currency
  }
  debitExchangeRates {
    aud
    cad
    eur
    gbp
    jpy
    sek
    usd
    date
  }
  eventExchangeRates {
    aud
    cad
    eur
    gbp
    jpy
    sek
    usd
    date
  }
}
    `, {"fragmentName":"DepositTransactionFields"}) as unknown as TypedDocumentString<DepositTransactionFieldsFragment, unknown>;
export const BusinessTripsRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripsRowFields on BusinessTrip {
  id
  name
  accountantApproval
}
    `, {"fragmentName":"BusinessTripsRowFields"}) as unknown as TypedDocumentString<BusinessTripsRowFieldsFragment, unknown>;
export const ClientIntegrationsSectionFragmentDoc = new TypedDocumentString(`
    fragment ClientIntegrationsSection on LtdFinancialEntity {
  id
  clientInfo {
    id
    integrations {
      id
      greenInvoiceInfo {
        businessId
        greenInvoiceId
      }
      hiveId
      linearId
      slackChannelKey
      notionId
      workflowyUrl
    }
  }
}
    `, {"fragmentName":"ClientIntegrationsSection"}) as unknown as TypedDocumentString<ClientIntegrationsSectionFragment, unknown>;
export const BusinessHeaderFragmentDoc = new TypedDocumentString(`
    fragment BusinessHeader on Business {
  __typename
  id
  name
  createdAt
  isActive
  ... on LtdFinancialEntity {
    governmentId
    adminInfo {
      id
    }
    clientInfo {
      id
    }
  }
}
    `, {"fragmentName":"BusinessHeader"}) as unknown as TypedDocumentString<BusinessHeaderFragment, unknown>;
export const BusinessContactSectionFragmentDoc = new TypedDocumentString(`
    fragment BusinessContactSection on Business {
  __typename
  id
  ... on LtdFinancialEntity {
    name
    hebrewName
    country {
      id
      code
    }
    governmentId
    address
    city
    zipCode
    email
    phoneNumber
    website
    clientInfo {
      id
      emails
    }
  }
}
    `, {"fragmentName":"BusinessContactSection"}) as unknown as TypedDocumentString<BusinessContactSectionFragment, unknown>;
export const BusinessConfigurationSectionFragmentDoc = new TypedDocumentString(`
    fragment BusinessConfigurationSection on Business {
  __typename
  id
  pcn874RecordType
  irsCode
  isActive
  ... on LtdFinancialEntity {
    optionalVAT
    exemptDealer
    isReceiptEnough
    isDocumentsOptional
    sortCode {
      id
      key
      defaultIrsCode
    }
    taxCategory {
      id
    }
    suggestions {
      phrases
      emails
      tags {
        id
      }
      description
      emailListener {
        internalEmailLinks
        emailBody
        attachments
      }
    }
    clientInfo {
      id
    }
  }
}
    `, {"fragmentName":"BusinessConfigurationSection"}) as unknown as TypedDocumentString<BusinessConfigurationSectionFragment, unknown>;
export const BusinessAdminSectionFragmentDoc = new TypedDocumentString(`
    fragment BusinessAdminSection on Business {
  id
  ... on LtdFinancialEntity {
    adminInfo {
      id
      registrationDate
      withholdingTaxAnnualIds {
        id
        year
      }
      withholdingTaxCompanyId
      socialSecurityEmployerIds {
        id
        year
      }
      socialSecurityDeductionsId
      taxAdvancesAnnualIds {
        id
        year
      }
      taxAdvancesRates {
        date
        rate
      }
    }
  }
}
    `, {"fragmentName":"BusinessAdminSection"}) as unknown as TypedDocumentString<BusinessAdminSectionFragment, unknown>;
export const BusinessPageFragmentDoc = new TypedDocumentString(`
    fragment BusinessPage on Business {
  id
  ... on LtdFinancialEntity {
    clientInfo {
      id
    }
    adminInfo {
      id
    }
  }
  ...ClientIntegrationsSection
  ...BusinessHeader
  ...BusinessContactSection
  ...BusinessConfigurationSection
  ...BusinessAdminSection
}
    fragment BusinessAdminSection on Business {
  id
  ... on LtdFinancialEntity {
    adminInfo {
      id
      registrationDate
      withholdingTaxAnnualIds {
        id
        year
      }
      withholdingTaxCompanyId
      socialSecurityEmployerIds {
        id
        year
      }
      socialSecurityDeductionsId
      taxAdvancesAnnualIds {
        id
        year
      }
      taxAdvancesRates {
        date
        rate
      }
    }
  }
}
fragment BusinessHeader on Business {
  __typename
  id
  name
  createdAt
  isActive
  ... on LtdFinancialEntity {
    governmentId
    adminInfo {
      id
    }
    clientInfo {
      id
    }
  }
}
fragment ClientIntegrationsSection on LtdFinancialEntity {
  id
  clientInfo {
    id
    integrations {
      id
      greenInvoiceInfo {
        businessId
        greenInvoiceId
      }
      hiveId
      linearId
      slackChannelKey
      notionId
      workflowyUrl
    }
  }
}
fragment BusinessConfigurationSection on Business {
  __typename
  id
  pcn874RecordType
  irsCode
  isActive
  ... on LtdFinancialEntity {
    optionalVAT
    exemptDealer
    isReceiptEnough
    isDocumentsOptional
    sortCode {
      id
      key
      defaultIrsCode
    }
    taxCategory {
      id
    }
    suggestions {
      phrases
      emails
      tags {
        id
      }
      description
      emailListener {
        internalEmailLinks
        emailBody
        attachments
      }
    }
    clientInfo {
      id
    }
  }
}
fragment BusinessContactSection on Business {
  __typename
  id
  ... on LtdFinancialEntity {
    name
    hebrewName
    country {
      id
      code
    }
    governmentId
    address
    city
    zipCode
    email
    phoneNumber
    website
    clientInfo {
      id
      emails
    }
  }
}`, {"fragmentName":"BusinessPage"}) as unknown as TypedDocumentString<BusinessPageFragment, unknown>;
export const ChargeMatchesTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargeMatchesTableFields on ChargeMatch {
  charge {
    id
    __typename
    minEventDate
    minDebitDate
    minDocumentsDate
    totalAmount {
      raw
      formatted
    }
    vat {
      raw
      formatted
    }
    counterparty {
      name
      id
    }
    userDescription
    tags {
      id
      name
      namePath
    }
    taxCategory {
      id
      name
    }
  }
  confidenceScore
}
    `, {"fragmentName":"ChargeMatchesTableFields"}) as unknown as TypedDocumentString<ChargeMatchesTableFieldsFragment, unknown>;
export const ChargesTableErrorsFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargesTableErrorsFields on Charge {
  id
  ... on Charge @defer {
    errorsLedger: ledger {
      ... on Ledger @defer {
        validate {
          ... on LedgerValidation @defer {
            errors
          }
        }
      }
    }
  }
}
    `, {"fragmentName":"ChargesTableErrorsFields"}) as unknown as TypedDocumentString<ChargesTableErrorsFieldsFragment, unknown>;
export const TableDocumentsRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment TableDocumentsRowFields on Document {
  id
  documentType
  image
  file
  description
  remarks
  charge {
    id
  }
  ... on FinancialDocument {
    amount {
      raw
      formatted
      currency
    }
    missingInfoSuggestions {
      amount {
        raw
        formatted
        currency
      }
      isIncome
      counterparty {
        id
        name
      }
      owner {
        id
        name
      }
    }
    date
    vat {
      raw
      formatted
      currency
    }
    serialNumber
    allocationNumber
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    issuedDocumentInfo {
      id
      status
      originalDocument {
        income {
          description
        }
      }
    }
  }
}
    `, {"fragmentName":"TableDocumentsRowFields"}) as unknown as TypedDocumentString<TableDocumentsRowFieldsFragment, unknown>;
export const TableDocumentsFieldsFragmentDoc = new TypedDocumentString(`
    fragment TableDocumentsFields on Charge {
  id
  additionalDocuments {
    id
    ...TableDocumentsRowFields
  }
}
    fragment TableDocumentsRowFields on Document {
  id
  documentType
  image
  file
  description
  remarks
  charge {
    id
  }
  ... on FinancialDocument {
    amount {
      raw
      formatted
      currency
    }
    missingInfoSuggestions {
      amount {
        raw
        formatted
        currency
      }
      isIncome
      counterparty {
        id
        name
      }
      owner {
        id
        name
      }
    }
    date
    vat {
      raw
      formatted
      currency
    }
    serialNumber
    allocationNumber
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    issuedDocumentInfo {
      id
      status
      originalDocument {
        income {
          description
        }
      }
    }
  }
}`, {"fragmentName":"TableDocumentsFields"}) as unknown as TypedDocumentString<TableDocumentsFieldsFragment, unknown>;
export const LedgerRecordsTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment LedgerRecordsTableFields on LedgerRecord {
  id
  creditAccount1 {
    __typename
    id
    name
  }
  creditAccount2 {
    __typename
    id
    name
  }
  debitAccount1 {
    __typename
    id
    name
  }
  debitAccount2 {
    __typename
    id
    name
  }
  creditAmount1 {
    formatted
    currency
  }
  creditAmount2 {
    formatted
    currency
  }
  debitAmount1 {
    formatted
    currency
  }
  debitAmount2 {
    formatted
    currency
  }
  localCurrencyCreditAmount1 {
    formatted
    raw
  }
  localCurrencyCreditAmount2 {
    formatted
    raw
  }
  localCurrencyDebitAmount1 {
    formatted
    raw
  }
  localCurrencyDebitAmount2 {
    formatted
    raw
  }
  invoiceDate
  valueDate
  description
  reference
}
    `, {"fragmentName":"LedgerRecordsTableFields"}) as unknown as TypedDocumentString<LedgerRecordsTableFieldsFragment, unknown>;
export const ChargeLedgerRecordsTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargeLedgerRecordsTableFields on Charge {
  id
  ledger {
    __typename
    records {
      id
      ...LedgerRecordsTableFields
    }
    ... on Ledger @defer {
      validate {
        ... on LedgerValidation @defer {
          matches
          differences {
            id
            ...LedgerRecordsTableFields
          }
        }
      }
    }
  }
}
    fragment LedgerRecordsTableFields on LedgerRecord {
  id
  creditAccount1 {
    __typename
    id
    name
  }
  creditAccount2 {
    __typename
    id
    name
  }
  debitAccount1 {
    __typename
    id
    name
  }
  debitAccount2 {
    __typename
    id
    name
  }
  creditAmount1 {
    formatted
    currency
  }
  creditAmount2 {
    formatted
    currency
  }
  debitAmount1 {
    formatted
    currency
  }
  debitAmount2 {
    formatted
    currency
  }
  localCurrencyCreditAmount1 {
    formatted
    raw
  }
  localCurrencyCreditAmount2 {
    formatted
    raw
  }
  localCurrencyDebitAmount1 {
    formatted
    raw
  }
  localCurrencyDebitAmount2 {
    formatted
    raw
  }
  invoiceDate
  valueDate
  description
  reference
}`, {"fragmentName":"ChargeLedgerRecordsTableFields"}) as unknown as TypedDocumentString<ChargeLedgerRecordsTableFieldsFragment, unknown>;
export const TransactionForTransactionsTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}
    `, {"fragmentName":"TransactionForTransactionsTableFields"}) as unknown as TypedDocumentString<TransactionForTransactionsTableFieldsFragment, unknown>;
export const ChargeTableTransactionsFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargeTableTransactionsFields on Charge {
  id
  transactions {
    id
    ...TransactionForTransactionsTableFields
  }
}
    fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}`, {"fragmentName":"ChargeTableTransactionsFields"}) as unknown as TypedDocumentString<ChargeTableTransactionsFieldsFragment, unknown>;
export const ConversionChargeInfoFragmentDoc = new TypedDocumentString(`
    fragment ConversionChargeInfo on Charge {
  id
  __typename
  ... on ConversionCharge {
    eventRate {
      from
      to
      rate
    }
    officialRate {
      from
      to
      rate
    }
  }
}
    `, {"fragmentName":"ConversionChargeInfo"}) as unknown as TypedDocumentString<ConversionChargeInfoFragment, unknown>;
export const CreditcardBankChargeInfoFragmentDoc = new TypedDocumentString(`
    fragment CreditcardBankChargeInfo on Charge {
  id
  __typename
  ... on CreditcardBankCharge {
    creditCardTransactions {
      id
      ...TransactionForTransactionsTableFields
    }
  }
}
    fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}`, {"fragmentName":"CreditcardBankChargeInfo"}) as unknown as TypedDocumentString<CreditcardBankChargeInfoFragment, unknown>;
export const ExchangeRatesInfoFragmentDoc = new TypedDocumentString(`
    fragment ExchangeRatesInfo on Charge {
  id
  __typename
  ... on FinancialCharge {
    exchangeRates {
      aud
      cad
      eur
      gbp
      ils
      jpy
      sek
      usd
      eth
      grt
      usdc
    }
  }
}
    `, {"fragmentName":"ExchangeRatesInfo"}) as unknown as TypedDocumentString<ExchangeRatesInfoFragment, unknown>;
export const EditMiscExpenseFieldsFragmentDoc = new TypedDocumentString(`
    fragment EditMiscExpenseFields on MiscExpense {
  id
  amount {
    raw
    currency
  }
  description
  invoiceDate
  valueDate
  creditor {
    id
  }
  debtor {
    id
  }
}
    `, {"fragmentName":"EditMiscExpenseFields"}) as unknown as TypedDocumentString<EditMiscExpenseFieldsFragment, unknown>;
export const TableMiscExpensesFieldsFragmentDoc = new TypedDocumentString(`
    fragment TableMiscExpensesFields on Charge {
  id
  miscExpenses {
    id
    amount {
      formatted
    }
    description
    invoiceDate
    valueDate
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    chargeId
    ...EditMiscExpenseFields
  }
}
    fragment EditMiscExpenseFields on MiscExpense {
  id
  amount {
    raw
    currency
  }
  description
  invoiceDate
  valueDate
  creditor {
    id
  }
  debtor {
    id
  }
}`, {"fragmentName":"TableMiscExpensesFields"}) as unknown as TypedDocumentString<TableMiscExpensesFieldsFragment, unknown>;
export const TableSalariesFieldsFragmentDoc = new TypedDocumentString(`
    fragment TableSalariesFields on Charge {
  id
  __typename
  ... on SalaryCharge {
    salaryRecords {
      directAmount {
        formatted
      }
      baseAmount {
        formatted
      }
      employee {
        id
        name
      }
      pensionFund {
        id
        name
      }
      pensionEmployeeAmount {
        formatted
      }
      pensionEmployerAmount {
        formatted
      }
      compensationsAmount {
        formatted
      }
      trainingFund {
        id
        name
      }
      trainingFundEmployeeAmount {
        formatted
      }
      trainingFundEmployerAmount {
        formatted
      }
      socialSecurityEmployeeAmount {
        formatted
      }
      socialSecurityEmployerAmount {
        formatted
      }
      incomeTaxAmount {
        formatted
      }
      healthInsuranceAmount {
        formatted
      }
    }
  }
}
    `, {"fragmentName":"TableSalariesFields"}) as unknown as TypedDocumentString<TableSalariesFieldsFragment, unknown>;
export const MonthlyIncomeExpenseChartInfoFragmentDoc = new TypedDocumentString(`
    fragment MonthlyIncomeExpenseChartInfo on IncomeExpenseChart {
  monthlyData {
    income {
      formatted
      raw
    }
    expense {
      formatted
      raw
    }
    balance {
      formatted
      raw
    }
    date
  }
}
    `, {"fragmentName":"MonthlyIncomeExpenseChartInfo"}) as unknown as TypedDocumentString<MonthlyIncomeExpenseChartInfoFragment, unknown>;
export const BusinessTripAccountantApprovalFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripAccountantApprovalFields on BusinessTrip {
  id
  accountantApproval
}
    `, {"fragmentName":"BusinessTripAccountantApprovalFields"}) as unknown as TypedDocumentString<BusinessTripAccountantApprovalFieldsFragment, unknown>;
export const BusinessTripReportHeaderFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportHeaderFields on BusinessTrip {
  id
  name
  dates {
    start
    end
  }
  purpose
  destination {
    id
    name
  }
  ...BusinessTripAccountantApprovalFields
}
    fragment BusinessTripAccountantApprovalFields on BusinessTrip {
  id
  accountantApproval
}`, {"fragmentName":"BusinessTripReportHeaderFields"}) as unknown as TypedDocumentString<BusinessTripReportHeaderFieldsFragment, unknown>;
export const BusinessTripReportSummaryFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportSummaryFields on BusinessTrip {
  id
  ... on BusinessTrip @defer {
    summary {
      excessExpenditure {
        formatted
      }
      excessTax
      rows {
        type
        totalForeignCurrency {
          formatted
        }
        totalLocalCurrency {
          formatted
        }
        taxableForeignCurrency {
          formatted
        }
        taxableLocalCurrency {
          formatted
        }
        maxTaxableForeignCurrency {
          formatted
        }
        maxTaxableLocalCurrency {
          formatted
        }
        excessExpenditure {
          formatted
        }
      }
      errors
    }
  }
}
    `, {"fragmentName":"BusinessTripReportSummaryFields"}) as unknown as TypedDocumentString<BusinessTripReportSummaryFieldsFragment, unknown>;
export const BusinessTripReportFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportFields on BusinessTrip {
  id
  ...BusinessTripReportHeaderFields
  ...BusinessTripReportSummaryFields
}
    fragment BusinessTripAccountantApprovalFields on BusinessTrip {
  id
  accountantApproval
}
fragment BusinessTripReportHeaderFields on BusinessTrip {
  id
  name
  dates {
    start
    end
  }
  purpose
  destination {
    id
    name
  }
  ...BusinessTripAccountantApprovalFields
}
fragment BusinessTripReportSummaryFields on BusinessTrip {
  id
  ... on BusinessTrip @defer {
    summary {
      excessExpenditure {
        formatted
      }
      excessTax
      rows {
        type
        totalForeignCurrency {
          formatted
        }
        totalLocalCurrency {
          formatted
        }
        taxableForeignCurrency {
          formatted
        }
        taxableLocalCurrency {
          formatted
        }
        maxTaxableForeignCurrency {
          formatted
        }
        maxTaxableLocalCurrency {
          formatted
        }
        excessExpenditure {
          formatted
        }
      }
      errors
    }
  }
}`, {"fragmentName":"BusinessTripReportFields"}) as unknown as TypedDocumentString<BusinessTripReportFieldsFragment, unknown>;
export const BusinessTripReportCoreExpenseRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}
    `, {"fragmentName":"BusinessTripReportCoreExpenseRowFields"}) as unknown as TypedDocumentString<BusinessTripReportCoreExpenseRowFieldsFragment, unknown>;
export const BusinessTripReportAccommodationsRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportAccommodationsRowFields on BusinessTripAccommodationExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  country {
    id
    name
  }
  nightsCount
  attendeesStay {
    id
    attendee {
      id
      name
    }
    nightsCount
  }
}
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}`, {"fragmentName":"BusinessTripReportAccommodationsRowFields"}) as unknown as TypedDocumentString<BusinessTripReportAccommodationsRowFieldsFragment, unknown>;
export const BusinessTripReportAccommodationsTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportAccommodationsTableFields on BusinessTripAccommodationExpense {
  id
  date
  ...BusinessTripReportAccommodationsRowFields
}
    fragment BusinessTripReportAccommodationsRowFields on BusinessTripAccommodationExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  country {
    id
    name
  }
  nightsCount
  attendeesStay {
    id
    attendee {
      id
      name
    }
    nightsCount
  }
}
fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}`, {"fragmentName":"BusinessTripReportAccommodationsTableFields"}) as unknown as TypedDocumentString<BusinessTripReportAccommodationsTableFieldsFragment, unknown>;
export const BusinessTripReportAccommodationsFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportAccommodationsFields on BusinessTrip {
  id
  accommodationExpenses {
    id
    ...BusinessTripReportAccommodationsTableFields
  }
}
    fragment BusinessTripReportAccommodationsRowFields on BusinessTripAccommodationExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  country {
    id
    name
  }
  nightsCount
  attendeesStay {
    id
    attendee {
      id
      name
    }
    nightsCount
  }
}
fragment BusinessTripReportAccommodationsTableFields on BusinessTripAccommodationExpense {
  id
  date
  ...BusinessTripReportAccommodationsRowFields
}
fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}`, {"fragmentName":"BusinessTripReportAccommodationsFields"}) as unknown as TypedDocumentString<BusinessTripReportAccommodationsFieldsFragment, unknown>;
export const BusinessTripReportFlightsRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportFlightsRowFields on BusinessTripFlightExpense {
  id
  payedByEmployee
  ...BusinessTripReportCoreExpenseRowFields
  path
  class
  attendees {
    id
    name
  }
}
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}`, {"fragmentName":"BusinessTripReportFlightsRowFields"}) as unknown as TypedDocumentString<BusinessTripReportFlightsRowFieldsFragment, unknown>;
export const BusinessTripReportFlightsTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportFlightsTableFields on BusinessTripFlightExpense {
  id
  date
  ...BusinessTripReportFlightsRowFields
}
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}
fragment BusinessTripReportFlightsRowFields on BusinessTripFlightExpense {
  id
  payedByEmployee
  ...BusinessTripReportCoreExpenseRowFields
  path
  class
  attendees {
    id
    name
  }
}`, {"fragmentName":"BusinessTripReportFlightsTableFields"}) as unknown as TypedDocumentString<BusinessTripReportFlightsTableFieldsFragment, unknown>;
export const BusinessTripReportAttendeeRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportAttendeeRowFields on BusinessTripAttendee {
  id
  name
  arrivalDate
  departureDate
  flights {
    id
    ...BusinessTripReportFlightsTableFields
  }
  accommodations {
    id
    ...BusinessTripReportAccommodationsTableFields
  }
}
    fragment BusinessTripReportAccommodationsRowFields on BusinessTripAccommodationExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  country {
    id
    name
  }
  nightsCount
  attendeesStay {
    id
    attendee {
      id
      name
    }
    nightsCount
  }
}
fragment BusinessTripReportAccommodationsTableFields on BusinessTripAccommodationExpense {
  id
  date
  ...BusinessTripReportAccommodationsRowFields
}
fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}
fragment BusinessTripReportFlightsRowFields on BusinessTripFlightExpense {
  id
  payedByEmployee
  ...BusinessTripReportCoreExpenseRowFields
  path
  class
  attendees {
    id
    name
  }
}
fragment BusinessTripReportFlightsTableFields on BusinessTripFlightExpense {
  id
  date
  ...BusinessTripReportFlightsRowFields
}`, {"fragmentName":"BusinessTripReportAttendeeRowFields"}) as unknown as TypedDocumentString<BusinessTripReportAttendeeRowFieldsFragment, unknown>;
export const BusinessTripReportAttendeesFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportAttendeesFields on BusinessTrip {
  id
  attendees {
    id
    name
    ...BusinessTripReportAttendeeRowFields
  }
}
    fragment BusinessTripReportAccommodationsRowFields on BusinessTripAccommodationExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  country {
    id
    name
  }
  nightsCount
  attendeesStay {
    id
    attendee {
      id
      name
    }
    nightsCount
  }
}
fragment BusinessTripReportAccommodationsTableFields on BusinessTripAccommodationExpense {
  id
  date
  ...BusinessTripReportAccommodationsRowFields
}
fragment BusinessTripReportAttendeeRowFields on BusinessTripAttendee {
  id
  name
  arrivalDate
  departureDate
  flights {
    id
    ...BusinessTripReportFlightsTableFields
  }
  accommodations {
    id
    ...BusinessTripReportAccommodationsTableFields
  }
}
fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}
fragment BusinessTripReportFlightsRowFields on BusinessTripFlightExpense {
  id
  payedByEmployee
  ...BusinessTripReportCoreExpenseRowFields
  path
  class
  attendees {
    id
    name
  }
}
fragment BusinessTripReportFlightsTableFields on BusinessTripFlightExpense {
  id
  date
  ...BusinessTripReportFlightsRowFields
}`, {"fragmentName":"BusinessTripReportAttendeesFields"}) as unknown as TypedDocumentString<BusinessTripReportAttendeesFieldsFragment, unknown>;
export const BusinessTripReportCarRentalRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportCarRentalRowFields on BusinessTripCarRentalExpense {
  id
  payedByEmployee
  ...BusinessTripReportCoreExpenseRowFields
  days
  isFuelExpense
}
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}`, {"fragmentName":"BusinessTripReportCarRentalRowFields"}) as unknown as TypedDocumentString<BusinessTripReportCarRentalRowFieldsFragment, unknown>;
export const BusinessTripReportCarRentalFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportCarRentalFields on BusinessTrip {
  id
  carRentalExpenses {
    id
    date
    ...BusinessTripReportCarRentalRowFields
  }
}
    fragment BusinessTripReportCarRentalRowFields on BusinessTripCarRentalExpense {
  id
  payedByEmployee
  ...BusinessTripReportCoreExpenseRowFields
  days
  isFuelExpense
}
fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}`, {"fragmentName":"BusinessTripReportCarRentalFields"}) as unknown as TypedDocumentString<BusinessTripReportCarRentalFieldsFragment, unknown>;
export const BusinessTripReportFlightsFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportFlightsFields on BusinessTrip {
  id
  flightExpenses {
    id
    ...BusinessTripReportFlightsTableFields
  }
  attendees {
    id
    name
  }
}
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}
fragment BusinessTripReportFlightsRowFields on BusinessTripFlightExpense {
  id
  payedByEmployee
  ...BusinessTripReportCoreExpenseRowFields
  path
  class
  attendees {
    id
    name
  }
}
fragment BusinessTripReportFlightsTableFields on BusinessTripFlightExpense {
  id
  date
  ...BusinessTripReportFlightsRowFields
}`, {"fragmentName":"BusinessTripReportFlightsFields"}) as unknown as TypedDocumentString<BusinessTripReportFlightsFieldsFragment, unknown>;
export const BusinessTripReportOtherRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportOtherRowFields on BusinessTripOtherExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  description
  deductibleExpense
}
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}`, {"fragmentName":"BusinessTripReportOtherRowFields"}) as unknown as TypedDocumentString<BusinessTripReportOtherRowFieldsFragment, unknown>;
export const BusinessTripReportOtherFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportOtherFields on BusinessTrip {
  id
  otherExpenses {
    id
    date
    ...BusinessTripReportOtherRowFields
  }
}
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}
fragment BusinessTripReportOtherRowFields on BusinessTripOtherExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  description
  deductibleExpense
}`, {"fragmentName":"BusinessTripReportOtherFields"}) as unknown as TypedDocumentString<BusinessTripReportOtherFieldsFragment, unknown>;
export const BusinessTripReportTravelAndSubsistenceRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportTravelAndSubsistenceRowFields on BusinessTripTravelAndSubsistenceExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  expenseType
}
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}`, {"fragmentName":"BusinessTripReportTravelAndSubsistenceRowFields"}) as unknown as TypedDocumentString<BusinessTripReportTravelAndSubsistenceRowFieldsFragment, unknown>;
export const BusinessTripReportTravelAndSubsistenceFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportTravelAndSubsistenceFields on BusinessTrip {
  id
  travelAndSubsistenceExpenses {
    id
    date
    ...BusinessTripReportTravelAndSubsistenceRowFields
  }
}
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}
fragment BusinessTripReportTravelAndSubsistenceRowFields on BusinessTripTravelAndSubsistenceExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  expenseType
}`, {"fragmentName":"BusinessTripReportTravelAndSubsistenceFields"}) as unknown as TypedDocumentString<BusinessTripReportTravelAndSubsistenceFieldsFragment, unknown>;
export const TransactionsTableEventDateFieldsFragmentDoc = new TypedDocumentString(`
    fragment TransactionsTableEventDateFields on Transaction {
  id
  eventDate
}
    `, {"fragmentName":"TransactionsTableEventDateFields"}) as unknown as TypedDocumentString<TransactionsTableEventDateFieldsFragment, unknown>;
export const TransactionsTableDebitDateFieldsFragmentDoc = new TypedDocumentString(`
    fragment TransactionsTableDebitDateFields on Transaction {
  id
  effectiveDate
  sourceEffectiveDate
}
    `, {"fragmentName":"TransactionsTableDebitDateFields"}) as unknown as TypedDocumentString<TransactionsTableDebitDateFieldsFragment, unknown>;
export const TransactionsTableAccountFieldsFragmentDoc = new TypedDocumentString(`
    fragment TransactionsTableAccountFields on Transaction {
  id
  account {
    id
    name
    type
  }
}
    `, {"fragmentName":"TransactionsTableAccountFields"}) as unknown as TypedDocumentString<TransactionsTableAccountFieldsFragment, unknown>;
export const TransactionsTableDescriptionFieldsFragmentDoc = new TypedDocumentString(`
    fragment TransactionsTableDescriptionFields on Transaction {
  id
  sourceDescription
}
    `, {"fragmentName":"TransactionsTableDescriptionFields"}) as unknown as TypedDocumentString<TransactionsTableDescriptionFieldsFragment, unknown>;
export const TransactionsTableSourceIdFieldsFragmentDoc = new TypedDocumentString(`
    fragment TransactionsTableSourceIDFields on Transaction {
  id
  referenceKey
}
    `, {"fragmentName":"TransactionsTableSourceIDFields"}) as unknown as TypedDocumentString<TransactionsTableSourceIdFieldsFragment, unknown>;
export const TransactionsTableEntityFieldsFragmentDoc = new TypedDocumentString(`
    fragment TransactionsTableEntityFields on Transaction {
  id
  counterparty {
    name
    id
  }
  sourceDescription
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}
    `, {"fragmentName":"TransactionsTableEntityFields"}) as unknown as TypedDocumentString<TransactionsTableEntityFieldsFragment, unknown>;
export const UncategorizedTransactionsTableAmountFieldsFragmentDoc = new TypedDocumentString(`
    fragment UncategorizedTransactionsTableAmountFields on UncategorizedTransaction {
  transaction {
    id
    amount {
      raw
      formatted
    }
    cryptoExchangeRate {
      rate
    }
  }
  categorizedAmount {
    raw
    formatted
  }
  errors
}
    `, {"fragmentName":"UncategorizedTransactionsTableAmountFields"}) as unknown as TypedDocumentString<UncategorizedTransactionsTableAmountFieldsFragment, unknown>;
export const BusinessTripUncategorizedTransactionsFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripUncategorizedTransactionsFields on BusinessTrip {
  id
  uncategorizedTransactions {
    transaction {
      id
      eventDate
      chargeId
      amount {
        raw
      }
      ...TransactionsTableEventDateFields
      ...TransactionsTableDebitDateFields
      ...TransactionsTableAccountFields
      ...TransactionsTableDescriptionFields
      ...TransactionsTableSourceIDFields
      ...TransactionsTableEntityFields
    }
    ...UncategorizedTransactionsTableAmountFields
  }
}
    fragment UncategorizedTransactionsTableAmountFields on UncategorizedTransaction {
  transaction {
    id
    amount {
      raw
      formatted
    }
    cryptoExchangeRate {
      rate
    }
  }
  categorizedAmount {
    raw
    formatted
  }
  errors
}
fragment TransactionsTableAccountFields on Transaction {
  id
  account {
    id
    name
    type
  }
}
fragment TransactionsTableEntityFields on Transaction {
  id
  counterparty {
    name
    id
  }
  sourceDescription
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}
fragment TransactionsTableDebitDateFields on Transaction {
  id
  effectiveDate
  sourceEffectiveDate
}
fragment TransactionsTableDescriptionFields on Transaction {
  id
  sourceDescription
}
fragment TransactionsTableEventDateFields on Transaction {
  id
  eventDate
}
fragment TransactionsTableSourceIDFields on Transaction {
  id
  referenceKey
}`, {"fragmentName":"BusinessTripUncategorizedTransactionsFields"}) as unknown as TypedDocumentString<BusinessTripUncategorizedTransactionsFieldsFragment, unknown>;
export const DepreciationRecordRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment DepreciationRecordRowFields on DepreciationRecord {
  id
  amount {
    currency
    formatted
    raw
  }
  activationDate
  category {
    id
    name
    percentage
  }
  type
  charge {
    id
    totalAmount {
      currency
      formatted
      raw
    }
  }
}
    `, {"fragmentName":"DepreciationRecordRowFields"}) as unknown as TypedDocumentString<DepreciationRecordRowFieldsFragment, unknown>;
export const EditTagFieldsFragmentDoc = new TypedDocumentString(`
    fragment EditTagFields on Tag {
  id
  name
  parent {
    id
    name
  }
}
    `, {"fragmentName":"EditTagFields"}) as unknown as TypedDocumentString<EditTagFieldsFragment, unknown>;
export const IssueDocumentClientFieldsFragmentDoc = new TypedDocumentString(`
    fragment IssueDocumentClientFields on Client {
  id
  originalBusiness {
    id
    address
    city
    zipCode
    country {
      id
      code
    }
    governmentId
    name
    phoneNumber
  }
  emails
}
    `, {"fragmentName":"IssueDocumentClientFields"}) as unknown as TypedDocumentString<IssueDocumentClientFieldsFragment, unknown>;
export const NewDocumentDraftFragmentDoc = new TypedDocumentString(`
    fragment NewDocumentDraft on DocumentDraft {
  description
  remarks
  footer
  type
  date
  dueDate
  language
  currency
  vatType
  discount {
    amount
    type
  }
  rounding
  signed
  maxPayments
  client {
    id
    originalBusiness {
      id
      name
    }
    integrations {
      id
    }
    emails
    ...IssueDocumentClientFields
  }
  income {
    currency
    currencyRate
    description
    itemId
    price
    quantity
    vatRate
    vatType
  }
  payment {
    currency
    currencyRate
    date
    price
    type
    bankName
    bankBranch
    bankAccount
    chequeNum
    accountId
    transactionId
    cardType
    cardNum
    numPayments
    firstPayment
  }
  linkedDocumentIds
  linkedPaymentId
}
    fragment IssueDocumentClientFields on Client {
  id
  originalBusiness {
    id
    address
    city
    zipCode
    country {
      id
      code
    }
    governmentId
    name
    phoneNumber
  }
  emails
}`, {"fragmentName":"NewDocumentDraft"}) as unknown as TypedDocumentString<NewDocumentDraftFragment, unknown>;
export const SimilarChargesTableFragmentDoc = new TypedDocumentString(`
    fragment SimilarChargesTable on Charge {
  id
  __typename
  counterparty {
    name
    id
  }
  minEventDate
  minDebitDate
  minDocumentsDate
  totalAmount {
    raw
    formatted
  }
  vat {
    raw
    formatted
  }
  userDescription
  tags {
    id
    name
  }
  taxCategory {
    id
    name
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
  }
}
    `, {"fragmentName":"SimilarChargesTable"}) as unknown as TypedDocumentString<SimilarChargesTableFragment, unknown>;
export const NewFetchedDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment NewFetchedDocumentFields on Document {
  id
  documentType
  charge {
    id
    userDescription
    counterparty {
      id
      name
    }
  }
}
    `, {"fragmentName":"NewFetchedDocumentFields"}) as unknown as TypedDocumentString<NewFetchedDocumentFieldsFragment, unknown>;
export const ContractForContractsTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment ContractForContractsTableFields on Contract {
  id
  isActive
  client {
    id
    originalBusiness {
      id
      name
    }
  }
  purchaseOrders
  startDate
  endDate
  amount {
    raw
    formatted
  }
  billingCycle
  product
  plan
  operationsLimit
  msCloud
}
    `, {"fragmentName":"ContractForContractsTableFields"}) as unknown as TypedDocumentString<ContractForContractsTableFieldsFragment, unknown>;
export const DocumentsGalleryFieldsFragmentDoc = new TypedDocumentString(`
    fragment DocumentsGalleryFields on Charge {
  id
  additionalDocuments {
    id
    image
    ... on FinancialDocument {
      documentType
    }
  }
}
    `, {"fragmentName":"DocumentsGalleryFields"}) as unknown as TypedDocumentString<DocumentsGalleryFieldsFragment, unknown>;
export const CorporateTaxRulingReportRuleCellFieldsFragmentDoc = new TypedDocumentString(`
    fragment CorporateTaxRulingReportRuleCellFields on CorporateTaxRule {
  id
  rule
  percentage {
    formatted
  }
  isCompliant
}
    `, {"fragmentName":"CorporateTaxRulingReportRuleCellFields"}) as unknown as TypedDocumentString<CorporateTaxRulingReportRuleCellFieldsFragment, unknown>;
export const ReportSubCommentaryTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment ReportSubCommentaryTableFields on ReportCommentarySubRecord {
  financialEntity {
    id
    name
  }
  amount {
    formatted
  }
}
    `, {"fragmentName":"ReportSubCommentaryTableFields"}) as unknown as TypedDocumentString<ReportSubCommentaryTableFieldsFragment, unknown>;
export const ReportCommentaryTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment ReportCommentaryTableFields on ReportCommentary {
  records {
    sortCode {
      id
      key
      name
    }
    amount {
      formatted
    }
    records {
      ...ReportSubCommentaryTableFields
    }
  }
}
    fragment ReportSubCommentaryTableFields on ReportCommentarySubRecord {
  financialEntity {
    id
    name
  }
  amount {
    formatted
  }
}`, {"fragmentName":"ReportCommentaryTableFields"}) as unknown as TypedDocumentString<ReportCommentaryTableFieldsFragment, unknown>;
export const TrialBalanceTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment TrialBalanceTableFields on BusinessTransactionsSumFromLedgerRecordsSuccessfulResult {
  businessTransactionsSum {
    business {
      id
      name
      sortCode {
        id
        key
        name
      }
    }
    credit {
      formatted
      raw
    }
    debit {
      formatted
      raw
    }
    total {
      formatted
      raw
    }
  }
}
    `, {"fragmentName":"TrialBalanceTableFields"}) as unknown as TypedDocumentString<TrialBalanceTableFieldsFragment, unknown>;
export const ChargesTableAccountantApprovalFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargesTableAccountantApprovalFields on Charge {
  id
  accountantApproval
}
    `, {"fragmentName":"ChargesTableAccountantApprovalFields"}) as unknown as TypedDocumentString<ChargesTableAccountantApprovalFieldsFragment, unknown>;
export const ChargesTableAmountFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargesTableAmountFields on Charge {
  __typename
  id
  totalAmount {
    raw
    formatted
  }
  ... on CreditcardBankCharge @defer {
    validCreditCardAmount
  }
}
    `, {"fragmentName":"ChargesTableAmountFields"}) as unknown as TypedDocumentString<ChargesTableAmountFieldsFragment, unknown>;
export const ChargesTableBusinessTripFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargesTableBusinessTripFields on Charge {
  id
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
}
    `, {"fragmentName":"ChargesTableBusinessTripFields"}) as unknown as TypedDocumentString<ChargesTableBusinessTripFieldsFragment, unknown>;
export const ChargesTableDateFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargesTableDateFields on Charge {
  id
  minEventDate
  minDebitDate
  minDocumentsDate
}
    `, {"fragmentName":"ChargesTableDateFields"}) as unknown as TypedDocumentString<ChargesTableDateFieldsFragment, unknown>;
export const ChargesTableDescriptionFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargesTableDescriptionFields on Charge {
  id
  userDescription
  ... on Charge @defer {
    validationData {
      missingInfo
    }
    missingInfoSuggestions {
      description
    }
  }
}
    `, {"fragmentName":"ChargesTableDescriptionFields"}) as unknown as TypedDocumentString<ChargesTableDescriptionFieldsFragment, unknown>;
export const ChargesTableEntityFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargesTableEntityFields on Charge {
  __typename
  id
  counterparty {
    name
    id
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
    `, {"fragmentName":"ChargesTableEntityFields"}) as unknown as TypedDocumentString<ChargesTableEntityFieldsFragment, unknown>;
export const ChargesTableMoreInfoFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargesTableMoreInfoFields on Charge {
  __typename
  id
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
    `, {"fragmentName":"ChargesTableMoreInfoFields"}) as unknown as TypedDocumentString<ChargesTableMoreInfoFieldsFragment, unknown>;
export const ChargesTableTagsFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargesTableTagsFields on Charge {
  id
  tags {
    id
    name
    namePath
  }
  ... on Charge @defer {
    validationData {
      ... on ValidationData {
        missingInfo
      }
    }
    missingInfoSuggestions {
      ... on ChargeSuggestions {
        tags {
          id
          name
          namePath
        }
      }
    }
  }
}
    `, {"fragmentName":"ChargesTableTagsFields"}) as unknown as TypedDocumentString<ChargesTableTagsFieldsFragment, unknown>;
export const ChargesTableTaxCategoryFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargesTableTaxCategoryFields on Charge {
  __typename
  id
  taxCategory {
    id
    name
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
    `, {"fragmentName":"ChargesTableTaxCategoryFields"}) as unknown as TypedDocumentString<ChargesTableTaxCategoryFieldsFragment, unknown>;
export const ChargesTableTypeFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargesTableTypeFields on Charge {
  __typename
  id
}
    `, {"fragmentName":"ChargesTableTypeFields"}) as unknown as TypedDocumentString<ChargesTableTypeFieldsFragment, unknown>;
export const ChargesTableVatFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargesTableVatFields on Charge {
  __typename
  id
  vat {
    raw
    formatted
  }
  totalAmount {
    raw
    currency
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
    `, {"fragmentName":"ChargesTableVatFields"}) as unknown as TypedDocumentString<ChargesTableVatFieldsFragment, unknown>;
export const ChargesTableRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargesTableRowFields on Charge {
  id
  __typename
  metadata {
    ... on ChargeMetadata @defer {
      documentsCount
      ledgerCount
      transactionsCount
      miscExpensesCount
    }
  }
  totalAmount {
    raw
  }
  ...ChargesTableAccountantApprovalFields
  ...ChargesTableAmountFields
  ...ChargesTableBusinessTripFields @defer
  ...ChargesTableDateFields
  ...ChargesTableDescriptionFields
  ...ChargesTableEntityFields @defer
  ...ChargesTableMoreInfoFields
  ...ChargesTableTagsFields @defer
  ...ChargesTableTaxCategoryFields @defer
  ...ChargesTableTypeFields
  ...ChargesTableVatFields
}
    fragment ChargesTableAccountantApprovalFields on Charge {
  id
  accountantApproval
}
fragment ChargesTableAmountFields on Charge {
  __typename
  id
  totalAmount {
    raw
    formatted
  }
  ... on CreditcardBankCharge @defer {
    validCreditCardAmount
  }
}
fragment ChargesTableBusinessTripFields on Charge {
  id
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
}
fragment ChargesTableEntityFields on Charge {
  __typename
  id
  counterparty {
    name
    id
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableDateFields on Charge {
  id
  minEventDate
  minDebitDate
  minDocumentsDate
}
fragment ChargesTableDescriptionFields on Charge {
  id
  userDescription
  ... on Charge @defer {
    validationData {
      missingInfo
    }
    missingInfoSuggestions {
      description
    }
  }
}
fragment ChargesTableMoreInfoFields on Charge {
  __typename
  id
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTagsFields on Charge {
  id
  tags {
    id
    name
    namePath
  }
  ... on Charge @defer {
    validationData {
      ... on ValidationData {
        missingInfo
      }
    }
    missingInfoSuggestions {
      ... on ChargeSuggestions {
        tags {
          id
          name
          namePath
        }
      }
    }
  }
}
fragment ChargesTableTaxCategoryFields on Charge {
  __typename
  id
  taxCategory {
    id
    name
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTypeFields on Charge {
  __typename
  id
}
fragment ChargesTableVatFields on Charge {
  __typename
  id
  vat {
    raw
    formatted
  }
  totalAmount {
    raw
    currency
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}`, {"fragmentName":"ChargesTableRowFields","deferredFields":{"ChargesTableBusinessTripFields":["id"],"ChargesTableEntityFields":["__typename","id","counterparty"],"ChargesTableTagsFields":["id","tags"],"ChargesTableTaxCategoryFields":["__typename","id","taxCategory"]}}) as unknown as TypedDocumentString<ChargesTableRowFieldsFragment, unknown>;
export const ChargesTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargesTableFields on Charge {
  id
  owner {
    id
  }
  ...ChargesTableRowFields
}
    fragment ChargesTableAccountantApprovalFields on Charge {
  id
  accountantApproval
}
fragment ChargesTableAmountFields on Charge {
  __typename
  id
  totalAmount {
    raw
    formatted
  }
  ... on CreditcardBankCharge @defer {
    validCreditCardAmount
  }
}
fragment ChargesTableBusinessTripFields on Charge {
  id
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
}
fragment ChargesTableEntityFields on Charge {
  __typename
  id
  counterparty {
    name
    id
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableDateFields on Charge {
  id
  minEventDate
  minDebitDate
  minDocumentsDate
}
fragment ChargesTableDescriptionFields on Charge {
  id
  userDescription
  ... on Charge @defer {
    validationData {
      missingInfo
    }
    missingInfoSuggestions {
      description
    }
  }
}
fragment ChargesTableMoreInfoFields on Charge {
  __typename
  id
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTagsFields on Charge {
  id
  tags {
    id
    name
    namePath
  }
  ... on Charge @defer {
    validationData {
      ... on ValidationData {
        missingInfo
      }
    }
    missingInfoSuggestions {
      ... on ChargeSuggestions {
        tags {
          id
          name
          namePath
        }
      }
    }
  }
}
fragment ChargesTableTaxCategoryFields on Charge {
  __typename
  id
  taxCategory {
    id
    name
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTypeFields on Charge {
  __typename
  id
}
fragment ChargesTableVatFields on Charge {
  __typename
  id
  vat {
    raw
    formatted
  }
  totalAmount {
    raw
    currency
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableRowFields on Charge {
  id
  __typename
  metadata {
    ... on ChargeMetadata @defer {
      documentsCount
      ledgerCount
      transactionsCount
      miscExpensesCount
    }
  }
  totalAmount {
    raw
  }
  ...ChargesTableAccountantApprovalFields
  ...ChargesTableAmountFields
  ...ChargesTableBusinessTripFields @defer
  ...ChargesTableDateFields
  ...ChargesTableDescriptionFields
  ...ChargesTableEntityFields @defer
  ...ChargesTableMoreInfoFields
  ...ChargesTableTagsFields @defer
  ...ChargesTableTaxCategoryFields @defer
  ...ChargesTableTypeFields
  ...ChargesTableVatFields
}`, {"fragmentName":"ChargesTableFields"}) as unknown as TypedDocumentString<ChargesTableFieldsFragment, unknown>;
export const VatReportBusinessTripsFieldsFragmentDoc = new TypedDocumentString(`
    fragment VatReportBusinessTripsFields on VatReportResult {
  businessTrips {
    id
    ...ChargesTableFields
  }
}
    fragment ChargesTableAccountantApprovalFields on Charge {
  id
  accountantApproval
}
fragment ChargesTableAmountFields on Charge {
  __typename
  id
  totalAmount {
    raw
    formatted
  }
  ... on CreditcardBankCharge @defer {
    validCreditCardAmount
  }
}
fragment ChargesTableBusinessTripFields on Charge {
  id
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
}
fragment ChargesTableEntityFields on Charge {
  __typename
  id
  counterparty {
    name
    id
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableDateFields on Charge {
  id
  minEventDate
  minDebitDate
  minDocumentsDate
}
fragment ChargesTableDescriptionFields on Charge {
  id
  userDescription
  ... on Charge @defer {
    validationData {
      missingInfo
    }
    missingInfoSuggestions {
      description
    }
  }
}
fragment ChargesTableMoreInfoFields on Charge {
  __typename
  id
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTagsFields on Charge {
  id
  tags {
    id
    name
    namePath
  }
  ... on Charge @defer {
    validationData {
      ... on ValidationData {
        missingInfo
      }
    }
    missingInfoSuggestions {
      ... on ChargeSuggestions {
        tags {
          id
          name
          namePath
        }
      }
    }
  }
}
fragment ChargesTableTaxCategoryFields on Charge {
  __typename
  id
  taxCategory {
    id
    name
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTypeFields on Charge {
  __typename
  id
}
fragment ChargesTableVatFields on Charge {
  __typename
  id
  vat {
    raw
    formatted
  }
  totalAmount {
    raw
    currency
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableRowFields on Charge {
  id
  __typename
  metadata {
    ... on ChargeMetadata @defer {
      documentsCount
      ledgerCount
      transactionsCount
      miscExpensesCount
    }
  }
  totalAmount {
    raw
  }
  ...ChargesTableAccountantApprovalFields
  ...ChargesTableAmountFields
  ...ChargesTableBusinessTripFields @defer
  ...ChargesTableDateFields
  ...ChargesTableDescriptionFields
  ...ChargesTableEntityFields @defer
  ...ChargesTableMoreInfoFields
  ...ChargesTableTagsFields @defer
  ...ChargesTableTaxCategoryFields @defer
  ...ChargesTableTypeFields
  ...ChargesTableVatFields
}
fragment ChargesTableFields on Charge {
  id
  owner {
    id
  }
  ...ChargesTableRowFields
}`, {"fragmentName":"VatReportBusinessTripsFields"}) as unknown as TypedDocumentString<VatReportBusinessTripsFieldsFragment, unknown>;
export const VatReportAccountantApprovalFieldsFragmentDoc = new TypedDocumentString(`
    fragment VatReportAccountantApprovalFields on VatReportRecord {
  chargeId
  chargeAccountantStatus
}
    `, {"fragmentName":"VatReportAccountantApprovalFields"}) as unknown as TypedDocumentString<VatReportAccountantApprovalFieldsFragment, unknown>;
export const VatReportExpensesRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment VatReportExpensesRowFields on VatReportRecord {
  ...VatReportAccountantApprovalFields
  business {
    id
    name
  }
  vatNumber
  image
  allocationNumber
  documentSerial
  documentDate
  chargeDate
  chargeId
  amount {
    formatted
    raw
  }
  localAmount {
    formatted
    raw
  }
  localVat {
    formatted
    raw
  }
  foreignVatAfterDeduction {
    formatted
    raw
  }
  localVatAfterDeduction {
    formatted
    raw
  }
  roundedLocalVatAfterDeduction {
    formatted
    raw
  }
  taxReducedLocalAmount {
    formatted
    raw
  }
  recordType
}
    fragment VatReportAccountantApprovalFields on VatReportRecord {
  chargeId
  chargeAccountantStatus
}`, {"fragmentName":"VatReportExpensesRowFields"}) as unknown as TypedDocumentString<VatReportExpensesRowFieldsFragment, unknown>;
export const VatReportExpensesFieldsFragmentDoc = new TypedDocumentString(`
    fragment VatReportExpensesFields on VatReportResult {
  expenses {
    ...VatReportExpensesRowFields
    roundedLocalVatAfterDeduction {
      raw
    }
    taxReducedLocalAmount {
      raw
    }
    recordType
  }
}
    fragment VatReportAccountantApprovalFields on VatReportRecord {
  chargeId
  chargeAccountantStatus
}
fragment VatReportExpensesRowFields on VatReportRecord {
  ...VatReportAccountantApprovalFields
  business {
    id
    name
  }
  vatNumber
  image
  allocationNumber
  documentSerial
  documentDate
  chargeDate
  chargeId
  amount {
    formatted
    raw
  }
  localAmount {
    formatted
    raw
  }
  localVat {
    formatted
    raw
  }
  foreignVatAfterDeduction {
    formatted
    raw
  }
  localVatAfterDeduction {
    formatted
    raw
  }
  roundedLocalVatAfterDeduction {
    formatted
    raw
  }
  taxReducedLocalAmount {
    formatted
    raw
  }
  recordType
}`, {"fragmentName":"VatReportExpensesFields"}) as unknown as TypedDocumentString<VatReportExpensesFieldsFragment, unknown>;
export const VatReportIncomeRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment VatReportIncomeRowFields on VatReportRecord {
  ...VatReportAccountantApprovalFields
  chargeId
  business {
    id
    name
  }
  vatNumber
  image
  allocationNumber
  documentSerial
  documentDate
  chargeDate
  taxReducedForeignAmount {
    formatted
    raw
  }
  taxReducedLocalAmount {
    formatted
    raw
  }
  recordType
}
    fragment VatReportAccountantApprovalFields on VatReportRecord {
  chargeId
  chargeAccountantStatus
}`, {"fragmentName":"VatReportIncomeRowFields"}) as unknown as TypedDocumentString<VatReportIncomeRowFieldsFragment, unknown>;
export const VatReportIncomeFieldsFragmentDoc = new TypedDocumentString(`
    fragment VatReportIncomeFields on VatReportResult {
  income {
    ...VatReportIncomeRowFields
    taxReducedLocalAmount {
      raw
    }
    recordType
  }
}
    fragment VatReportAccountantApprovalFields on VatReportRecord {
  chargeId
  chargeAccountantStatus
}
fragment VatReportIncomeRowFields on VatReportRecord {
  ...VatReportAccountantApprovalFields
  chargeId
  business {
    id
    name
  }
  vatNumber
  image
  allocationNumber
  documentSerial
  documentDate
  chargeDate
  taxReducedForeignAmount {
    formatted
    raw
  }
  taxReducedLocalAmount {
    formatted
    raw
  }
  recordType
}`, {"fragmentName":"VatReportIncomeFields"}) as unknown as TypedDocumentString<VatReportIncomeFieldsFragment, unknown>;
export const VatReportMiscTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment VatReportMiscTableFields on VatReportResult {
  differentMonthDoc {
    id
    ...ChargesTableFields
  }
}
    fragment ChargesTableAccountantApprovalFields on Charge {
  id
  accountantApproval
}
fragment ChargesTableAmountFields on Charge {
  __typename
  id
  totalAmount {
    raw
    formatted
  }
  ... on CreditcardBankCharge @defer {
    validCreditCardAmount
  }
}
fragment ChargesTableBusinessTripFields on Charge {
  id
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
}
fragment ChargesTableEntityFields on Charge {
  __typename
  id
  counterparty {
    name
    id
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableDateFields on Charge {
  id
  minEventDate
  minDebitDate
  minDocumentsDate
}
fragment ChargesTableDescriptionFields on Charge {
  id
  userDescription
  ... on Charge @defer {
    validationData {
      missingInfo
    }
    missingInfoSuggestions {
      description
    }
  }
}
fragment ChargesTableMoreInfoFields on Charge {
  __typename
  id
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTagsFields on Charge {
  id
  tags {
    id
    name
    namePath
  }
  ... on Charge @defer {
    validationData {
      ... on ValidationData {
        missingInfo
      }
    }
    missingInfoSuggestions {
      ... on ChargeSuggestions {
        tags {
          id
          name
          namePath
        }
      }
    }
  }
}
fragment ChargesTableTaxCategoryFields on Charge {
  __typename
  id
  taxCategory {
    id
    name
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTypeFields on Charge {
  __typename
  id
}
fragment ChargesTableVatFields on Charge {
  __typename
  id
  vat {
    raw
    formatted
  }
  totalAmount {
    raw
    currency
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableRowFields on Charge {
  id
  __typename
  metadata {
    ... on ChargeMetadata @defer {
      documentsCount
      ledgerCount
      transactionsCount
      miscExpensesCount
    }
  }
  totalAmount {
    raw
  }
  ...ChargesTableAccountantApprovalFields
  ...ChargesTableAmountFields
  ...ChargesTableBusinessTripFields @defer
  ...ChargesTableDateFields
  ...ChargesTableDescriptionFields
  ...ChargesTableEntityFields @defer
  ...ChargesTableMoreInfoFields
  ...ChargesTableTagsFields @defer
  ...ChargesTableTaxCategoryFields @defer
  ...ChargesTableTypeFields
  ...ChargesTableVatFields
}
fragment ChargesTableFields on Charge {
  id
  owner {
    id
  }
  ...ChargesTableRowFields
}`, {"fragmentName":"VatReportMiscTableFields"}) as unknown as TypedDocumentString<VatReportMiscTableFieldsFragment, unknown>;
export const VatReportMissingInfoFieldsFragmentDoc = new TypedDocumentString(`
    fragment VatReportMissingInfoFields on VatReportResult {
  missingInfo {
    id
    ...ChargesTableFields
  }
}
    fragment ChargesTableAccountantApprovalFields on Charge {
  id
  accountantApproval
}
fragment ChargesTableAmountFields on Charge {
  __typename
  id
  totalAmount {
    raw
    formatted
  }
  ... on CreditcardBankCharge @defer {
    validCreditCardAmount
  }
}
fragment ChargesTableBusinessTripFields on Charge {
  id
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
}
fragment ChargesTableEntityFields on Charge {
  __typename
  id
  counterparty {
    name
    id
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableDateFields on Charge {
  id
  minEventDate
  minDebitDate
  minDocumentsDate
}
fragment ChargesTableDescriptionFields on Charge {
  id
  userDescription
  ... on Charge @defer {
    validationData {
      missingInfo
    }
    missingInfoSuggestions {
      description
    }
  }
}
fragment ChargesTableMoreInfoFields on Charge {
  __typename
  id
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTagsFields on Charge {
  id
  tags {
    id
    name
    namePath
  }
  ... on Charge @defer {
    validationData {
      ... on ValidationData {
        missingInfo
      }
    }
    missingInfoSuggestions {
      ... on ChargeSuggestions {
        tags {
          id
          name
          namePath
        }
      }
    }
  }
}
fragment ChargesTableTaxCategoryFields on Charge {
  __typename
  id
  taxCategory {
    id
    name
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTypeFields on Charge {
  __typename
  id
}
fragment ChargesTableVatFields on Charge {
  __typename
  id
  vat {
    raw
    formatted
  }
  totalAmount {
    raw
    currency
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableRowFields on Charge {
  id
  __typename
  metadata {
    ... on ChargeMetadata @defer {
      documentsCount
      ledgerCount
      transactionsCount
      miscExpensesCount
    }
  }
  totalAmount {
    raw
  }
  ...ChargesTableAccountantApprovalFields
  ...ChargesTableAmountFields
  ...ChargesTableBusinessTripFields @defer
  ...ChargesTableDateFields
  ...ChargesTableDescriptionFields
  ...ChargesTableEntityFields @defer
  ...ChargesTableMoreInfoFields
  ...ChargesTableTagsFields @defer
  ...ChargesTableTaxCategoryFields @defer
  ...ChargesTableTypeFields
  ...ChargesTableVatFields
}
fragment ChargesTableFields on Charge {
  id
  owner {
    id
  }
  ...ChargesTableRowFields
}`, {"fragmentName":"VatReportMissingInfoFields"}) as unknown as TypedDocumentString<VatReportMissingInfoFieldsFragment, unknown>;
export const VatReportSummaryFieldsFragmentDoc = new TypedDocumentString(`
    fragment VatReportSummaryFields on VatReportResult {
  expenses {
    roundedLocalVatAfterDeduction {
      raw
    }
    taxReducedLocalAmount {
      raw
    }
    recordType
    isProperty
  }
  income {
    roundedLocalVatAfterDeduction {
      raw
    }
    taxReducedLocalAmount {
      raw
    }
    recordType
  }
}
    `, {"fragmentName":"VatReportSummaryFields"}) as unknown as TypedDocumentString<VatReportSummaryFieldsFragment, unknown>;
export const LedgerCsvFieldsFragmentDoc = new TypedDocumentString(`
    fragment LedgerCsvFields on YearlyLedgerReport {
  id
  year
  financialEntitiesInfo {
    entity {
      id
      name
      sortCode {
        id
        key
      }
    }
    openingBalance {
      raw
    }
    totalCredit {
      raw
    }
    totalDebit {
      raw
    }
    closingBalance {
      raw
    }
    records {
      id
      amount {
        raw
        formatted
      }
      invoiceDate
      valueDate
      description
      reference
      counterParty {
        id
        name
      }
      balance
    }
  }
}
    `, {"fragmentName":"LedgerCsvFields"}) as unknown as TypedDocumentString<LedgerCsvFieldsFragment, unknown>;
export const SalariesRecordEmployeeFieldsFragmentDoc = new TypedDocumentString(`
    fragment SalariesRecordEmployeeFields on Salary {
  month
  employee {
    id
    name
  }
}
    `, {"fragmentName":"SalariesRecordEmployeeFields"}) as unknown as TypedDocumentString<SalariesRecordEmployeeFieldsFragment, unknown>;
export const SalariesRecordMainSalaryFieldsFragmentDoc = new TypedDocumentString(`
    fragment SalariesRecordMainSalaryFields on Salary {
  month
  employee {
    id
  }
  baseAmount {
    formatted
  }
  directAmount {
    formatted
  }
  globalAdditionalHoursAmount {
    formatted
  }
  bonus {
    formatted
    raw
  }
  gift {
    formatted
    raw
  }
  recovery {
    formatted
    raw
  }
  vacationTakeout {
    formatted
    raw
  }
}
    `, {"fragmentName":"SalariesRecordMainSalaryFields"}) as unknown as TypedDocumentString<SalariesRecordMainSalaryFieldsFragment, unknown>;
export const SalariesRecordFundsFieldsFragmentDoc = new TypedDocumentString(`
    fragment SalariesRecordFundsFields on Salary {
  month
  employee {
    id
  }
  pensionFund {
    id
    name
  }
  pensionEmployeeAmount {
    formatted
    raw
  }
  pensionEmployeePercentage
  pensionEmployerAmount {
    formatted
    raw
  }
  pensionEmployerPercentage
  compensationsAmount {
    formatted
    raw
  }
  compensationsPercentage
  trainingFund {
    id
    name
  }
  trainingFundEmployeeAmount {
    formatted
    raw
  }
  trainingFundEmployeePercentage
  trainingFundEmployerAmount {
    formatted
    raw
  }
  trainingFundEmployerPercentage
}
    `, {"fragmentName":"SalariesRecordFundsFields"}) as unknown as TypedDocumentString<SalariesRecordFundsFieldsFragment, unknown>;
export const SalariesRecordInsurancesAndTaxesFieldsFragmentDoc = new TypedDocumentString(`
    fragment SalariesRecordInsurancesAndTaxesFields on Salary {
  month
  employee {
    id
  }
  healthInsuranceAmount {
    formatted
    raw
  }
  socialSecurityEmployeeAmount {
    formatted
    raw
  }
  socialSecurityEmployerAmount {
    formatted
    raw
  }
  incomeTaxAmount {
    formatted
    raw
  }
  notionalExpense {
    formatted
    raw
  }
}
    `, {"fragmentName":"SalariesRecordInsurancesAndTaxesFields"}) as unknown as TypedDocumentString<SalariesRecordInsurancesAndTaxesFieldsFragment, unknown>;
export const SalariesRecordWorkFrameFieldsFragmentDoc = new TypedDocumentString(`
    fragment SalariesRecordWorkFrameFields on Salary {
  month
  employee {
    id
  }
  vacationDays {
    added
    taken
    balance
  }
  workDays
  sicknessDays {
    balance
  }
}
    `, {"fragmentName":"SalariesRecordWorkFrameFields"}) as unknown as TypedDocumentString<SalariesRecordWorkFrameFieldsFragment, unknown>;
export const SalariesRecordFieldsFragmentDoc = new TypedDocumentString(`
    fragment SalariesRecordFields on Salary {
  month
  employee {
    id
  }
  ...SalariesRecordEmployeeFields
  ...SalariesRecordMainSalaryFields
  ...SalariesRecordFundsFields
  ...SalariesRecordInsurancesAndTaxesFields
  ...SalariesRecordWorkFrameFields
}
    fragment SalariesRecordEmployeeFields on Salary {
  month
  employee {
    id
    name
  }
}
fragment SalariesRecordFundsFields on Salary {
  month
  employee {
    id
  }
  pensionFund {
    id
    name
  }
  pensionEmployeeAmount {
    formatted
    raw
  }
  pensionEmployeePercentage
  pensionEmployerAmount {
    formatted
    raw
  }
  pensionEmployerPercentage
  compensationsAmount {
    formatted
    raw
  }
  compensationsPercentage
  trainingFund {
    id
    name
  }
  trainingFundEmployeeAmount {
    formatted
    raw
  }
  trainingFundEmployeePercentage
  trainingFundEmployerAmount {
    formatted
    raw
  }
  trainingFundEmployerPercentage
}
fragment SalariesRecordInsurancesAndTaxesFields on Salary {
  month
  employee {
    id
  }
  healthInsuranceAmount {
    formatted
    raw
  }
  socialSecurityEmployeeAmount {
    formatted
    raw
  }
  socialSecurityEmployerAmount {
    formatted
    raw
  }
  incomeTaxAmount {
    formatted
    raw
  }
  notionalExpense {
    formatted
    raw
  }
}
fragment SalariesRecordMainSalaryFields on Salary {
  month
  employee {
    id
  }
  baseAmount {
    formatted
  }
  directAmount {
    formatted
  }
  globalAdditionalHoursAmount {
    formatted
  }
  bonus {
    formatted
    raw
  }
  gift {
    formatted
    raw
  }
  recovery {
    formatted
    raw
  }
  vacationTakeout {
    formatted
    raw
  }
}
fragment SalariesRecordWorkFrameFields on Salary {
  month
  employee {
    id
  }
  vacationDays {
    added
    taken
    balance
  }
  workDays
  sicknessDays {
    balance
  }
}`, {"fragmentName":"SalariesRecordFields"}) as unknown as TypedDocumentString<SalariesRecordFieldsFragment, unknown>;
export const SalariesMonthFieldsFragmentDoc = new TypedDocumentString(`
    fragment SalariesMonthFields on Salary {
  month
  employee {
    id
  }
  ...SalariesRecordFields
}
    fragment SalariesRecordEmployeeFields on Salary {
  month
  employee {
    id
    name
  }
}
fragment SalariesRecordFundsFields on Salary {
  month
  employee {
    id
  }
  pensionFund {
    id
    name
  }
  pensionEmployeeAmount {
    formatted
    raw
  }
  pensionEmployeePercentage
  pensionEmployerAmount {
    formatted
    raw
  }
  pensionEmployerPercentage
  compensationsAmount {
    formatted
    raw
  }
  compensationsPercentage
  trainingFund {
    id
    name
  }
  trainingFundEmployeeAmount {
    formatted
    raw
  }
  trainingFundEmployeePercentage
  trainingFundEmployerAmount {
    formatted
    raw
  }
  trainingFundEmployerPercentage
}
fragment SalariesRecordInsurancesAndTaxesFields on Salary {
  month
  employee {
    id
  }
  healthInsuranceAmount {
    formatted
    raw
  }
  socialSecurityEmployeeAmount {
    formatted
    raw
  }
  socialSecurityEmployerAmount {
    formatted
    raw
  }
  incomeTaxAmount {
    formatted
    raw
  }
  notionalExpense {
    formatted
    raw
  }
}
fragment SalariesRecordMainSalaryFields on Salary {
  month
  employee {
    id
  }
  baseAmount {
    formatted
  }
  directAmount {
    formatted
  }
  globalAdditionalHoursAmount {
    formatted
  }
  bonus {
    formatted
    raw
  }
  gift {
    formatted
    raw
  }
  recovery {
    formatted
    raw
  }
  vacationTakeout {
    formatted
    raw
  }
}
fragment SalariesRecordWorkFrameFields on Salary {
  month
  employee {
    id
  }
  vacationDays {
    added
    taken
    balance
  }
  workDays
  sicknessDays {
    balance
  }
}
fragment SalariesRecordFields on Salary {
  month
  employee {
    id
  }
  ...SalariesRecordEmployeeFields
  ...SalariesRecordMainSalaryFields
  ...SalariesRecordFundsFields
  ...SalariesRecordInsurancesAndTaxesFields
  ...SalariesRecordWorkFrameFields
}`, {"fragmentName":"SalariesMonthFields"}) as unknown as TypedDocumentString<SalariesMonthFieldsFragment, unknown>;
export const SalariesTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment SalariesTableFields on Salary {
  month
  employee {
    id
  }
  ...SalariesMonthFields
}
    fragment SalariesRecordEmployeeFields on Salary {
  month
  employee {
    id
    name
  }
}
fragment SalariesRecordFundsFields on Salary {
  month
  employee {
    id
  }
  pensionFund {
    id
    name
  }
  pensionEmployeeAmount {
    formatted
    raw
  }
  pensionEmployeePercentage
  pensionEmployerAmount {
    formatted
    raw
  }
  pensionEmployerPercentage
  compensationsAmount {
    formatted
    raw
  }
  compensationsPercentage
  trainingFund {
    id
    name
  }
  trainingFundEmployeeAmount {
    formatted
    raw
  }
  trainingFundEmployeePercentage
  trainingFundEmployerAmount {
    formatted
    raw
  }
  trainingFundEmployerPercentage
}
fragment SalariesRecordInsurancesAndTaxesFields on Salary {
  month
  employee {
    id
  }
  healthInsuranceAmount {
    formatted
    raw
  }
  socialSecurityEmployeeAmount {
    formatted
    raw
  }
  socialSecurityEmployerAmount {
    formatted
    raw
  }
  incomeTaxAmount {
    formatted
    raw
  }
  notionalExpense {
    formatted
    raw
  }
}
fragment SalariesRecordMainSalaryFields on Salary {
  month
  employee {
    id
  }
  baseAmount {
    formatted
  }
  directAmount {
    formatted
  }
  globalAdditionalHoursAmount {
    formatted
  }
  bonus {
    formatted
    raw
  }
  gift {
    formatted
    raw
  }
  recovery {
    formatted
    raw
  }
  vacationTakeout {
    formatted
    raw
  }
}
fragment SalariesRecordWorkFrameFields on Salary {
  month
  employee {
    id
  }
  vacationDays {
    added
    taken
    balance
  }
  workDays
  sicknessDays {
    balance
  }
}
fragment SalariesMonthFields on Salary {
  month
  employee {
    id
  }
  ...SalariesRecordFields
}
fragment SalariesRecordFields on Salary {
  month
  employee {
    id
  }
  ...SalariesRecordEmployeeFields
  ...SalariesRecordMainSalaryFields
  ...SalariesRecordFundsFields
  ...SalariesRecordInsurancesAndTaxesFields
  ...SalariesRecordWorkFrameFields
}`, {"fragmentName":"SalariesTableFields"}) as unknown as TypedDocumentString<SalariesTableFieldsFragment, unknown>;
export const AnnualRevenueReportRecordFragmentDoc = new TypedDocumentString(`
    fragment AnnualRevenueReportRecord on AnnualRevenueReportClientRecord {
  id
  revenueLocal {
    raw
    formatted
    currency
  }
  revenueDefaultForeign {
    raw
    formatted
    currency
  }
  revenueOriginal {
    raw
    formatted
    currency
  }
  chargeId
  date
  description
  reference
}
    `, {"fragmentName":"AnnualRevenueReportRecord"}) as unknown as TypedDocumentString<AnnualRevenueReportRecordFragment, unknown>;
export const AnnualRevenueReportClientFragmentDoc = new TypedDocumentString(`
    fragment AnnualRevenueReportClient on AnnualRevenueReportCountryClient {
  id
  name
  revenueLocal {
    raw
    formatted
    currency
  }
  revenueDefaultForeign {
    raw
    formatted
    currency
  }
  records {
    id
    date
    ...AnnualRevenueReportRecord
  }
}
    fragment AnnualRevenueReportRecord on AnnualRevenueReportClientRecord {
  id
  revenueLocal {
    raw
    formatted
    currency
  }
  revenueDefaultForeign {
    raw
    formatted
    currency
  }
  revenueOriginal {
    raw
    formatted
    currency
  }
  chargeId
  date
  description
  reference
}`, {"fragmentName":"AnnualRevenueReportClient"}) as unknown as TypedDocumentString<AnnualRevenueReportClientFragment, unknown>;
export const AnnualRevenueReportCountryFragmentDoc = new TypedDocumentString(`
    fragment AnnualRevenueReportCountry on AnnualRevenueReportCountry {
  id
  code
  name
  revenueLocal {
    raw
    formatted
    currency
  }
  revenueDefaultForeign {
    raw
    formatted
    currency
  }
  clients {
    id
    revenueDefaultForeign {
      raw
    }
    ...AnnualRevenueReportClient
  }
}
    fragment AnnualRevenueReportClient on AnnualRevenueReportCountryClient {
  id
  name
  revenueLocal {
    raw
    formatted
    currency
  }
  revenueDefaultForeign {
    raw
    formatted
    currency
  }
  records {
    id
    date
    ...AnnualRevenueReportRecord
  }
}
fragment AnnualRevenueReportRecord on AnnualRevenueReportClientRecord {
  id
  revenueLocal {
    raw
    formatted
    currency
  }
  revenueDefaultForeign {
    raw
    formatted
    currency
  }
  revenueOriginal {
    raw
    formatted
    currency
  }
  chargeId
  date
  description
  reference
}`, {"fragmentName":"AnnualRevenueReportCountry"}) as unknown as TypedDocumentString<AnnualRevenueReportCountryFragment, unknown>;
export const DepreciationReportRecordCoreFragmentDoc = new TypedDocumentString(`
    fragment DepreciationReportRecordCore on DepreciationCoreRecord {
  id
  originalCost
  reportYearDelta
  totalDepreciableCosts
  reportYearClaimedDepreciation
  pastYearsAccumulatedDepreciation
  totalDepreciation
  netValue
}
    `, {"fragmentName":"DepreciationReportRecordCore"}) as unknown as TypedDocumentString<DepreciationReportRecordCoreFragment, unknown>;
export const Shaam6111DataContentHeaderBusinessFragmentDoc = new TypedDocumentString(`
    fragment Shaam6111DataContentHeaderBusiness on Business {
  id
  name
}
    `, {"fragmentName":"Shaam6111DataContentHeaderBusiness"}) as unknown as TypedDocumentString<Shaam6111DataContentHeaderBusinessFragment, unknown>;
export const Shaam6111DataContentHeaderFragmentDoc = new TypedDocumentString(`
    fragment Shaam6111DataContentHeader on Shaam6111Data {
  id
  header {
    taxYear
    businessDescription
    taxFileNumber
    idNumber
    vatFileNumber
    withholdingTaxFileNumber
    businessType
    reportingMethod
    currencyType
    amountsInThousands
    accountingMethod
    accountingSystem
    softwareRegistrationNumber
    isPartnership
    partnershipCount
    partnershipProfitShare
    ifrsImplementationYear
    ifrsReportingOption
    includesProfitLoss
    includesTaxAdjustment
    includesBalanceSheet
    industryCode
    auditOpinionType
  }
}
    `, {"fragmentName":"Shaam6111DataContentHeader"}) as unknown as TypedDocumentString<Shaam6111DataContentHeaderFragment, unknown>;
export const Shaam6111DataContentProfitLossFragmentDoc = new TypedDocumentString(`
    fragment Shaam6111DataContentProfitLoss on Shaam6111Data {
  id
  profitAndLoss {
    code
    amount
    label
  }
}
    `, {"fragmentName":"Shaam6111DataContentProfitLoss"}) as unknown as TypedDocumentString<Shaam6111DataContentProfitLossFragment, unknown>;
export const Shaam6111DataContentTaxAdjustmentFragmentDoc = new TypedDocumentString(`
    fragment Shaam6111DataContentTaxAdjustment on Shaam6111Data {
  id
  taxAdjustment {
    code
    amount
    label
  }
}
    `, {"fragmentName":"Shaam6111DataContentTaxAdjustment"}) as unknown as TypedDocumentString<Shaam6111DataContentTaxAdjustmentFragment, unknown>;
export const Shaam6111DataContentBalanceSheetFragmentDoc = new TypedDocumentString(`
    fragment Shaam6111DataContentBalanceSheet on Shaam6111Data {
  id
  balanceSheet {
    code
    amount
    label
  }
}
    `, {"fragmentName":"Shaam6111DataContentBalanceSheet"}) as unknown as TypedDocumentString<Shaam6111DataContentBalanceSheetFragment, unknown>;
export const Shaam6111DataContentFragmentDoc = new TypedDocumentString(`
    fragment Shaam6111DataContent on Shaam6111Data {
  id
  ...Shaam6111DataContentHeader
  ...Shaam6111DataContentProfitLoss
  ...Shaam6111DataContentTaxAdjustment
  ...Shaam6111DataContentBalanceSheet
}
    fragment Shaam6111DataContentBalanceSheet on Shaam6111Data {
  id
  balanceSheet {
    code
    amount
    label
  }
}
fragment Shaam6111DataContentHeader on Shaam6111Data {
  id
  header {
    taxYear
    businessDescription
    taxFileNumber
    idNumber
    vatFileNumber
    withholdingTaxFileNumber
    businessType
    reportingMethod
    currencyType
    amountsInThousands
    accountingMethod
    accountingSystem
    softwareRegistrationNumber
    isPartnership
    partnershipCount
    partnershipProfitShare
    ifrsImplementationYear
    ifrsReportingOption
    includesProfitLoss
    includesTaxAdjustment
    includesBalanceSheet
    industryCode
    auditOpinionType
  }
}
fragment Shaam6111DataContentProfitLoss on Shaam6111Data {
  id
  profitAndLoss {
    code
    amount
    label
  }
}
fragment Shaam6111DataContentTaxAdjustment on Shaam6111Data {
  id
  taxAdjustment {
    code
    amount
    label
  }
}`, {"fragmentName":"Shaam6111DataContent"}) as unknown as TypedDocumentString<Shaam6111DataContentFragment, unknown>;
export const TransactionToDownloadForTransactionsTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment TransactionToDownloadForTransactionsTableFields on Transaction {
  id
  account {
    id
    name
    type
  }
  amount {
    currency
    raw
  }
  counterparty {
    id
    name
  }
  effectiveDate
  eventDate
  referenceKey
  sourceDescription
}
    `, {"fragmentName":"TransactionToDownloadForTransactionsTableFields"}) as unknown as TypedDocumentString<TransactionToDownloadForTransactionsTableFieldsFragment, unknown>;
export const SharedDepositTransactionsDocument = new TypedDocumentString(`
    query SharedDepositTransactions($depositId: UUID!) {
  deposit(id: $depositId) {
    id
    currency
    metadata {
      id
      transactions {
        id
        ...DepositTransactionFields
      }
    }
  }
}
    fragment DepositTransactionFields on Transaction {
  id
  eventDate
  chargeId
  amount {
    raw
    formatted
    currency
  }
  debitExchangeRates {
    aud
    cad
    eur
    gbp
    jpy
    sek
    usd
    date
  }
  eventExchangeRates {
    aud
    cad
    eur
    gbp
    jpy
    sek
    usd
    date
  }
}`) as unknown as TypedDocumentString<SharedDepositTransactionsQuery, SharedDepositTransactionsQueryVariables>;
export const BusinessLedgerInfoDocument = new TypedDocumentString(`
    query BusinessLedgerInfo($filters: BusinessTransactionsFilter) {
  businessTransactionsFromLedgerRecords(filters: $filters) {
    ... on BusinessTransactionsFromLedgerRecordsSuccessfulResult {
      businessTransactions {
        amount {
          formatted
          raw
        }
        business {
          id
          name
        }
        foreignAmount {
          formatted
          raw
          currency
        }
        invoiceDate
        reference
        details
        counterAccount {
          __typename
          id
          name
        }
        chargeId
      }
    }
    ... on CommonError {
      __typename
      message
    }
  }
}
    `) as unknown as TypedDocumentString<BusinessLedgerInfoQuery, BusinessLedgerInfoQueryVariables>;
export const BusinessLedgerRecordsSummeryDocument = new TypedDocumentString(`
    query BusinessLedgerRecordsSummery($filters: BusinessTransactionsFilter) {
  businessTransactionsSumFromLedgerRecords(filters: $filters) {
    ... on BusinessTransactionsSumFromLedgerRecordsSuccessfulResult {
      businessTransactionsSum {
        business {
          id
          name
        }
        credit {
          formatted
        }
        debit {
          formatted
        }
        total {
          formatted
          raw
        }
        foreignCurrenciesSum {
          currency
          credit {
            formatted
          }
          debit {
            formatted
          }
          total {
            formatted
            raw
          }
        }
      }
    }
    ... on CommonError {
      __typename
      message
    }
  }
}
    `) as unknown as TypedDocumentString<BusinessLedgerRecordsSummeryQuery, BusinessLedgerRecordsSummeryQueryVariables>;
export const BusinessTripScreenDocument = new TypedDocumentString(`
    query BusinessTripScreen($businessTripId: UUID!) {
  businessTrip(id: $businessTripId) {
    id
    name
    dates {
      start
    }
  }
}
    `) as unknown as TypedDocumentString<BusinessTripScreenQuery, BusinessTripScreenQueryVariables>;
export const BusinessTripsRowValidationDocument = new TypedDocumentString(`
    query BusinessTripsRowValidation($id: UUID!) {
  businessTrip(id: $id) {
    id
    uncategorizedTransactions {
      transaction {
        ... on Transaction @defer {
          id
        }
      }
    }
    summary {
      ... on BusinessTripSummary @defer {
        errors
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BusinessTripsRowValidationQuery, BusinessTripsRowValidationQueryVariables>;
export const EditableBusinessTripDocument = new TypedDocumentString(`
    query EditableBusinessTrip($businessTripId: UUID!) {
  businessTrip(id: $businessTripId) {
    id
    ...BusinessTripReportHeaderFields
    ...BusinessTripReportAttendeesFields
    ...BusinessTripUncategorizedTransactionsFields
    ...BusinessTripReportFlightsFields
    ...BusinessTripReportAccommodationsFields
    ...BusinessTripReportTravelAndSubsistenceFields
    ...BusinessTripReportCarRentalFields
    ...BusinessTripReportOtherFields
    ...BusinessTripReportSummaryFields
    ... on BusinessTrip {
      uncategorizedTransactions {
        transaction {
          id
        }
      }
    }
  }
}
    fragment BusinessTripAccountantApprovalFields on BusinessTrip {
  id
  accountantApproval
}
fragment BusinessTripReportAccommodationsRowFields on BusinessTripAccommodationExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  country {
    id
    name
  }
  nightsCount
  attendeesStay {
    id
    attendee {
      id
      name
    }
    nightsCount
  }
}
fragment BusinessTripReportAccommodationsTableFields on BusinessTripAccommodationExpense {
  id
  date
  ...BusinessTripReportAccommodationsRowFields
}
fragment BusinessTripReportAccommodationsFields on BusinessTrip {
  id
  accommodationExpenses {
    id
    ...BusinessTripReportAccommodationsTableFields
  }
}
fragment BusinessTripReportAttendeeRowFields on BusinessTripAttendee {
  id
  name
  arrivalDate
  departureDate
  flights {
    id
    ...BusinessTripReportFlightsTableFields
  }
  accommodations {
    id
    ...BusinessTripReportAccommodationsTableFields
  }
}
fragment BusinessTripReportAttendeesFields on BusinessTrip {
  id
  attendees {
    id
    name
    ...BusinessTripReportAttendeeRowFields
  }
}
fragment BusinessTripReportCarRentalRowFields on BusinessTripCarRentalExpense {
  id
  payedByEmployee
  ...BusinessTripReportCoreExpenseRowFields
  days
  isFuelExpense
}
fragment BusinessTripReportCarRentalFields on BusinessTrip {
  id
  carRentalExpenses {
    id
    date
    ...BusinessTripReportCarRentalRowFields
  }
}
fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}
fragment BusinessTripReportFlightsRowFields on BusinessTripFlightExpense {
  id
  payedByEmployee
  ...BusinessTripReportCoreExpenseRowFields
  path
  class
  attendees {
    id
    name
  }
}
fragment BusinessTripReportFlightsTableFields on BusinessTripFlightExpense {
  id
  date
  ...BusinessTripReportFlightsRowFields
}
fragment BusinessTripReportFlightsFields on BusinessTrip {
  id
  flightExpenses {
    id
    ...BusinessTripReportFlightsTableFields
  }
  attendees {
    id
    name
  }
}
fragment BusinessTripReportOtherRowFields on BusinessTripOtherExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  description
  deductibleExpense
}
fragment BusinessTripReportOtherFields on BusinessTrip {
  id
  otherExpenses {
    id
    date
    ...BusinessTripReportOtherRowFields
  }
}
fragment BusinessTripReportHeaderFields on BusinessTrip {
  id
  name
  dates {
    start
    end
  }
  purpose
  destination {
    id
    name
  }
  ...BusinessTripAccountantApprovalFields
}
fragment BusinessTripReportSummaryFields on BusinessTrip {
  id
  ... on BusinessTrip @defer {
    summary {
      excessExpenditure {
        formatted
      }
      excessTax
      rows {
        type
        totalForeignCurrency {
          formatted
        }
        totalLocalCurrency {
          formatted
        }
        taxableForeignCurrency {
          formatted
        }
        taxableLocalCurrency {
          formatted
        }
        maxTaxableForeignCurrency {
          formatted
        }
        maxTaxableLocalCurrency {
          formatted
        }
        excessExpenditure {
          formatted
        }
      }
      errors
    }
  }
}
fragment BusinessTripReportTravelAndSubsistenceRowFields on BusinessTripTravelAndSubsistenceExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  expenseType
}
fragment BusinessTripReportTravelAndSubsistenceFields on BusinessTrip {
  id
  travelAndSubsistenceExpenses {
    id
    date
    ...BusinessTripReportTravelAndSubsistenceRowFields
  }
}
fragment BusinessTripUncategorizedTransactionsFields on BusinessTrip {
  id
  uncategorizedTransactions {
    transaction {
      id
      eventDate
      chargeId
      amount {
        raw
      }
      ...TransactionsTableEventDateFields
      ...TransactionsTableDebitDateFields
      ...TransactionsTableAccountFields
      ...TransactionsTableDescriptionFields
      ...TransactionsTableSourceIDFields
      ...TransactionsTableEntityFields
    }
    ...UncategorizedTransactionsTableAmountFields
  }
}
fragment UncategorizedTransactionsTableAmountFields on UncategorizedTransaction {
  transaction {
    id
    amount {
      raw
      formatted
    }
    cryptoExchangeRate {
      rate
    }
  }
  categorizedAmount {
    raw
    formatted
  }
  errors
}
fragment TransactionsTableAccountFields on Transaction {
  id
  account {
    id
    name
    type
  }
}
fragment TransactionsTableEntityFields on Transaction {
  id
  counterparty {
    name
    id
  }
  sourceDescription
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}
fragment TransactionsTableDebitDateFields on Transaction {
  id
  effectiveDate
  sourceEffectiveDate
}
fragment TransactionsTableDescriptionFields on Transaction {
  id
  sourceDescription
}
fragment TransactionsTableEventDateFields on Transaction {
  id
  eventDate
}
fragment TransactionsTableSourceIDFields on Transaction {
  id
  referenceKey
}`) as unknown as TypedDocumentString<EditableBusinessTripQuery, EditableBusinessTripQueryVariables>;
export const BusinessTripsScreenDocument = new TypedDocumentString(`
    query BusinessTripsScreen {
  allBusinessTrips {
    id
    name
    dates {
      start
    }
    ...BusinessTripsRowFields
  }
}
    fragment BusinessTripsRowFields on BusinessTrip {
  id
  name
  accountantApproval
}`) as unknown as TypedDocumentString<BusinessTripsScreenQuery, BusinessTripsScreenQueryVariables>;
export const AdminFinancialAccountsSectionDocument = new TypedDocumentString(`
    query AdminFinancialAccountsSection($adminId: UUID!) {
  financialAccountsByOwner(ownerId: $adminId) {
    id
    __typename
    name
    number
    type
    privateOrBusiness
    accountTaxCategories {
      id
      currency
      taxCategory {
        id
        name
      }
    }
    ... on BankFinancialAccount {
      bankNumber
      branchNumber
      iban
      swiftCode
      extendedBankNumber
      partyPreferredIndication
      partyAccountInvolvementCode
      accountDealDate
      accountUpdateDate
      metegDoarNet
      kodHarshaatPeilut
      accountClosingReasonCode
      accountAgreementOpeningDate
      serviceAuthorizationDesc
      branchTypeCode
      mymailEntitlementSwitch
      productLabel
    }
  }
}
    `) as unknown as TypedDocumentString<AdminFinancialAccountsSectionQuery, AdminFinancialAccountsSectionQueryVariables>;
export const BusinessChargesSectionDocument = new TypedDocumentString(`
    query BusinessChargesSection($page: Int, $limit: Int, $filters: ChargeFilter) {
  allCharges(page: $page, limit: $limit, filters: $filters) {
    nodes {
      id
      ...ChargesTableFields
    }
    pageInfo {
      totalPages
    }
  }
}
    fragment ChargesTableAccountantApprovalFields on Charge {
  id
  accountantApproval
}
fragment ChargesTableAmountFields on Charge {
  __typename
  id
  totalAmount {
    raw
    formatted
  }
  ... on CreditcardBankCharge @defer {
    validCreditCardAmount
  }
}
fragment ChargesTableBusinessTripFields on Charge {
  id
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
}
fragment ChargesTableEntityFields on Charge {
  __typename
  id
  counterparty {
    name
    id
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableDateFields on Charge {
  id
  minEventDate
  minDebitDate
  minDocumentsDate
}
fragment ChargesTableDescriptionFields on Charge {
  id
  userDescription
  ... on Charge @defer {
    validationData {
      missingInfo
    }
    missingInfoSuggestions {
      description
    }
  }
}
fragment ChargesTableMoreInfoFields on Charge {
  __typename
  id
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTagsFields on Charge {
  id
  tags {
    id
    name
    namePath
  }
  ... on Charge @defer {
    validationData {
      ... on ValidationData {
        missingInfo
      }
    }
    missingInfoSuggestions {
      ... on ChargeSuggestions {
        tags {
          id
          name
          namePath
        }
      }
    }
  }
}
fragment ChargesTableTaxCategoryFields on Charge {
  __typename
  id
  taxCategory {
    id
    name
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTypeFields on Charge {
  __typename
  id
}
fragment ChargesTableVatFields on Charge {
  __typename
  id
  vat {
    raw
    formatted
  }
  totalAmount {
    raw
    currency
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableRowFields on Charge {
  id
  __typename
  metadata {
    ... on ChargeMetadata @defer {
      documentsCount
      ledgerCount
      transactionsCount
      miscExpensesCount
    }
  }
  totalAmount {
    raw
  }
  ...ChargesTableAccountantApprovalFields
  ...ChargesTableAmountFields
  ...ChargesTableBusinessTripFields @defer
  ...ChargesTableDateFields
  ...ChargesTableDescriptionFields
  ...ChargesTableEntityFields @defer
  ...ChargesTableMoreInfoFields
  ...ChargesTableTagsFields @defer
  ...ChargesTableTaxCategoryFields @defer
  ...ChargesTableTypeFields
  ...ChargesTableVatFields
}
fragment ChargesTableFields on Charge {
  id
  owner {
    id
  }
  ...ChargesTableRowFields
}`) as unknown as TypedDocumentString<BusinessChargesSectionQuery, BusinessChargesSectionQueryVariables>;
export const ClientContractsSectionDocument = new TypedDocumentString(`
    query ClientContractsSection($clientId: UUID!) {
  contractsByClient(clientId: $clientId) {
    id
    purchaseOrders
    startDate
    endDate
    amount {
      raw
      currency
    }
    billingCycle
    isActive
    product
    documentType
    remarks
    plan
    msCloud
    operationsLimit
  }
}
    `) as unknown as TypedDocumentString<ClientContractsSectionQuery, ClientContractsSectionQueryVariables>;
export const ClientIntegrationsSectionGreenInvoiceDocument = new TypedDocumentString(`
    query ClientIntegrationsSectionGreenInvoice($clientId: UUID!) {
  greenInvoiceClient(clientId: $clientId) {
    businessId
    greenInvoiceId
    country {
      id
      name
    }
    emails
    name
    phone
    taxId
    address
    city
    zip
    fax
    mobile
  }
}
    `) as unknown as TypedDocumentString<ClientIntegrationsSectionGreenInvoiceQuery, ClientIntegrationsSectionGreenInvoiceQueryVariables>;
export const ContractBasedDocumentDraftDocument = new TypedDocumentString(`
    query ContractBasedDocumentDraft($issueMonth: TimelessDate!, $contractId: UUID!) {
  periodicalDocumentDraftsByContracts(
    issueMonth: $issueMonth
    contractIds: [$contractId]
  ) {
    ...NewDocumentDraft
  }
}
    fragment IssueDocumentClientFields on Client {
  id
  originalBusiness {
    id
    address
    city
    zipCode
    country {
      id
      code
    }
    governmentId
    name
    phoneNumber
  }
  emails
}
fragment NewDocumentDraft on DocumentDraft {
  description
  remarks
  footer
  type
  date
  dueDate
  language
  currency
  vatType
  discount {
    amount
    type
  }
  rounding
  signed
  maxPayments
  client {
    id
    originalBusiness {
      id
      name
    }
    integrations {
      id
    }
    emails
    ...IssueDocumentClientFields
  }
  income {
    currency
    currencyRate
    description
    itemId
    price
    quantity
    vatRate
    vatType
  }
  payment {
    currency
    currencyRate
    date
    price
    type
    bankName
    bankBranch
    bankAccount
    chequeNum
    accountId
    transactionId
    cardType
    cardNum
    numPayments
    firstPayment
  }
  linkedDocumentIds
  linkedPaymentId
}`) as unknown as TypedDocumentString<ContractBasedDocumentDraftQuery, ContractBasedDocumentDraftQueryVariables>;
export const BusinessLedgerSectionDocument = new TypedDocumentString(`
    query BusinessLedgerSection($businessId: UUID!) {
  ledgerRecordsByFinancialEntity(financialEntityId: $businessId) {
    id
    ...LedgerRecordsTableFields
  }
}
    fragment LedgerRecordsTableFields on LedgerRecord {
  id
  creditAccount1 {
    __typename
    id
    name
  }
  creditAccount2 {
    __typename
    id
    name
  }
  debitAccount1 {
    __typename
    id
    name
  }
  debitAccount2 {
    __typename
    id
    name
  }
  creditAmount1 {
    formatted
    currency
  }
  creditAmount2 {
    formatted
    currency
  }
  debitAmount1 {
    formatted
    currency
  }
  debitAmount2 {
    formatted
    currency
  }
  localCurrencyCreditAmount1 {
    formatted
    raw
  }
  localCurrencyCreditAmount2 {
    formatted
    raw
  }
  localCurrencyDebitAmount1 {
    formatted
    raw
  }
  localCurrencyDebitAmount2 {
    formatted
    raw
  }
  invoiceDate
  valueDate
  description
  reference
}`) as unknown as TypedDocumentString<BusinessLedgerSectionQuery, BusinessLedgerSectionQueryVariables>;
export const BusinessTransactionsSectionDocument = new TypedDocumentString(`
    query BusinessTransactionsSection($businessId: UUID!) {
  transactionsByFinancialEntity(financialEntityID: $businessId) {
    id
    ...TransactionForTransactionsTableFields
    ...TransactionToDownloadForTransactionsTableFields
  }
}
    fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}
fragment TransactionToDownloadForTransactionsTableFields on Transaction {
  id
  account {
    id
    name
    type
  }
  amount {
    currency
    raw
  }
  counterparty {
    id
    name
  }
  effectiveDate
  eventDate
  referenceKey
  sourceDescription
}`) as unknown as TypedDocumentString<BusinessTransactionsSectionQuery, BusinessTransactionsSectionQueryVariables>;
export const AllBusinessesForScreenDocument = new TypedDocumentString(`
    query AllBusinessesForScreen($page: Int, $limit: Int, $name: String) {
  allBusinesses(page: $page, limit: $limit, name: $name) {
    nodes {
      __typename
      id
      name
      ... on LtdFinancialEntity {
        ...BusinessHeader
      }
    }
    pageInfo {
      totalPages
      totalRecords
    }
  }
}
    fragment BusinessHeader on Business {
  __typename
  id
  name
  createdAt
  isActive
  ... on LtdFinancialEntity {
    governmentId
    adminInfo {
      id
    }
    clientInfo {
      id
    }
  }
}`) as unknown as TypedDocumentString<AllBusinessesForScreenQuery, AllBusinessesForScreenQueryVariables>;
export const ChargeExtendedInfoForChargeMatchesDocument = new TypedDocumentString(`
    query ChargeExtendedInfoForChargeMatches($chargeId: UUID!) {
  charge(chargeId: $chargeId) {
    id
    transactions {
      id
      ...TransactionForTransactionsTableFields
    }
    additionalDocuments {
      id
      ...TableDocumentsRowFields
    }
  }
}
    fragment TableDocumentsRowFields on Document {
  id
  documentType
  image
  file
  description
  remarks
  charge {
    id
  }
  ... on FinancialDocument {
    amount {
      raw
      formatted
      currency
    }
    missingInfoSuggestions {
      amount {
        raw
        formatted
        currency
      }
      isIncome
      counterparty {
        id
        name
      }
      owner {
        id
        name
      }
    }
    date
    vat {
      raw
      formatted
      currency
    }
    serialNumber
    allocationNumber
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    issuedDocumentInfo {
      id
      status
      originalDocument {
        income {
          description
        }
      }
    }
  }
}
fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<ChargeExtendedInfoForChargeMatchesQuery, ChargeExtendedInfoForChargeMatchesQueryVariables>;
export const ChargesLedgerValidationDocument = new TypedDocumentString(`
    query ChargesLedgerValidation($limit: Int, $filters: ChargeFilter) {
  chargesWithLedgerChanges(limit: $limit, filters: $filters) @stream {
    progress
    charge {
      id
      ...ChargesTableFields
    }
  }
}
    fragment ChargesTableAccountantApprovalFields on Charge {
  id
  accountantApproval
}
fragment ChargesTableAmountFields on Charge {
  __typename
  id
  totalAmount {
    raw
    formatted
  }
  ... on CreditcardBankCharge @defer {
    validCreditCardAmount
  }
}
fragment ChargesTableBusinessTripFields on Charge {
  id
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
}
fragment ChargesTableEntityFields on Charge {
  __typename
  id
  counterparty {
    name
    id
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableDateFields on Charge {
  id
  minEventDate
  minDebitDate
  minDocumentsDate
}
fragment ChargesTableDescriptionFields on Charge {
  id
  userDescription
  ... on Charge @defer {
    validationData {
      missingInfo
    }
    missingInfoSuggestions {
      description
    }
  }
}
fragment ChargesTableMoreInfoFields on Charge {
  __typename
  id
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTagsFields on Charge {
  id
  tags {
    id
    name
    namePath
  }
  ... on Charge @defer {
    validationData {
      ... on ValidationData {
        missingInfo
      }
    }
    missingInfoSuggestions {
      ... on ChargeSuggestions {
        tags {
          id
          name
          namePath
        }
      }
    }
  }
}
fragment ChargesTableTaxCategoryFields on Charge {
  __typename
  id
  taxCategory {
    id
    name
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTypeFields on Charge {
  __typename
  id
}
fragment ChargesTableVatFields on Charge {
  __typename
  id
  vat {
    raw
    formatted
  }
  totalAmount {
    raw
    currency
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableRowFields on Charge {
  id
  __typename
  metadata {
    ... on ChargeMetadata @defer {
      documentsCount
      ledgerCount
      transactionsCount
      miscExpensesCount
    }
  }
  totalAmount {
    raw
  }
  ...ChargesTableAccountantApprovalFields
  ...ChargesTableAmountFields
  ...ChargesTableBusinessTripFields @defer
  ...ChargesTableDateFields
  ...ChargesTableDescriptionFields
  ...ChargesTableEntityFields @defer
  ...ChargesTableMoreInfoFields
  ...ChargesTableTagsFields @defer
  ...ChargesTableTaxCategoryFields @defer
  ...ChargesTableTypeFields
  ...ChargesTableVatFields
}
fragment ChargesTableFields on Charge {
  id
  owner {
    id
  }
  ...ChargesTableRowFields
}`) as unknown as TypedDocumentString<ChargesLedgerValidationQuery, ChargesLedgerValidationQueryVariables>;
export const FetchChargeDocument = new TypedDocumentString(`
    query FetchCharge($chargeId: UUID!) {
  charge(chargeId: $chargeId) {
    __typename
    id
    metadata {
      transactionsCount
      documentsCount
      receiptsCount
      invoicesCount
      ledgerCount
      isLedgerLocked
      openDocuments
    }
    totalAmount {
      raw
    }
    ...DocumentsGalleryFields @defer
    ...TableDocumentsFields @defer
    ...ChargeLedgerRecordsTableFields @defer
    ...ChargeTableTransactionsFields @defer
    ...ConversionChargeInfo @defer
    ...CreditcardBankChargeInfo @defer
    ...TableSalariesFields @defer
    ... on BusinessTripCharge {
      businessTrip {
        id
        ... on BusinessTrip @defer {
          ...BusinessTripReportFields
        }
      }
    }
    ...ChargesTableErrorsFields @defer
    miscExpenses {
      id
    }
    ...TableMiscExpensesFields @defer
    ...ExchangeRatesInfo @defer
  }
}
    fragment ChargesTableErrorsFields on Charge {
  id
  ... on Charge @defer {
    errorsLedger: ledger {
      ... on Ledger @defer {
        validate {
          ... on LedgerValidation @defer {
            errors
          }
        }
      }
    }
  }
}
fragment TableDocumentsFields on Charge {
  id
  additionalDocuments {
    id
    ...TableDocumentsRowFields
  }
}
fragment ChargeLedgerRecordsTableFields on Charge {
  id
  ledger {
    __typename
    records {
      id
      ...LedgerRecordsTableFields
    }
    ... on Ledger @defer {
      validate {
        ... on LedgerValidation @defer {
          matches
          differences {
            id
            ...LedgerRecordsTableFields
          }
        }
      }
    }
  }
}
fragment ChargeTableTransactionsFields on Charge {
  id
  transactions {
    id
    ...TransactionForTransactionsTableFields
  }
}
fragment ConversionChargeInfo on Charge {
  id
  __typename
  ... on ConversionCharge {
    eventRate {
      from
      to
      rate
    }
    officialRate {
      from
      to
      rate
    }
  }
}
fragment CreditcardBankChargeInfo on Charge {
  id
  __typename
  ... on CreditcardBankCharge {
    creditCardTransactions {
      id
      ...TransactionForTransactionsTableFields
    }
  }
}
fragment ExchangeRatesInfo on Charge {
  id
  __typename
  ... on FinancialCharge {
    exchangeRates {
      aud
      cad
      eur
      gbp
      ils
      jpy
      sek
      usd
      eth
      grt
      usdc
    }
  }
}
fragment TableMiscExpensesFields on Charge {
  id
  miscExpenses {
    id
    amount {
      formatted
    }
    description
    invoiceDate
    valueDate
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    chargeId
    ...EditMiscExpenseFields
  }
}
fragment TableSalariesFields on Charge {
  id
  __typename
  ... on SalaryCharge {
    salaryRecords {
      directAmount {
        formatted
      }
      baseAmount {
        formatted
      }
      employee {
        id
        name
      }
      pensionFund {
        id
        name
      }
      pensionEmployeeAmount {
        formatted
      }
      pensionEmployerAmount {
        formatted
      }
      compensationsAmount {
        formatted
      }
      trainingFund {
        id
        name
      }
      trainingFundEmployeeAmount {
        formatted
      }
      trainingFundEmployerAmount {
        formatted
      }
      socialSecurityEmployeeAmount {
        formatted
      }
      socialSecurityEmployerAmount {
        formatted
      }
      incomeTaxAmount {
        formatted
      }
      healthInsuranceAmount {
        formatted
      }
    }
  }
}
fragment BusinessTripReportFields on BusinessTrip {
  id
  ...BusinessTripReportHeaderFields
  ...BusinessTripReportSummaryFields
}
fragment BusinessTripAccountantApprovalFields on BusinessTrip {
  id
  accountantApproval
}
fragment BusinessTripReportHeaderFields on BusinessTrip {
  id
  name
  dates {
    start
    end
  }
  purpose
  destination {
    id
    name
  }
  ...BusinessTripAccountantApprovalFields
}
fragment BusinessTripReportSummaryFields on BusinessTrip {
  id
  ... on BusinessTrip @defer {
    summary {
      excessExpenditure {
        formatted
      }
      excessTax
      rows {
        type
        totalForeignCurrency {
          formatted
        }
        totalLocalCurrency {
          formatted
        }
        taxableForeignCurrency {
          formatted
        }
        taxableLocalCurrency {
          formatted
        }
        maxTaxableForeignCurrency {
          formatted
        }
        maxTaxableLocalCurrency {
          formatted
        }
        excessExpenditure {
          formatted
        }
      }
      errors
    }
  }
}
fragment EditMiscExpenseFields on MiscExpense {
  id
  amount {
    raw
    currency
  }
  description
  invoiceDate
  valueDate
  creditor {
    id
  }
  debtor {
    id
  }
}
fragment TableDocumentsRowFields on Document {
  id
  documentType
  image
  file
  description
  remarks
  charge {
    id
  }
  ... on FinancialDocument {
    amount {
      raw
      formatted
      currency
    }
    missingInfoSuggestions {
      amount {
        raw
        formatted
        currency
      }
      isIncome
      counterparty {
        id
        name
      }
      owner {
        id
        name
      }
    }
    date
    vat {
      raw
      formatted
      currency
    }
    serialNumber
    allocationNumber
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    issuedDocumentInfo {
      id
      status
      originalDocument {
        income {
          description
        }
      }
    }
  }
}
fragment DocumentsGalleryFields on Charge {
  id
  additionalDocuments {
    id
    image
    ... on FinancialDocument {
      documentType
    }
  }
}
fragment LedgerRecordsTableFields on LedgerRecord {
  id
  creditAccount1 {
    __typename
    id
    name
  }
  creditAccount2 {
    __typename
    id
    name
  }
  debitAccount1 {
    __typename
    id
    name
  }
  debitAccount2 {
    __typename
    id
    name
  }
  creditAmount1 {
    formatted
    currency
  }
  creditAmount2 {
    formatted
    currency
  }
  debitAmount1 {
    formatted
    currency
  }
  debitAmount2 {
    formatted
    currency
  }
  localCurrencyCreditAmount1 {
    formatted
    raw
  }
  localCurrencyCreditAmount2 {
    formatted
    raw
  }
  localCurrencyDebitAmount1 {
    formatted
    raw
  }
  localCurrencyDebitAmount2 {
    formatted
    raw
  }
  invoiceDate
  valueDate
  description
  reference
}
fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}`, {"deferredFields":{"DocumentsGalleryFields":["id","additionalDocuments"],"TableDocumentsFields":["id","additionalDocuments"],"ChargeLedgerRecordsTableFields":["id","ledger"],"ChargeTableTransactionsFields":["id","transactions"],"ConversionChargeInfo":["id","__typename"],"CreditcardBankChargeInfo":["id","__typename"],"TableSalariesFields":["id","__typename"],"ChargesTableErrorsFields":["id"],"TableMiscExpensesFields":["id","miscExpenses"],"ExchangeRatesInfo":["id","__typename"]}}) as unknown as TypedDocumentString<FetchChargeQuery, FetchChargeQueryVariables>;
export const ChargeForRowDocument = new TypedDocumentString(`
    query ChargeForRow($chargeId: UUID!) {
  charge(chargeId: $chargeId) {
    id
    ...ChargesTableRowFields
  }
}
    fragment ChargesTableAccountantApprovalFields on Charge {
  id
  accountantApproval
}
fragment ChargesTableAmountFields on Charge {
  __typename
  id
  totalAmount {
    raw
    formatted
  }
  ... on CreditcardBankCharge @defer {
    validCreditCardAmount
  }
}
fragment ChargesTableBusinessTripFields on Charge {
  id
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
}
fragment ChargesTableEntityFields on Charge {
  __typename
  id
  counterparty {
    name
    id
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableDateFields on Charge {
  id
  minEventDate
  minDebitDate
  minDocumentsDate
}
fragment ChargesTableDescriptionFields on Charge {
  id
  userDescription
  ... on Charge @defer {
    validationData {
      missingInfo
    }
    missingInfoSuggestions {
      description
    }
  }
}
fragment ChargesTableMoreInfoFields on Charge {
  __typename
  id
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTagsFields on Charge {
  id
  tags {
    id
    name
    namePath
  }
  ... on Charge @defer {
    validationData {
      ... on ValidationData {
        missingInfo
      }
    }
    missingInfoSuggestions {
      ... on ChargeSuggestions {
        tags {
          id
          name
          namePath
        }
      }
    }
  }
}
fragment ChargesTableTaxCategoryFields on Charge {
  __typename
  id
  taxCategory {
    id
    name
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTypeFields on Charge {
  __typename
  id
}
fragment ChargesTableVatFields on Charge {
  __typename
  id
  vat {
    raw
    formatted
  }
  totalAmount {
    raw
    currency
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableRowFields on Charge {
  id
  __typename
  metadata {
    ... on ChargeMetadata @defer {
      documentsCount
      ledgerCount
      transactionsCount
      miscExpensesCount
    }
  }
  totalAmount {
    raw
  }
  ...ChargesTableAccountantApprovalFields
  ...ChargesTableAmountFields
  ...ChargesTableBusinessTripFields @defer
  ...ChargesTableDateFields
  ...ChargesTableDescriptionFields
  ...ChargesTableEntityFields @defer
  ...ChargesTableMoreInfoFields
  ...ChargesTableTagsFields @defer
  ...ChargesTableTaxCategoryFields @defer
  ...ChargesTableTypeFields
  ...ChargesTableVatFields
}`) as unknown as TypedDocumentString<ChargeForRowQuery, ChargeForRowQueryVariables>;
export const BankDepositInfoDocument = new TypedDocumentString(`
    query BankDepositInfo($chargeId: UUID!) {
  depositByCharge(chargeId: $chargeId) {
    id
    name
    metadata {
      id
      currentBalance {
        formatted
      }
      transactions {
        id
        chargeId
        ...TransactionForTransactionsTableFields
      }
    }
    isOpen
  }
}
    fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<BankDepositInfoQuery, BankDepositInfoQueryVariables>;
export const ChargeMatchesDocument = new TypedDocumentString(`
    query ChargeMatches($chargeId: UUID!) {
  findChargeMatches(chargeId: $chargeId) {
    matches {
      chargeId
      ...ChargeMatchesTableFields
    }
  }
}
    fragment ChargeMatchesTableFields on ChargeMatch {
  charge {
    id
    __typename
    minEventDate
    minDebitDate
    minDocumentsDate
    totalAmount {
      raw
      formatted
    }
    vat {
      raw
      formatted
    }
    counterparty {
      name
      id
    }
    userDescription
    tags {
      id
      name
      namePath
    }
    taxCategory {
      id
      name
    }
  }
  confidenceScore
}`) as unknown as TypedDocumentString<ChargeMatchesQuery, ChargeMatchesQueryVariables>;
export const IncomeChargesChartDocument = new TypedDocumentString(`
    query IncomeChargesChart($filters: ChargeFilter) {
  allCharges(filters: $filters) {
    nodes {
      id
      transactions {
        id
        eventDate
        effectiveDate
        amount {
          currency
          formatted
          raw
        }
        eventExchangeRates {
          aud
          cad
          eur
          gbp
          jpy
          sek
          usd
          date
        }
        debitExchangeRates {
          aud
          cad
          eur
          gbp
          jpy
          sek
          usd
          date
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IncomeChargesChartQuery, IncomeChargesChartQueryVariables>;
export const MonthlyIncomeExpenseChartDocument = new TypedDocumentString(`
    query MonthlyIncomeExpenseChart($filters: IncomeExpenseChartFilters!) {
  incomeExpenseChart(filters: $filters) {
    fromDate
    toDate
    currency
    ...MonthlyIncomeExpenseChartInfo
  }
}
    fragment MonthlyIncomeExpenseChartInfo on IncomeExpenseChart {
  monthlyData {
    income {
      formatted
      raw
    }
    expense {
      formatted
      raw
    }
    balance {
      formatted
      raw
    }
    date
  }
}`) as unknown as TypedDocumentString<MonthlyIncomeExpenseChartQuery, MonthlyIncomeExpenseChartQueryVariables>;
export const ContractsEditModalDocument = new TypedDocumentString(`
    query ContractsEditModal($contractId: UUID!) {
  contractsById(id: $contractId) {
    id
    startDate
    endDate
    purchaseOrders
    amount {
      raw
      currency
    }
    product
    msCloud
    billingCycle
    plan
    isActive
    remarks
    documentType
    operationsLimit
  }
}
    `) as unknown as TypedDocumentString<ContractsEditModalQuery, ContractsEditModalQueryVariables>;
export const UncategorizedTransactionsByBusinessTripDocument = new TypedDocumentString(`
    query UncategorizedTransactionsByBusinessTrip($businessTripId: UUID!) {
  businessTrip(id: $businessTripId) {
    id
    uncategorizedTransactions {
      transaction {
        id
        eventDate
        sourceDescription
        referenceKey
        counterparty {
          id
          name
        }
        amount {
          formatted
          raw
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UncategorizedTransactionsByBusinessTripQuery, UncategorizedTransactionsByBusinessTripQueryVariables>;
export const ChargeDepreciationDocument = new TypedDocumentString(`
    query ChargeDepreciation($chargeId: UUID!) {
  depreciationRecordsByCharge(chargeId: $chargeId) {
    id
    ...DepreciationRecordRowFields
  }
}
    fragment DepreciationRecordRowFields on DepreciationRecord {
  id
  amount {
    currency
    formatted
    raw
  }
  activationDate
  category {
    id
    name
    percentage
  }
  type
  charge {
    id
    totalAmount {
      currency
      formatted
      raw
    }
  }
}`) as unknown as TypedDocumentString<ChargeDepreciationQuery, ChargeDepreciationQueryVariables>;
export const RecentBusinessIssuedDocumentsDocument = new TypedDocumentString(`
    query RecentBusinessIssuedDocuments($businessId: UUID!, $limit: Int) {
  recentDocumentsByBusiness(businessId: $businessId, limit: $limit) {
    id
    ... on FinancialDocument {
      issuedDocumentInfo {
        id
        status
        externalId
      }
    }
    ...TableDocumentsRowFields
  }
}
    fragment TableDocumentsRowFields on Document {
  id
  documentType
  image
  file
  description
  remarks
  charge {
    id
  }
  ... on FinancialDocument {
    amount {
      raw
      formatted
      currency
    }
    missingInfoSuggestions {
      amount {
        raw
        formatted
        currency
      }
      isIncome
      counterparty {
        id
        name
      }
      owner {
        id
        name
      }
    }
    date
    vat {
      raw
      formatted
      currency
    }
    serialNumber
    allocationNumber
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    issuedDocumentInfo {
      id
      status
      originalDocument {
        income {
          description
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<RecentBusinessIssuedDocumentsQuery, RecentBusinessIssuedDocumentsQueryVariables>;
export const RecentIssuedDocumentsOfSameTypeDocument = new TypedDocumentString(`
    query RecentIssuedDocumentsOfSameType($documentType: DocumentType!) {
  recentIssuedDocumentsByType(documentType: $documentType) {
    id
    ...TableDocumentsRowFields
  }
}
    fragment TableDocumentsRowFields on Document {
  id
  documentType
  image
  file
  description
  remarks
  charge {
    id
  }
  ... on FinancialDocument {
    amount {
      raw
      formatted
      currency
    }
    missingInfoSuggestions {
      amount {
        raw
        formatted
        currency
      }
      isIncome
      counterparty {
        id
        name
      }
      owner {
        id
        name
      }
    }
    date
    vat {
      raw
      formatted
      currency
    }
    serialNumber
    allocationNumber
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    issuedDocumentInfo {
      id
      status
      originalDocument {
        income {
          description
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<RecentIssuedDocumentsOfSameTypeQuery, RecentIssuedDocumentsOfSameTypeQueryVariables>;
export const EditDocumentDocument = new TypedDocumentString(`
    query EditDocument($documentId: UUID!) {
  documentById(documentId: $documentId) {
    id
    image
    file
    documentType
    description
    remarks
    __typename
    ... on FinancialDocument {
      vat {
        raw
        currency
      }
      serialNumber
      date
      amount {
        raw
        currency
      }
      debtor {
        id
        name
      }
      creditor {
        id
        name
      }
      vatReportDateOverride
      noVatAmount
      allocationNumber
      exchangeRateOverride
    }
  }
}
    `) as unknown as TypedDocumentString<EditDocumentQuery, EditDocumentQueryVariables>;
export const EditTransactionDocument = new TypedDocumentString(`
    query EditTransaction($transactionIDs: [UUID!]!) {
  transactionsByIDs(transactionIDs: $transactionIDs) {
    id
    counterparty {
      id
      name
    }
    effectiveDate
    isFee
    account {
      type
      id
    }
  }
}
    `) as unknown as TypedDocumentString<EditTransactionQuery, EditTransactionQueryVariables>;
export const ClientInfoForDocumentIssuingDocument = new TypedDocumentString(`
    query ClientInfoForDocumentIssuing($businessId: UUID!) {
  client(businessId: $businessId) {
    id
    integrations {
      id
      greenInvoiceInfo {
        greenInvoiceId
        businessId
        name
      }
    }
    ...IssueDocumentClientFields
  }
}
    fragment IssueDocumentClientFields on Client {
  id
  originalBusiness {
    id
    address
    city
    zipCode
    country {
      id
      code
    }
    governmentId
    name
    phoneNumber
  }
  emails
}`) as unknown as TypedDocumentString<ClientInfoForDocumentIssuingQuery, ClientInfoForDocumentIssuingQueryVariables>;
export const AllBusinessTripsDocument = new TypedDocumentString(`
    query AllBusinessTrips {
  allBusinessTrips {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<AllBusinessTripsQuery, AllBusinessTripsQueryVariables>;
export const AllDepreciationCategoriesDocument = new TypedDocumentString(`
    query AllDepreciationCategories {
  depreciationCategories {
    id
    name
    percentage
  }
}
    `) as unknown as TypedDocumentString<AllDepreciationCategoriesQuery, AllDepreciationCategoriesQueryVariables>;
export const AllEmployeesByEmployerDocument = new TypedDocumentString(`
    query AllEmployeesByEmployer($employerId: UUID!) {
  employeesByEmployerId(employerId: $employerId) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<AllEmployeesByEmployerQuery, AllEmployeesByEmployerQueryVariables>;
export const AllPensionFundsDocument = new TypedDocumentString(`
    query AllPensionFunds {
  allPensionFunds {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<AllPensionFundsQuery, AllPensionFundsQueryVariables>;
export const AllTrainingFundsDocument = new TypedDocumentString(`
    query AllTrainingFunds {
  allTrainingFunds {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<AllTrainingFundsQuery, AllTrainingFundsQueryVariables>;
export const AttendeesByBusinessTripDocument = new TypedDocumentString(`
    query AttendeesByBusinessTrip($businessTripId: UUID!) {
  businessTrip(id: $businessTripId) {
    id
    attendees {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<AttendeesByBusinessTripQuery, AttendeesByBusinessTripQueryVariables>;
export const FetchMultipleBusinessesDocument = new TypedDocumentString(`
    query FetchMultipleBusinesses($businessIds: [UUID!]!) {
  businesses(ids: $businessIds) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<FetchMultipleBusinessesQuery, FetchMultipleBusinessesQueryVariables>;
export const FetchMultipleChargesDocument = new TypedDocumentString(`
    query FetchMultipleCharges($chargeIds: [UUID!]!) {
  chargesByIDs(chargeIDs: $chargeIds) {
    id
    __typename
    metadata {
      transactionsCount
      invoicesCount
    }
    owner {
      id
      name
    }
    tags {
      id
      name
      namePath
    }
    decreasedVAT
    property
    isInvoicePaymentDifferentCurrency
    userDescription
    optionalVAT
    optionalDocuments
  }
}
    `) as unknown as TypedDocumentString<FetchMultipleChargesQuery, FetchMultipleChargesQueryVariables>;
export const EditChargeDocument = new TypedDocumentString(`
    query EditCharge($chargeId: UUID!) {
  charge(chargeId: $chargeId) {
    id
    __typename
    counterparty {
      id
      name
    }
    owner {
      id
      name
    }
    property
    decreasedVAT
    isInvoicePaymentDifferentCurrency
    userDescription
    taxCategory {
      id
      name
    }
    tags {
      id
    }
    missingInfoSuggestions {
      ... on ChargeSuggestions {
        tags {
          id
        }
      }
    }
    optionalVAT
    optionalDocuments
    ... on BusinessTripCharge {
      businessTrip {
        id
        name
      }
    }
    yearsOfRelevance {
      year
      amount
    }
  }
}
    `) as unknown as TypedDocumentString<EditChargeQuery, EditChargeQueryVariables>;
export const EditSalaryRecordDocument = new TypedDocumentString(`
    query EditSalaryRecord($month: TimelessDate!, $employeeIDs: [UUID!]!) {
  salaryRecordsByDates(
    fromDate: $month
    toDate: $month
    employeeIDs: $employeeIDs
  ) {
    month
    charge {
      id
    }
    directAmount {
      raw
    }
    baseAmount {
      raw
    }
    employee {
      id
      name
    }
    employer {
      id
      name
    }
    pensionFund {
      id
      name
    }
    pensionEmployeeAmount {
      raw
    }
    pensionEmployeePercentage
    pensionEmployerAmount {
      raw
    }
    pensionEmployerPercentage
    compensationsAmount {
      raw
    }
    compensationsPercentage
    trainingFund {
      id
      name
    }
    trainingFundEmployeeAmount {
      raw
    }
    trainingFundEmployeePercentage
    trainingFundEmployerAmount {
      raw
    }
    trainingFundEmployerPercentage
    socialSecurityEmployeeAmount {
      raw
    }
    socialSecurityEmployerAmount {
      raw
    }
    incomeTaxAmount {
      raw
    }
    healthInsuranceAmount {
      raw
    }
    globalAdditionalHoursAmount {
      raw
    }
    bonus {
      raw
    }
    gift {
      raw
    }
    travelAndSubsistence {
      raw
    }
    recovery {
      raw
    }
    notionalExpense {
      raw
    }
    vacationDays {
      added
      balance
    }
    vacationTakeout {
      raw
    }
    workDays
    sicknessDays {
      balance
    }
  }
}
    `) as unknown as TypedDocumentString<EditSalaryRecordQuery, EditSalaryRecordQueryVariables>;
export const SortCodeToUpdateDocument = new TypedDocumentString(`
    query SortCodeToUpdate($key: Int!) {
  sortCode(key: $key) {
    id
    key
    name
    defaultIrsCode
  }
}
    `) as unknown as TypedDocumentString<SortCodeToUpdateQuery, SortCodeToUpdateQueryVariables>;
export const TaxCategoryToUpdateDocument = new TypedDocumentString(`
    query TaxCategoryToUpdate($id: UUID!) {
  taxCategory(id: $id) {
    id
    name
    sortCode {
      id
      key
      name
    }
    irsCode
  }
}
    `) as unknown as TypedDocumentString<TaxCategoryToUpdateQuery, TaxCategoryToUpdateQueryVariables>;
export const MiscExpenseTransactionFieldsDocument = new TypedDocumentString(`
    query MiscExpenseTransactionFields($transactionId: UUID!) {
  transactionsByIDs(transactionIDs: [$transactionId]) {
    id
    chargeId
    amount {
      raw
      currency
    }
    eventDate
    effectiveDate
    exactEffectiveDate
    counterparty {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<MiscExpenseTransactionFieldsQuery, MiscExpenseTransactionFieldsQueryVariables>;
export const NewDocumentDraftByChargeDocument = new TypedDocumentString(`
    query NewDocumentDraftByCharge($chargeId: UUID!) {
  newDocumentDraftByCharge(chargeId: $chargeId) {
    ...NewDocumentDraft
  }
}
    fragment IssueDocumentClientFields on Client {
  id
  originalBusiness {
    id
    address
    city
    zipCode
    country {
      id
      code
    }
    governmentId
    name
    phoneNumber
  }
  emails
}
fragment NewDocumentDraft on DocumentDraft {
  description
  remarks
  footer
  type
  date
  dueDate
  language
  currency
  vatType
  discount {
    amount
    type
  }
  rounding
  signed
  maxPayments
  client {
    id
    originalBusiness {
      id
      name
    }
    integrations {
      id
    }
    emails
    ...IssueDocumentClientFields
  }
  income {
    currency
    currencyRate
    description
    itemId
    price
    quantity
    vatRate
    vatType
  }
  payment {
    currency
    currencyRate
    date
    price
    type
    bankName
    bankBranch
    bankAccount
    chequeNum
    accountId
    transactionId
    cardType
    cardNum
    numPayments
    firstPayment
  }
  linkedDocumentIds
  linkedPaymentId
}`) as unknown as TypedDocumentString<NewDocumentDraftByChargeQuery, NewDocumentDraftByChargeQueryVariables>;
export const NewDocumentDraftByDocumentDocument = new TypedDocumentString(`
    query NewDocumentDraftByDocument($documentId: UUID!) {
  newDocumentDraftByDocument(documentId: $documentId) {
    ...NewDocumentDraft
  }
}
    fragment IssueDocumentClientFields on Client {
  id
  originalBusiness {
    id
    address
    city
    zipCode
    country {
      id
      code
    }
    governmentId
    name
    phoneNumber
  }
  emails
}
fragment NewDocumentDraft on DocumentDraft {
  description
  remarks
  footer
  type
  date
  dueDate
  language
  currency
  vatType
  discount {
    amount
    type
  }
  rounding
  signed
  maxPayments
  client {
    id
    originalBusiness {
      id
      name
    }
    integrations {
      id
    }
    emails
    ...IssueDocumentClientFields
  }
  income {
    currency
    currencyRate
    description
    itemId
    price
    quantity
    vatRate
    vatType
  }
  payment {
    currency
    currencyRate
    date
    price
    type
    bankName
    bankBranch
    bankAccount
    chequeNum
    accountId
    transactionId
    cardType
    cardNum
    numPayments
    firstPayment
  }
  linkedDocumentIds
  linkedPaymentId
}`) as unknown as TypedDocumentString<NewDocumentDraftByDocumentQuery, NewDocumentDraftByDocumentQueryVariables>;
export const SimilarChargesByBusinessDocument = new TypedDocumentString(`
    query SimilarChargesByBusiness($businessId: UUID!, $tagsDifferentThan: [String!], $descriptionDifferentThan: String) {
  similarChargesByBusiness(
    businessId: $businessId
    tagsDifferentThan: $tagsDifferentThan
    descriptionDifferentThan: $descriptionDifferentThan
  ) {
    id
    ...SimilarChargesTable
  }
}
    fragment SimilarChargesTable on Charge {
  id
  __typename
  counterparty {
    name
    id
  }
  minEventDate
  minDebitDate
  minDocumentsDate
  totalAmount {
    raw
    formatted
  }
  vat {
    raw
    formatted
  }
  userDescription
  tags {
    id
    name
  }
  taxCategory {
    id
    name
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
  }
}`) as unknown as TypedDocumentString<SimilarChargesByBusinessQuery, SimilarChargesByBusinessQueryVariables>;
export const SimilarChargesDocument = new TypedDocumentString(`
    query SimilarCharges($chargeId: UUID!, $withMissingTags: Boolean!, $withMissingDescription: Boolean!, $tagsDifferentThan: [String!], $descriptionDifferentThan: String) {
  similarCharges(
    chargeId: $chargeId
    withMissingTags: $withMissingTags
    withMissingDescription: $withMissingDescription
    tagsDifferentThan: $tagsDifferentThan
    descriptionDifferentThan: $descriptionDifferentThan
  ) {
    id
    ...SimilarChargesTable
  }
}
    fragment SimilarChargesTable on Charge {
  id
  __typename
  counterparty {
    name
    id
  }
  minEventDate
  minDebitDate
  minDocumentsDate
  totalAmount {
    raw
    formatted
  }
  vat {
    raw
    formatted
  }
  userDescription
  tags {
    id
    name
  }
  taxCategory {
    id
    name
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
  }
}`) as unknown as TypedDocumentString<SimilarChargesQuery, SimilarChargesQueryVariables>;
export const SimilarTransactionsDocument = new TypedDocumentString(`
    query SimilarTransactions($transactionId: UUID!, $withMissingInfo: Boolean!) {
  similarTransactions(
    transactionId: $transactionId
    withMissingInfo: $withMissingInfo
  ) {
    id
    account {
      id
      name
      type
    }
    amount {
      formatted
      raw
    }
    effectiveDate
    eventDate
    sourceDescription
  }
}
    `) as unknown as TypedDocumentString<SimilarTransactionsQuery, SimilarTransactionsQueryVariables>;
export const UniformFormatDocument = new TypedDocumentString(`
    query UniformFormat($fromDate: TimelessDate!, $toDate: TimelessDate!) {
  uniformFormat(fromDate: $fromDate, toDate: $toDate) {
    bkmvdata
    ini
  }
}
    `) as unknown as TypedDocumentString<UniformFormatQuery, UniformFormatQueryVariables>;
export const ContractBasedDocumentDraftsDocument = new TypedDocumentString(`
    query ContractBasedDocumentDrafts($issueMonth: TimelessDate!, $contractIds: [UUID!]!) {
  periodicalDocumentDraftsByContracts(
    issueMonth: $issueMonth
    contractIds: $contractIds
  ) {
    ...NewDocumentDraft
  }
}
    fragment IssueDocumentClientFields on Client {
  id
  originalBusiness {
    id
    address
    city
    zipCode
    country {
      id
      code
    }
    governmentId
    name
    phoneNumber
  }
  emails
}
fragment NewDocumentDraft on DocumentDraft {
  description
  remarks
  footer
  type
  date
  dueDate
  language
  currency
  vatType
  discount {
    amount
    type
  }
  rounding
  signed
  maxPayments
  client {
    id
    originalBusiness {
      id
      name
    }
    integrations {
      id
    }
    emails
    ...IssueDocumentClientFields
  }
  income {
    currency
    currencyRate
    description
    itemId
    price
    quantity
    vatRate
    vatType
  }
  payment {
    currency
    currencyRate
    date
    price
    type
    bankName
    bankBranch
    bankAccount
    chequeNum
    accountId
    transactionId
    cardType
    cardNum
    numPayments
    firstPayment
  }
  linkedDocumentIds
  linkedPaymentId
}`) as unknown as TypedDocumentString<ContractBasedDocumentDraftsQuery, ContractBasedDocumentDraftsQueryVariables>;
export const AccountantApprovalsChargesTableDocument = new TypedDocumentString(`
    query AccountantApprovalsChargesTable($page: Int, $limit: Int, $filters: ChargeFilter) {
  allCharges(page: $page, limit: $limit, filters: $filters) {
    nodes {
      id
      accountantApproval
    }
  }
}
    `) as unknown as TypedDocumentString<AccountantApprovalsChargesTableQuery, AccountantApprovalsChargesTableQueryVariables>;
export const CorporateTaxRulingComplianceReportDocument = new TypedDocumentString(`
    query CorporateTaxRulingComplianceReport($years: [Int!]!) {
  corporateTaxRulingComplianceReport(years: $years) {
    id
    year
    totalIncome {
      formatted
      raw
      currency
    }
    researchAndDevelopmentExpenses {
      formatted
      raw
      currency
    }
    rndRelativeToIncome {
      rule
      ...CorporateTaxRulingReportRuleCellFields
    }
    localDevelopmentExpenses {
      formatted
      raw
      currency
    }
    localDevelopmentRelativeToRnd {
      rule
      ...CorporateTaxRulingReportRuleCellFields
    }
    foreignDevelopmentExpenses {
      formatted
      raw
      currency
    }
    foreignDevelopmentRelativeToRnd {
      rule
      ...CorporateTaxRulingReportRuleCellFields
    }
    businessTripRndExpenses {
      formatted
      raw
      currency
    }
    ... on CorporateTaxRulingComplianceReport @defer {
      differences {
        id
        totalIncome {
          formatted
          raw
          currency
        }
        researchAndDevelopmentExpenses {
          formatted
          raw
          currency
        }
        rndRelativeToIncome {
          ...CorporateTaxRulingReportRuleCellFields
        }
        localDevelopmentExpenses {
          formatted
          raw
          currency
        }
        localDevelopmentRelativeToRnd {
          ...CorporateTaxRulingReportRuleCellFields
        }
        foreignDevelopmentExpenses {
          formatted
          raw
          currency
        }
        foreignDevelopmentRelativeToRnd {
          ...CorporateTaxRulingReportRuleCellFields
        }
        businessTripRndExpenses {
          formatted
          raw
          currency
        }
      }
    }
  }
}
    fragment CorporateTaxRulingReportRuleCellFields on CorporateTaxRule {
  id
  rule
  percentage {
    formatted
  }
  isCompliant
}`) as unknown as TypedDocumentString<CorporateTaxRulingComplianceReportQuery, CorporateTaxRulingComplianceReportQueryVariables>;
export const AllDynamicReportsDocument = new TypedDocumentString(`
    query AllDynamicReports {
  allDynamicReports {
    id
    name
    isLocked
    updated
  }
}
    `) as unknown as TypedDocumentString<AllDynamicReportsQuery, AllDynamicReportsQueryVariables>;
export const DynamicReportDocument = new TypedDocumentString(`
    query DynamicReport($filters: BusinessTransactionsFilter) {
  businessTransactionsSumFromLedgerRecords(filters: $filters) {
    __typename
    ... on BusinessTransactionsSumFromLedgerRecordsSuccessfulResult {
      businessTransactionsSum {
        business {
          id
          name
          sortCode {
            id
            key
            name
          }
        }
        credit {
          formatted
          raw
        }
        debit {
          formatted
          raw
        }
        total {
          formatted
          raw
        }
      }
    }
    ... on CommonError {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<DynamicReportQuery, DynamicReportQueryVariables>;
export const DynamicReportTemplateDocument = new TypedDocumentString(`
    query DynamicReportTemplate($name: String!) {
  dynamicReport(name: $name) {
    id
    name
    isLocked
    updated
    template {
      id
      parent
      text
      droppable
      data {
        nodeType
        isOpen
        hebrewText
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DynamicReportTemplateQuery, DynamicReportTemplateQueryVariables>;
export const ProfitAndLossReportDocument = new TypedDocumentString(`
    query ProfitAndLossReport($reportYear: Int!, $referenceYears: [Int!]!) {
  profitAndLossReport(reportYear: $reportYear, referenceYears: $referenceYears) {
    id
    report {
      id
      year
      revenue {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      costOfSales {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      grossProfit {
        formatted
      }
      researchAndDevelopmentExpenses {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      marketingExpenses {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      managementAndGeneralExpenses {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      operatingProfit {
        formatted
      }
      financialExpenses {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      otherIncome {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      profitBeforeTax {
        formatted
      }
      tax {
        formatted
      }
      netProfit {
        formatted
      }
    }
    reference {
      id
      year
      revenue {
        amount {
          formatted
        }
      }
      costOfSales {
        amount {
          formatted
        }
      }
      grossProfit {
        formatted
      }
      researchAndDevelopmentExpenses {
        amount {
          formatted
        }
      }
      marketingExpenses {
        amount {
          formatted
        }
      }
      managementAndGeneralExpenses {
        amount {
          formatted
        }
      }
      operatingProfit {
        formatted
      }
      financialExpenses {
        amount {
          formatted
        }
      }
      otherIncome {
        amount {
          formatted
        }
      }
      profitBeforeTax {
        formatted
      }
      tax {
        formatted
      }
      netProfit {
        formatted
      }
    }
  }
}
    fragment ReportCommentaryTableFields on ReportCommentary {
  records {
    sortCode {
      id
      key
      name
    }
    amount {
      formatted
    }
    records {
      ...ReportSubCommentaryTableFields
    }
  }
}
fragment ReportSubCommentaryTableFields on ReportCommentarySubRecord {
  financialEntity {
    id
    name
  }
  amount {
    formatted
  }
}`) as unknown as TypedDocumentString<ProfitAndLossReportQuery, ProfitAndLossReportQueryVariables>;
export const TaxReportDocument = new TypedDocumentString(`
    query TaxReport($reportYear: Int!, $referenceYears: [Int!]!) {
  taxReport(reportYear: $reportYear, referenceYears: $referenceYears) {
    id
    report {
      id
      year
      profitBeforeTax {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      researchAndDevelopmentExpensesByRecords {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      researchAndDevelopmentExpensesForTax {
        formatted
      }
      fines {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      untaxableGifts {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      businessTripsExcessExpensesAmount {
        formatted
      }
      salaryExcessExpensesAmount {
        formatted
      }
      reserves {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      nontaxableLinkage {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      taxableIncome {
        formatted
      }
      taxRate
      specialTaxableIncome {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      specialTaxRate
      annualTaxExpense {
        formatted
      }
    }
    reference {
      id
      year
      profitBeforeTax {
        amount {
          formatted
        }
      }
      researchAndDevelopmentExpensesByRecords {
        amount {
          formatted
        }
      }
      researchAndDevelopmentExpensesForTax {
        formatted
      }
      fines {
        amount {
          formatted
        }
      }
      untaxableGifts {
        amount {
          formatted
        }
      }
      businessTripsExcessExpensesAmount {
        formatted
      }
      salaryExcessExpensesAmount {
        formatted
      }
      reserves {
        amount {
          formatted
        }
      }
      nontaxableLinkage {
        amount {
          formatted
        }
      }
      taxableIncome {
        formatted
      }
      taxRate
      specialTaxableIncome {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      specialTaxRate
      annualTaxExpense {
        formatted
      }
    }
  }
}
    fragment ReportCommentaryTableFields on ReportCommentary {
  records {
    sortCode {
      id
      key
      name
    }
    amount {
      formatted
    }
    records {
      ...ReportSubCommentaryTableFields
    }
  }
}
fragment ReportSubCommentaryTableFields on ReportCommentarySubRecord {
  financialEntity {
    id
    name
  }
  amount {
    formatted
  }
}`) as unknown as TypedDocumentString<TaxReportQuery, TaxReportQueryVariables>;
export const TrialBalanceReportDocument = new TypedDocumentString(`
    query TrialBalanceReport($filters: BusinessTransactionsFilter) {
  businessTransactionsSumFromLedgerRecords(filters: $filters) {
    ... on BusinessTransactionsSumFromLedgerRecordsSuccessfulResult {
      ...TrialBalanceTableFields
    }
    ... on CommonError {
      __typename
    }
  }
}
    fragment TrialBalanceTableFields on BusinessTransactionsSumFromLedgerRecordsSuccessfulResult {
  businessTransactionsSum {
    business {
      id
      name
      sortCode {
        id
        key
        name
      }
    }
    credit {
      formatted
      raw
    }
    debit {
      formatted
      raw
    }
    total {
      formatted
      raw
    }
  }
}`) as unknown as TypedDocumentString<TrialBalanceReportQuery, TrialBalanceReportQueryVariables>;
export const ValidatePcn874ReportsDocument = new TypedDocumentString(`
    query ValidatePcn874Reports($businessId: UUID, $fromMonthDate: TimelessDate!, $toMonthDate: TimelessDate!) {
  pcnByDate(
    businessId: $businessId
    fromMonthDate: $fromMonthDate
    toMonthDate: $toMonthDate
  ) @stream {
    id
    business {
      id
      name
    }
    date
    content
    diffContent
  }
}
    `) as unknown as TypedDocumentString<ValidatePcn874ReportsQuery, ValidatePcn874ReportsQueryVariables>;
export const VatMonthlyReportDocument = new TypedDocumentString(`
    query VatMonthlyReport($filters: VatReportFilter) {
  vatReport(filters: $filters) {
    ...VatReportSummaryFields
    ...VatReportIncomeFields
    ...VatReportExpensesFields
    ...VatReportMissingInfoFields
    ...VatReportMiscTableFields
    ...VatReportBusinessTripsFields
  }
}
    fragment ChargesTableAccountantApprovalFields on Charge {
  id
  accountantApproval
}
fragment ChargesTableAmountFields on Charge {
  __typename
  id
  totalAmount {
    raw
    formatted
  }
  ... on CreditcardBankCharge @defer {
    validCreditCardAmount
  }
}
fragment ChargesTableBusinessTripFields on Charge {
  id
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
}
fragment ChargesTableEntityFields on Charge {
  __typename
  id
  counterparty {
    name
    id
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableDateFields on Charge {
  id
  minEventDate
  minDebitDate
  minDocumentsDate
}
fragment ChargesTableDescriptionFields on Charge {
  id
  userDescription
  ... on Charge @defer {
    validationData {
      missingInfo
    }
    missingInfoSuggestions {
      description
    }
  }
}
fragment ChargesTableMoreInfoFields on Charge {
  __typename
  id
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTagsFields on Charge {
  id
  tags {
    id
    name
    namePath
  }
  ... on Charge @defer {
    validationData {
      ... on ValidationData {
        missingInfo
      }
    }
    missingInfoSuggestions {
      ... on ChargeSuggestions {
        tags {
          id
          name
          namePath
        }
      }
    }
  }
}
fragment ChargesTableTaxCategoryFields on Charge {
  __typename
  id
  taxCategory {
    id
    name
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTypeFields on Charge {
  __typename
  id
}
fragment ChargesTableVatFields on Charge {
  __typename
  id
  vat {
    raw
    formatted
  }
  totalAmount {
    raw
    currency
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableRowFields on Charge {
  id
  __typename
  metadata {
    ... on ChargeMetadata @defer {
      documentsCount
      ledgerCount
      transactionsCount
      miscExpensesCount
    }
  }
  totalAmount {
    raw
  }
  ...ChargesTableAccountantApprovalFields
  ...ChargesTableAmountFields
  ...ChargesTableBusinessTripFields @defer
  ...ChargesTableDateFields
  ...ChargesTableDescriptionFields
  ...ChargesTableEntityFields @defer
  ...ChargesTableMoreInfoFields
  ...ChargesTableTagsFields @defer
  ...ChargesTableTaxCategoryFields @defer
  ...ChargesTableTypeFields
  ...ChargesTableVatFields
}
fragment ChargesTableFields on Charge {
  id
  owner {
    id
  }
  ...ChargesTableRowFields
}
fragment VatReportBusinessTripsFields on VatReportResult {
  businessTrips {
    id
    ...ChargesTableFields
  }
}
fragment VatReportAccountantApprovalFields on VatReportRecord {
  chargeId
  chargeAccountantStatus
}
fragment VatReportExpensesRowFields on VatReportRecord {
  ...VatReportAccountantApprovalFields
  business {
    id
    name
  }
  vatNumber
  image
  allocationNumber
  documentSerial
  documentDate
  chargeDate
  chargeId
  amount {
    formatted
    raw
  }
  localAmount {
    formatted
    raw
  }
  localVat {
    formatted
    raw
  }
  foreignVatAfterDeduction {
    formatted
    raw
  }
  localVatAfterDeduction {
    formatted
    raw
  }
  roundedLocalVatAfterDeduction {
    formatted
    raw
  }
  taxReducedLocalAmount {
    formatted
    raw
  }
  recordType
}
fragment VatReportExpensesFields on VatReportResult {
  expenses {
    ...VatReportExpensesRowFields
    roundedLocalVatAfterDeduction {
      raw
    }
    taxReducedLocalAmount {
      raw
    }
    recordType
  }
}
fragment VatReportIncomeRowFields on VatReportRecord {
  ...VatReportAccountantApprovalFields
  chargeId
  business {
    id
    name
  }
  vatNumber
  image
  allocationNumber
  documentSerial
  documentDate
  chargeDate
  taxReducedForeignAmount {
    formatted
    raw
  }
  taxReducedLocalAmount {
    formatted
    raw
  }
  recordType
}
fragment VatReportIncomeFields on VatReportResult {
  income {
    ...VatReportIncomeRowFields
    taxReducedLocalAmount {
      raw
    }
    recordType
  }
}
fragment VatReportMiscTableFields on VatReportResult {
  differentMonthDoc {
    id
    ...ChargesTableFields
  }
}
fragment VatReportMissingInfoFields on VatReportResult {
  missingInfo {
    id
    ...ChargesTableFields
  }
}
fragment VatReportSummaryFields on VatReportResult {
  expenses {
    roundedLocalVatAfterDeduction {
      raw
    }
    taxReducedLocalAmount {
      raw
    }
    recordType
    isProperty
  }
  income {
    roundedLocalVatAfterDeduction {
      raw
    }
    taxReducedLocalAmount {
      raw
    }
    recordType
  }
}`) as unknown as TypedDocumentString<VatMonthlyReportQuery, VatMonthlyReportQueryVariables>;
export const GeneratePcnDocument = new TypedDocumentString(`
    query GeneratePCN($monthDate: TimelessDate!, $financialEntityId: UUID!) {
  pcnFile(monthDate: $monthDate, financialEntityId: $financialEntityId) {
    reportContent
    fileName
  }
}
    `) as unknown as TypedDocumentString<GeneratePcnQuery, GeneratePcnQueryVariables>;
export const YearlyLedgerDocument = new TypedDocumentString(`
    query YearlyLedger($year: Int!) {
  yearlyLedgerReport(year: $year) {
    id
    year
    financialEntitiesInfo {
      entity {
        id
        name
        sortCode {
          id
          key
        }
      }
      openingBalance {
        raw
      }
      totalCredit {
        raw
      }
      totalDebit {
        raw
      }
      closingBalance {
        raw
      }
      records {
        id
        amount {
          raw
          formatted
        }
        invoiceDate
        valueDate
        description
        reference
        counterParty {
          id
          name
        }
        balance
      }
    }
    ...LedgerCsvFields
  }
}
    fragment LedgerCsvFields on YearlyLedgerReport {
  id
  year
  financialEntitiesInfo {
    entity {
      id
      name
      sortCode {
        id
        key
      }
    }
    openingBalance {
      raw
    }
    totalCredit {
      raw
    }
    totalDebit {
      raw
    }
    closingBalance {
      raw
    }
    records {
      id
      amount {
        raw
        formatted
      }
      invoiceDate
      valueDate
      description
      reference
      counterParty {
        id
        name
      }
      balance
    }
  }
}`) as unknown as TypedDocumentString<YearlyLedgerQuery, YearlyLedgerQueryVariables>;
export const SalaryScreenRecordsDocument = new TypedDocumentString(`
    query SalaryScreenRecords($fromDate: TimelessDate!, $toDate: TimelessDate!, $employeeIDs: [UUID!]) {
  salaryRecordsByDates(
    fromDate: $fromDate
    toDate: $toDate
    employeeIDs: $employeeIDs
  ) {
    month
    employee {
      id
    }
    ...SalariesTableFields
  }
}
    fragment SalariesRecordEmployeeFields on Salary {
  month
  employee {
    id
    name
  }
}
fragment SalariesRecordFundsFields on Salary {
  month
  employee {
    id
  }
  pensionFund {
    id
    name
  }
  pensionEmployeeAmount {
    formatted
    raw
  }
  pensionEmployeePercentage
  pensionEmployerAmount {
    formatted
    raw
  }
  pensionEmployerPercentage
  compensationsAmount {
    formatted
    raw
  }
  compensationsPercentage
  trainingFund {
    id
    name
  }
  trainingFundEmployeeAmount {
    formatted
    raw
  }
  trainingFundEmployeePercentage
  trainingFundEmployerAmount {
    formatted
    raw
  }
  trainingFundEmployerPercentage
}
fragment SalariesRecordInsurancesAndTaxesFields on Salary {
  month
  employee {
    id
  }
  healthInsuranceAmount {
    formatted
    raw
  }
  socialSecurityEmployeeAmount {
    formatted
    raw
  }
  socialSecurityEmployerAmount {
    formatted
    raw
  }
  incomeTaxAmount {
    formatted
    raw
  }
  notionalExpense {
    formatted
    raw
  }
}
fragment SalariesRecordMainSalaryFields on Salary {
  month
  employee {
    id
  }
  baseAmount {
    formatted
  }
  directAmount {
    formatted
  }
  globalAdditionalHoursAmount {
    formatted
  }
  bonus {
    formatted
    raw
  }
  gift {
    formatted
    raw
  }
  recovery {
    formatted
    raw
  }
  vacationTakeout {
    formatted
    raw
  }
}
fragment SalariesRecordWorkFrameFields on Salary {
  month
  employee {
    id
  }
  vacationDays {
    added
    taken
    balance
  }
  workDays
  sicknessDays {
    balance
  }
}
fragment SalariesMonthFields on Salary {
  month
  employee {
    id
  }
  ...SalariesRecordFields
}
fragment SalariesTableFields on Salary {
  month
  employee {
    id
  }
  ...SalariesMonthFields
}
fragment SalariesRecordFields on Salary {
  month
  employee {
    id
  }
  ...SalariesRecordEmployeeFields
  ...SalariesRecordMainSalaryFields
  ...SalariesRecordFundsFields
  ...SalariesRecordInsurancesAndTaxesFields
  ...SalariesRecordWorkFrameFields
}`) as unknown as TypedDocumentString<SalaryScreenRecordsQuery, SalaryScreenRecordsQueryVariables>;
export const AllDepositsDocument = new TypedDocumentString(`
    query AllDeposits {
  allDeposits {
    id
    name
    currency
    openDate
    closeDate
    isOpen
    metadata {
      id
      currentBalance {
        raw
        formatted
      }
      totalDeposit {
        raw
        formatted
      }
      totalInterest {
        raw
        formatted
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AllDepositsQuery, AllDepositsQueryVariables>;
export const BusinessScreenDocument = new TypedDocumentString(`
    query BusinessScreen($businessId: UUID!) {
  business(id: $businessId) {
    id
    ...BusinessPage
  }
}
    fragment BusinessAdminSection on Business {
  id
  ... on LtdFinancialEntity {
    adminInfo {
      id
      registrationDate
      withholdingTaxAnnualIds {
        id
        year
      }
      withholdingTaxCompanyId
      socialSecurityEmployerIds {
        id
        year
      }
      socialSecurityDeductionsId
      taxAdvancesAnnualIds {
        id
        year
      }
      taxAdvancesRates {
        date
        rate
      }
    }
  }
}
fragment BusinessHeader on Business {
  __typename
  id
  name
  createdAt
  isActive
  ... on LtdFinancialEntity {
    governmentId
    adminInfo {
      id
    }
    clientInfo {
      id
    }
  }
}
fragment ClientIntegrationsSection on LtdFinancialEntity {
  id
  clientInfo {
    id
    integrations {
      id
      greenInvoiceInfo {
        businessId
        greenInvoiceId
      }
      hiveId
      linearId
      slackChannelKey
      notionId
      workflowyUrl
    }
  }
}
fragment BusinessConfigurationSection on Business {
  __typename
  id
  pcn874RecordType
  irsCode
  isActive
  ... on LtdFinancialEntity {
    optionalVAT
    exemptDealer
    isReceiptEnough
    isDocumentsOptional
    sortCode {
      id
      key
      defaultIrsCode
    }
    taxCategory {
      id
    }
    suggestions {
      phrases
      emails
      tags {
        id
      }
      description
      emailListener {
        internalEmailLinks
        emailBody
        attachments
      }
    }
    clientInfo {
      id
    }
  }
}
fragment BusinessContactSection on Business {
  __typename
  id
  ... on LtdFinancialEntity {
    name
    hebrewName
    country {
      id
      code
    }
    governmentId
    address
    city
    zipCode
    email
    phoneNumber
    website
    clientInfo {
      id
      emails
    }
  }
}
fragment BusinessPage on Business {
  id
  ... on LtdFinancialEntity {
    clientInfo {
      id
    }
    adminInfo {
      id
    }
  }
  ...ClientIntegrationsSection
  ...BusinessHeader
  ...BusinessContactSection
  ...BusinessConfigurationSection
  ...BusinessAdminSection
}`) as unknown as TypedDocumentString<BusinessScreenQuery, BusinessScreenQueryVariables>;
export const ContractsScreenDocument = new TypedDocumentString(`
    query ContractsScreen($adminId: UUID!) {
  contractsByAdmin(adminId: $adminId) {
    id
    ...ContractForContractsTableFields
  }
}
    fragment ContractForContractsTableFields on Contract {
  id
  isActive
  client {
    id
    originalBusiness {
      id
      name
    }
  }
  purchaseOrders
  startDate
  endDate
  amount {
    raw
    formatted
  }
  billingCycle
  product
  plan
  operationsLimit
  msCloud
}`) as unknown as TypedDocumentString<ContractsScreenQuery, ContractsScreenQueryVariables>;
export const AllChargesDocument = new TypedDocumentString(`
    query AllCharges($page: Int, $limit: Int, $filters: ChargeFilter) {
  allCharges(page: $page, limit: $limit, filters: $filters) {
    nodes {
      id
      ...ChargesTableFields
    }
    pageInfo {
      totalPages
    }
  }
}
    fragment ChargesTableAccountantApprovalFields on Charge {
  id
  accountantApproval
}
fragment ChargesTableAmountFields on Charge {
  __typename
  id
  totalAmount {
    raw
    formatted
  }
  ... on CreditcardBankCharge @defer {
    validCreditCardAmount
  }
}
fragment ChargesTableBusinessTripFields on Charge {
  id
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
}
fragment ChargesTableEntityFields on Charge {
  __typename
  id
  counterparty {
    name
    id
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableDateFields on Charge {
  id
  minEventDate
  minDebitDate
  minDocumentsDate
}
fragment ChargesTableDescriptionFields on Charge {
  id
  userDescription
  ... on Charge @defer {
    validationData {
      missingInfo
    }
    missingInfoSuggestions {
      description
    }
  }
}
fragment ChargesTableMoreInfoFields on Charge {
  __typename
  id
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTagsFields on Charge {
  id
  tags {
    id
    name
    namePath
  }
  ... on Charge @defer {
    validationData {
      ... on ValidationData {
        missingInfo
      }
    }
    missingInfoSuggestions {
      ... on ChargeSuggestions {
        tags {
          id
          name
          namePath
        }
      }
    }
  }
}
fragment ChargesTableTaxCategoryFields on Charge {
  __typename
  id
  taxCategory {
    id
    name
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTypeFields on Charge {
  __typename
  id
}
fragment ChargesTableVatFields on Charge {
  __typename
  id
  vat {
    raw
    formatted
  }
  totalAmount {
    raw
    currency
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableRowFields on Charge {
  id
  __typename
  metadata {
    ... on ChargeMetadata @defer {
      documentsCount
      ledgerCount
      transactionsCount
      miscExpensesCount
    }
  }
  totalAmount {
    raw
  }
  ...ChargesTableAccountantApprovalFields
  ...ChargesTableAmountFields
  ...ChargesTableBusinessTripFields @defer
  ...ChargesTableDateFields
  ...ChargesTableDescriptionFields
  ...ChargesTableEntityFields @defer
  ...ChargesTableMoreInfoFields
  ...ChargesTableTagsFields @defer
  ...ChargesTableTaxCategoryFields @defer
  ...ChargesTableTypeFields
  ...ChargesTableVatFields
}
fragment ChargesTableFields on Charge {
  id
  owner {
    id
  }
  ...ChargesTableRowFields
}`) as unknown as TypedDocumentString<AllChargesQuery, AllChargesQueryVariables>;
export const ChargeScreenDocument = new TypedDocumentString(`
    query ChargeScreen($chargeId: UUID!) {
  charge(chargeId: $chargeId) {
    id
    ...ChargesTableFields
  }
}
    fragment ChargesTableAccountantApprovalFields on Charge {
  id
  accountantApproval
}
fragment ChargesTableAmountFields on Charge {
  __typename
  id
  totalAmount {
    raw
    formatted
  }
  ... on CreditcardBankCharge @defer {
    validCreditCardAmount
  }
}
fragment ChargesTableBusinessTripFields on Charge {
  id
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
}
fragment ChargesTableEntityFields on Charge {
  __typename
  id
  counterparty {
    name
    id
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableDateFields on Charge {
  id
  minEventDate
  minDebitDate
  minDocumentsDate
}
fragment ChargesTableDescriptionFields on Charge {
  id
  userDescription
  ... on Charge @defer {
    validationData {
      missingInfo
    }
    missingInfoSuggestions {
      description
    }
  }
}
fragment ChargesTableMoreInfoFields on Charge {
  __typename
  id
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTagsFields on Charge {
  id
  tags {
    id
    name
    namePath
  }
  ... on Charge @defer {
    validationData {
      ... on ValidationData {
        missingInfo
      }
    }
    missingInfoSuggestions {
      ... on ChargeSuggestions {
        tags {
          id
          name
          namePath
        }
      }
    }
  }
}
fragment ChargesTableTaxCategoryFields on Charge {
  __typename
  id
  taxCategory {
    id
    name
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTypeFields on Charge {
  __typename
  id
}
fragment ChargesTableVatFields on Charge {
  __typename
  id
  vat {
    raw
    formatted
  }
  totalAmount {
    raw
    currency
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableRowFields on Charge {
  id
  __typename
  metadata {
    ... on ChargeMetadata @defer {
      documentsCount
      ledgerCount
      transactionsCount
      miscExpensesCount
    }
  }
  totalAmount {
    raw
  }
  ...ChargesTableAccountantApprovalFields
  ...ChargesTableAmountFields
  ...ChargesTableBusinessTripFields @defer
  ...ChargesTableDateFields
  ...ChargesTableDescriptionFields
  ...ChargesTableEntityFields @defer
  ...ChargesTableMoreInfoFields
  ...ChargesTableTagsFields @defer
  ...ChargesTableTaxCategoryFields @defer
  ...ChargesTableTypeFields
  ...ChargesTableVatFields
}
fragment ChargesTableFields on Charge {
  id
  owner {
    id
  }
  ...ChargesTableRowFields
}`) as unknown as TypedDocumentString<ChargeScreenQuery, ChargeScreenQueryVariables>;
export const MissingInfoChargesDocument = new TypedDocumentString(`
    query MissingInfoCharges($page: Int, $limit: Int) {
  chargesWithMissingRequiredInfo(page: $page, limit: $limit) {
    nodes {
      id
      ...ChargesTableFields
    }
    pageInfo {
      totalPages
    }
  }
}
    fragment ChargesTableAccountantApprovalFields on Charge {
  id
  accountantApproval
}
fragment ChargesTableAmountFields on Charge {
  __typename
  id
  totalAmount {
    raw
    formatted
  }
  ... on CreditcardBankCharge @defer {
    validCreditCardAmount
  }
}
fragment ChargesTableBusinessTripFields on Charge {
  id
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
}
fragment ChargesTableEntityFields on Charge {
  __typename
  id
  counterparty {
    name
    id
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableDateFields on Charge {
  id
  minEventDate
  minDebitDate
  minDocumentsDate
}
fragment ChargesTableDescriptionFields on Charge {
  id
  userDescription
  ... on Charge @defer {
    validationData {
      missingInfo
    }
    missingInfoSuggestions {
      description
    }
  }
}
fragment ChargesTableMoreInfoFields on Charge {
  __typename
  id
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTagsFields on Charge {
  id
  tags {
    id
    name
    namePath
  }
  ... on Charge @defer {
    validationData {
      ... on ValidationData {
        missingInfo
      }
    }
    missingInfoSuggestions {
      ... on ChargeSuggestions {
        tags {
          id
          name
          namePath
        }
      }
    }
  }
}
fragment ChargesTableTaxCategoryFields on Charge {
  __typename
  id
  taxCategory {
    id
    name
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableTypeFields on Charge {
  __typename
  id
}
fragment ChargesTableVatFields on Charge {
  __typename
  id
  vat {
    raw
    formatted
  }
  totalAmount {
    raw
    currency
  }
  ... on Charge @defer {
    validationData {
      missingInfo
    }
  }
}
fragment ChargesTableRowFields on Charge {
  id
  __typename
  metadata {
    ... on ChargeMetadata @defer {
      documentsCount
      ledgerCount
      transactionsCount
      miscExpensesCount
    }
  }
  totalAmount {
    raw
  }
  ...ChargesTableAccountantApprovalFields
  ...ChargesTableAmountFields
  ...ChargesTableBusinessTripFields @defer
  ...ChargesTableDateFields
  ...ChargesTableDescriptionFields
  ...ChargesTableEntityFields @defer
  ...ChargesTableMoreInfoFields
  ...ChargesTableTagsFields @defer
  ...ChargesTableTaxCategoryFields @defer
  ...ChargesTableTypeFields
  ...ChargesTableVatFields
}
fragment ChargesTableFields on Charge {
  id
  owner {
    id
  }
  ...ChargesTableRowFields
}`) as unknown as TypedDocumentString<MissingInfoChargesQuery, MissingInfoChargesQueryVariables>;
export const DocumentsScreenDocument = new TypedDocumentString(`
    query DocumentsScreen($filters: DocumentsFilters!) {
  documentsByFilters(filters: $filters) {
    id
    image
    file
    charge {
      id
      userDescription
      __typename
      vat {
        formatted
        __typename
      }
      transactions {
        id
        eventDate
        sourceDescription
        effectiveDate
        amount {
          formatted
          __typename
        }
      }
    }
    __typename
    ... on FinancialDocument {
      creditor {
        id
        name
      }
      debtor {
        id
        name
      }
      vat {
        raw
        formatted
        currency
      }
      serialNumber
      date
      amount {
        raw
        formatted
        currency
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentsScreenQuery, DocumentsScreenQueryVariables>;
export const MonthlyDocumentDraftByClientDocument = new TypedDocumentString(`
    query MonthlyDocumentDraftByClient($clientId: UUID!, $issueMonth: TimelessDate!) {
  clientMonthlyChargeDraft(clientId: $clientId, issueMonth: $issueMonth) {
    ...NewDocumentDraft
  }
}
    fragment IssueDocumentClientFields on Client {
  id
  originalBusiness {
    id
    address
    city
    zipCode
    country {
      id
      code
    }
    governmentId
    name
    phoneNumber
  }
  emails
}
fragment NewDocumentDraft on DocumentDraft {
  description
  remarks
  footer
  type
  date
  dueDate
  language
  currency
  vatType
  discount {
    amount
    type
  }
  rounding
  signed
  maxPayments
  client {
    id
    originalBusiness {
      id
      name
    }
    integrations {
      id
    }
    emails
    ...IssueDocumentClientFields
  }
  income {
    currency
    currencyRate
    description
    itemId
    price
    quantity
    vatRate
    vatType
  }
  payment {
    currency
    currencyRate
    date
    price
    type
    bankName
    bankBranch
    bankAccount
    chequeNum
    accountId
    transactionId
    cardType
    cardNum
    numPayments
    firstPayment
  }
  linkedDocumentIds
  linkedPaymentId
}`) as unknown as TypedDocumentString<MonthlyDocumentDraftByClientQuery, MonthlyDocumentDraftByClientQueryVariables>;
export const MonthlyDocumentsDraftsDocument = new TypedDocumentString(`
    query MonthlyDocumentsDrafts($issueMonth: TimelessDate!) {
  periodicalDocumentDrafts(issueMonth: $issueMonth) {
    ...NewDocumentDraft
  }
}
    fragment IssueDocumentClientFields on Client {
  id
  originalBusiness {
    id
    address
    city
    zipCode
    country {
      id
      code
    }
    governmentId
    name
    phoneNumber
  }
  emails
}
fragment NewDocumentDraft on DocumentDraft {
  description
  remarks
  footer
  type
  date
  dueDate
  language
  currency
  vatType
  discount {
    amount
    type
  }
  rounding
  signed
  maxPayments
  client {
    id
    originalBusiness {
      id
      name
    }
    integrations {
      id
    }
    emails
    ...IssueDocumentClientFields
  }
  income {
    currency
    currencyRate
    description
    itemId
    price
    quantity
    vatRate
    vatType
  }
  payment {
    currency
    currencyRate
    date
    price
    type
    bankName
    bankBranch
    bankAccount
    chequeNum
    accountId
    transactionId
    cardType
    cardNum
    numPayments
    firstPayment
  }
  linkedDocumentIds
  linkedPaymentId
}`) as unknown as TypedDocumentString<MonthlyDocumentsDraftsQuery, MonthlyDocumentsDraftsQueryVariables>;
export const AllOpenContractsDocument = new TypedDocumentString(`
    query AllOpenContracts {
  allOpenContracts {
    id
    client {
      id
      originalBusiness {
        id
        name
      }
    }
    billingCycle
  }
}
    `) as unknown as TypedDocumentString<AllOpenContractsQuery, AllOpenContractsQueryVariables>;
export const AnnualAuditStepsStatusDocument = new TypedDocumentString(`
    query AnnualAuditStepsStatus($ownerId: UUID!, $year: Int!) {
  annualAuditStepStatuses(ownerId: $ownerId, year: $year) {
    id
    stepId
    status
    notes
  }
}
    `) as unknown as TypedDocumentString<AnnualAuditStepsStatusQuery, AnnualAuditStepsStatusQueryVariables>;
export const AccountantApprovalStatusDocument = new TypedDocumentString(`
    query AccountantApprovalStatus($fromDate: TimelessDate!, $toDate: TimelessDate!) {
  accountantApprovalStatus(from: $fromDate, to: $toDate) {
    totalCharges
    approvedCount
    pendingCount
    unapprovedCount
  }
}
    `) as unknown as TypedDocumentString<AccountantApprovalStatusQuery, AccountantApprovalStatusQueryVariables>;
export const LedgerValidationStatusDocument = new TypedDocumentString(`
    query LedgerValidationStatus($limit: Int, $filters: ChargeFilter) {
  chargesWithLedgerChanges(limit: $limit, filters: $filters) {
    charge {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<LedgerValidationStatusQuery, LedgerValidationStatusQueryVariables>;
export const AnnualAuditOpeningBalanceStatusDocument = new TypedDocumentString(`
    query AnnualAuditOpeningBalanceStatus($ownerId: UUID!, $year: Int!) {
  annualAuditOpeningBalanceStatus(ownerId: $ownerId, year: $year) {
    id
    userType
    balanceChargeId
    derivedStatus
    errorMessage
  }
}
    `) as unknown as TypedDocumentString<AnnualAuditOpeningBalanceStatusQuery, AnnualAuditOpeningBalanceStatusQueryVariables>;
export const AnnualFinancialChargesDocument = new TypedDocumentString(`
    query AnnualFinancialCharges($ownerId: UUID, $year: TimelessDate!) {
  annualFinancialCharges(ownerId: $ownerId, year: $year) {
    id
    revaluationCharge {
      id
    }
    taxExpensesCharge {
      id
    }
    depreciationCharge {
      id
    }
    recoveryReserveCharge {
      id
    }
    vacationReserveCharge {
      id
    }
    bankDepositsRevaluationCharge {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<AnnualFinancialChargesQuery, AnnualFinancialChargesQueryVariables>;
export const Step05PrevYearTemplateDocument = new TypedDocumentString(`
    query Step05PrevYearTemplate($ownerId: UUID!, $year: Int!) {
  annualAuditStepStatuses(ownerId: $ownerId, year: $year) {
    id
    stepId
    status
    evidence
  }
}
    `) as unknown as TypedDocumentString<Step05PrevYearTemplateQuery, Step05PrevYearTemplateQueryVariables>;
export const AdminLedgerLockDateDocument = new TypedDocumentString(`
    query AdminLedgerLockDate($ownerId: UUID) {
  adminContext(ownerId: $ownerId) {
    id
    ledgerLock
  }
}
    `) as unknown as TypedDocumentString<AdminLedgerLockDateQuery, AdminLedgerLockDateQueryVariables>;
export const Step09SaveTemplateStatusDocument = new TypedDocumentString(`
    query Step09SaveTemplateStatus($ownerId: UUID!, $year: Int!) {
  annualAuditStepStatuses(ownerId: $ownerId, year: $year) {
    id
    stepId
    status
    evidence
  }
}
    `) as unknown as TypedDocumentString<Step09SaveTemplateStatusQuery, Step09SaveTemplateStatusQueryVariables>;
export const AnnualRevenueReportScreenDocument = new TypedDocumentString(`
    query AnnualRevenueReportScreen($filters: AnnualRevenueReportFilter!) {
  annualRevenueReport(filters: $filters) {
    id
    year
    countries {
      id
      name
      revenueLocal {
        raw
        currency
      }
      revenueDefaultForeign {
        raw
        currency
      }
      clients {
        id
        name
        revenueLocal {
          raw
        }
        revenueDefaultForeign {
          raw
        }
        records {
          id
          date
          description
          reference
          chargeId
          revenueLocal {
            raw
          }
          revenueDefaultForeign {
            raw
          }
        }
      }
      ...AnnualRevenueReportCountry
    }
  }
}
    fragment AnnualRevenueReportClient on AnnualRevenueReportCountryClient {
  id
  name
  revenueLocal {
    raw
    formatted
    currency
  }
  revenueDefaultForeign {
    raw
    formatted
    currency
  }
  records {
    id
    date
    ...AnnualRevenueReportRecord
  }
}
fragment AnnualRevenueReportCountry on AnnualRevenueReportCountry {
  id
  code
  name
  revenueLocal {
    raw
    formatted
    currency
  }
  revenueDefaultForeign {
    raw
    formatted
    currency
  }
  clients {
    id
    revenueDefaultForeign {
      raw
    }
    ...AnnualRevenueReportClient
  }
}
fragment AnnualRevenueReportRecord on AnnualRevenueReportClientRecord {
  id
  revenueLocal {
    raw
    formatted
    currency
  }
  revenueDefaultForeign {
    raw
    formatted
    currency
  }
  revenueOriginal {
    raw
    formatted
    currency
  }
  chargeId
  date
  description
  reference
}`) as unknown as TypedDocumentString<AnnualRevenueReportScreenQuery, AnnualRevenueReportScreenQueryVariables>;
export const BalanceReportExtendedTransactionsDocument = new TypedDocumentString(`
    query BalanceReportExtendedTransactions($transactionIDs: [UUID!]!) {
  transactionsByIDs(transactionIDs: $transactionIDs) {
    id
    ...TransactionForTransactionsTableFields
    ...TransactionToDownloadForTransactionsTableFields
  }
}
    fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}
fragment TransactionToDownloadForTransactionsTableFields on Transaction {
  id
  account {
    id
    name
    type
  }
  amount {
    currency
    raw
  }
  counterparty {
    id
    name
  }
  effectiveDate
  eventDate
  referenceKey
  sourceDescription
}`) as unknown as TypedDocumentString<BalanceReportExtendedTransactionsQuery, BalanceReportExtendedTransactionsQueryVariables>;
export const BalanceReportScreenDocument = new TypedDocumentString(`
    query BalanceReportScreen($fromDate: TimelessDate!, $toDate: TimelessDate!, $ownerId: UUID) {
  transactionsForBalanceReport(
    fromDate: $fromDate
    toDate: $toDate
    ownerId: $ownerId
  ) {
    id
    amountUsd {
      formatted
      raw
    }
    amount {
      currency
      raw
    }
    date
    month
    year
    counterparty {
      id
    }
    account {
      id
      name
    }
    isFee
    description
    charge {
      id
      tags {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BalanceReportScreenQuery, BalanceReportScreenQueryVariables>;
export const DepreciationReportScreenDocument = new TypedDocumentString(`
    query DepreciationReportScreen($filters: DepreciationReportFilter!) {
  depreciationReport(filters: $filters) {
    id
    year
    categories {
      id
      category {
        id
        name
        percentage
      }
      records {
        id
        chargeId
        description
        purchaseDate
        activationDate
        statutoryDepreciationRate
        claimedDepreciationRate
        ...DepreciationReportRecordCore
      }
      summary {
        id
        ...DepreciationReportRecordCore
      }
    }
    summary {
      id
      ...DepreciationReportRecordCore
    }
  }
}
    fragment DepreciationReportRecordCore on DepreciationCoreRecord {
  id
  originalCost
  reportYearDelta
  totalDepreciableCosts
  reportYearClaimedDepreciation
  pastYearsAccumulatedDepreciation
  totalDepreciation
  netValue
}`) as unknown as TypedDocumentString<DepreciationReportScreenQuery, DepreciationReportScreenQueryVariables>;
export const Shaam6111ReportScreenDocument = new TypedDocumentString(`
    query Shaam6111ReportScreen($year: Int!, $businessId: UUID) {
  shaam6111(year: $year, businessId: $businessId) {
    id
    year
    data {
      id
      ...Shaam6111DataContent
    }
    business {
      id
      ...Shaam6111DataContentHeaderBusiness
    }
  }
}
    fragment Shaam6111DataContentBalanceSheet on Shaam6111Data {
  id
  balanceSheet {
    code
    amount
    label
  }
}
fragment Shaam6111DataContentHeader on Shaam6111Data {
  id
  header {
    taxYear
    businessDescription
    taxFileNumber
    idNumber
    vatFileNumber
    withholdingTaxFileNumber
    businessType
    reportingMethod
    currencyType
    amountsInThousands
    accountingMethod
    accountingSystem
    softwareRegistrationNumber
    isPartnership
    partnershipCount
    partnershipProfitShare
    ifrsImplementationYear
    ifrsReportingOption
    includesProfitLoss
    includesTaxAdjustment
    includesBalanceSheet
    industryCode
    auditOpinionType
  }
}
fragment Shaam6111DataContentHeaderBusiness on Business {
  id
  name
}
fragment Shaam6111DataContentProfitLoss on Shaam6111Data {
  id
  profitAndLoss {
    code
    amount
    label
  }
}
fragment Shaam6111DataContent on Shaam6111Data {
  id
  ...Shaam6111DataContentHeader
  ...Shaam6111DataContentProfitLoss
  ...Shaam6111DataContentTaxAdjustment
  ...Shaam6111DataContentBalanceSheet
}
fragment Shaam6111DataContentTaxAdjustment on Shaam6111Data {
  id
  taxAdjustment {
    code
    amount
    label
  }
}`) as unknown as TypedDocumentString<Shaam6111ReportScreenQuery, Shaam6111ReportScreenQueryVariables>;
export const AllSortCodesForScreenDocument = new TypedDocumentString(`
    query AllSortCodesForScreen {
  allSortCodes {
    id
    key
    name
    defaultIrsCode
  }
}
    `) as unknown as TypedDocumentString<AllSortCodesForScreenQuery, AllSortCodesForScreenQueryVariables>;
export const AllTagsScreenDocument = new TypedDocumentString(`
    query AllTagsScreen {
  allTags {
    id
    name
    namePath
    parent {
      id
    }
    ...EditTagFields
  }
}
    fragment EditTagFields on Tag {
  id
  name
  parent {
    id
    name
  }
}`) as unknown as TypedDocumentString<AllTagsScreenQuery, AllTagsScreenQueryVariables>;
export const AllTaxCategoriesForScreenDocument = new TypedDocumentString(`
    query AllTaxCategoriesForScreen {
  taxCategories {
    id
    name
    sortCode {
      id
      key
      name
    }
  }
}
    `) as unknown as TypedDocumentString<AllTaxCategoriesForScreenQuery, AllTaxCategoriesForScreenQueryVariables>;
export const AcceptInvitationDocument = new TypedDocumentString(`
    mutation AcceptInvitation($token: String!) {
  acceptInvitation(token: $token) {
    success
    businessId
    roleId
  }
}
    `) as unknown as TypedDocumentString<AcceptInvitationMutation, AcceptInvitationMutationVariables>;
export const AddBusinessTripAccommodationsExpenseDocument = new TypedDocumentString(`
    mutation AddBusinessTripAccommodationsExpense($fields: AddBusinessTripAccommodationsExpenseInput!) {
  addBusinessTripAccommodationsExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<AddBusinessTripAccommodationsExpenseMutation, AddBusinessTripAccommodationsExpenseMutationVariables>;
export const AddBusinessTripCarRentalExpenseDocument = new TypedDocumentString(`
    mutation AddBusinessTripCarRentalExpense($fields: AddBusinessTripCarRentalExpenseInput!) {
  addBusinessTripCarRentalExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<AddBusinessTripCarRentalExpenseMutation, AddBusinessTripCarRentalExpenseMutationVariables>;
export const AddBusinessTripFlightsExpenseDocument = new TypedDocumentString(`
    mutation AddBusinessTripFlightsExpense($fields: AddBusinessTripFlightsExpenseInput!) {
  addBusinessTripFlightsExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<AddBusinessTripFlightsExpenseMutation, AddBusinessTripFlightsExpenseMutationVariables>;
export const AddBusinessTripOtherExpenseDocument = new TypedDocumentString(`
    mutation AddBusinessTripOtherExpense($fields: AddBusinessTripOtherExpenseInput!) {
  addBusinessTripOtherExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<AddBusinessTripOtherExpenseMutation, AddBusinessTripOtherExpenseMutationVariables>;
export const AddBusinessTripTravelAndSubsistenceExpenseDocument = new TypedDocumentString(`
    mutation AddBusinessTripTravelAndSubsistenceExpense($fields: AddBusinessTripTravelAndSubsistenceExpenseInput!) {
  addBusinessTripTravelAndSubsistenceExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<AddBusinessTripTravelAndSubsistenceExpenseMutation, AddBusinessTripTravelAndSubsistenceExpenseMutationVariables>;
export const AddDepreciationRecordDocument = new TypedDocumentString(`
    mutation AddDepreciationRecord($fields: InsertDepreciationRecordInput!) {
  insertDepreciationRecord(input: $fields) {
    __typename
    ... on CommonError {
      message
    }
    ... on DepreciationRecord {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<AddDepreciationRecordMutation, AddDepreciationRecordMutationVariables>;
export const AddSortCodeDocument = new TypedDocumentString(`
    mutation AddSortCode($key: Int!, $name: String!, $defaultIrsCode: Int) {
  addSortCode(key: $key, name: $name, defaultIrsCode: $defaultIrsCode)
}
    `) as unknown as TypedDocumentString<AddSortCodeMutation, AddSortCodeMutationVariables>;
export const AddTagDocument = new TypedDocumentString(`
    mutation AddTag($tagName: String!, $parentTag: UUID) {
  addTag(name: $tagName, parentId: $parentTag)
}
    `) as unknown as TypedDocumentString<AddTagMutation, AddTagMutationVariables>;
export const AnnualAuditStepStatusDocument = new TypedDocumentString(`
    query AnnualAuditStepStatus($ownerId: UUID!, $year: Int!) {
  annualAuditStepStatuses(ownerId: $ownerId, year: $year) {
    id
    stepId
    status
  }
}
    `) as unknown as TypedDocumentString<AnnualAuditStepStatusQuery, AnnualAuditStepStatusQueryVariables>;
export const AssignChargeToDepositDocument = new TypedDocumentString(`
    mutation AssignChargeToDeposit($chargeId: UUID!, $depositId: String!) {
  assignChargeToDeposit(chargeId: $chargeId, depositId: $depositId) {
    id
  }
}
    `) as unknown as TypedDocumentString<AssignChargeToDepositMutation, AssignChargeToDepositMutationVariables>;
export const GenerateBalanceChargeDocument = new TypedDocumentString(`
    mutation GenerateBalanceCharge($description: String!, $balanceRecords: [InsertMiscExpenseInput!]!) {
  generateBalanceCharge(
    description: $description
    balanceRecords: $balanceRecords
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GenerateBalanceChargeMutation, GenerateBalanceChargeMutationVariables>;
export const BatchUpdateChargesDocument = new TypedDocumentString(`
    mutation BatchUpdateCharges($chargeIds: [UUID!]!, $fields: UpdateChargeInput!) {
  batchUpdateCharges(chargeIds: $chargeIds, fields: $fields) {
    __typename
    ... on BatchUpdateChargesSuccessfulResult {
      charges {
        id
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<BatchUpdateChargesMutation, BatchUpdateChargesMutationVariables>;
export const CategorizeBusinessTripExpenseDocument = new TypedDocumentString(`
    mutation CategorizeBusinessTripExpense($fields: CategorizeBusinessTripExpenseInput!) {
  categorizeBusinessTripExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<CategorizeBusinessTripExpenseMutation, CategorizeBusinessTripExpenseMutationVariables>;
export const CategorizeIntoExistingBusinessTripExpenseDocument = new TypedDocumentString(`
    mutation CategorizeIntoExistingBusinessTripExpense($fields: CategorizeIntoExistingBusinessTripExpenseInput!) {
  categorizeIntoExistingBusinessTripExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<CategorizeIntoExistingBusinessTripExpenseMutation, CategorizeIntoExistingBusinessTripExpenseMutationVariables>;
export const CloseDocumentDocument = new TypedDocumentString(`
    mutation CloseDocument($documentId: UUID!) {
  closeDocument(id: $documentId)
}
    `) as unknown as TypedDocumentString<CloseDocumentMutation, CloseDocumentMutationVariables>;
export const FlagForeignFeeTransactionsDocument = new TypedDocumentString(`
    mutation FlagForeignFeeTransactions {
  flagForeignFeeTransactions {
    success
    errors
  }
}
    `) as unknown as TypedDocumentString<FlagForeignFeeTransactionsMutation, FlagForeignFeeTransactionsMutationVariables>;
export const MergeChargesByTransactionReferenceDocument = new TypedDocumentString(`
    mutation MergeChargesByTransactionReference {
  mergeChargesByTransactionReference {
    success
    errors
  }
}
    `) as unknown as TypedDocumentString<MergeChargesByTransactionReferenceMutation, MergeChargesByTransactionReferenceMutationVariables>;
export const CalculateCreditcardTransactionsDebitDateDocument = new TypedDocumentString(`
    mutation CalculateCreditcardTransactionsDebitDate {
  calculateCreditcardTransactionsDebitDate
}
    `) as unknown as TypedDocumentString<CalculateCreditcardTransactionsDebitDateMutation, CalculateCreditcardTransactionsDebitDateMutationVariables>;
export const CreateContractDocument = new TypedDocumentString(`
    mutation CreateContract($input: CreateContractInput!) {
  createContract(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateContractMutation, CreateContractMutationVariables>;
export const CreateDepositFromChargeDocument = new TypedDocumentString(`
    mutation CreateDepositFromCharge($chargeId: UUID!, $name: String!) {
  createDepositFromCharge(chargeId: $chargeId, name: $name) {
    id
    name
    currency
    isOpen
  }
}
    `) as unknown as TypedDocumentString<CreateDepositFromChargeMutation, CreateDepositFromChargeMutationVariables>;
export const CreateDepositDocument = new TypedDocumentString(`
    mutation CreateDeposit($name: String!, $currency: Currency!, $openDate: TimelessDate!, $accountId: UUID) {
  createDeposit(
    name: $name
    currency: $currency
    openDate: $openDate
    accountId: $accountId
  ) {
    id
    currency
    isOpen
  }
}
    `) as unknown as TypedDocumentString<CreateDepositMutation, CreateDepositMutationVariables>;
export const CreateFinancialAccountDocument = new TypedDocumentString(`
    mutation CreateFinancialAccount($input: CreateFinancialAccountInput!) {
  createFinancialAccount(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateFinancialAccountMutation, CreateFinancialAccountMutationVariables>;
export const CreditShareholdersBusinessTripTravelAndSubsistenceDocument = new TypedDocumentString(`
    mutation CreditShareholdersBusinessTripTravelAndSubsistence($businessTripId: UUID!) {
  creditShareholdersBusinessTripTravelAndSubsistence(
    businessTripId: $businessTripId
  )
}
    `) as unknown as TypedDocumentString<CreditShareholdersBusinessTripTravelAndSubsistenceMutation, CreditShareholdersBusinessTripTravelAndSubsistenceMutationVariables>;
export const DeleteBusinessTripAttendeeDocument = new TypedDocumentString(`
    mutation DeleteBusinessTripAttendee($fields: DeleteBusinessTripAttendeeInput!) {
  deleteBusinessTripAttendee(fields: $fields)
}
    `) as unknown as TypedDocumentString<DeleteBusinessTripAttendeeMutation, DeleteBusinessTripAttendeeMutationVariables>;
export const DeleteBusinessTripExpenseDocument = new TypedDocumentString(`
    mutation DeleteBusinessTripExpense($businessTripExpenseId: UUID!) {
  deleteBusinessTripExpense(businessTripExpenseId: $businessTripExpenseId)
}
    `) as unknown as TypedDocumentString<DeleteBusinessTripExpenseMutation, DeleteBusinessTripExpenseMutationVariables>;
export const DeleteChargeDocument = new TypedDocumentString(`
    mutation DeleteCharge($chargeId: UUID!) {
  deleteCharge(chargeId: $chargeId)
}
    `) as unknown as TypedDocumentString<DeleteChargeMutation, DeleteChargeMutationVariables>;
export const DeleteContractDocument = new TypedDocumentString(`
    mutation DeleteContract($contractId: UUID!) {
  deleteContract(id: $contractId)
}
    `) as unknown as TypedDocumentString<DeleteContractMutation, DeleteContractMutationVariables>;
export const DeleteDepreciationRecordDocument = new TypedDocumentString(`
    mutation DeleteDepreciationRecord($depreciationRecordId: UUID!) {
  deleteDepreciationRecord(depreciationRecordId: $depreciationRecordId)
}
    `) as unknown as TypedDocumentString<DeleteDepreciationRecordMutation, DeleteDepreciationRecordMutationVariables>;
export const DeleteDocumentDocument = new TypedDocumentString(`
    mutation DeleteDocument($documentId: UUID!) {
  deleteDocument(documentId: $documentId)
}
    `) as unknown as TypedDocumentString<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const DeleteDynamicReportTemplateDocument = new TypedDocumentString(`
    mutation DeleteDynamicReportTemplate($name: String!) {
  deleteDynamicReportTemplate(name: $name)
}
    `) as unknown as TypedDocumentString<DeleteDynamicReportTemplateMutation, DeleteDynamicReportTemplateMutationVariables>;
export const DeleteMiscExpenseDocument = new TypedDocumentString(`
    mutation DeleteMiscExpense($id: UUID!) {
  deleteMiscExpense(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteMiscExpenseMutation, DeleteMiscExpenseMutationVariables>;
export const DeleteProviderCredentialsDocument = new TypedDocumentString(`
    mutation DeleteProviderCredentials($provider: ProviderKey!) {
  deleteProviderCredentials(provider: $provider) {
    ... on ProviderCredentialDeleteResult {
      id
      provider
      success
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteProviderCredentialsMutation, DeleteProviderCredentialsMutationVariables>;
export const DeleteTagDocument = new TypedDocumentString(`
    mutation DeleteTag($tagId: UUID!) {
  deleteTag(id: $tagId)
}
    `) as unknown as TypedDocumentString<DeleteTagMutation, DeleteTagMutationVariables>;
export const GenerateRevaluationChargeDocument = new TypedDocumentString(`
    mutation GenerateRevaluationCharge($ownerId: UUID!, $date: TimelessDate!) {
  generateRevaluationCharge(ownerId: $ownerId, date: $date) {
    id
  }
}
    `) as unknown as TypedDocumentString<GenerateRevaluationChargeMutation, GenerateRevaluationChargeMutationVariables>;
export const GenerateBankDepositsRevaluationChargeDocument = new TypedDocumentString(`
    mutation GenerateBankDepositsRevaluationCharge($ownerId: UUID!, $date: TimelessDate!) {
  generateBankDepositsRevaluationCharge(ownerId: $ownerId, date: $date) {
    id
  }
}
    `) as unknown as TypedDocumentString<GenerateBankDepositsRevaluationChargeMutation, GenerateBankDepositsRevaluationChargeMutationVariables>;
export const GenerateTaxExpensesChargeDocument = new TypedDocumentString(`
    mutation GenerateTaxExpensesCharge($ownerId: UUID!, $date: TimelessDate!) {
  generateTaxExpensesCharge(ownerId: $ownerId, year: $date) {
    id
  }
}
    `) as unknown as TypedDocumentString<GenerateTaxExpensesChargeMutation, GenerateTaxExpensesChargeMutationVariables>;
export const GenerateDepreciationChargeDocument = new TypedDocumentString(`
    mutation GenerateDepreciationCharge($ownerId: UUID!, $date: TimelessDate!) {
  generateDepreciationCharge(ownerId: $ownerId, year: $date) {
    id
  }
}
    `) as unknown as TypedDocumentString<GenerateDepreciationChargeMutation, GenerateDepreciationChargeMutationVariables>;
export const GenerateRecoveryReserveChargeDocument = new TypedDocumentString(`
    mutation GenerateRecoveryReserveCharge($ownerId: UUID!, $date: TimelessDate!) {
  generateRecoveryReserveCharge(ownerId: $ownerId, year: $date) {
    id
  }
}
    `) as unknown as TypedDocumentString<GenerateRecoveryReserveChargeMutation, GenerateRecoveryReserveChargeMutationVariables>;
export const GenerateVacationReserveChargeDocument = new TypedDocumentString(`
    mutation GenerateVacationReserveCharge($ownerId: UUID!, $date: TimelessDate!) {
  generateVacationReserveCharge(ownerId: $ownerId, year: $date) {
    id
  }
}
    `) as unknown as TypedDocumentString<GenerateVacationReserveChargeMutation, GenerateVacationReserveChargeMutationVariables>;
export const AllAdminBusinessesDocument = new TypedDocumentString(`
    query AllAdminBusinesses {
  allAdminBusinesses {
    id
    name
    governmentId
  }
}
    `) as unknown as TypedDocumentString<AllAdminBusinessesQuery, AllAdminBusinessesQueryVariables>;
export const AllClientsDocument = new TypedDocumentString(`
    query AllClients {
  allClients {
    id
    originalBusiness {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<AllClientsQuery, AllClientsQueryVariables>;
export const AllBusinessesDocument = new TypedDocumentString(`
    query AllBusinesses {
  allBusinesses {
    nodes {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<AllBusinessesQuery, AllBusinessesQueryVariables>;
export const AllCountriesDocument = new TypedDocumentString(`
    query AllCountries {
  allCountries {
    id
    name
    code
  }
}
    `) as unknown as TypedDocumentString<AllCountriesQuery, AllCountriesQueryVariables>;
export const AllFinancialAccountsDocument = new TypedDocumentString(`
    query AllFinancialAccounts {
  allFinancialAccounts {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<AllFinancialAccountsQuery, AllFinancialAccountsQueryVariables>;
export const AllFinancialEntitiesDocument = new TypedDocumentString(`
    query AllFinancialEntities {
  allFinancialEntities {
    nodes {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<AllFinancialEntitiesQuery, AllFinancialEntitiesQueryVariables>;
export const AllSortCodesDocument = new TypedDocumentString(`
    query AllSortCodes {
  allSortCodes {
    id
    key
    name
    defaultIrsCode
  }
}
    `) as unknown as TypedDocumentString<AllSortCodesQuery, AllSortCodesQueryVariables>;
export const AllTagsDocument = new TypedDocumentString(`
    query AllTags {
  allTags {
    id
    name
    namePath
  }
}
    `) as unknown as TypedDocumentString<AllTagsQuery, AllTagsQueryVariables>;
export const AllTaxCategoriesDocument = new TypedDocumentString(`
    query AllTaxCategories {
  taxCategories {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<AllTaxCategoriesQuery, AllTaxCategoriesQueryVariables>;
export const InsertBusinessTripAttendeeDocument = new TypedDocumentString(`
    mutation InsertBusinessTripAttendee($fields: InsertBusinessTripAttendeeInput!) {
  insertBusinessTripAttendee(fields: $fields)
}
    `) as unknown as TypedDocumentString<InsertBusinessTripAttendeeMutation, InsertBusinessTripAttendeeMutationVariables>;
export const InsertBusinessTripDocument = new TypedDocumentString(`
    mutation InsertBusinessTrip($fields: InsertBusinessTripInput!) {
  insertBusinessTrip(fields: $fields)
}
    `) as unknown as TypedDocumentString<InsertBusinessTripMutation, InsertBusinessTripMutationVariables>;
export const InsertBusinessDocument = new TypedDocumentString(`
    mutation InsertBusiness($fields: InsertNewBusinessInput!) {
  insertNewBusiness(fields: $fields) {
    __typename
    ... on LtdFinancialEntity {
      id
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<InsertBusinessMutation, InsertBusinessMutationVariables>;
export const InsertClientDocument = new TypedDocumentString(`
    mutation InsertClient($fields: ClientInsertInput!) {
  insertClient(fields: $fields) {
    __typename
    ... on Client {
      id
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<InsertClientMutation, InsertClientMutationVariables>;
export const InsertDocumentDocument = new TypedDocumentString(`
    mutation InsertDocument($record: InsertDocumentInput!) {
  insertDocument(record: $record) {
    __typename
    ... on InsertDocumentSuccessfulResult {
      document {
        id
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<InsertDocumentMutation, InsertDocumentMutationVariables>;
export const InsertDynamicReportTemplateDocument = new TypedDocumentString(`
    mutation InsertDynamicReportTemplate($name: String!, $template: String!) {
  insertDynamicReportTemplate(name: $name, template: $template) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<InsertDynamicReportTemplateMutation, InsertDynamicReportTemplateMutationVariables>;
export const InsertMiscExpenseDocument = new TypedDocumentString(`
    mutation InsertMiscExpense($chargeId: UUID!, $fields: InsertMiscExpenseInput!) {
  insertMiscExpense(chargeId: $chargeId, fields: $fields) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertMiscExpenseMutation, InsertMiscExpenseMutationVariables>;
export const InsertMiscExpensesDocument = new TypedDocumentString(`
    mutation InsertMiscExpenses($chargeId: UUID!, $expenses: [InsertMiscExpenseInput!]!) {
  insertMiscExpenses(chargeId: $chargeId, expenses: $expenses) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertMiscExpensesMutation, InsertMiscExpensesMutationVariables>;
export const InsertSalaryRecordDocument = new TypedDocumentString(`
    mutation InsertSalaryRecord($salaryRecords: [SalaryRecordInput!]!) {
  insertSalaryRecords(salaryRecords: $salaryRecords) {
    __typename
    ... on InsertSalaryRecordsSuccessfulResult {
      salaryRecords {
        month
        employee {
          id
        }
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<InsertSalaryRecordMutation, InsertSalaryRecordMutationVariables>;
export const InsertTaxCategoryDocument = new TypedDocumentString(`
    mutation InsertTaxCategory($fields: InsertTaxCategoryInput!) {
  insertTaxCategory(fields: $fields) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<InsertTaxCategoryMutation, InsertTaxCategoryMutationVariables>;
export const IssueGreenInvoiceDocumentDocument = new TypedDocumentString(`
    mutation IssueGreenInvoiceDocument($input: DocumentIssueInput!, $emailContent: String, $attachment: Boolean, $chargeId: UUID) {
  issueGreenInvoiceDocument(
    input: $input
    emailContent: $emailContent
    attachment: $attachment
    chargeId: $chargeId
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<IssueGreenInvoiceDocumentMutation, IssueGreenInvoiceDocumentMutationVariables>;
export const IssueMonthlyDocumentsDocument = new TypedDocumentString(`
    mutation IssueMonthlyDocuments($generateDocumentsInfo: [DocumentIssueInput!]!) {
  issueGreenInvoiceDocuments(generateDocumentsInfo: $generateDocumentsInfo) {
    success
    errors
  }
}
    `) as unknown as TypedDocumentString<IssueMonthlyDocumentsMutation, IssueMonthlyDocumentsMutationVariables>;
export const LedgerLockDocument = new TypedDocumentString(`
    mutation LedgerLock($date: TimelessDate!) {
  lockLedgerRecords(date: $date)
}
    `) as unknown as TypedDocumentString<LedgerLockMutation, LedgerLockMutationVariables>;
export const LockDynamicReportTemplateDocument = new TypedDocumentString(`
    mutation LockDynamicReportTemplate($name: String!) {
  lockDynamicReportTemplate(name: $name) {
    id
    name
    isLocked
    updated
  }
}
    `) as unknown as TypedDocumentString<LockDynamicReportTemplateMutation, LockDynamicReportTemplateMutationVariables>;
export const MergeBusinessesDocument = new TypedDocumentString(`
    mutation MergeBusinesses($targetBusinessId: UUID!, $businessIdsToMerge: [UUID!]!) {
  mergeBusinesses(
    targetBusinessId: $targetBusinessId
    businessIdsToMerge: $businessIdsToMerge
  ) {
    __typename
    id
  }
}
    `) as unknown as TypedDocumentString<MergeBusinessesMutation, MergeBusinessesMutationVariables>;
export const MergeChargesDocument = new TypedDocumentString(`
    mutation MergeCharges($baseChargeID: UUID!, $chargeIdsToMerge: [UUID!]!, $fields: UpdateChargeInput) {
  mergeCharges(
    baseChargeID: $baseChargeID
    chargeIdsToMerge: $chargeIdsToMerge
    fields: $fields
  ) {
    __typename
    ... on MergeChargeSuccessfulResult {
      charge {
        id
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<MergeChargesMutation, MergeChargesMutationVariables>;
export const PreviewDocumentDocument = new TypedDocumentString(`
    mutation PreviewDocument($input: DocumentIssueInput!) {
  previewDocument(input: $input)
}
    `) as unknown as TypedDocumentString<PreviewDocumentMutation, PreviewDocumentMutationVariables>;
export const ProviderCredentialsDocument = new TypedDocumentString(`
    query ProviderCredentials {
  providerCredentials {
    id
    provider
    configuredAt
  }
}
    `) as unknown as TypedDocumentString<ProviderCredentialsQuery, ProviderCredentialsQueryVariables>;
export const RegenerateLedgerDocument = new TypedDocumentString(`
    mutation RegenerateLedger($chargeId: UUID!) {
  regenerateLedgerRecords(chargeId: $chargeId) {
    __typename
    ... on Ledger {
      records {
        id
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<RegenerateLedgerMutation, RegenerateLedgerMutationVariables>;
export const RelevantDepositsForChargeDocument = new TypedDocumentString(`
    query RelevantDepositsForCharge($chargeId: UUID!) {
  relevantDepositsForCharge(chargeId: $chargeId) {
    id
    deposits {
      id
      name
      currency
      isOpen
    }
    error
  }
}
    `) as unknown as TypedDocumentString<RelevantDepositsForChargeQuery, RelevantDepositsForChargeQueryVariables>;
export const SetAnnualAuditStepStatusDocument = new TypedDocumentString(`
    mutation SetAnnualAuditStepStatus($input: SetAnnualAuditStepStatusInput!) {
  setAnnualAuditStepStatus(input: $input) {
    id
    ownerId
    year
    stepId
    status
    notes
    evidence
    updatedAt
    completedAt
  }
}
    `) as unknown as TypedDocumentString<SetAnnualAuditStepStatusMutation, SetAnnualAuditStepStatusMutationVariables>;
export const SetAnnualAuditStep03StatusDocument = new TypedDocumentString(`
    mutation SetAnnualAuditStep03Status($input: SetAnnualAuditStep03StatusInput!) {
  setAnnualAuditStep03Status(input: $input) {
    id
    ownerId
    year
    stepId
    status
    notes
    updatedAt
    completedAt
  }
}
    `) as unknown as TypedDocumentString<SetAnnualAuditStep03StatusMutation, SetAnnualAuditStep03StatusMutationVariables>;
export const SetAnnualAuditStep09StatusDocument = new TypedDocumentString(`
    mutation SetAnnualAuditStep09Status($input: SetAnnualAuditStep09StatusInput!) {
  setAnnualAuditStep09Status(input: $input) {
    id
    ownerId
    year
    stepId
    status
    notes
    evidence
    updatedAt
    completedAt
  }
}
    `) as unknown as TypedDocumentString<SetAnnualAuditStep09StatusMutation, SetAnnualAuditStep09StatusMutationVariables>;
export const SetDeelCredentialsDocument = new TypedDocumentString(`
    mutation SetDeelCredentials($apiToken: String!) {
  setDeelCredentials(apiToken: $apiToken) {
    ... on ProviderCredentialResult {
      id
      provider
      configuredAt
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<SetDeelCredentialsMutation, SetDeelCredentialsMutationVariables>;
export const SetGreenInvoiceCredentialsDocument = new TypedDocumentString(`
    mutation SetGreenInvoiceCredentials($id: String!, $secret: String!) {
  setGreenInvoiceCredentials(id: $id, secret: $secret) {
    ... on ProviderCredentialResult {
      id
      provider
      configuredAt
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<SetGreenInvoiceCredentialsMutation, SetGreenInvoiceCredentialsMutationVariables>;
export const SyncGreenInvoiceDocumentsDocument = new TypedDocumentString(`
    mutation SyncGreenInvoiceDocuments($ownerId: UUID!) {
  syncGreenInvoiceDocuments(ownerId: $ownerId) {
    id
    ...NewFetchedDocumentFields
  }
}
    fragment NewFetchedDocumentFields on Document {
  id
  documentType
  charge {
    id
    userDescription
    counterparty {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<SyncGreenInvoiceDocumentsMutation, SyncGreenInvoiceDocumentsMutationVariables>;
export const UnlockDynamicReportTemplateDocument = new TypedDocumentString(`
    mutation UnlockDynamicReportTemplate($name: String!) {
  unlockDynamicReportTemplate(name: $name) {
    id
    name
    isLocked
    updated
  }
}
    `) as unknown as TypedDocumentString<UnlockDynamicReportTemplateMutation, UnlockDynamicReportTemplateMutationVariables>;
export const UpdateAdminBusinessDocument = new TypedDocumentString(`
    mutation UpdateAdminBusiness($adminBusinessId: UUID!, $fields: UpdateAdminBusinessInput!) {
  updateAdminBusiness(businessId: $adminBusinessId, fields: $fields) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateAdminBusinessMutation, UpdateAdminBusinessMutationVariables>;
export const UpdateBusinessTripAccommodationsExpenseDocument = new TypedDocumentString(`
    mutation UpdateBusinessTripAccommodationsExpense($fields: UpdateBusinessTripAccommodationsExpenseInput!) {
  updateBusinessTripAccommodationsExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<UpdateBusinessTripAccommodationsExpenseMutation, UpdateBusinessTripAccommodationsExpenseMutationVariables>;
export const UpdateBusinessTripAccountantApprovalDocument = new TypedDocumentString(`
    mutation UpdateBusinessTripAccountantApproval($businessTripId: UUID!, $status: AccountantStatus!) {
  updateBusinessTripAccountantApproval(
    businessTripId: $businessTripId
    approvalStatus: $status
  )
}
    `) as unknown as TypedDocumentString<UpdateBusinessTripAccountantApprovalMutation, UpdateBusinessTripAccountantApprovalMutationVariables>;
export const UpdateBusinessTripAttendeeDocument = new TypedDocumentString(`
    mutation UpdateBusinessTripAttendee($fields: BusinessTripAttendeeUpdateInput!) {
  updateBusinessTripAttendee(fields: $fields)
}
    `) as unknown as TypedDocumentString<UpdateBusinessTripAttendeeMutation, UpdateBusinessTripAttendeeMutationVariables>;
export const UpdateBusinessTripCarRentalExpenseDocument = new TypedDocumentString(`
    mutation UpdateBusinessTripCarRentalExpense($fields: UpdateBusinessTripCarRentalExpenseInput!) {
  updateBusinessTripCarRentalExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<UpdateBusinessTripCarRentalExpenseMutation, UpdateBusinessTripCarRentalExpenseMutationVariables>;
export const UpdateBusinessTripFlightsExpenseDocument = new TypedDocumentString(`
    mutation UpdateBusinessTripFlightsExpense($fields: UpdateBusinessTripFlightsExpenseInput!) {
  updateBusinessTripFlightsExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<UpdateBusinessTripFlightsExpenseMutation, UpdateBusinessTripFlightsExpenseMutationVariables>;
export const UpdateBusinessTripOtherExpenseDocument = new TypedDocumentString(`
    mutation UpdateBusinessTripOtherExpense($fields: UpdateBusinessTripOtherExpenseInput!) {
  updateBusinessTripOtherExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<UpdateBusinessTripOtherExpenseMutation, UpdateBusinessTripOtherExpenseMutationVariables>;
export const UpdateBusinessTripTravelAndSubsistenceExpenseDocument = new TypedDocumentString(`
    mutation UpdateBusinessTripTravelAndSubsistenceExpense($fields: UpdateBusinessTripTravelAndSubsistenceExpenseInput!) {
  updateBusinessTripTravelAndSubsistenceExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<UpdateBusinessTripTravelAndSubsistenceExpenseMutation, UpdateBusinessTripTravelAndSubsistenceExpenseMutationVariables>;
export const UpdateBusinessDocument = new TypedDocumentString(`
    mutation UpdateBusiness($businessId: UUID!, $ownerId: UUID!, $fields: UpdateBusinessInput!) {
  updateBusiness(businessId: $businessId, ownerId: $ownerId, fields: $fields) {
    __typename
    ... on LtdFinancialEntity {
      id
      name
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateBusinessMutation, UpdateBusinessMutationVariables>;
export const UpdateChargeAccountantApprovalDocument = new TypedDocumentString(`
    mutation UpdateChargeAccountantApproval($chargeId: UUID!, $status: AccountantStatus!) {
  updateChargeAccountantApproval(chargeId: $chargeId, approvalStatus: $status)
}
    `) as unknown as TypedDocumentString<UpdateChargeAccountantApprovalMutation, UpdateChargeAccountantApprovalMutationVariables>;
export const UpdateChargeDocument = new TypedDocumentString(`
    mutation UpdateCharge($chargeId: UUID!, $fields: UpdateChargeInput!) {
  updateCharge(chargeId: $chargeId, fields: $fields) {
    __typename
    ... on UpdateChargeSuccessfulResult {
      charge {
        id
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateChargeMutation, UpdateChargeMutationVariables>;
export const UpdateClientDocument = new TypedDocumentString(`
    mutation UpdateClient($businessId: UUID!, $fields: ClientUpdateInput!) {
  updateClient(businessId: $businessId, fields: $fields) {
    __typename
    ... on Client {
      id
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateClientMutation, UpdateClientMutationVariables>;
export const UpdateContractDocument = new TypedDocumentString(`
    mutation UpdateContract($contractId: UUID!, $input: UpdateContractInput!) {
  updateContract(contractId: $contractId, input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateContractMutation, UpdateContractMutationVariables>;
export const UpdateDepositDocument = new TypedDocumentString(`
    mutation UpdateDeposit($id: UUID!, $name: String, $openDate: TimelessDate, $closeDate: TimelessDate) {
  updateDeposit(id: $id, name: $name, openDate: $openDate, closeDate: $closeDate) {
    id
    name
    openDate
    closeDate
    isOpen
  }
}
    `) as unknown as TypedDocumentString<UpdateDepositMutation, UpdateDepositMutationVariables>;
export const UpdateDepreciationRecordDocument = new TypedDocumentString(`
    mutation UpdateDepreciationRecord($fields: UpdateDepreciationRecordInput!) {
  updateDepreciationRecord(input: $fields) {
    __typename
    ... on CommonError {
      message
    }
    ... on DepreciationRecord {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateDepreciationRecordMutation, UpdateDepreciationRecordMutationVariables>;
export const UpdateDocumentDocument = new TypedDocumentString(`
    mutation UpdateDocument($documentId: UUID!, $fields: UpdateDocumentFieldsInput!) {
  updateDocument(documentId: $documentId, fields: $fields) {
    __typename
    ... on CommonError {
      message
    }
    ... on UpdateDocumentSuccessfulResult {
      document {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateDocumentMutation, UpdateDocumentMutationVariables>;
export const UpdateDynamicReportTemplateNameDocument = new TypedDocumentString(`
    mutation UpdateDynamicReportTemplateName($name: String!, $newName: String!) {
  updateDynamicReportTemplateName(name: $name, newName: $newName) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<UpdateDynamicReportTemplateNameMutation, UpdateDynamicReportTemplateNameMutationVariables>;
export const UpdateDynamicReportTemplateDocument = new TypedDocumentString(`
    mutation UpdateDynamicReportTemplate($name: String!, $template: String!) {
  updateDynamicReportTemplate(name: $name, template: $template) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<UpdateDynamicReportTemplateMutation, UpdateDynamicReportTemplateMutationVariables>;
export const UpdateFinancialAccountDocument = new TypedDocumentString(`
    mutation UpdateFinancialAccount($financialAccountId: UUID!, $fields: UpdateFinancialAccountInput!) {
  updateFinancialAccount(id: $financialAccountId, fields: $fields) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateFinancialAccountMutation, UpdateFinancialAccountMutationVariables>;
export const UpdateMiscExpenseDocument = new TypedDocumentString(`
    mutation UpdateMiscExpense($id: UUID!, $fields: UpdateMiscExpenseInput!) {
  updateMiscExpense(id: $id, fields: $fields) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateMiscExpenseMutation, UpdateMiscExpenseMutationVariables>;
export const UpdateOrInsertSalaryRecordsDocument = new TypedDocumentString(`
    mutation UpdateOrInsertSalaryRecords($salaryRecords: [SalaryRecordInput!]!) {
  insertOrUpdateSalaryRecords(salaryRecords: $salaryRecords) {
    __typename
    ... on InsertSalaryRecordsSuccessfulResult {
      salaryRecords {
        month
        employee {
          id
        }
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateOrInsertSalaryRecordsMutation, UpdateOrInsertSalaryRecordsMutationVariables>;
export const UpdateSalaryRecordDocument = new TypedDocumentString(`
    mutation UpdateSalaryRecord($salaryRecord: SalaryRecordEditInput!) {
  updateSalaryRecord(salaryRecord: $salaryRecord) {
    __typename
    ... on UpdateSalaryRecordSuccessfulResult {
      salaryRecord {
        month
        employee {
          id
        }
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateSalaryRecordMutation, UpdateSalaryRecordMutationVariables>;
export const UpdateSortCodeDocument = new TypedDocumentString(`
    mutation UpdateSortCode($key: Int!, $fields: UpdateSortCodeFieldsInput!) {
  updateSortCode(key: $key, fields: $fields)
}
    `) as unknown as TypedDocumentString<UpdateSortCodeMutation, UpdateSortCodeMutationVariables>;
export const UpdateTagDocument = new TypedDocumentString(`
    mutation UpdateTag($tagId: UUID!, $fields: UpdateTagFieldsInput!) {
  updateTag(id: $tagId, fields: $fields)
}
    `) as unknown as TypedDocumentString<UpdateTagMutation, UpdateTagMutationVariables>;
export const UpdateTaxCategoryDocument = new TypedDocumentString(`
    mutation UpdateTaxCategory($taxCategoryId: UUID!, $fields: UpdateTaxCategoryInput!) {
  updateTaxCategory(taxCategoryId: $taxCategoryId, fields: $fields) {
    __typename
    ... on TaxCategory {
      id
      name
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateTaxCategoryMutation, UpdateTaxCategoryMutationVariables>;
export const UpdateTransactionDocument = new TypedDocumentString(`
    mutation UpdateTransaction($transactionId: UUID!, $fields: UpdateTransactionInput!) {
  updateTransaction(transactionId: $transactionId, fields: $fields) {
    __typename
    ... on Transaction {
      id
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateTransactionMutation, UpdateTransactionMutationVariables>;
export const UpdateTransactionsDocument = new TypedDocumentString(`
    mutation UpdateTransactions($transactionIds: [UUID!]!, $fields: UpdateTransactionInput!) {
  updateTransactions(transactionIds: $transactionIds, fields: $fields) {
    __typename
    ... on UpdatedTransactionsSuccessfulResult {
      transactions {
        ... on Transaction {
          id
        }
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateTransactionsMutation, UpdateTransactionsMutationVariables>;
export const UploadDocumentDocument = new TypedDocumentString(`
    mutation UploadDocument($file: FileScalar!, $chargeId: UUID) {
  uploadDocument(file: $file, chargeId: $chargeId) {
    __typename
    ... on UploadDocumentSuccessfulResult {
      document {
        id
        charge {
          id
        }
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<UploadDocumentMutation, UploadDocumentMutationVariables>;
export const UploadDocumentsFromGoogleDriveDocument = new TypedDocumentString(`
    mutation UploadDocumentsFromGoogleDrive($sharedFolderUrl: String!, $chargeId: UUID, $isSensitive: Boolean) {
  batchUploadDocumentsFromGoogleDrive(
    sharedFolderUrl: $sharedFolderUrl
    chargeId: $chargeId
    isSensitive: $isSensitive
  ) {
    ... on CommonError {
      message
    }
    ... on UploadDocumentSuccessfulResult {
      document {
        id
        ...NewFetchedDocumentFields
      }
    }
  }
}
    fragment NewFetchedDocumentFields on Document {
  id
  documentType
  charge {
    id
    userDescription
    counterparty {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<UploadDocumentsFromGoogleDriveMutation, UploadDocumentsFromGoogleDriveMutationVariables>;
export const UploadMultipleDocumentsDocument = new TypedDocumentString(`
    mutation UploadMultipleDocuments($documents: [FileScalar!]!, $chargeId: UUID, $isSensitive: Boolean) {
  batchUploadDocuments(
    documents: $documents
    chargeId: $chargeId
    isSensitive: $isSensitive
  ) {
    ... on CommonError {
      message
    }
    ... on UploadDocumentSuccessfulResult {
      document {
        id
        ...NewFetchedDocumentFields
      }
    }
  }
}
    fragment NewFetchedDocumentFields on Document {
  id
  documentType
  charge {
    id
    userDescription
    counterparty {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<UploadMultipleDocumentsMutation, UploadMultipleDocumentsMutationVariables>;
export const UploadPayrollFileDocument = new TypedDocumentString(`
    mutation UploadPayrollFile($file: FileScalar!, $chargeId: UUID!) {
  insertSalaryRecordsFromFile(file: $file, chargeId: $chargeId)
}
    `) as unknown as TypedDocumentString<UploadPayrollFileMutation, UploadPayrollFileMutationVariables>;
export const UserContextDocument = new TypedDocumentString(`
    query UserContext {
  userContext {
    adminBusinessId
    defaultLocalCurrency
    defaultCryptoConversionFiatCurrency
    ledgerLock
    financialAccountsBusinessesIds
    locality
  }
}
    `) as unknown as TypedDocumentString<UserContextQuery, UserContextQueryVariables>;
export const BusinessEmailConfigDocument = new TypedDocumentString(`
    query BusinessEmailConfig($email: String!) {
  businessEmailConfig(email: $email) {
    businessId
    internalEmailLinks
    emailBody
    attachments
  }
}
    `) as unknown as TypedDocumentString<BusinessEmailConfigQuery, BusinessEmailConfigQueryVariables>;
export const InsertEmailDocumentsDocument = new TypedDocumentString(`
    mutation InsertEmailDocuments($documents: [FileScalar!]!, $userDescription: String!, $messageId: String, $businessId: UUID) {
  insertEmailDocuments(
    documents: $documents
    userDescription: $userDescription
    messageId: $messageId
    businessId: $businessId
  )
}
    `) as unknown as TypedDocumentString<InsertEmailDocumentsMutation, InsertEmailDocumentsMutationVariables>;
export const UploadPoalimIlsTransactionsDocument = new TypedDocumentString(`
    mutation UploadPoalimIlsTransactions($transactions: [PoalimIlsTransactionInput!]!) {
  uploadPoalimIlsTransactions(transactions: $transactions) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadPoalimIlsTransactionsMutation, UploadPoalimIlsTransactionsMutationVariables>;
export const UploadPoalimForeignTransactionsDocument = new TypedDocumentString(`
    mutation UploadPoalimForeignTransactions($transactions: [PoalimForeignTransactionInput!]!) {
  uploadPoalimForeignTransactions(transactions: $transactions) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadPoalimForeignTransactionsMutation, UploadPoalimForeignTransactionsMutationVariables>;
export const UploadPoalimSwiftTransactionsDocument = new TypedDocumentString(`
    mutation UploadPoalimSwiftTransactions($swifts: [PoalimSwiftTransactionInput!]!) {
  uploadPoalimSwiftTransactions(swifts: $swifts) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadPoalimSwiftTransactionsMutation, UploadPoalimSwiftTransactionsMutationVariables>;
export const UploadIsracardTransactionsDocument = new TypedDocumentString(`
    mutation UploadIsracardTransactions($transactions: [IsracardTransactionInput!]!) {
  uploadIsracardTransactions(transactions: $transactions) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadIsracardTransactionsMutation, UploadIsracardTransactionsMutationVariables>;
export const UploadAmexTransactionsDocument = new TypedDocumentString(`
    mutation UploadAmexTransactions($transactions: [AmexTransactionInput!]!) {
  uploadAmexTransactions(transactions: $transactions) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadAmexTransactionsMutation, UploadAmexTransactionsMutationVariables>;
export const UploadCalTransactionsDocument = new TypedDocumentString(`
    mutation UploadCalTransactions($transactions: [CalTransactionInput!]!) {
  uploadCalTransactions(transactions: $transactions) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadCalTransactionsMutation, UploadCalTransactionsMutationVariables>;
export const UploadDiscountTransactionsDocument = new TypedDocumentString(`
    mutation UploadDiscountTransactions($transactions: [DiscountTransactionInput!]!) {
  uploadDiscountTransactions(transactions: $transactions) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadDiscountTransactionsMutation, UploadDiscountTransactionsMutationVariables>;
export const UploadMaxTransactionsDocument = new TypedDocumentString(`
    mutation UploadMaxTransactions($transactions: [MaxTransactionInput!]!) {
  uploadMaxTransactions(transactions: $transactions) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadMaxTransactionsMutation, UploadMaxTransactionsMutationVariables>;
export const UploadCurrencyRatesDocument = new TypedDocumentString(`
    mutation UploadCurrencyRates($rates: [CurrencyRateInput!]!) {
  uploadCurrencyRates(rates: $rates) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadCurrencyRatesMutation, UploadCurrencyRatesMutationVariables>;